
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3084"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3084"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("boZNq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e4b14ad7ed75be8c$export$2e2bcd8739ae039);

var $87GX8 = parcelRequire("87GX8");

var $bXYKW = parcelRequire("bXYKW");

var $1LCJs = parcelRequire("1LCJs");
var $e4b14ad7ed75be8c$export$2e2bcd8739ae039 = {
    name: 'App',
    components: {
        Header: $87GX8.default,
        Footer: $bXYKW.default,
        Loading: $1LCJs.default
    },
    data () {
        return {
            show: true
        };
    },
    mounted () {
        window.addEventListener('load', ()=>this.show = !this.show);
    }
};

});
parcelRegister("87GX8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ea04bb99a847ad4$export$2e2bcd8739ae039);
let $5ea04bb99a847ad4$var$script;



let $5ea04bb99a847ad4$var$initialize = ()=>{
    $5ea04bb99a847ad4$var$script = (parcelRequire("hx1ni"));
    if ($5ea04bb99a847ad4$var$script.__esModule) $5ea04bb99a847ad4$var$script = $5ea04bb99a847ad4$var$script.default;
    $5ea04bb99a847ad4$var$script.render = (parcelRequire("8vzlI")).render;
    (parcelRequire("21zwM")).default($5ea04bb99a847ad4$var$script);
    $5ea04bb99a847ad4$var$script.__scopeId = 'data-v-6ae1f3';
    $5ea04bb99a847ad4$var$script.__file = "Header.vue";
};
$5ea04bb99a847ad4$var$initialize();
var $5ea04bb99a847ad4$export$2e2bcd8739ae039 = $5ea04bb99a847ad4$var$script;

});
parcelRegister("hx1ni", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cc3695b74b92ab2d$export$2e2bcd8739ae039);

var $3taZC = parcelRequire("3taZC");

var $hEHvj = parcelRequire("hEHvj");
var $cc3695b74b92ab2d$export$2e2bcd8739ae039 = {
    name: 'Header',
    data () {
        return {
            overlay: false
        };
    },
    components: {
        HeaderDefault: $3taZC.default,
        HeaderOverlay: $hEHvj.default
    },
    watch: {
        $route (to, from) {
            this.overlay = false;
        }
    }
};

});
parcelRegister("3taZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $286c9b7c7e7d0d30$export$2e2bcd8739ae039);
let $286c9b7c7e7d0d30$var$script;




let $286c9b7c7e7d0d30$var$initialize = ()=>{
    $286c9b7c7e7d0d30$var$script = (parcelRequire("cuENK"));
    if ($286c9b7c7e7d0d30$var$script.__esModule) $286c9b7c7e7d0d30$var$script = $286c9b7c7e7d0d30$var$script.default;
    $286c9b7c7e7d0d30$var$script.render = (parcelRequire("2OxMi")).render;
    $286c9b7c7e7d0d30$var$script.__cssModules = {};
    (parcelRequire("5VMzB")).default($286c9b7c7e7d0d30$var$script);
    $286c9b7c7e7d0d30$var$script.__scopeId = 'data-v-879550';
    $286c9b7c7e7d0d30$var$script.__file = "HeaderDefault.vue";
};
$286c9b7c7e7d0d30$var$initialize();
var $286c9b7c7e7d0d30$export$2e2bcd8739ae039 = $286c9b7c7e7d0d30$var$script;

});
parcelRegister("cuENK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9187efacd9cbe8e1$export$2e2bcd8739ae039);

var $iGa2N = parcelRequire("iGa2N");

var $eCPNH = parcelRequire("eCPNH");

var $g2ma9 = parcelRequire("g2ma9");

var $9187efacd9cbe8e1$export$2e2bcd8739ae039 = {
    name: 'HeaderDefault',
    props: {
        toggleIcon: {
            default: 'charm:menu-hamburger'
        }
    },
    components: {
        Container: $iGa2N.default,
        Navigation: $eCPNH.default,
        Icon: $g2ma9.default
    },
    emits: [
        'toggle'
    ],
    data () {
        return {
            logo: {}
        };
    }
};

});
parcelRegister("iGa2N", function(module, exports) {

$parcel$export(module.exports, "default", () => $d993f0cc61f8847b$export$2e2bcd8739ae039);
let $d993f0cc61f8847b$var$script;




let $d993f0cc61f8847b$var$initialize = ()=>{
    $d993f0cc61f8847b$var$script = (parcelRequire("gj9yN"));
    if ($d993f0cc61f8847b$var$script.__esModule) $d993f0cc61f8847b$var$script = $d993f0cc61f8847b$var$script.default;
    $d993f0cc61f8847b$var$script.render = (parcelRequire("9GmDR")).render;
    $d993f0cc61f8847b$var$script.__cssModules = {};
    (parcelRequire("hhMUS")).default($d993f0cc61f8847b$var$script);
    $d993f0cc61f8847b$var$script.__scopeId = 'data-v-89fb5b';
    $d993f0cc61f8847b$var$script.__file = "Container.vue";
};
$d993f0cc61f8847b$var$initialize();
var $d993f0cc61f8847b$export$2e2bcd8739ae039 = $d993f0cc61f8847b$var$script;

});
parcelRegister("gj9yN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bdf5d6273ec974b9$export$2e2bcd8739ae039);
var $bdf5d6273ec974b9$export$2e2bcd8739ae039 = {
    name: 'Container'
};

});

parcelRegister("9GmDR", function(module, exports) {

$parcel$export(module.exports, "render", () => $70c99985db81e72d$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
const $70c99985db81e72d$var$_hoisted_1 = {
    class: "container"
};
function $70c99985db81e72d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("div", $70c99985db81e72d$var$_hoisted_1, [
        (0, $igcaK.renderSlot)(_ctx.$slots, "default")
    ]);
}

});
parcelRegister("4GnCG", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("igcaK")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("igcaK")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("igcaK")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("igcaK")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("igcaK")).createElementVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("igcaK")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("igcaK")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("igcaK")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("igcaK")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("igcaK")).getCurrentInstance);
$parcel$export(module.exports, "h", () => (parcelRequire("igcaK")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("igcaK")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("igcaK")).inject);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("igcaK")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("oF3Y1")).normalizeClass);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("igcaK")).onActivated);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("igcaK")).onDeactivated);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("igcaK")).onUnmounted);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("igcaK")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("igcaK")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("mHgsT")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("mHgsT")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("igcaK")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("igcaK")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("igcaK")).resolveComponent);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("igcaK")).resolveDynamicComponent);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("mHgsT")).shallowReactive);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("mHgsT")).shallowRef);
$parcel$export(module.exports, "watch", () => (parcelRequire("igcaK")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("igcaK")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("igcaK")).withCtx);
$parcel$export(module.exports, "createApp", () => (parcelRequire("jfBPE")).createApp);
$parcel$export(module.exports, "Transition", () => (parcelRequire("jfBPE")).Transition);
$parcel$export(module.exports, "withModifiers", () => (parcelRequire("jfBPE")).withModifiers);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("oF3Y1")).toDisplayString);
$parcel$export(module.exports, "unref", () => (parcelRequire("mHgsT")).unref);
/**
* vue v3.5.40
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $igcaK = parcelRequire("igcaK");parcelRequire("jfBPE");parcelRequire("oF3Y1");parcelRequire("mHgsT");
function $368d68b51b6965aa$var$initDev() {
    (0, $igcaK.initCustomFormatter)();
}
const $368d68b51b6965aa$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("igcaK", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $d4b329d0bc8bd329$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $d4b329d0bc8bd329$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $d4b329d0bc8bd329$export$59536a0199721cab);
$parcel$export(module.exports, "Fragment", () => $d4b329d0bc8bd329$export$ffb0004e005737fa);
$parcel$export(module.exports, "Static", () => $d4b329d0bc8bd329$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $d4b329d0bc8bd329$export$694b237e827a3d23);
$parcel$export(module.exports, "provide", () => $d4b329d0bc8bd329$export$abe1e183e22e10ad);
$parcel$export(module.exports, "inject", () => $d4b329d0bc8bd329$export$a976684a0efeb93f);
$parcel$export(module.exports, "getCurrentInstance", () => $d4b329d0bc8bd329$export$f13e630aa3915748);
$parcel$export(module.exports, "watchEffect", () => $d4b329d0bc8bd329$export$ede35fc0e5500309);
$parcel$export(module.exports, "watch", () => $d4b329d0bc8bd329$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "useTransitionState", () => $d4b329d0bc8bd329$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $d4b329d0bc8bd329$export$6d1641039221b5cb);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $d4b329d0bc8bd329$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getTransitionRawChildren", () => $d4b329d0bc8bd329$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "createCommentVNode", () => $d4b329d0bc8bd329$export$49553837c7236d3c);
$parcel$export(module.exports, "resolveTransitionHooks", () => $d4b329d0bc8bd329$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $d4b329d0bc8bd329$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $d4b329d0bc8bd329$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $d4b329d0bc8bd329$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "createVNode", () => $d4b329d0bc8bd329$export$bf5c4cf060303d58);
$parcel$export(module.exports, "createTextVNode", () => $d4b329d0bc8bd329$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "onUnmounted", () => $d4b329d0bc8bd329$export$13348a43ccacfe58);
$parcel$export(module.exports, "onUpdated", () => $d4b329d0bc8bd329$export$5876c47052fb88b1);
$parcel$export(module.exports, "onActivated", () => $d4b329d0bc8bd329$export$ba52d824b95a2154);
$parcel$export(module.exports, "onDeactivated", () => $d4b329d0bc8bd329$export$bf1440eeaf5fa709);
$parcel$export(module.exports, "onBeforeUpdate", () => $d4b329d0bc8bd329$export$ab91988a13872e4c);
$parcel$export(module.exports, "resolveComponent", () => $d4b329d0bc8bd329$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "resolveDynamicComponent", () => $d4b329d0bc8bd329$export$b44c564a05ca975);
$parcel$export(module.exports, "renderList", () => $d4b329d0bc8bd329$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "renderSlot", () => $d4b329d0bc8bd329$export$4abee4c34694ada1);
$parcel$export(module.exports, "openBlock", () => $d4b329d0bc8bd329$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "createBlock", () => $d4b329d0bc8bd329$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "computed", () => $d4b329d0bc8bd329$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "createRenderer", () => $d4b329d0bc8bd329$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $d4b329d0bc8bd329$export$200524cf0d997ff0);
$parcel$export(module.exports, "createElementBlock", () => $d4b329d0bc8bd329$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $d4b329d0bc8bd329$export$42098e0eaa15c48e);
$parcel$export(module.exports, "isRuntimeOnly", () => $d4b329d0bc8bd329$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $d4b329d0bc8bd329$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $d4b329d0bc8bd329$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $d4b329d0bc8bd329$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "reactive", () => (parcelRequire("mHgsT")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("mHgsT")).ref);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("mHgsT")).shallowReactive);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("mHgsT")).shallowRef);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("mHgsT")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("oF3Y1")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("oF3Y1")).normalizeClass);
/**
* @vue/runtime-core v3.5.40
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $mHgsT = parcelRequire("mHgsT");

var $oF3Y1 = parcelRequire("oF3Y1");
const $d4b329d0bc8bd329$var$stack = [];
function $d4b329d0bc8bd329$var$pushWarningContext(vnode) {
    $d4b329d0bc8bd329$var$stack.push(vnode);
}
function $d4b329d0bc8bd329$var$popWarningContext() {
    $d4b329d0bc8bd329$var$stack.pop();
}
let $d4b329d0bc8bd329$var$isWarning = false;
function $d4b329d0bc8bd329$var$warn$1(msg, ...args) {
    if ($d4b329d0bc8bd329$var$isWarning) return;
    $d4b329d0bc8bd329$var$isWarning = true;
    (0, $mHgsT.pauseTracking)();
    const instance = $d4b329d0bc8bd329$var$stack.length ? $d4b329d0bc8bd329$var$stack[$d4b329d0bc8bd329$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $d4b329d0bc8bd329$var$getComponentTrace();
    if (appWarnHandler) $d4b329d0bc8bd329$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$d4b329d0bc8bd329$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$d4b329d0bc8bd329$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $mHgsT.resetTracking)();
    $d4b329d0bc8bd329$var$isWarning = false;
}
function $d4b329d0bc8bd329$var$getComponentTrace() {
    let currentVNode = $d4b329d0bc8bd329$var$stack[$d4b329d0bc8bd329$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $d4b329d0bc8bd329$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$d4b329d0bc8bd329$var$formatTraceEntry(entry));
    });
    return logs;
}
function $d4b329d0bc8bd329$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$d4b329d0bc8bd329$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$d4b329d0bc8bd329$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $d4b329d0bc8bd329$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$d4b329d0bc8bd329$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $d4b329d0bc8bd329$var$formatProp(key, value, raw) {
    if ((0, $oF3Y1.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $mHgsT.isRef)(value)) {
        value = $d4b329d0bc8bd329$var$formatProp(key, (0, $mHgsT.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $oF3Y1.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $mHgsT.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $d4b329d0bc8bd329$export$dfbcecb440255e4a(val, type) {
    return;
}
const $d4b329d0bc8bd329$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $d4b329d0bc8bd329$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $d4b329d0bc8bd329$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $d4b329d0bc8bd329$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $d4b329d0bc8bd329$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $oF3Y1.isFunction)(fn)) {
        const res = $d4b329d0bc8bd329$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $oF3Y1.isPromise)(res)) res.catch((err)=>{
            $d4b329d0bc8bd329$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $oF3Y1.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($d4b329d0bc8bd329$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $d4b329d0bc8bd329$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $oF3Y1.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $mHgsT.pauseTracking)();
            $d4b329d0bc8bd329$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $mHgsT.resetTracking)();
            return;
        }
    }
    $d4b329d0bc8bd329$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $d4b329d0bc8bd329$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $d4b329d0bc8bd329$var$queue = [];
let $d4b329d0bc8bd329$var$flushIndex = -1;
const $d4b329d0bc8bd329$var$pendingPostFlushCbs = [];
let $d4b329d0bc8bd329$var$activePostFlushCbs = null;
let $d4b329d0bc8bd329$var$postFlushIndex = 0;
const $d4b329d0bc8bd329$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $d4b329d0bc8bd329$var$currentFlushPromise = null;
const $d4b329d0bc8bd329$var$RECURSION_LIMIT = 100;
function $d4b329d0bc8bd329$export$bdd553fddd433dcb(fn) {
    const p = $d4b329d0bc8bd329$var$currentFlushPromise || $d4b329d0bc8bd329$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $d4b329d0bc8bd329$var$findInsertionIndex(id) {
    let start = $d4b329d0bc8bd329$var$flushIndex + 1;
    let end = $d4b329d0bc8bd329$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $d4b329d0bc8bd329$var$queue[middle];
        const middleJobId = $d4b329d0bc8bd329$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $d4b329d0bc8bd329$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $d4b329d0bc8bd329$var$getId(job);
        const lastJob = $d4b329d0bc8bd329$var$queue[$d4b329d0bc8bd329$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $d4b329d0bc8bd329$var$getId(lastJob)) $d4b329d0bc8bd329$var$queue.push(job);
        else $d4b329d0bc8bd329$var$queue.splice($d4b329d0bc8bd329$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $d4b329d0bc8bd329$var$queueFlush();
    }
}
function $d4b329d0bc8bd329$var$queueFlush() {
    if (!$d4b329d0bc8bd329$var$currentFlushPromise) $d4b329d0bc8bd329$var$currentFlushPromise = $d4b329d0bc8bd329$var$resolvedPromise.then($d4b329d0bc8bd329$var$flushJobs);
}
function $d4b329d0bc8bd329$export$59536a0199721cab(cb) {
    if (!(0, $oF3Y1.isArray)(cb)) {
        if ($d4b329d0bc8bd329$var$activePostFlushCbs && cb.id === -1) $d4b329d0bc8bd329$var$activePostFlushCbs.splice($d4b329d0bc8bd329$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $d4b329d0bc8bd329$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else $d4b329d0bc8bd329$var$pendingPostFlushCbs.push(...cb);
    $d4b329d0bc8bd329$var$queueFlush();
}
function $d4b329d0bc8bd329$var$flushPreFlushCbs(instance, seen, i = $d4b329d0bc8bd329$var$flushIndex + 1) {
    for(; i < $d4b329d0bc8bd329$var$queue.length; i++){
        const cb = $d4b329d0bc8bd329$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            $d4b329d0bc8bd329$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $d4b329d0bc8bd329$var$flushPostFlushCbs(seen) {
    if ($d4b329d0bc8bd329$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($d4b329d0bc8bd329$var$pendingPostFlushCbs)
        ].sort((a, b)=>$d4b329d0bc8bd329$var$getId(a) - $d4b329d0bc8bd329$var$getId(b));
        $d4b329d0bc8bd329$var$pendingPostFlushCbs.length = 0;
        if ($d4b329d0bc8bd329$var$activePostFlushCbs) {
            $d4b329d0bc8bd329$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $d4b329d0bc8bd329$var$activePostFlushCbs = deduped;
        for($d4b329d0bc8bd329$var$postFlushIndex = 0; $d4b329d0bc8bd329$var$postFlushIndex < $d4b329d0bc8bd329$var$activePostFlushCbs.length; $d4b329d0bc8bd329$var$postFlushIndex++){
            const cb = $d4b329d0bc8bd329$var$activePostFlushCbs[$d4b329d0bc8bd329$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $d4b329d0bc8bd329$var$activePostFlushCbs = null;
        $d4b329d0bc8bd329$var$postFlushIndex = 0;
    }
}
const $d4b329d0bc8bd329$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $d4b329d0bc8bd329$var$flushJobs(seen) {
    const check = (0, $oF3Y1.NOOP);
    try {
        for($d4b329d0bc8bd329$var$flushIndex = 0; $d4b329d0bc8bd329$var$flushIndex < $d4b329d0bc8bd329$var$queue.length; $d4b329d0bc8bd329$var$flushIndex++){
            const job = $d4b329d0bc8bd329$var$queue[$d4b329d0bc8bd329$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $d4b329d0bc8bd329$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $d4b329d0bc8bd329$var$flushIndex < $d4b329d0bc8bd329$var$queue.length; $d4b329d0bc8bd329$var$flushIndex++){
            const job = $d4b329d0bc8bd329$var$queue[$d4b329d0bc8bd329$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $d4b329d0bc8bd329$var$flushIndex = -1;
        $d4b329d0bc8bd329$var$queue.length = 0;
        $d4b329d0bc8bd329$var$flushPostFlushCbs(seen);
        $d4b329d0bc8bd329$var$currentFlushPromise = null;
        if ($d4b329d0bc8bd329$var$queue.length || $d4b329d0bc8bd329$var$pendingPostFlushCbs.length) $d4b329d0bc8bd329$var$flushJobs(seen);
    }
}
function $d4b329d0bc8bd329$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $d4b329d0bc8bd329$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $d4b329d0bc8bd329$var$getComponentName(instance.type);
        $d4b329d0bc8bd329$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $d4b329d0bc8bd329$var$isHmrUpdating = false;
const $d4b329d0bc8bd329$var$setHmrUpdating = (v1)=>{
    try {
        return $d4b329d0bc8bd329$var$isHmrUpdating;
    } finally{
        $d4b329d0bc8bd329$var$isHmrUpdating = v1;
    }
};
const $d4b329d0bc8bd329$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $d4b329d0bc8bd329$var$map = /* @__PURE__ */ new Map();
function $d4b329d0bc8bd329$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $d4b329d0bc8bd329$var$map.get(id);
    if (!record) {
        $d4b329d0bc8bd329$var$createRecord(id, instance.type);
        record = $d4b329d0bc8bd329$var$map.get(id);
    }
    record.instances.add(instance);
}
function $d4b329d0bc8bd329$var$unregisterHMR(instance) {
    $d4b329d0bc8bd329$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $d4b329d0bc8bd329$var$createRecord(id, initialDef) {
    if ($d4b329d0bc8bd329$var$map.has(id)) return false;
    $d4b329d0bc8bd329$var$map.set(id, {
        initialDef: $d4b329d0bc8bd329$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $d4b329d0bc8bd329$var$normalizeClassComponent(component) {
    return $d4b329d0bc8bd329$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $d4b329d0bc8bd329$var$rerender(id, newRender) {
    const record = $d4b329d0bc8bd329$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $d4b329d0bc8bd329$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $d4b329d0bc8bd329$var$isHmrUpdating = true;
        if (!(instance.job.flags & 8)) instance.update();
        $d4b329d0bc8bd329$var$isHmrUpdating = false;
    });
}
function $d4b329d0bc8bd329$var$reload(id, newComp) {
    const record = $d4b329d0bc8bd329$var$map.get(id);
    if (!record) return;
    newComp = $d4b329d0bc8bd329$var$normalizeClassComponent(newComp);
    $d4b329d0bc8bd329$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $d4b329d0bc8bd329$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $d4b329d0bc8bd329$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $d4b329d0bc8bd329$var$updateComponentDef(oldComp, newComp);
            $d4b329d0bc8bd329$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $d4b329d0bc8bd329$var$queueJob(()=>{
            if (!(instance.job.flags & 8)) {
                $d4b329d0bc8bd329$var$isHmrUpdating = true;
                instance.parent.update();
                $d4b329d0bc8bd329$var$isHmrUpdating = false;
                dirtyInstances.delete(instance);
            }
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $d4b329d0bc8bd329$export$59536a0199721cab(()=>{
        $d4b329d0bc8bd329$var$hmrDirtyComponents.clear();
    });
}
function $d4b329d0bc8bd329$var$updateComponentDef(oldComp, newComp) {
    (0, $oF3Y1.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $d4b329d0bc8bd329$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $d4b329d0bc8bd329$var$devtools$1;
let $d4b329d0bc8bd329$var$buffer = [];
let $d4b329d0bc8bd329$var$devtoolsNotInstalled = false;
function $d4b329d0bc8bd329$var$emit$1(event, ...args) {
    if ($d4b329d0bc8bd329$var$devtools$1) $d4b329d0bc8bd329$var$devtools$1.emit(event, ...args);
    else if (!$d4b329d0bc8bd329$var$devtoolsNotInstalled) $d4b329d0bc8bd329$var$buffer.push({
        event: event,
        args: args
    });
}
function $d4b329d0bc8bd329$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $d4b329d0bc8bd329$var$devtools$1 = hook;
    if ($d4b329d0bc8bd329$var$devtools$1) {
        $d4b329d0bc8bd329$var$devtools$1.enabled = true;
        $d4b329d0bc8bd329$var$buffer.forEach(({ event: event, args: args })=>$d4b329d0bc8bd329$var$devtools$1.emit(event, ...args));
        $d4b329d0bc8bd329$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $d4b329d0bc8bd329$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$d4b329d0bc8bd329$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $d4b329d0bc8bd329$var$devtoolsNotInstalled = true;
                $d4b329d0bc8bd329$var$buffer = [];
            }
        }, 3e3);
    } else {
        $d4b329d0bc8bd329$var$devtoolsNotInstalled = true;
        $d4b329d0bc8bd329$var$buffer = [];
    }
}
function $d4b329d0bc8bd329$var$devtoolsInitApp(app, version) {
    $d4b329d0bc8bd329$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $d4b329d0bc8bd329$export$ffb0004e005737fa,
        Text: $d4b329d0bc8bd329$export$5f1af8db9871e1d6,
        Comment: $d4b329d0bc8bd329$export$4d299b491347818a,
        Static: $d4b329d0bc8bd329$export$c1b9a1d3af45b7b6
    });
}
function $d4b329d0bc8bd329$var$devtoolsUnmountApp(app) {
    $d4b329d0bc8bd329$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $d4b329d0bc8bd329$var$devtoolsComponentAdded = /* @__PURE__ */ $d4b329d0bc8bd329$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $d4b329d0bc8bd329$var$devtoolsComponentUpdated = /* @__PURE__ */ $d4b329d0bc8bd329$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $d4b329d0bc8bd329$var$_devtoolsComponentRemoved = /* @__PURE__ */ $d4b329d0bc8bd329$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $d4b329d0bc8bd329$var$devtoolsComponentRemoved = (component)=>{
    if ($d4b329d0bc8bd329$var$devtools$1 && typeof $d4b329d0bc8bd329$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$d4b329d0bc8bd329$var$devtools$1.cleanupBuffer(component)) $d4b329d0bc8bd329$var$_devtoolsComponentRemoved(component);
};
// @__NO_SIDE_EFFECTS__
function $d4b329d0bc8bd329$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $d4b329d0bc8bd329$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $d4b329d0bc8bd329$var$devtoolsPerfStart = /* @__PURE__ */ $d4b329d0bc8bd329$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $d4b329d0bc8bd329$var$devtoolsPerfEnd = /* @__PURE__ */ $d4b329d0bc8bd329$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $d4b329d0bc8bd329$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $d4b329d0bc8bd329$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $d4b329d0bc8bd329$var$devtoolsComponentEmit(component, event, params) {
    $d4b329d0bc8bd329$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $d4b329d0bc8bd329$var$currentRenderingInstance = null;
let $d4b329d0bc8bd329$var$currentScopeId = null;
function $d4b329d0bc8bd329$var$setCurrentRenderingInstance(instance) {
    const prev = $d4b329d0bc8bd329$var$currentRenderingInstance;
    $d4b329d0bc8bd329$var$currentRenderingInstance = instance;
    $d4b329d0bc8bd329$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $d4b329d0bc8bd329$export$ac020265ca2cc4cd(id) {
    $d4b329d0bc8bd329$var$currentScopeId = id;
}
function $d4b329d0bc8bd329$export$f2dc6805dc11834e() {
    $d4b329d0bc8bd329$var$currentScopeId = null;
}
const $d4b329d0bc8bd329$export$15ba313e13f3dd04 = (_id)=>$d4b329d0bc8bd329$export$694b237e827a3d23;
function $d4b329d0bc8bd329$export$694b237e827a3d23(fn, ctx = $d4b329d0bc8bd329$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $d4b329d0bc8bd329$export$c20bee82f26f1e27(-1);
        const prevInstance = $d4b329d0bc8bd329$var$setCurrentRenderingInstance(ctx);
        const prevStackSize = $d4b329d0bc8bd329$var$blockStack.length;
        let res;
        try {
            res = fn(...args);
        } finally{
            for(let i = $d4b329d0bc8bd329$var$blockStack.length; i > prevStackSize; i--)$d4b329d0bc8bd329$var$closeBlock();
            $d4b329d0bc8bd329$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $d4b329d0bc8bd329$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $d4b329d0bc8bd329$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $d4b329d0bc8bd329$var$validateDirectiveName(name) {
    if ((0, $oF3Y1.isBuiltInDirective)(name)) $d4b329d0bc8bd329$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $d4b329d0bc8bd329$export$49729353e7c1e6c5(vnode, directives) {
    if ($d4b329d0bc8bd329$var$currentRenderingInstance === null) return vnode;
    const instance = $d4b329d0bc8bd329$var$getComponentPublicInstance($d4b329d0bc8bd329$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $oF3Y1.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $oF3Y1.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $mHgsT.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $d4b329d0bc8bd329$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $mHgsT.pauseTracking)();
            $d4b329d0bc8bd329$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $mHgsT.resetTracking)();
        }
    }
}
function $d4b329d0bc8bd329$export$abe1e183e22e10ad(key, value) {
    if ($d4b329d0bc8bd329$var$currentInstance) {
        let provides = $d4b329d0bc8bd329$var$currentInstance.provides;
        const parentProvides = $d4b329d0bc8bd329$var$currentInstance.parent && $d4b329d0bc8bd329$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $d4b329d0bc8bd329$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $d4b329d0bc8bd329$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $d4b329d0bc8bd329$export$f13e630aa3915748();
    if (instance || $d4b329d0bc8bd329$var$currentApp) {
        let provides = $d4b329d0bc8bd329$var$currentApp ? $d4b329d0bc8bd329$var$currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $oF3Y1.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $d4b329d0bc8bd329$export$caf6761f24fc571a() {
    return !!($d4b329d0bc8bd329$export$f13e630aa3915748() || $d4b329d0bc8bd329$var$currentApp);
}
const $d4b329d0bc8bd329$export$f2549a27e18acf2d = /* @__PURE__ */ Symbol.for("v-scx");
const $d4b329d0bc8bd329$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $d4b329d0bc8bd329$export$a976684a0efeb93f($d4b329d0bc8bd329$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $d4b329d0bc8bd329$export$ede35fc0e5500309(effect, options) {
    return $d4b329d0bc8bd329$var$doWatch(effect, null, options);
}
function $d4b329d0bc8bd329$export$b7f27ea67102d543(effect, options) {
    return $d4b329d0bc8bd329$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $d4b329d0bc8bd329$export$2035654f31b0e555(effect, options) {
    return $d4b329d0bc8bd329$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $d4b329d0bc8bd329$export$3db5d71bdb2d5499(source, cb, options) {
    return $d4b329d0bc8bd329$var$doWatch(source, cb, options);
}
function $d4b329d0bc8bd329$var$doWatch(source, cb, options = (0, $oF3Y1.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $oF3Y1.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($d4b329d0bc8bd329$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $d4b329d0bc8bd329$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $oF3Y1.NOOP);
            watchStopHandle.resume = (0, $oF3Y1.NOOP);
            watchStopHandle.pause = (0, $oF3Y1.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $d4b329d0bc8bd329$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$d4b329d0bc8bd329$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        $d4b329d0bc8bd329$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $d4b329d0bc8bd329$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $mHgsT.watch)(source, cb, baseWatchOptions);
    if ($d4b329d0bc8bd329$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $d4b329d0bc8bd329$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $oF3Y1.isString)(source) ? source.includes(".") ? $d4b329d0bc8bd329$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $oF3Y1.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $d4b329d0bc8bd329$var$setCurrentInstance(this);
    const res = $d4b329d0bc8bd329$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $d4b329d0bc8bd329$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
const $d4b329d0bc8bd329$var$pendingMounts = /* @__PURE__ */ new WeakMap();
const $d4b329d0bc8bd329$var$TeleportEndKey = /* @__PURE__ */ Symbol("_vte");
const $d4b329d0bc8bd329$var$isTeleport = (type)=>type.__isTeleport;
const $d4b329d0bc8bd329$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $d4b329d0bc8bd329$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $d4b329d0bc8bd329$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $d4b329d0bc8bd329$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $d4b329d0bc8bd329$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $oF3Y1.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $d4b329d0bc8bd329$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment, parentNode: parentNode } } = internals;
        const disabled = $d4b329d0bc8bd329$var$isTeleportDisabled(n2.props);
        let { dynamicChildren: dynamicChildren } = n2;
        const mount = (vnode, container2, anchor2)=>{
            if (vnode.shapeFlag & 16) mountChildren(vnode.children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        };
        const mountToTarget = (vnode = n2)=>{
            const disabled2 = $d4b329d0bc8bd329$var$isTeleportDisabled(vnode.props);
            const target = vnode.target = $d4b329d0bc8bd329$var$resolveTarget(vnode.props, querySelector);
            const targetAnchor = $d4b329d0bc8bd329$var$prepareAnchor(target, vnode, createText, insert);
            if (target) {
                if (namespace !== "svg" && $d4b329d0bc8bd329$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace !== "mathml" && $d4b329d0bc8bd329$var$isTargetMathML(target)) namespace = "mathml";
                if (parentComponent && parentComponent.isCE) (parentComponent.ce._teleportTargets || (parentComponent.ce._teleportTargets = /* @__PURE__ */ new Set())).add(target);
                if (!disabled2) {
                    mount(vnode, target, targetAnchor);
                    $d4b329d0bc8bd329$var$updateCssVars(vnode, false);
                }
            }
        };
        const queuePendingMount = (vnode)=>{
            const mountJob = ()=>{
                if ($d4b329d0bc8bd329$var$pendingMounts.get(vnode) !== mountJob) return;
                $d4b329d0bc8bd329$var$pendingMounts.delete(vnode);
                if ($d4b329d0bc8bd329$var$isTeleportDisabled(vnode.props)) {
                    const mountContainer = parentNode(vnode.el) || container;
                    mount(vnode, mountContainer, vnode.anchor);
                    $d4b329d0bc8bd329$var$updateCssVars(vnode, true);
                }
                mountToTarget(vnode);
            };
            $d4b329d0bc8bd329$var$pendingMounts.set(vnode, mountJob);
            $d4b329d0bc8bd329$var$queuePostRenderEffect(mountJob, parentSuspense);
        };
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            if ($d4b329d0bc8bd329$var$isTeleportDeferred(n2.props) || parentSuspense && parentSuspense.pendingBranch) {
                queuePendingMount(n2);
                return;
            }
            if (disabled) {
                mount(n2, container, mainAnchor);
                $d4b329d0bc8bd329$var$updateCssVars(n2, true);
            }
            mountToTarget();
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const pendingMount = $d4b329d0bc8bd329$var$pendingMounts.get(n1);
            if (pendingMount) {
                pendingMount.flags |= 8;
                $d4b329d0bc8bd329$var$pendingMounts.delete(n1);
                queuePendingMount(n2);
                return;
            }
            n2.targetStart = n1.targetStart;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $d4b329d0bc8bd329$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $d4b329d0bc8bd329$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $d4b329d0bc8bd329$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $d4b329d0bc8bd329$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $d4b329d0bc8bd329$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = $d4b329d0bc8bd329$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) {
                        n2.target = nextTarget;
                        $d4b329d0bc8bd329$var$moveTeleport(n2, nextTarget, null, internals, 0);
                    }
                } else if (wasDisabled) $d4b329d0bc8bd329$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $d4b329d0bc8bd329$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        const disabled = $d4b329d0bc8bd329$var$isTeleportDisabled(props);
        const shouldRemove = doRemove || !disabled;
        const pendingMount = $d4b329d0bc8bd329$var$pendingMounts.get(vnode);
        if (pendingMount) {
            pendingMount.flags |= 8;
            $d4b329d0bc8bd329$var$pendingMounts.delete(vnode);
        }
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (!pendingMount && (disabled || target) && shapeFlag & 16) for(let i = 0; i < children.length; i++){
            const child = children[i];
            unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
        }
    },
    move: $d4b329d0bc8bd329$var$moveTeleport,
    hydrate: $d4b329d0bc8bd329$var$hydrateTeleport
};
function $d4b329d0bc8bd329$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!$d4b329d0bc8bd329$var$pendingMounts.has(vnode) && (!isReorder || $d4b329d0bc8bd329$var$isTeleportDisabled(props))) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $d4b329d0bc8bd329$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    function hydrateAnchor(target2, targetNode) {
        let targetAnchor = targetNode;
        while(targetAnchor){
            if (targetAnchor && targetAnchor.nodeType === 8) {
                if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                else if (targetAnchor.data === "teleport anchor") {
                    vnode.targetAnchor = targetAnchor;
                    target2._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                    break;
                }
            }
            targetAnchor = nextSibling(targetAnchor);
        }
    }
    function hydrateDisabledTeleport(node2, vnode2) {
        vnode2.anchor = hydrateChildren(nextSibling(node2), vnode2, parentNode(node2), parentComponent, parentSuspense, slotScopeIds, optimized);
    }
    const target = vnode.target = $d4b329d0bc8bd329$var$resolveTarget(vnode.props, querySelector);
    const disabled = $d4b329d0bc8bd329$var$isTeleportDisabled(vnode.props);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                hydrateDisabledTeleport(node, vnode);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $d4b329d0bc8bd329$var$prepareAnchor(target, vnode, createText, insert, // if target is the same as the main view, insert anchors before current node
                // to avoid hydrating mismatch
                parentNode(node) === target ? node : null);
            } else {
                vnode.anchor = nextSibling(node);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $d4b329d0bc8bd329$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $d4b329d0bc8bd329$var$updateCssVars(vnode, disabled);
    } else if (disabled) {
        if (vnode.shapeFlag & 16) {
            hydrateDisabledTeleport(node, vnode);
            vnode.targetStart = node;
            vnode.targetAnchor = nextSibling(node);
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $d4b329d0bc8bd329$export$76d55a0304a371f4 = $d4b329d0bc8bd329$var$TeleportImpl;
function $d4b329d0bc8bd329$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $d4b329d0bc8bd329$var$prepareAnchor(target, vnode, createText, insert, anchor = null) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$d4b329d0bc8bd329$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target, anchor);
        insert(targetAnchor, target, anchor);
    }
    return targetAnchor;
}
const $d4b329d0bc8bd329$var$leaveCbKey = /* @__PURE__ */ Symbol("_leaveCb");
const $d4b329d0bc8bd329$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
function $d4b329d0bc8bd329$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $d4b329d0bc8bd329$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $d4b329d0bc8bd329$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $d4b329d0bc8bd329$var$TransitionHookValidator = [
    Function,
    Array
];
const $d4b329d0bc8bd329$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $d4b329d0bc8bd329$var$TransitionHookValidator,
    onEnter: $d4b329d0bc8bd329$var$TransitionHookValidator,
    onAfterEnter: $d4b329d0bc8bd329$var$TransitionHookValidator,
    onEnterCancelled: $d4b329d0bc8bd329$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $d4b329d0bc8bd329$var$TransitionHookValidator,
    onLeave: $d4b329d0bc8bd329$var$TransitionHookValidator,
    onAfterLeave: $d4b329d0bc8bd329$var$TransitionHookValidator,
    onLeaveCancelled: $d4b329d0bc8bd329$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $d4b329d0bc8bd329$var$TransitionHookValidator,
    onAppear: $d4b329d0bc8bd329$var$TransitionHookValidator,
    onAfterAppear: $d4b329d0bc8bd329$var$TransitionHookValidator,
    onAppearCancelled: $d4b329d0bc8bd329$var$TransitionHookValidator
};
const $d4b329d0bc8bd329$var$recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? $d4b329d0bc8bd329$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $d4b329d0bc8bd329$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $d4b329d0bc8bd329$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $d4b329d0bc8bd329$export$f13e630aa3915748();
        const state = $d4b329d0bc8bd329$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $d4b329d0bc8bd329$export$a67f9b1229c7c97a(slots.default(), true);
            const child = children && children.length ? $d4b329d0bc8bd329$var$findNonCommentChild(children) : // Keep explicit default-slot conditionals on the same transition path
            // as regular v-if branches, which render a comment placeholder.
            instance.subTree ? $d4b329d0bc8bd329$export$49553837c7236d3c() : void 0;
            if (!child) return;
            const rawProps = (0, $mHgsT.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $d4b329d0bc8bd329$var$emptyPlaceholder(child);
            const innerChild = $d4b329d0bc8bd329$var$getInnerChild$1(child);
            if (!innerChild) return $d4b329d0bc8bd329$var$emptyPlaceholder(child);
            let enterHooks = $d4b329d0bc8bd329$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $d4b329d0bc8bd329$export$4d299b491347818a) $d4b329d0bc8bd329$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $d4b329d0bc8bd329$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $d4b329d0bc8bd329$export$4d299b491347818a && !$d4b329d0bc8bd329$var$isSameVNodeType(oldInnerChild, innerChild) && $d4b329d0bc8bd329$var$recursiveGetSubtree(instance).type !== $d4b329d0bc8bd329$export$4d299b491347818a) {
                let leavingHooks = $d4b329d0bc8bd329$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $d4b329d0bc8bd329$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $d4b329d0bc8bd329$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $d4b329d0bc8bd329$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $d4b329d0bc8bd329$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $d4b329d0bc8bd329$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$d4b329d0bc8bd329$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$d4b329d0bc8bd329$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $d4b329d0bc8bd329$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $d4b329d0bc8bd329$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $d4b329d0bc8bd329$export$abd95b5f5e8a8837 = $d4b329d0bc8bd329$var$BaseTransitionImpl;
function $d4b329d0bc8bd329$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $d4b329d0bc8bd329$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $d4b329d0bc8bd329$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $d4b329d0bc8bd329$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $oF3Y1.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$d4b329d0bc8bd329$var$leaveCbKey]) el[$d4b329d0bc8bd329$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $d4b329d0bc8bd329$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$d4b329d0bc8bd329$var$leaveCbKey]) leavingVNode.el[$d4b329d0bc8bd329$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            if (!$d4b329d0bc8bd329$var$isHmrUpdating && leavingVNodesCache[key] === vnode) return;
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            el[$d4b329d0bc8bd329$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$d4b329d0bc8bd329$var$enterCbKey] = void 0;
            };
            const done = el[$d4b329d0bc8bd329$var$enterCbKey].bind(null, false);
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$d4b329d0bc8bd329$var$enterCbKey]) el[$d4b329d0bc8bd329$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            el[$d4b329d0bc8bd329$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$d4b329d0bc8bd329$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            const done = el[$d4b329d0bc8bd329$var$leaveCbKey].bind(null, false);
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $d4b329d0bc8bd329$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $d4b329d0bc8bd329$var$emptyPlaceholder(vnode) {
    if ($d4b329d0bc8bd329$var$isKeepAlive(vnode)) {
        vnode = $d4b329d0bc8bd329$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $d4b329d0bc8bd329$var$getInnerChild$1(vnode) {
    if (!$d4b329d0bc8bd329$var$isKeepAlive(vnode)) {
        if ($d4b329d0bc8bd329$var$isTeleport(vnode.type) && vnode.children) return $d4b329d0bc8bd329$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $oF3Y1.isFunction)(children.default)) return children.default();
    }
}
function $d4b329d0bc8bd329$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        $d4b329d0bc8bd329$export$7770a22486565649(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $d4b329d0bc8bd329$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $d4b329d0bc8bd329$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($d4b329d0bc8bd329$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $d4b329d0bc8bd329$export$4d299b491347818a) ret.push(key != null ? $d4b329d0bc8bd329$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
// @__NO_SIDE_EFFECTS__
function $d4b329d0bc8bd329$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $oF3Y1.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $oF3Y1.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $d4b329d0bc8bd329$export$f680877a34711e37() {
    const i = $d4b329d0bc8bd329$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $d4b329d0bc8bd329$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $d4b329d0bc8bd329$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $d4b329d0bc8bd329$export$83a5dbc1f35517ca(key) {
    const i = $d4b329d0bc8bd329$export$f13e630aa3915748();
    const r = (0, $mHgsT.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $oF3Y1.EMPTY_OBJ) ? i.refs = {} : i.refs;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $d4b329d0bc8bd329$var$isTemplateRefKey(refs, key) {
    let desc;
    return !!((desc = Object.getOwnPropertyDescriptor(refs, key)) && !desc.configurable);
}
const $d4b329d0bc8bd329$var$pendingSetRefMap = /* @__PURE__ */ new WeakMap();
function $d4b329d0bc8bd329$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $oF3Y1.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$d4b329d0bc8bd329$var$setRef(r, oldRawRef && ((0, $oF3Y1.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($d4b329d0bc8bd329$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $d4b329d0bc8bd329$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $d4b329d0bc8bd329$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $oF3Y1.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $mHgsT.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $oF3Y1.EMPTY_OBJ) ? (0, $oF3Y1.NO) : (key)=>{
        if ($d4b329d0bc8bd329$var$isTemplateRefKey(refs, key)) return false;
        return (0, $oF3Y1.hasOwn)(rawSetupState, key);
    };
    const canSetRef = (ref2, key)=>{
        if (key && $d4b329d0bc8bd329$var$isTemplateRefKey(refs, key)) return false;
        return true;
    };
    if (oldRef != null && oldRef !== ref) {
        $d4b329d0bc8bd329$var$invalidatePendingSetRef(oldRawRef);
        if ((0, $oF3Y1.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $mHgsT.isRef)(oldRef)) {
            const oldRawRefAtom = oldRawRef;
            if (canSetRef(oldRef, oldRawRefAtom.k)) oldRef.value = null;
            if (oldRawRefAtom.k) refs[oldRawRefAtom.k] = null;
        }
    }
    if ((0, $oF3Y1.isFunction)(ref)) $d4b329d0bc8bd329$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $oF3Y1.isString)(ref);
        const _isRef = (0, $mHgsT.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : canSetRef(ref) || !rawRef.k ? ref.value : refs[rawRef.k];
                    if (isUnmount) (0, $oF3Y1.isArray)(existing) && (0, $oF3Y1.remove)(existing, refValue);
                    else {
                        if (!(0, $oF3Y1.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                const newVal = [
                                    refValue
                                ];
                                if (canSetRef(ref, rawRef.k)) ref.value = newVal;
                                if (rawRef.k) refs[rawRef.k] = newVal;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    if (canSetRef(ref, rawRef.k)) ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                const job = ()=>{
                    doSet();
                    $d4b329d0bc8bd329$var$pendingSetRefMap.delete(rawRef);
                };
                job.id = -1;
                $d4b329d0bc8bd329$var$pendingSetRefMap.set(rawRef, job);
                $d4b329d0bc8bd329$var$queuePostRenderEffect(job, parentSuspense);
            } else {
                $d4b329d0bc8bd329$var$invalidatePendingSetRef(rawRef);
                doSet();
            }
        }
    }
}
function $d4b329d0bc8bd329$var$invalidatePendingSetRef(rawRef) {
    const pendingSetRef = $d4b329d0bc8bd329$var$pendingSetRefMap.get(rawRef);
    if (pendingSetRef) {
        pendingSetRef.flags |= 8;
        $d4b329d0bc8bd329$var$pendingSetRefMap.delete(rawRef);
    }
}
let $d4b329d0bc8bd329$var$hasLoggedMismatchError = false;
const $d4b329d0bc8bd329$var$logMismatchError = ()=>{
    if ($d4b329d0bc8bd329$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $d4b329d0bc8bd329$var$hasLoggedMismatchError = true;
};
const $d4b329d0bc8bd329$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $d4b329d0bc8bd329$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $d4b329d0bc8bd329$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($d4b329d0bc8bd329$var$isSVGContainer(container)) return "svg";
    if ($d4b329d0bc8bd329$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $d4b329d0bc8bd329$var$isComment = (node)=>node.nodeType === 8;
function $d4b329d0bc8bd329$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $d4b329d0bc8bd329$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $d4b329d0bc8bd329$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $d4b329d0bc8bd329$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $d4b329d0bc8bd329$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $oF3Y1.def)(node, "__vnode", vnode, true);
            (0, $oF3Y1.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $d4b329d0bc8bd329$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $d4b329d0bc8bd329$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $d4b329d0bc8bd329$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $d4b329d0bc8bd329$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $d4b329d0bc8bd329$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $d4b329d0bc8bd329$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($d4b329d0bc8bd329$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $d4b329d0bc8bd329$var$getContainerType(container), optimized);
                    if ($d4b329d0bc8bd329$var$isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $d4b329d0bc8bd329$export$bf5c4cf060303d58($d4b329d0bc8bd329$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $d4b329d0bc8bd329$export$22f9b5ffd89dac9("") : $d4b329d0bc8bd329$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $d4b329d0bc8bd329$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $d4b329d0bc8bd329$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $d4b329d0bc8bd329$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, dynamicProps: dynamicProps, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        const hasDynamicProps = !!dynamicProps;
        if (forcePatch || hasDynamicProps || patchFlag !== -1) {
            if (dirs) $d4b329d0bc8bd329$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $d4b329d0bc8bd329$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    const cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                if (next && !$d4b329d0bc8bd329$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $d4b329d0bc8bd329$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                    $d4b329d0bc8bd329$var$logMismatchError();
                }
                while(next){
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                const { textContent: textContent } = el;
                if (textContent !== clientText && // innerHTML normalize \r\n or \r into a single \n in the DOM
                textContent !== clientText.replace(/\r\n|\r/g, "\n")) {
                    if (!$d4b329d0bc8bd329$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $d4b329d0bc8bd329$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${textContent}
  - expected on client: ${clientText}`);
                        $d4b329d0bc8bd329$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || hasDynamicProps || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    const namespace = el.namespaceURI.includes("svg") ? "svg" : el.namespaceURI.includes("MathML") ? "mathml" : void 0;
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $d4b329d0bc8bd329$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $d4b329d0bc8bd329$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $oF3Y1.isOn)(key) && !(0, $oF3Y1.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement && !(0, $oF3Y1.isReservedProp)(key) || dynamicProps && dynamicProps.includes(key)) patchProp(el, key, null, props[key], namespace, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $mHgsT.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $d4b329d0bc8bd329$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $d4b329d0bc8bd329$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $d4b329d0bc8bd329$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $d4b329d0bc8bd329$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $d4b329d0bc8bd329$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasCheckedMismatch = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $d4b329d0bc8bd329$var$normalizeVNode(children[i]);
            const isText = vnode.type === $d4b329d0bc8bd329$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $d4b329d0bc8bd329$var$normalizeVNode(children[i + 1]).type === $d4b329d0bc8bd329$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!hasCheckedMismatch) {
                    hasCheckedMismatch = true;
                    if (!$d4b329d0bc8bd329$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $d4b329d0bc8bd329$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        $d4b329d0bc8bd329$var$logMismatchError();
                    }
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $d4b329d0bc8bd329$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $d4b329d0bc8bd329$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $d4b329d0bc8bd329$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$d4b329d0bc8bd329$var$isNodeMismatchAllowed(node, vnode)) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $d4b329d0bc8bd329$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $d4b329d0bc8bd329$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $d4b329d0bc8bd329$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $d4b329d0bc8bd329$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $d4b329d0bc8bd329$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $d4b329d0bc8bd329$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $d4b329d0bc8bd329$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, $oF3Y1.normalizeClass)(clientValue);
        if (!$d4b329d0bc8bd329$var$isSetEqual($d4b329d0bc8bd329$var$toClassSet(actual || ""), $d4b329d0bc8bd329$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $oF3Y1.isString)(clientValue) ? clientValue : (0, $oF3Y1.stringifyStyle)((0, $oF3Y1.normalizeStyle)(clientValue));
        const actualMap = $d4b329d0bc8bd329$var$toStyleMap(actual);
        const expectedMap = $d4b329d0bc8bd329$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $d4b329d0bc8bd329$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$d4b329d0bc8bd329$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $oF3Y1.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $oF3Y1.isBooleanAttr)(key) || (0, $oF3Y1.isKnownHtmlAttr)(key))) {
        if ((0, $oF3Y1.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $oF3Y1.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $oF3Y1.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$d4b329d0bc8bd329$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$d4b329d0bc8bd329$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $d4b329d0bc8bd329$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $d4b329d0bc8bd329$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $d4b329d0bc8bd329$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $d4b329d0bc8bd329$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $d4b329d0bc8bd329$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $d4b329d0bc8bd329$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $d4b329d0bc8bd329$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars){
            const value = (0, $oF3Y1.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set(`--${(0, $oF3Y1.getEscapedCssVarName)(key, false)}`, value);
        }
    }
    if (vnode === root && instance.parent) $d4b329d0bc8bd329$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $d4b329d0bc8bd329$var$allowMismatchAttr = "data-allow-mismatch";
const $d4b329d0bc8bd329$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $d4b329d0bc8bd329$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($d4b329d0bc8bd329$var$allowMismatchAttr))el = el.parentElement;
    return $d4b329d0bc8bd329$var$isMismatchAllowedByAttr(el && el.getAttribute($d4b329d0bc8bd329$var$allowMismatchAttr), allowedType);
}
function $d4b329d0bc8bd329$var$isMismatchAllowedByAttr(allowedAttr, allowedType) {
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return list.includes($d4b329d0bc8bd329$var$MismatchTypeString[allowedType]);
    }
}
function $d4b329d0bc8bd329$var$isNodeMismatchAllowed(node, vnode) {
    return $d4b329d0bc8bd329$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ ) || $d4b329d0bc8bd329$var$isMismatchAllowedByNode(node) || $d4b329d0bc8bd329$var$isMismatchAllowedByVNode(vnode);
}
function $d4b329d0bc8bd329$var$isMismatchAllowedByNode(node) {
    return node.nodeType === 1 && $d4b329d0bc8bd329$var$isMismatchAllowedByAttr(node.getAttribute($d4b329d0bc8bd329$var$allowMismatchAttr), 1 /* CHILDREN */ );
}
function $d4b329d0bc8bd329$var$isMismatchAllowedByVNode({ props: props }) {
    const allowedAttr = props && props[$d4b329d0bc8bd329$var$allowMismatchAttr];
    return typeof allowedAttr === "string" && $d4b329d0bc8bd329$var$isMismatchAllowedByAttr(allowedAttr, 1 /* CHILDREN */ );
}
const $d4b329d0bc8bd329$var$requestIdleCallback = (0, $oF3Y1.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $d4b329d0bc8bd329$var$cancelIdleCallback = (0, $oF3Y1.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $d4b329d0bc8bd329$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $d4b329d0bc8bd329$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$d4b329d0bc8bd329$var$cancelIdleCallback(id);
    };
function $d4b329d0bc8bd329$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $d4b329d0bc8bd329$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if ($d4b329d0bc8bd329$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const $d4b329d0bc8bd329$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $d4b329d0bc8bd329$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $oF3Y1.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $d4b329d0bc8bd329$var$forEachElement(node, cb) {
    if ($d4b329d0bc8bd329$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($d4b329d0bc8bd329$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $d4b329d0bc8bd329$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
// @__NO_SIDE_EFFECTS__
function $d4b329d0bc8bd329$export$d75d499b4c16cf21(source) {
    if ((0, $oF3Y1.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $d4b329d0bc8bd329$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            const wasConnected = el.isConnected;
            let patched = false;
            (instance.bu || (instance.bu = [])).push(()=>patched = true);
            const performHydrate = ()=>{
                if (patched) return;
                if (!el.parentNode || wasConnected && !el.isConnected) return;
                hydrate();
            };
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(performHydrate, (cb)=>$d4b329d0bc8bd329$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : performHydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $d4b329d0bc8bd329$var$currentInstance;
            $d4b329d0bc8bd329$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$d4b329d0bc8bd329$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $d4b329d0bc8bd329$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $d4b329d0bc8bd329$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$d4b329d0bc8bd329$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $d4b329d0bc8bd329$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $mHgsT.ref)(false);
            const error = (0, $mHgsT.ref)();
            const delayed = (0, $mHgsT.ref)(!!delay);
            let timeoutTimer;
            let delayTimer;
            $d4b329d0bc8bd329$export$13348a43ccacfe58(()=>{
                if (timeoutTimer != null) clearTimeout(timeoutTimer);
                if (delayTimer != null) clearTimeout(delayTimer);
            });
            if (delay) delayTimer = setTimeout(()=>{
                if (instance.isUnmounted) return;
                delayed.value = false;
            }, delay);
            if (timeout != null) timeoutTimer = setTimeout(()=>{
                if (instance.isUnmounted) return;
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                if (instance.isUnmounted) return;
                loaded.value = true;
                if (instance.parent && $d4b329d0bc8bd329$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                if (instance.isUnmounted) {
                    pendingRequest = null;
                    return;
                }
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $d4b329d0bc8bd329$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $d4b329d0bc8bd329$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $d4b329d0bc8bd329$var$createInnerComp(loadingComponent, instance);
            };
        }
    });
}
function $d4b329d0bc8bd329$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $d4b329d0bc8bd329$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $d4b329d0bc8bd329$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $d4b329d0bc8bd329$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $d4b329d0bc8bd329$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $d4b329d0bc8bd329$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $oF3Y1.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $d4b329d0bc8bd329$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $d4b329d0bc8bd329$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $d4b329d0bc8bd329$var$invalidateMount(instance2.m);
            $d4b329d0bc8bd329$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $d4b329d0bc8bd329$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $oF3Y1.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $d4b329d0bc8bd329$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $d4b329d0bc8bd329$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $d4b329d0bc8bd329$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $d4b329d0bc8bd329$var$getComponentName($d4b329d0bc8bd329$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$d4b329d0bc8bd329$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $d4b329d0bc8bd329$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $d4b329d0bc8bd329$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$d4b329d0bc8bd329$var$matches(include, name));
            exclude && pruneCache((name)=>!$d4b329d0bc8bd329$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($d4b329d0bc8bd329$var$isSuspense(instance.subTree.type)) $d4b329d0bc8bd329$var$queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, $d4b329d0bc8bd329$var$getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $d4b329d0bc8bd329$var$getInnerChild(instance.subTree));
            }
        };
        $d4b329d0bc8bd329$export$6d1641039221b5cb(cacheSubtree);
        $d4b329d0bc8bd329$export$5876c47052fb88b1(cacheSubtree);
        $d4b329d0bc8bd329$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $d4b329d0bc8bd329$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $d4b329d0bc8bd329$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $d4b329d0bc8bd329$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$d4b329d0bc8bd329$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $d4b329d0bc8bd329$var$getInnerChild(rawVNode);
            if (vnode.type === $d4b329d0bc8bd329$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $d4b329d0bc8bd329$var$getComponentName($d4b329d0bc8bd329$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$d4b329d0bc8bd329$var$matches(include, name)) || exclude && name && $d4b329d0bc8bd329$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $d4b329d0bc8bd329$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $d4b329d0bc8bd329$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $d4b329d0bc8bd329$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $d4b329d0bc8bd329$export$70eb8a58709972df = $d4b329d0bc8bd329$var$KeepAliveImpl;
function $d4b329d0bc8bd329$var$matches(pattern, name) {
    if ((0, $oF3Y1.isArray)(pattern)) return pattern.some((p)=>$d4b329d0bc8bd329$var$matches(p, name));
    else if ((0, $oF3Y1.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $oF3Y1.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $d4b329d0bc8bd329$export$ba52d824b95a2154(hook, target) {
    $d4b329d0bc8bd329$var$registerKeepAliveHook(hook, "a", target);
}
function $d4b329d0bc8bd329$export$bf1440eeaf5fa709(hook, target) {
    $d4b329d0bc8bd329$var$registerKeepAliveHook(hook, "da", target);
}
function $d4b329d0bc8bd329$var$registerKeepAliveHook(hook, type, target = $d4b329d0bc8bd329$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $d4b329d0bc8bd329$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($d4b329d0bc8bd329$var$isKeepAlive(current.parent.vnode)) $d4b329d0bc8bd329$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $d4b329d0bc8bd329$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $d4b329d0bc8bd329$var$injectHook(type, hook, keepAliveRoot, true);
    $d4b329d0bc8bd329$export$13348a43ccacfe58(()=>{
        (0, $oF3Y1.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $d4b329d0bc8bd329$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $d4b329d0bc8bd329$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $d4b329d0bc8bd329$var$injectHook(type, hook, target = $d4b329d0bc8bd329$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $mHgsT.pauseTracking)();
            const reset = $d4b329d0bc8bd329$var$setCurrentInstance(target);
            const res = $d4b329d0bc8bd329$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $mHgsT.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $d4b329d0bc8bd329$var$createHook = (lifecycle)=>(hook, target = $d4b329d0bc8bd329$var$currentInstance)=>{
        if (!$d4b329d0bc8bd329$var$isInSSRComponentSetup || lifecycle === "sp") $d4b329d0bc8bd329$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $d4b329d0bc8bd329$export$23b7aeb0d671f804 = $d4b329d0bc8bd329$var$createHook("bm");
const $d4b329d0bc8bd329$export$6d1641039221b5cb = $d4b329d0bc8bd329$var$createHook("m");
const $d4b329d0bc8bd329$export$ab91988a13872e4c = $d4b329d0bc8bd329$var$createHook("bu");
const $d4b329d0bc8bd329$export$5876c47052fb88b1 = $d4b329d0bc8bd329$var$createHook("u");
const $d4b329d0bc8bd329$export$40c420df62d2614 = $d4b329d0bc8bd329$var$createHook("bum");
const $d4b329d0bc8bd329$export$13348a43ccacfe58 = $d4b329d0bc8bd329$var$createHook("um");
const $d4b329d0bc8bd329$export$ebf0c601f267bceb = $d4b329d0bc8bd329$var$createHook("sp");
const $d4b329d0bc8bd329$export$898295a813d662eb = $d4b329d0bc8bd329$var$createHook("rtg");
const $d4b329d0bc8bd329$export$2b41f4235363e921 = $d4b329d0bc8bd329$var$createHook("rtc");
function $d4b329d0bc8bd329$export$6a3a15856e50ad19(hook, target = $d4b329d0bc8bd329$var$currentInstance) {
    $d4b329d0bc8bd329$var$injectHook("ec", hook, target);
}
const $d4b329d0bc8bd329$var$COMPONENTS = "components";
const $d4b329d0bc8bd329$var$DIRECTIVES = "directives";
function $d4b329d0bc8bd329$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $d4b329d0bc8bd329$var$resolveAsset($d4b329d0bc8bd329$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $d4b329d0bc8bd329$var$NULL_DYNAMIC_COMPONENT = /* @__PURE__ */ Symbol.for("v-ndc");
function $d4b329d0bc8bd329$export$b44c564a05ca975(component) {
    if ((0, $oF3Y1.isString)(component)) return $d4b329d0bc8bd329$var$resolveAsset($d4b329d0bc8bd329$var$COMPONENTS, component, false) || component;
    else return component || $d4b329d0bc8bd329$var$NULL_DYNAMIC_COMPONENT;
}
function $d4b329d0bc8bd329$export$a1989e995cd481be(name) {
    return $d4b329d0bc8bd329$var$resolveAsset($d4b329d0bc8bd329$var$DIRECTIVES, name);
}
function $d4b329d0bc8bd329$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $d4b329d0bc8bd329$var$currentRenderingInstance || $d4b329d0bc8bd329$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $d4b329d0bc8bd329$var$COMPONENTS) {
            const selfName = $d4b329d0bc8bd329$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $oF3Y1.camelize)(name) || selfName === (0, $oF3Y1.capitalize)((0, $oF3Y1.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $d4b329d0bc8bd329$var$resolve(instance[type] || Component[type], name) || // global registration
        $d4b329d0bc8bd329$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $d4b329d0bc8bd329$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $oF3Y1.camelize)(name)] || registry[(0, $oF3Y1.capitalize)((0, $oF3Y1.camelize)(name))]);
}
function $d4b329d0bc8bd329$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $oF3Y1.isArray)(source);
    if (sourceIsArray || (0, $oF3Y1.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $mHgsT.isReactive)(source);
        let needsWrap = false;
        let isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $mHgsT.isShallow)(source);
            isReadonlySource = (0, $mHgsT.isReadonly)(source);
            source = (0, $mHgsT.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $mHgsT.toReadonly)((0, $mHgsT.toReactive)(source[i])) : (0, $mHgsT.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $oF3Y1.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $d4b329d0bc8bd329$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $oF3Y1.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $d4b329d0bc8bd329$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted, branchKey) {
    if ($d4b329d0bc8bd329$var$currentRenderingInstance.ce || $d4b329d0bc8bd329$var$currentRenderingInstance.parent && $d4b329d0bc8bd329$var$isAsyncWrapper($d4b329d0bc8bd329$var$currentRenderingInstance.parent) && $d4b329d0bc8bd329$var$currentRenderingInstance.parent.ce) {
        const slotProps = branchKey != null && props.key == null ? (0, $oF3Y1.extend)({}, props, {
            key: branchKey
        }) : props;
        const hasProps = Object.keys(slotProps).length > 0;
        if (name !== "default") slotProps.name = name;
        return $d4b329d0bc8bd329$export$e7eaa45e502fe5cc(), $d4b329d0bc8bd329$export$9f2dfe8048dfb22b($d4b329d0bc8bd329$export$ffb0004e005737fa, null, [
            $d4b329d0bc8bd329$export$bf5c4cf060303d58("slot", slotProps, fallback && fallback())
        ], hasProps ? -2 : 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    const prevStackSize = $d4b329d0bc8bd329$var$blockStack.length;
    $d4b329d0bc8bd329$export$e7eaa45e502fe5cc();
    let rendered;
    try {
        const validSlotContent = slot && $d4b329d0bc8bd329$var$ensureValidVNode(slot(props));
        const slotKey = props.key || branchKey || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key;
        rendered = $d4b329d0bc8bd329$export$9f2dfe8048dfb22b($d4b329d0bc8bd329$export$ffb0004e005737fa, {
            key: (slotKey && !(0, $oF3Y1.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
            (!validSlotContent && fallback ? "_fb" : "")
        }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    } catch (err) {
        for(let i = $d4b329d0bc8bd329$var$blockStack.length; i > prevStackSize; i--)$d4b329d0bc8bd329$var$closeBlock();
        throw err;
    } finally{
        if (slot && slot._c) slot._d = true;
    }
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    return rendered;
}
function $d4b329d0bc8bd329$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$d4b329d0bc8bd329$export$3868d13f8734ae81(child)) return true;
        if (child.type === $d4b329d0bc8bd329$export$4d299b491347818a) return false;
        if (child.type === $d4b329d0bc8bd329$export$ffb0004e005737fa && !$d4b329d0bc8bd329$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $d4b329d0bc8bd329$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $oF3Y1.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $d4b329d0bc8bd329$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($d4b329d0bc8bd329$var$isStatefulComponent(i)) return $d4b329d0bc8bd329$var$getComponentPublicInstance(i);
    return $d4b329d0bc8bd329$var$getPublicInstance(i.parent);
};
const $d4b329d0bc8bd329$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $oF3Y1.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$d4b329d0bc8bd329$var$getPublicInstance(i.parent),
    $root: (i)=>$d4b329d0bc8bd329$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $d4b329d0bc8bd329$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $d4b329d0bc8bd329$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $d4b329d0bc8bd329$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $d4b329d0bc8bd329$var$instanceWatch.bind(i) : (0, $oF3Y1.NOOP)
});
const $d4b329d0bc8bd329$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $d4b329d0bc8bd329$var$hasSetupBinding = (state, key)=>state !== (0, $oF3Y1.EMPTY_OBJ) && !state.__isScriptSetup && (0, $oF3Y1.hasOwn)(state, key);
const $d4b329d0bc8bd329$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($d4b329d0bc8bd329$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (__VUE_OPTIONS_API__ && data !== (0, $oF3Y1.EMPTY_OBJ) && (0, $oF3Y1.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if ((0, $oF3Y1.hasOwn)(props, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $oF3Y1.EMPTY_OBJ) && (0, $oF3Y1.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $d4b329d0bc8bd329$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $d4b329d0bc8bd329$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $mHgsT.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $oF3Y1.EMPTY_OBJ) && (0, $oF3Y1.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $oF3Y1.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($d4b329d0bc8bd329$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (__VUE_OPTIONS_API__ && data !== (0, $oF3Y1.EMPTY_OBJ) && (0, $oF3Y1.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $oF3Y1.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, props: props, type: type } }, key) {
        let cssModules;
        return !!(accessCache[key] || __VUE_OPTIONS_API__ && data !== (0, $oF3Y1.EMPTY_OBJ) && key[0] !== "$" && (0, $oF3Y1.hasOwn)(data, key) || $d4b329d0bc8bd329$var$hasSetupBinding(setupState, key) || (0, $oF3Y1.hasOwn)(props, key) || (0, $oF3Y1.hasOwn)(ctx, key) || (0, $oF3Y1.hasOwn)($d4b329d0bc8bd329$var$publicPropertiesMap, key) || (0, $oF3Y1.hasOwn)(appContext.config.globalProperties, key) || (cssModules = type.__cssModules) && cssModules[key]);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $oF3Y1.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $d4b329d0bc8bd329$var$target;
const $d4b329d0bc8bd329$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $oF3Y1.extend)({}, $d4b329d0bc8bd329$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $d4b329d0bc8bd329$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $oF3Y1.isGloballyAllowed)(key);
        return has;
    }
});
function $d4b329d0bc8bd329$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($d4b329d0bc8bd329$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$d4b329d0bc8bd329$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $oF3Y1.NOOP)
        });
    });
    return target;
}
function $d4b329d0bc8bd329$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $oF3Y1.NOOP)
        });
    });
}
function $d4b329d0bc8bd329$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $mHgsT.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($d4b329d0bc8bd329$var$isReservedPrefix(key[0])) {
                $d4b329d0bc8bd329$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $oF3Y1.NOOP)
            });
        }
    });
}
const $d4b329d0bc8bd329$var$warnRuntimeUsage = (method)=>$d4b329d0bc8bd329$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $d4b329d0bc8bd329$export$80b33eababae110e() {
    return null;
}
function $d4b329d0bc8bd329$export$51ecece22fc17ddc() {
    return null;
}
function $d4b329d0bc8bd329$export$da25b65ca24b518a(exposed) {}
function $d4b329d0bc8bd329$export$77e79129327f3d0d(options) {}
function $d4b329d0bc8bd329$export$1b3acd4bb805b712() {
    return null;
}
function $d4b329d0bc8bd329$export$acd55aa037e791bb() {}
function $d4b329d0bc8bd329$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $d4b329d0bc8bd329$export$9203a8e84125433c() {
    return $d4b329d0bc8bd329$var$getContext("useSlots").slots;
}
function $d4b329d0bc8bd329$export$75e29435042cd2ea() {
    return $d4b329d0bc8bd329$var$getContext("useAttrs").attrs;
}
function $d4b329d0bc8bd329$var$getContext(calledFunctionName) {
    const i = $d4b329d0bc8bd329$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $d4b329d0bc8bd329$var$createSetupContext(i));
}
function $d4b329d0bc8bd329$var$normalizePropsOrEmits(props) {
    return (0, $oF3Y1.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $d4b329d0bc8bd329$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $d4b329d0bc8bd329$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $oF3Y1.isArray)(opt) || (0, $oF3Y1.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $d4b329d0bc8bd329$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $oF3Y1.isArray)(a) && (0, $oF3Y1.isArray)(b)) return a.concat(b);
    return (0, $oF3Y1.extend)({}, $d4b329d0bc8bd329$var$normalizePropsOrEmits(a), $d4b329d0bc8bd329$var$normalizePropsOrEmits(b));
}
function $d4b329d0bc8bd329$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $d4b329d0bc8bd329$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $d4b329d0bc8bd329$export$f13e630aa3915748();
    const inSSRSetup = $d4b329d0bc8bd329$var$isInSSRComponentSetup;
    let awaitable = getAwaitable();
    $d4b329d0bc8bd329$var$unsetCurrentInstance();
    if (inSSRSetup) $d4b329d0bc8bd329$var$setInSSRSetupState(false);
    const restore = ()=>{
        $d4b329d0bc8bd329$var$setCurrentInstance(ctx);
        if (inSSRSetup) $d4b329d0bc8bd329$var$setInSSRSetupState(true);
    };
    const cleanup = ()=>{
        if ($d4b329d0bc8bd329$export$f13e630aa3915748() !== ctx) ctx.scope.off();
        $d4b329d0bc8bd329$var$unsetCurrentInstance();
        if (inSSRSetup) $d4b329d0bc8bd329$var$setInSSRSetupState(false);
    };
    if ((0, $oF3Y1.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        restore();
        Promise.resolve().then(()=>Promise.resolve().then(cleanup));
        throw e;
    });
    return [
        awaitable,
        ()=>{
            restore();
            Promise.resolve().then(cleanup);
        }
    ];
}
function $d4b329d0bc8bd329$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $d4b329d0bc8bd329$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $d4b329d0bc8bd329$var$shouldCacheAccess = true;
function $d4b329d0bc8bd329$var$applyOptions(instance) {
    const options = $d4b329d0bc8bd329$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $d4b329d0bc8bd329$var$shouldCacheAccess = false;
    if (options.beforeCreate) $d4b329d0bc8bd329$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $d4b329d0bc8bd329$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $oF3Y1.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $oF3Y1.isObject)(data)) ;
        else instance.data = (0, $mHgsT.reactive)(data);
    }
    $d4b329d0bc8bd329$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $oF3Y1.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $oF3Y1.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $oF3Y1.NOOP);
        const set = !(0, $oF3Y1.isFunction)(opt) && (0, $oF3Y1.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $oF3Y1.NOOP);
        const c = $d4b329d0bc8bd329$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$d4b329d0bc8bd329$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $oF3Y1.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $d4b329d0bc8bd329$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $d4b329d0bc8bd329$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $oF3Y1.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($d4b329d0bc8bd329$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($d4b329d0bc8bd329$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($d4b329d0bc8bd329$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($d4b329d0bc8bd329$export$5876c47052fb88b1, updated);
    registerLifecycleHook($d4b329d0bc8bd329$export$ba52d824b95a2154, activated);
    registerLifecycleHook($d4b329d0bc8bd329$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($d4b329d0bc8bd329$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($d4b329d0bc8bd329$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($d4b329d0bc8bd329$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($d4b329d0bc8bd329$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($d4b329d0bc8bd329$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($d4b329d0bc8bd329$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $oF3Y1.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val,
                    enumerable: true
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $oF3Y1.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $d4b329d0bc8bd329$var$markAsyncBoundary(instance);
}
function $d4b329d0bc8bd329$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $oF3Y1.NOOP)) {
    if ((0, $oF3Y1.isArray)(injectOptions)) injectOptions = $d4b329d0bc8bd329$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $oF3Y1.isObject)(opt)) {
            if ("default" in opt) injected = $d4b329d0bc8bd329$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $d4b329d0bc8bd329$export$a976684a0efeb93f(opt.from || key);
        } else injected = $d4b329d0bc8bd329$export$a976684a0efeb93f(opt);
        if ((0, $mHgsT.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $d4b329d0bc8bd329$var$callHook(hook, instance, type) {
    $d4b329d0bc8bd329$export$dae85862a8d94378((0, $oF3Y1.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $d4b329d0bc8bd329$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $d4b329d0bc8bd329$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $oF3Y1.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $oF3Y1.isFunction)(handler)) $d4b329d0bc8bd329$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $oF3Y1.isFunction)(raw)) $d4b329d0bc8bd329$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $oF3Y1.isObject)(raw)) {
        if ((0, $oF3Y1.isArray)(raw)) raw.forEach((r)=>$d4b329d0bc8bd329$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $oF3Y1.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $oF3Y1.isFunction)(handler)) $d4b329d0bc8bd329$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $d4b329d0bc8bd329$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$d4b329d0bc8bd329$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $d4b329d0bc8bd329$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $oF3Y1.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $d4b329d0bc8bd329$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $d4b329d0bc8bd329$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$d4b329d0bc8bd329$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $d4b329d0bc8bd329$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $d4b329d0bc8bd329$var$internalOptionMergeStrats = {
    data: $d4b329d0bc8bd329$var$mergeDataFn,
    props: $d4b329d0bc8bd329$var$mergeEmitsOrPropsOptions,
    emits: $d4b329d0bc8bd329$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $d4b329d0bc8bd329$var$mergeObjectOptions,
    computed: $d4b329d0bc8bd329$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $d4b329d0bc8bd329$var$mergeAsArray,
    created: $d4b329d0bc8bd329$var$mergeAsArray,
    beforeMount: $d4b329d0bc8bd329$var$mergeAsArray,
    mounted: $d4b329d0bc8bd329$var$mergeAsArray,
    beforeUpdate: $d4b329d0bc8bd329$var$mergeAsArray,
    updated: $d4b329d0bc8bd329$var$mergeAsArray,
    beforeDestroy: $d4b329d0bc8bd329$var$mergeAsArray,
    beforeUnmount: $d4b329d0bc8bd329$var$mergeAsArray,
    destroyed: $d4b329d0bc8bd329$var$mergeAsArray,
    unmounted: $d4b329d0bc8bd329$var$mergeAsArray,
    activated: $d4b329d0bc8bd329$var$mergeAsArray,
    deactivated: $d4b329d0bc8bd329$var$mergeAsArray,
    errorCaptured: $d4b329d0bc8bd329$var$mergeAsArray,
    serverPrefetch: $d4b329d0bc8bd329$var$mergeAsArray,
    // assets
    components: $d4b329d0bc8bd329$var$mergeObjectOptions,
    directives: $d4b329d0bc8bd329$var$mergeObjectOptions,
    // watch
    watch: $d4b329d0bc8bd329$var$mergeWatchOptions,
    // provide / inject
    provide: $d4b329d0bc8bd329$var$mergeDataFn,
    inject: $d4b329d0bc8bd329$var$mergeInject
};
function $d4b329d0bc8bd329$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $oF3Y1.extend)((0, $oF3Y1.isFunction)(to) ? to.call(this, this) : to, (0, $oF3Y1.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $d4b329d0bc8bd329$var$mergeInject(to, from) {
    return $d4b329d0bc8bd329$var$mergeObjectOptions($d4b329d0bc8bd329$var$normalizeInject(to), $d4b329d0bc8bd329$var$normalizeInject(from));
}
function $d4b329d0bc8bd329$var$normalizeInject(raw) {
    if ((0, $oF3Y1.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $d4b329d0bc8bd329$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $d4b329d0bc8bd329$var$mergeObjectOptions(to, from) {
    return to ? (0, $oF3Y1.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $d4b329d0bc8bd329$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $oF3Y1.isArray)(to) && (0, $oF3Y1.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $oF3Y1.extend)(/* @__PURE__ */ Object.create(null), $d4b329d0bc8bd329$var$normalizePropsOrEmits(to), $d4b329d0bc8bd329$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $d4b329d0bc8bd329$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $oF3Y1.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $d4b329d0bc8bd329$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $d4b329d0bc8bd329$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $oF3Y1.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $d4b329d0bc8bd329$var$uid$1 = 0;
function $d4b329d0bc8bd329$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $oF3Y1.isFunction)(rootComponent)) rootComponent = (0, $oF3Y1.extend)({}, rootComponent);
        if (rootProps != null && !(0, $oF3Y1.isObject)(rootProps)) rootProps = null;
        const context = $d4b329d0bc8bd329$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $d4b329d0bc8bd329$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $d4b329d0bc8bd329$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $oF3Y1.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $oF3Y1.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $d4b329d0bc8bd329$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $d4b329d0bc8bd329$var$devtoolsInitApp(app, $d4b329d0bc8bd329$export$83d89fbfd8236492);
                    }
                    return $d4b329d0bc8bd329$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $d4b329d0bc8bd329$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $d4b329d0bc8bd329$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $d4b329d0bc8bd329$var$currentApp;
                $d4b329d0bc8bd329$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $d4b329d0bc8bd329$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $d4b329d0bc8bd329$var$currentApp = null;
function $d4b329d0bc8bd329$export$fb78bd113157f1a1(props, name, options = (0, $oF3Y1.EMPTY_OBJ)) {
    const i = $d4b329d0bc8bd329$export$f13e630aa3915748();
    const camelizedName = (0, $oF3Y1.camelize)(name);
    const hyphenatedName = (0, $oF3Y1.hyphenate)(name);
    const modifiers = $d4b329d0bc8bd329$var$getModelModifiers(props, camelizedName);
    const res = (0, $mHgsT.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $oF3Y1.EMPTY_OBJ);
        let prevEmittedValue;
        $d4b329d0bc8bd329$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $oF3Y1.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $oF3Y1.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $oF3Y1.EMPTY_OBJ) && (0, $oF3Y1.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                const hasVModel = !!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps));
                if (!hasVModel) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $oF3Y1.hasChanged)(value, prevSetValue) && ((0, $oF3Y1.hasChanged)(value, emittedValue) && !(0, $oF3Y1.hasChanged)(emittedValue, prevEmittedValue) || // #13524: browsers differ in when they flush microtasks between
                // event listeners. If a v-model listener emits an intermediate value
                // and a following listener restores the model to its previous prop
                // value before parent updates are flushed, the parent render can be
                // deduped as having no prop change. Force a local update so DOM state
                // such as an input's value is synchronized back to the current model.
                hasVModel && prevSetValue !== (0, $oF3Y1.EMPTY_OBJ) && !(0, $oF3Y1.hasChanged)(emittedValue, localValue))) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $oF3Y1.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $d4b329d0bc8bd329$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $oF3Y1.camelize)(modelName)}Modifiers`] || props[`${(0, $oF3Y1.hyphenate)(modelName)}Modifiers`];
};
function $d4b329d0bc8bd329$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $oF3Y1.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $d4b329d0bc8bd329$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $oF3Y1.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, $oF3Y1.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $d4b329d0bc8bd329$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $oF3Y1.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $oF3Y1.toHandlerKey)((0, $oF3Y1.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $oF3Y1.toHandlerKey)((0, $oF3Y1.hyphenate)(event))];
    if (handler) $d4b329d0bc8bd329$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $d4b329d0bc8bd329$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
const $d4b329d0bc8bd329$var$mixinEmitsCache = /* @__PURE__ */ new WeakMap();
function $d4b329d0bc8bd329$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $d4b329d0bc8bd329$var$mixinEmitsCache : appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $oF3Y1.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $d4b329d0bc8bd329$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $oF3Y1.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $oF3Y1.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $oF3Y1.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $oF3Y1.extend)(normalized, raw);
    if ((0, $oF3Y1.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $d4b329d0bc8bd329$var$isEmitListener(options, key) {
    if (!options || !(0, $oF3Y1.isOn)(key)) return false;
    key = key.slice(2);
    key = key === "Once" ? key : key.replace(/Once$/, "");
    return (0, $oF3Y1.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $oF3Y1.hasOwn)(options, (0, $oF3Y1.hyphenate)(key)) || (0, $oF3Y1.hasOwn)(options, key);
}
let $d4b329d0bc8bd329$var$accessedAttrs = false;
function $d4b329d0bc8bd329$var$markAttrsAccessed() {
    $d4b329d0bc8bd329$var$accessedAttrs = true;
}
function $d4b329d0bc8bd329$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $d4b329d0bc8bd329$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $d4b329d0bc8bd329$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $d4b329d0bc8bd329$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $d4b329d0bc8bd329$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $d4b329d0bc8bd329$var$blockStack.length = 0;
        $d4b329d0bc8bd329$export$d3da1ecaf1206c58(err, instance, 1);
        result = $d4b329d0bc8bd329$export$bf5c4cf060303d58($d4b329d0bc8bd329$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $oF3Y1.isModelListener))) fallthroughAttrs = $d4b329d0bc8bd329$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $d4b329d0bc8bd329$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $d4b329d0bc8bd329$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) $d4b329d0bc8bd329$export$7770a22486565649(root, vnode.transition);
    result = root;
    $d4b329d0bc8bd329$var$setCurrentRenderingInstance(prev);
    return result;
}
const $d4b329d0bc8bd329$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $d4b329d0bc8bd329$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $d4b329d0bc8bd329$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $d4b329d0bc8bd329$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($d4b329d0bc8bd329$export$3868d13f8734ae81(child)) {
            if (child.type !== $d4b329d0bc8bd329$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $d4b329d0bc8bd329$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $oF3Y1.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $d4b329d0bc8bd329$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $oF3Y1.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $d4b329d0bc8bd329$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $d4b329d0bc8bd329$export$4d299b491347818a;
};
function $d4b329d0bc8bd329$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $d4b329d0bc8bd329$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if ($d4b329d0bc8bd329$var$hasPropValueChanged(nextProps, prevProps, key) && !$d4b329d0bc8bd329$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $d4b329d0bc8bd329$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $d4b329d0bc8bd329$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if ($d4b329d0bc8bd329$var$hasPropValueChanged(nextProps, prevProps, key) && !$d4b329d0bc8bd329$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $d4b329d0bc8bd329$var$hasPropValueChanged(nextProps, prevProps, key) {
    const nextProp = nextProps[key];
    const prevProp = prevProps[key];
    if (key === "style" && (0, $oF3Y1.isObject)(nextProp) && (0, $oF3Y1.isObject)(prevProp)) return !(0, $oF3Y1.looseEqual)(nextProp, prevProp);
    return nextProp !== prevProp;
}
function $d4b329d0bc8bd329$var$updateHOCHostEl({ vnode: vnode, parent: parent, suspense: suspense }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) {
            root.suspense.vnode.el = root.el = el;
            vnode = root;
        }
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
    if (suspense && suspense.activeBranch === vnode) suspense.vnode.el = el;
}
const $d4b329d0bc8bd329$var$internalObjectProto = {};
const $d4b329d0bc8bd329$var$createInternalObject = ()=>Object.create($d4b329d0bc8bd329$var$internalObjectProto);
const $d4b329d0bc8bd329$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $d4b329d0bc8bd329$var$internalObjectProto;
function $d4b329d0bc8bd329$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $d4b329d0bc8bd329$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $d4b329d0bc8bd329$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $mHgsT.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $d4b329d0bc8bd329$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $d4b329d0bc8bd329$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $mHgsT.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($d4b329d0bc8bd329$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $oF3Y1.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $oF3Y1.camelize)(key);
                        props[camelizedKey] = $d4b329d0bc8bd329$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($d4b329d0bc8bd329$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $oF3Y1.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $oF3Y1.hyphenate)(key)) === key || !(0, $oF3Y1.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $d4b329d0bc8bd329$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $oF3Y1.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $mHgsT.trigger)(instance.attrs, "set", "");
}
function $d4b329d0bc8bd329$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $oF3Y1.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $oF3Y1.hasOwn)(options, camelKey = (0, $oF3Y1.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$d4b329d0bc8bd329$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $mHgsT.toRaw)(props);
        const castValues = rawCastValues || (0, $oF3Y1.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $d4b329d0bc8bd329$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $oF3Y1.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $d4b329d0bc8bd329$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $oF3Y1.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $oF3Y1.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $d4b329d0bc8bd329$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $oF3Y1.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $d4b329d0bc8bd329$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $d4b329d0bc8bd329$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $d4b329d0bc8bd329$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $oF3Y1.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $d4b329d0bc8bd329$var$normalizePropsOptions(raw2, appContext, true);
            (0, $oF3Y1.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $oF3Y1.isObject)(comp)) cache.set(comp, (0, $oF3Y1.EMPTY_ARR));
        return 0, $oF3Y1.EMPTY_ARR;
    }
    if ((0, $oF3Y1.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $oF3Y1.camelize)(raw[i]);
        if ($d4b329d0bc8bd329$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $oF3Y1.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $oF3Y1.camelize)(key);
        if ($d4b329d0bc8bd329$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $oF3Y1.isArray)(opt) || (0, $oF3Y1.isFunction)(opt) ? {
                type: opt
            } : (0, $oF3Y1.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $oF3Y1.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $oF3Y1.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $oF3Y1.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $oF3Y1.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $oF3Y1.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $d4b329d0bc8bd329$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $oF3Y1.isReservedProp)(key)) return true;
    return false;
}
function $d4b329d0bc8bd329$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $d4b329d0bc8bd329$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $mHgsT.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $oF3Y1.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $d4b329d0bc8bd329$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $d4b329d0bc8bd329$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $d4b329d0bc8bd329$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $oF3Y1.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $d4b329d0bc8bd329$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $d4b329d0bc8bd329$var$warn$1($d4b329d0bc8bd329$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $d4b329d0bc8bd329$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $d4b329d0bc8bd329$var$isSimpleType = /* @__PURE__ */ (0, $oF3Y1.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $d4b329d0bc8bd329$var$assertType(value, type) {
    let valid;
    const expectedType = $d4b329d0bc8bd329$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($d4b329d0bc8bd329$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $oF3Y1.isObject)(value);
    else if (expectedType === "Array") valid = (0, $oF3Y1.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $d4b329d0bc8bd329$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $oF3Y1.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $oF3Y1.toRawType)(value);
    const expectedValue = $d4b329d0bc8bd329$var$styleValue(value, expectedType);
    const receivedValue = $d4b329d0bc8bd329$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $d4b329d0bc8bd329$var$isExplicable(expectedType) && $d4b329d0bc8bd329$var$isCoercible(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($d4b329d0bc8bd329$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $d4b329d0bc8bd329$var$styleValue(value, type) {
    if ((0, $oF3Y1.isSymbol)(value)) return value.toString();
    else if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $d4b329d0bc8bd329$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $d4b329d0bc8bd329$var$isCoercible(...args) {
    return args.every((elem)=>{
        const value = elem.toLowerCase();
        return value !== "boolean" && value !== "symbol";
    });
}
const $d4b329d0bc8bd329$var$isInternalKey = (key)=>key === "_" || key === "_ctx" || key === "$stable";
const $d4b329d0bc8bd329$var$normalizeSlotValue = (value)=>(0, $oF3Y1.isArray)(value) ? value.map($d4b329d0bc8bd329$var$normalizeVNode) : [
        $d4b329d0bc8bd329$var$normalizeVNode(value)
    ];
const $d4b329d0bc8bd329$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $d4b329d0bc8bd329$export$694b237e827a3d23((...args)=>{
        return $d4b329d0bc8bd329$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $d4b329d0bc8bd329$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($d4b329d0bc8bd329$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $oF3Y1.isFunction)(value)) slots[key] = $d4b329d0bc8bd329$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $d4b329d0bc8bd329$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $d4b329d0bc8bd329$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $d4b329d0bc8bd329$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $d4b329d0bc8bd329$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || !$d4b329d0bc8bd329$var$isInternalKey(key)) slots[key] = children[key];
};
const $d4b329d0bc8bd329$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $d4b329d0bc8bd329$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $d4b329d0bc8bd329$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $oF3Y1.def)(slots, "_", type, true);
        } else $d4b329d0bc8bd329$var$normalizeObjectSlots(children, slots);
    } else if (children) $d4b329d0bc8bd329$var$normalizeVNodeSlots(instance, children);
};
const $d4b329d0bc8bd329$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $oF3Y1.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $d4b329d0bc8bd329$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $d4b329d0bc8bd329$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $d4b329d0bc8bd329$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$d4b329d0bc8bd329$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $d4b329d0bc8bd329$var$supported;
let $d4b329d0bc8bd329$var$perf;
function $d4b329d0bc8bd329$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $d4b329d0bc8bd329$var$isSupported()) $d4b329d0bc8bd329$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $d4b329d0bc8bd329$var$devtoolsPerfStart(instance, type, $d4b329d0bc8bd329$var$isSupported() ? $d4b329d0bc8bd329$var$perf.now() : Date.now());
}
function $d4b329d0bc8bd329$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $d4b329d0bc8bd329$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        const measureName = `<${$d4b329d0bc8bd329$var$formatComponentName(instance, instance.type)}> ${type}`;
        $d4b329d0bc8bd329$var$perf.mark(endTag);
        $d4b329d0bc8bd329$var$perf.measure(measureName, startTag, endTag);
        $d4b329d0bc8bd329$var$perf.clearMeasures(measureName);
        $d4b329d0bc8bd329$var$perf.clearMarks(startTag);
        $d4b329d0bc8bd329$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $d4b329d0bc8bd329$var$devtoolsPerfEnd(instance, type, $d4b329d0bc8bd329$var$isSupported() ? $d4b329d0bc8bd329$var$perf.now() : Date.now());
}
function $d4b329d0bc8bd329$var$isSupported() {
    if ($d4b329d0bc8bd329$var$supported !== void 0) return $d4b329d0bc8bd329$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $d4b329d0bc8bd329$var$supported = true;
        $d4b329d0bc8bd329$var$perf = window.performance;
    } else $d4b329d0bc8bd329$var$supported = false;
    return $d4b329d0bc8bd329$var$supported;
}
function $d4b329d0bc8bd329$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $oF3Y1.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $oF3Y1.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $oF3Y1.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $d4b329d0bc8bd329$var$queuePostRenderEffect = $d4b329d0bc8bd329$var$queueEffectWithSuspense;
function $d4b329d0bc8bd329$export$53ae2f996c64e9a(options) {
    return $d4b329d0bc8bd329$var$baseCreateRenderer(options);
}
function $d4b329d0bc8bd329$export$200524cf0d997ff0(options) {
    return $d4b329d0bc8bd329$var$baseCreateRenderer(options, $d4b329d0bc8bd329$var$createHydrationFunctions);
}
function $d4b329d0bc8bd329$var$baseCreateRenderer(options, createHydrationFns) {
    $d4b329d0bc8bd329$var$initFeatureFlags();
    const target = (0, $oF3Y1.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $d4b329d0bc8bd329$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $oF3Y1.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$d4b329d0bc8bd329$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $d4b329d0bc8bd329$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $d4b329d0bc8bd329$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $d4b329d0bc8bd329$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $d4b329d0bc8bd329$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $d4b329d0bc8bd329$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        else if (ref == null && n1 && n1.ref != null) $d4b329d0bc8bd329$var$setRef(n1.ref, null, parentSuspense, n1, true);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else {
            const customElement = n1.el && n1.el._isVueCE ? n1.el : null;
            try {
                if (customElement) customElement._beginPatch();
                patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            } finally{
                if (customElement) customElement._endPatch();
            }
        }
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $d4b329d0bc8bd329$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $d4b329d0bc8bd329$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $oF3Y1.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $d4b329d0bc8bd329$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $oF3Y1.def)(el, "__vnode", vnode, true);
            (0, $oF3Y1.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $d4b329d0bc8bd329$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $d4b329d0bc8bd329$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
            const isHmr = false;
            $d4b329d0bc8bd329$var$queuePostRenderEffect(()=>{
                let prev;
                vnodeHook && $d4b329d0bc8bd329$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $d4b329d0bc8bd329$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $d4b329d0bc8bd329$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $d4b329d0bc8bd329$var$cloneIfMounted(children[i]) : $d4b329d0bc8bd329$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $oF3Y1.EMPTY_OBJ);
        const newProps = n2.props || (0, $oF3Y1.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $d4b329d0bc8bd329$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $d4b329d0bc8bd329$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $d4b329d0bc8bd329$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $d4b329d0bc8bd329$var$toggleRecurse(parentComponent, true);
        if (// #6385 the old vnode may be a user-wrapped non-isomorphic block
        // Force full diff when block metadata is unstable.
        dynamicChildren && (!n1.dynamicChildren || n1.dynamicChildren.length !== dynamicChildren.length)) {
            patchFlag = 0;
            optimized = false;
            dynamicChildren = null;
        }
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $d4b329d0bc8bd329$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $d4b329d0bc8bd329$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $d4b329d0bc8bd329$var$queuePostRenderEffect(()=>{
            vnodeHook && $d4b329d0bc8bd329$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $d4b329d0bc8bd329$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $d4b329d0bc8bd329$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$d4b329d0bc8bd329$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 198) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $oF3Y1.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $oF3Y1.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $oF3Y1.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren && n1.dynamicChildren.length === dynamicChildren.length) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $d4b329d0bc8bd329$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $d4b329d0bc8bd329$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($d4b329d0bc8bd329$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $d4b329d0bc8bd329$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $d4b329d0bc8bd329$export$bf5c4cf060303d58($d4b329d0bc8bd329$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
                initialVNode.placeholder = placeholder.el;
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($d4b329d0bc8bd329$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $d4b329d0bc8bd329$var$isAsyncWrapper(initialVNode);
                $d4b329d0bc8bd329$var$toggleRecurse(instance, false);
                if (bm) (0, $oF3Y1.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $d4b329d0bc8bd329$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $d4b329d0bc8bd329$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $d4b329d0bc8bd329$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce && root.ce._hasShadowRoot()) root.ce._injectChildStyle(type, instance.parent ? instance.parent.type : void 0);
                    const subTree = instance.subTree = $d4b329d0bc8bd329$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $d4b329d0bc8bd329$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $d4b329d0bc8bd329$var$queuePostRenderEffect(()=>$d4b329d0bc8bd329$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $d4b329d0bc8bd329$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $d4b329d0bc8bd329$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $d4b329d0bc8bd329$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $d4b329d0bc8bd329$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            $d4b329d0bc8bd329$var$queuePostRenderEffect(()=>{
                                if (!instance.isUnmounted) update();
                            }, parentSuspense);
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $d4b329d0bc8bd329$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $oF3Y1.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $d4b329d0bc8bd329$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $d4b329d0bc8bd329$var$toggleRecurse(instance, true);
                const nextTree = $d4b329d0bc8bd329$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $d4b329d0bc8bd329$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $d4b329d0bc8bd329$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $d4b329d0bc8bd329$var$queuePostRenderEffect(()=>$d4b329d0bc8bd329$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $d4b329d0bc8bd329$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $mHgsT.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$d4b329d0bc8bd329$var$queueJob(job);
        $d4b329d0bc8bd329$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $d4b329d0bc8bd329$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $d4b329d0bc8bd329$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $mHgsT.pauseTracking)();
        $d4b329d0bc8bd329$var$flushPreFlushCbs(instance);
        (0, $mHgsT.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $oF3Y1.EMPTY_ARR);
        c2 = c2 || (0, $oF3Y1.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $d4b329d0bc8bd329$var$cloneIfMounted(c2[i]) : $d4b329d0bc8bd329$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $d4b329d0bc8bd329$var$cloneIfMounted(c2[i]) : $d4b329d0bc8bd329$var$normalizeVNode(c2[i]);
            if ($d4b329d0bc8bd329$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $d4b329d0bc8bd329$var$cloneIfMounted(c2[e2]) : $d4b329d0bc8bd329$var$normalizeVNode(c2[e2]);
            if ($d4b329d0bc8bd329$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $d4b329d0bc8bd329$var$cloneIfMounted(c2[i]) : $d4b329d0bc8bd329$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $d4b329d0bc8bd329$var$cloneIfMounted(c2[i]) : $d4b329d0bc8bd329$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $d4b329d0bc8bd329$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $d4b329d0bc8bd329$var$getSequence(newIndexToOldIndexMap) : (0, $oF3Y1.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchorVNode = c2[nextIndex + 1];
                const anchor = nextIndex + 1 < l2 ? // #13559, #14173 fallback to el placeholder for unresolved async component
                anchorVNode.el || $d4b329d0bc8bd329$var$resolveAsyncComponentPlaceholder(anchorVNode) : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $d4b329d0bc8bd329$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $d4b329d0bc8bd329$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                if (transition.persisted && !el[$d4b329d0bc8bd329$var$leaveCbKey]) hostInsert(el, container, anchor);
                else {
                    transition.beforeEnter(el);
                    hostInsert(el, container, anchor);
                    $d4b329d0bc8bd329$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
                }
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>{
                    if (vnode.ctx.isUnmounted) hostRemove(el);
                    else hostInsert(el, container, anchor);
                };
                const performLeave = ()=>{
                    const wasLeaving = el._isLeaving || !!el[$d4b329d0bc8bd329$var$leaveCbKey];
                    if (el._isLeaving) el[$d4b329d0bc8bd329$var$leaveCbKey](true);
                    if (transition.persisted && !wasLeaving) remove2();
                    else leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex, memo: memo } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) {
            (0, $mHgsT.pauseTracking)();
            $d4b329d0bc8bd329$var$setRef(ref, null, parentSuspense, vnode, true);
            (0, $mHgsT.resetTracking)();
        }
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$d4b329d0bc8bd329$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $d4b329d0bc8bd329$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $d4b329d0bc8bd329$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $d4b329d0bc8bd329$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $d4b329d0bc8bd329$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        const shouldInvalidateMemo = memo != null && cacheIndex == null;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs || shouldInvalidateMemo) $d4b329d0bc8bd329$var$queuePostRenderEffect(()=>{
            vnodeHook && $d4b329d0bc8bd329$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $d4b329d0bc8bd329$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
            if (shouldInvalidateMemo) vnode.el = null;
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $d4b329d0bc8bd329$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $d4b329d0bc8bd329$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a } = instance;
        $d4b329d0bc8bd329$var$invalidateMount(m);
        $d4b329d0bc8bd329$var$invalidateMount(a);
        if (bum) (0, $oF3Y1.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $d4b329d0bc8bd329$var$queuePostRenderEffect(um, parentSuspense);
        $d4b329d0bc8bd329$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (__VUE_PROD_DEVTOOLS__) $d4b329d0bc8bd329$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$d4b329d0bc8bd329$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        let instance;
        if (vnode == null) {
            if (container._vnode) {
                unmount(container._vnode, null, null, true);
                instance = container._vnode.component;
            }
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $d4b329d0bc8bd329$var$flushPreFlushCbs(instance);
            $d4b329d0bc8bd329$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $d4b329d0bc8bd329$var$createAppAPI(render, hydrate)
    };
}
function $d4b329d0bc8bd329$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $d4b329d0bc8bd329$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $d4b329d0bc8bd329$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $d4b329d0bc8bd329$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $oF3Y1.isArray)(ch1) && (0, $oF3Y1.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $d4b329d0bc8bd329$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $d4b329d0bc8bd329$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $d4b329d0bc8bd329$export$5f1af8db9871e1d6) {
            if (c2.patchFlag === -1) c2 = ch2[i] = $d4b329d0bc8bd329$var$cloneIfMounted(c2);
            c2.el = c1.el;
        }
        if (c2.type === $d4b329d0bc8bd329$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $d4b329d0bc8bd329$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $d4b329d0bc8bd329$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $d4b329d0bc8bd329$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $d4b329d0bc8bd329$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
function $d4b329d0bc8bd329$var$resolveAsyncComponentPlaceholder(anchorVnode) {
    if (anchorVnode.placeholder) return anchorVnode.placeholder;
    const instance = anchorVnode.component;
    if (instance) return $d4b329d0bc8bd329$var$resolveAsyncComponentPlaceholder(instance.subTree);
    return null;
}
const $d4b329d0bc8bd329$var$isSuspense = (type)=>type.__isSuspense;
let $d4b329d0bc8bd329$var$suspenseId = 0;
const $d4b329d0bc8bd329$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $d4b329d0bc8bd329$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $d4b329d0bc8bd329$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $d4b329d0bc8bd329$var$hydrateSuspense,
    normalize: $d4b329d0bc8bd329$var$normalizeSuspenseChildren
};
const $d4b329d0bc8bd329$export$74bf444e3cd11ea5 = $d4b329d0bc8bd329$var$SuspenseImpl;
function $d4b329d0bc8bd329$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $oF3Y1.isFunction)(eventListener)) eventListener();
}
function $d4b329d0bc8bd329$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $d4b329d0bc8bd329$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $d4b329d0bc8bd329$var$triggerEvent(vnode, "onPending");
        $d4b329d0bc8bd329$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $d4b329d0bc8bd329$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $d4b329d0bc8bd329$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($d4b329d0bc8bd329$var$isSameVNodeType(pendingBranch, newBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $d4b329d0bc8bd329$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $d4b329d0bc8bd329$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $d4b329d0bc8bd329$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $d4b329d0bc8bd329$var$isSameVNodeType(activeBranch, newBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $d4b329d0bc8bd329$var$isSameVNodeType(activeBranch, newBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $d4b329d0bc8bd329$var$setActiveBranch(suspense, newBranch);
    } else {
        $d4b329d0bc8bd329$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $d4b329d0bc8bd329$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $d4b329d0bc8bd329$var$hasWarned = false;
function $d4b329d0bc8bd329$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $d4b329d0bc8bd329$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $oF3Y1.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $d4b329d0bc8bd329$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        isFallbackMountPending: false,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2, isInFallback: isInFallback } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                let hasUpdatedAnchor = false;
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor && !hasUpdatedAnchor ? next(activeBranch) : anchor, 0);
                        $d4b329d0bc8bd329$export$59536a0199721cab(effects);
                        if (isInFallback && vnode2.ssFallback) vnode2.ssFallback.el = null;
                    }
                };
                if (activeBranch && !suspense.isFallbackMountPending) {
                    if (parentNode(activeBranch.el) === container2) {
                        anchor = next(activeBranch);
                        hasUpdatedAnchor = true;
                    }
                    unmount(activeBranch, parentComponent2, suspense, true);
                    if (!delayEnter && isInFallback && vnode2.ssFallback) $d4b329d0bc8bd329$var$queuePostRenderEffect(()=>vnode2.ssFallback.el = null, suspense);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            suspense.isFallbackMountPending = false;
            $d4b329d0bc8bd329$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $d4b329d0bc8bd329$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $d4b329d0bc8bd329$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $d4b329d0bc8bd329$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                suspense.isFallbackMountPending = false;
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $d4b329d0bc8bd329$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) {
                suspense.isFallbackMountPending = true;
                activeBranch.transition.afterLeave = mountFallback;
            }
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $d4b329d0bc8bd329$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                $d4b329d0bc8bd329$var$unsetCurrentInstance();
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $d4b329d0bc8bd329$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) {
                    vnode2.placeholder = null;
                    remove(placeholder);
                }
                $d4b329d0bc8bd329$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $d4b329d0bc8bd329$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $d4b329d0bc8bd329$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $d4b329d0bc8bd329$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $d4b329d0bc8bd329$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $d4b329d0bc8bd329$var$normalizeSuspenseSlot(children.fallback) : $d4b329d0bc8bd329$export$bf5c4cf060303d58($d4b329d0bc8bd329$export$4d299b491347818a);
}
function $d4b329d0bc8bd329$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $oF3Y1.isFunction)(s)) {
        const trackBlock = $d4b329d0bc8bd329$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $d4b329d0bc8bd329$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $d4b329d0bc8bd329$var$currentBlock;
            $d4b329d0bc8bd329$var$closeBlock();
        }
    }
    if ((0, $oF3Y1.isArray)(s)) {
        const singleChild = $d4b329d0bc8bd329$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $d4b329d0bc8bd329$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $d4b329d0bc8bd329$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $oF3Y1.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $d4b329d0bc8bd329$export$59536a0199721cab(fn);
}
function $d4b329d0bc8bd329$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $d4b329d0bc8bd329$var$updateHOCHostEl(parentComponent, el);
    }
}
function $d4b329d0bc8bd329$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $d4b329d0bc8bd329$export$ffb0004e005737fa = /* @__PURE__ */ Symbol.for("v-fgt");
const $d4b329d0bc8bd329$export$5f1af8db9871e1d6 = /* @__PURE__ */ Symbol.for("v-txt");
const $d4b329d0bc8bd329$export$4d299b491347818a = /* @__PURE__ */ Symbol.for("v-cmt");
const $d4b329d0bc8bd329$export$c1b9a1d3af45b7b6 = /* @__PURE__ */ Symbol.for("v-stc");
const $d4b329d0bc8bd329$var$blockStack = [];
let $d4b329d0bc8bd329$var$currentBlock = null;
function $d4b329d0bc8bd329$export$e7eaa45e502fe5cc(disableTracking = false) {
    $d4b329d0bc8bd329$var$blockStack.push($d4b329d0bc8bd329$var$currentBlock = disableTracking ? null : []);
}
function $d4b329d0bc8bd329$var$closeBlock() {
    $d4b329d0bc8bd329$var$blockStack.pop();
    $d4b329d0bc8bd329$var$currentBlock = $d4b329d0bc8bd329$var$blockStack[$d4b329d0bc8bd329$var$blockStack.length - 1] || null;
}
let $d4b329d0bc8bd329$var$isBlockTreeEnabled = 1;
function $d4b329d0bc8bd329$export$c20bee82f26f1e27(value, inVOnce = false) {
    $d4b329d0bc8bd329$var$isBlockTreeEnabled += value;
    if (value < 0 && $d4b329d0bc8bd329$var$currentBlock && inVOnce) $d4b329d0bc8bd329$var$currentBlock.hasOnce = true;
}
function $d4b329d0bc8bd329$var$setupBlock(vnode) {
    vnode.dynamicChildren = $d4b329d0bc8bd329$var$isBlockTreeEnabled > 0 ? $d4b329d0bc8bd329$var$currentBlock || (0, $oF3Y1.EMPTY_ARR) : null;
    $d4b329d0bc8bd329$var$closeBlock();
    if ($d4b329d0bc8bd329$var$isBlockTreeEnabled > 0 && $d4b329d0bc8bd329$var$currentBlock) $d4b329d0bc8bd329$var$currentBlock.push(vnode);
    return vnode;
}
function $d4b329d0bc8bd329$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $d4b329d0bc8bd329$var$setupBlock($d4b329d0bc8bd329$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $d4b329d0bc8bd329$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $d4b329d0bc8bd329$var$setupBlock($d4b329d0bc8bd329$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $d4b329d0bc8bd329$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $d4b329d0bc8bd329$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $d4b329d0bc8bd329$var$vnodeArgsTransformer;
function $d4b329d0bc8bd329$export$83beccd3afeeb809(transformer) {
    $d4b329d0bc8bd329$var$vnodeArgsTransformer = transformer;
}
const $d4b329d0bc8bd329$var$createVNodeWithArgsTransform = (...args)=>{
    return $d4b329d0bc8bd329$var$_createVNode(...$d4b329d0bc8bd329$var$vnodeArgsTransformer ? $d4b329d0bc8bd329$var$vnodeArgsTransformer(args, $d4b329d0bc8bd329$var$currentRenderingInstance) : args);
};
const $d4b329d0bc8bd329$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $d4b329d0bc8bd329$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $oF3Y1.isString)(ref) || (0, $mHgsT.isRef)(ref) || (0, $oF3Y1.isFunction)(ref) ? {
        i: $d4b329d0bc8bd329$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $d4b329d0bc8bd329$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $d4b329d0bc8bd329$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $d4b329d0bc8bd329$var$normalizeKey(props),
        ref: props && $d4b329d0bc8bd329$var$normalizeRef(props),
        scopeId: $d4b329d0bc8bd329$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $d4b329d0bc8bd329$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $d4b329d0bc8bd329$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $oF3Y1.isString)(children) ? 8 : 16;
    if ($d4b329d0bc8bd329$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $d4b329d0bc8bd329$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $d4b329d0bc8bd329$var$currentBlock.push(vnode);
    return vnode;
}
const $d4b329d0bc8bd329$export$bf5c4cf060303d58 = $d4b329d0bc8bd329$var$_createVNode;
function $d4b329d0bc8bd329$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $d4b329d0bc8bd329$var$NULL_DYNAMIC_COMPONENT) type = $d4b329d0bc8bd329$export$4d299b491347818a;
    if ($d4b329d0bc8bd329$export$3868d13f8734ae81(type)) {
        const cloned = $d4b329d0bc8bd329$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $d4b329d0bc8bd329$var$normalizeChildren(cloned, children);
        if ($d4b329d0bc8bd329$var$isBlockTreeEnabled > 0 && !isBlockNode && $d4b329d0bc8bd329$var$currentBlock) {
            if (cloned.shapeFlag & 6) $d4b329d0bc8bd329$var$currentBlock[$d4b329d0bc8bd329$var$currentBlock.indexOf(type)] = cloned;
            else $d4b329d0bc8bd329$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($d4b329d0bc8bd329$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $d4b329d0bc8bd329$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $oF3Y1.isString)(klass)) props.class = (0, $oF3Y1.normalizeClass)(klass);
        if ((0, $oF3Y1.isObject)(style)) {
            if ((0, $mHgsT.isProxy)(style) && !(0, $oF3Y1.isArray)(style)) style = (0, $oF3Y1.extend)({}, style);
            props.style = (0, $oF3Y1.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $oF3Y1.isString)(type) ? 1 : $d4b329d0bc8bd329$var$isSuspense(type) ? 128 : $d4b329d0bc8bd329$var$isTeleport(type) ? 64 : (0, $oF3Y1.isObject)(type) ? 4 : (0, $oF3Y1.isFunction)(type) ? 2 : 0;
    return $d4b329d0bc8bd329$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $d4b329d0bc8bd329$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $mHgsT.isProxy)(props) || $d4b329d0bc8bd329$var$isInternalObject(props) ? (0, $oF3Y1.extend)({}, props) : props;
}
function $d4b329d0bc8bd329$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $d4b329d0bc8bd329$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $d4b329d0bc8bd329$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $oF3Y1.isArray)(ref) ? ref.concat($d4b329d0bc8bd329$var$normalizeRef(extraProps)) : [
            ref,
            $d4b329d0bc8bd329$var$normalizeRef(extraProps)
        ] : $d4b329d0bc8bd329$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $d4b329d0bc8bd329$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $d4b329d0bc8bd329$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $d4b329d0bc8bd329$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        placeholder: vnode.placeholder,
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $d4b329d0bc8bd329$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $d4b329d0bc8bd329$var$deepCloneVNode(vnode) {
    const cloned = $d4b329d0bc8bd329$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $oF3Y1.isArray)(vnode.children)) cloned.children = vnode.children.map($d4b329d0bc8bd329$var$deepCloneVNode);
    return cloned;
}
function $d4b329d0bc8bd329$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $d4b329d0bc8bd329$export$bf5c4cf060303d58($d4b329d0bc8bd329$export$5f1af8db9871e1d6, null, text, flag);
}
function $d4b329d0bc8bd329$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $d4b329d0bc8bd329$export$bf5c4cf060303d58($d4b329d0bc8bd329$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $d4b329d0bc8bd329$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($d4b329d0bc8bd329$export$e7eaa45e502fe5cc(), $d4b329d0bc8bd329$export$9f2dfe8048dfb22b($d4b329d0bc8bd329$export$4d299b491347818a, null, text)) : $d4b329d0bc8bd329$export$bf5c4cf060303d58($d4b329d0bc8bd329$export$4d299b491347818a, null, text);
}
function $d4b329d0bc8bd329$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $d4b329d0bc8bd329$export$bf5c4cf060303d58($d4b329d0bc8bd329$export$4d299b491347818a);
    else if ((0, $oF3Y1.isArray)(child)) return $d4b329d0bc8bd329$export$bf5c4cf060303d58($d4b329d0bc8bd329$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($d4b329d0bc8bd329$export$3868d13f8734ae81(child)) return $d4b329d0bc8bd329$var$cloneIfMounted(child);
    else return $d4b329d0bc8bd329$export$bf5c4cf060303d58($d4b329d0bc8bd329$export$5f1af8db9871e1d6, null, String(child));
}
function $d4b329d0bc8bd329$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $d4b329d0bc8bd329$export$ee4f9e12c0a92a1a(child);
}
function $d4b329d0bc8bd329$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $oF3Y1.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $d4b329d0bc8bd329$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$d4b329d0bc8bd329$var$isInternalObject(children)) children._ctx = $d4b329d0bc8bd329$var$currentRenderingInstance;
            else if (slotFlag === 3 && $d4b329d0bc8bd329$var$currentRenderingInstance) {
                if ($d4b329d0bc8bd329$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $oF3Y1.isFunction)(children)) {
        if (shapeFlag & 65) {
            $d4b329d0bc8bd329$var$normalizeChildren(vnode, {
                default: children
            });
            return;
        }
        children = {
            default: children,
            _ctx: $d4b329d0bc8bd329$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $d4b329d0bc8bd329$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $d4b329d0bc8bd329$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $oF3Y1.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $oF3Y1.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $oF3Y1.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $oF3Y1.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
                else if (incoming == null && existing == null && // mergeProps({ 'onUpdate:modelValue': undefined }) should not retain
                // the model listener.
                !(0, $oF3Y1.isModelListener)(key)) ret[key] = incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $d4b329d0bc8bd329$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $d4b329d0bc8bd329$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $d4b329d0bc8bd329$var$emptyAppContext = $d4b329d0bc8bd329$var$createAppContext();
let $d4b329d0bc8bd329$var$uid = 0;
function $d4b329d0bc8bd329$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $d4b329d0bc8bd329$var$emptyAppContext;
    const instance = {
        uid: $d4b329d0bc8bd329$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $mHgsT.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $d4b329d0bc8bd329$var$normalizePropsOptions(type, appContext),
        emitsOptions: $d4b329d0bc8bd329$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $oF3Y1.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $oF3Y1.EMPTY_OBJ),
        data: (0, $oF3Y1.EMPTY_OBJ),
        props: (0, $oF3Y1.EMPTY_OBJ),
        attrs: (0, $oF3Y1.EMPTY_OBJ),
        slots: (0, $oF3Y1.EMPTY_OBJ),
        refs: (0, $oF3Y1.EMPTY_OBJ),
        setupState: (0, $oF3Y1.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $d4b329d0bc8bd329$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $d4b329d0bc8bd329$var$currentInstance = null;
const $d4b329d0bc8bd329$export$f13e630aa3915748 = ()=>$d4b329d0bc8bd329$var$currentInstance || $d4b329d0bc8bd329$var$currentRenderingInstance;
let $d4b329d0bc8bd329$var$internalSetCurrentInstance;
let $d4b329d0bc8bd329$var$setInSSRSetupState;
{
    const g = (0, $oF3Y1.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $d4b329d0bc8bd329$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$d4b329d0bc8bd329$var$currentInstance = v1);
    $d4b329d0bc8bd329$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$d4b329d0bc8bd329$var$isInSSRComponentSetup = v1);
}const $d4b329d0bc8bd329$var$setCurrentInstance = (instance)=>{
    const prev = $d4b329d0bc8bd329$var$currentInstance;
    $d4b329d0bc8bd329$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $d4b329d0bc8bd329$var$internalSetCurrentInstance(prev);
    };
};
const $d4b329d0bc8bd329$var$unsetCurrentInstance = ()=>{
    $d4b329d0bc8bd329$var$currentInstance && $d4b329d0bc8bd329$var$currentInstance.scope.off();
    $d4b329d0bc8bd329$var$internalSetCurrentInstance(null);
};
const $d4b329d0bc8bd329$var$isBuiltInTag = /* @__PURE__ */ (0, $oF3Y1.makeMap)("slot,component");
function $d4b329d0bc8bd329$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($d4b329d0bc8bd329$var$isBuiltInTag(name) || isNativeTag(name)) $d4b329d0bc8bd329$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $d4b329d0bc8bd329$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $d4b329d0bc8bd329$var$isInSSRComponentSetup = false;
function $d4b329d0bc8bd329$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $d4b329d0bc8bd329$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $d4b329d0bc8bd329$var$isStatefulComponent(instance);
    $d4b329d0bc8bd329$var$initProps(instance, props, isStateful, isSSR);
    $d4b329d0bc8bd329$var$initSlots(instance, children, optimized || isSSR);
    const setupResult = isStateful ? $d4b329d0bc8bd329$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $d4b329d0bc8bd329$var$setInSSRSetupState(false);
    return setupResult;
}
function $d4b329d0bc8bd329$var$setupStatefulComponent(instance, isSSR) {
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $d4b329d0bc8bd329$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $mHgsT.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $d4b329d0bc8bd329$var$createSetupContext(instance) : null;
        const reset = $d4b329d0bc8bd329$var$setCurrentInstance(instance);
        const setupResult = $d4b329d0bc8bd329$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $oF3Y1.isPromise)(setupResult);
        (0, $mHgsT.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$d4b329d0bc8bd329$var$isAsyncWrapper(instance)) $d4b329d0bc8bd329$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($d4b329d0bc8bd329$var$unsetCurrentInstance, $d4b329d0bc8bd329$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $d4b329d0bc8bd329$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $d4b329d0bc8bd329$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $d4b329d0bc8bd329$var$handleSetupResult(instance, setupResult, isSSR);
    } else $d4b329d0bc8bd329$var$finishComponentSetup(instance, isSSR);
}
function $d4b329d0bc8bd329$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $oF3Y1.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $oF3Y1.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $mHgsT.proxyRefs)(setupResult);
    }
    $d4b329d0bc8bd329$var$finishComponentSetup(instance, isSSR);
}
let $d4b329d0bc8bd329$var$compile;
let $d4b329d0bc8bd329$var$installWithProxy;
function $d4b329d0bc8bd329$export$667bb5a67822b941(_compile) {
    $d4b329d0bc8bd329$var$compile = _compile;
    $d4b329d0bc8bd329$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $d4b329d0bc8bd329$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $d4b329d0bc8bd329$export$c93a9c496c5211fa = ()=>!$d4b329d0bc8bd329$var$compile;
function $d4b329d0bc8bd329$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $d4b329d0bc8bd329$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $d4b329d0bc8bd329$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $oF3Y1.extend)((0, $oF3Y1.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $d4b329d0bc8bd329$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $oF3Y1.NOOP);
        if ($d4b329d0bc8bd329$var$installWithProxy) $d4b329d0bc8bd329$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $d4b329d0bc8bd329$var$setCurrentInstance(instance);
        (0, $mHgsT.pauseTracking)();
        try {
            $d4b329d0bc8bd329$var$applyOptions(instance);
        } finally{
            (0, $mHgsT.resetTracking)();
            reset();
        }
    }
}
const $d4b329d0bc8bd329$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $mHgsT.track)(target, "get", "");
        return target[key];
    }
};
function $d4b329d0bc8bd329$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $mHgsT.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $d4b329d0bc8bd329$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $d4b329d0bc8bd329$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $d4b329d0bc8bd329$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $mHgsT.proxyRefs)((0, $mHgsT.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $d4b329d0bc8bd329$var$publicPropertiesMap) return $d4b329d0bc8bd329$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $d4b329d0bc8bd329$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $d4b329d0bc8bd329$var$classifyRE = /(?:^|[-_])\w/g;
const $d4b329d0bc8bd329$var$classify = (str)=>str.replace($d4b329d0bc8bd329$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $d4b329d0bc8bd329$var$getComponentName(Component, includeInferred = true) {
    return (0, $oF3Y1.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $d4b329d0bc8bd329$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $d4b329d0bc8bd329$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components) || instance.parent && inferFromRegistry(instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $d4b329d0bc8bd329$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $d4b329d0bc8bd329$var$isClassComponent(value) {
    return (0, $oF3Y1.isFunction)(value) && "__vccOpts" in value;
}
const $d4b329d0bc8bd329$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $mHgsT.computed)(getterOrOptions, debugOptions, $d4b329d0bc8bd329$var$isInSSRComponentSetup);
    return c;
};
function $d4b329d0bc8bd329$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    try {
        $d4b329d0bc8bd329$export$c20bee82f26f1e27(-1);
        const l = arguments.length;
        if (l === 2) {
            if ((0, $oF3Y1.isObject)(propsOrChildren) && !(0, $oF3Y1.isArray)(propsOrChildren)) {
                if ($d4b329d0bc8bd329$export$3868d13f8734ae81(propsOrChildren)) return $d4b329d0bc8bd329$export$bf5c4cf060303d58(type, null, [
                    propsOrChildren
                ]);
                return $d4b329d0bc8bd329$export$bf5c4cf060303d58(type, propsOrChildren);
            } else return $d4b329d0bc8bd329$export$bf5c4cf060303d58(type, null, propsOrChildren);
        } else {
            if (l > 3) children = Array.prototype.slice.call(arguments, 2);
            else if (l === 3 && $d4b329d0bc8bd329$export$3868d13f8734ae81(children)) children = [
                children
            ];
            return $d4b329d0bc8bd329$export$bf5c4cf060303d58(type, propsOrChildren, children);
        }
    } finally{
        $d4b329d0bc8bd329$export$c20bee82f26f1e27(1);
    }
}
function $d4b329d0bc8bd329$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $mHgsT.toRaw)(instance.props)));
        if (instance.setupState !== (0, $oF3Y1.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $oF3Y1.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $mHgsT.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $oF3Y1.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $oF3Y1.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $mHgsT.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $oF3Y1.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $oF3Y1.isArray)(opts) && opts.includes(key) || (0, $oF3Y1.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $mHgsT.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $d4b329d0bc8bd329$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $d4b329d0bc8bd329$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $d4b329d0bc8bd329$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $oF3Y1.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($d4b329d0bc8bd329$var$isBlockTreeEnabled > 0 && $d4b329d0bc8bd329$var$currentBlock) $d4b329d0bc8bd329$var$currentBlock.push(cached);
    return true;
}
const $d4b329d0bc8bd329$export$83d89fbfd8236492 = "3.5.40";
const $d4b329d0bc8bd329$export$c106dd0671a0fc2d = (0, $oF3Y1.NOOP);
const $d4b329d0bc8bd329$export$795e0ad4a0e2ed30 = $d4b329d0bc8bd329$var$ErrorTypeStrings$1;
const $d4b329d0bc8bd329$export$6922d3b3a607469e = $d4b329d0bc8bd329$var$devtools$1;
const $d4b329d0bc8bd329$export$b0c258b32c26c785 = $d4b329d0bc8bd329$var$setDevtoolsHook$1;
const $d4b329d0bc8bd329$var$_ssrUtils = {
    createComponentInstance: $d4b329d0bc8bd329$var$createComponentInstance,
    setupComponent: $d4b329d0bc8bd329$var$setupComponent,
    renderComponentRoot: $d4b329d0bc8bd329$var$renderComponentRoot,
    setCurrentRenderingInstance: $d4b329d0bc8bd329$var$setCurrentRenderingInstance,
    isVNode: $d4b329d0bc8bd329$export$3868d13f8734ae81,
    normalizeVNode: $d4b329d0bc8bd329$var$normalizeVNode,
    getComponentPublicInstance: $d4b329d0bc8bd329$var$getComponentPublicInstance,
    ensureValidVNode: $d4b329d0bc8bd329$var$ensureValidVNode,
    pushWarningContext: $d4b329d0bc8bd329$var$pushWarningContext,
    popWarningContext: $d4b329d0bc8bd329$var$popWarningContext
};
const $d4b329d0bc8bd329$export$a9679033567b336d = $d4b329d0bc8bd329$var$_ssrUtils;
const $d4b329d0bc8bd329$export$83cf26e06ea620e1 = null;
const $d4b329d0bc8bd329$export$dc678eddf276286e = null;
const $d4b329d0bc8bd329$export$22072a82865312f6 = null;

});
parcelRegister("mHgsT", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $04439da16088dcbf$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "ReactiveEffect", () => $04439da16088dcbf$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $04439da16088dcbf$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $04439da16088dcbf$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $04439da16088dcbf$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $04439da16088dcbf$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $04439da16088dcbf$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isShallow", () => $04439da16088dcbf$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "toReactive", () => $04439da16088dcbf$export$45c769cf449a508c);
$parcel$export(module.exports, "shallowReadArray", () => $04439da16088dcbf$export$5eb48af14254449e);
$parcel$export(module.exports, "isReadonly", () => $04439da16088dcbf$export$92d09b48637741e7);
$parcel$export(module.exports, "isReactive", () => $04439da16088dcbf$export$352205f445242f02);
$parcel$export(module.exports, "toReadonly", () => $04439da16088dcbf$export$4a78e7a2a4fb689f);
$parcel$export(module.exports, "isProxy", () => $04439da16088dcbf$export$5f3ca29d057519b3);
$parcel$export(module.exports, "isRef", () => $04439da16088dcbf$export$4f9f5282de18fc69);
$parcel$export(module.exports, "reactive", () => $04439da16088dcbf$export$90a44edba14e47be);
$parcel$export(module.exports, "shallowReactive", () => $04439da16088dcbf$export$8d81cefd22d22260);
$parcel$export(module.exports, "markRaw", () => $04439da16088dcbf$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $04439da16088dcbf$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $04439da16088dcbf$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $04439da16088dcbf$export$a239a76781616204);
$parcel$export(module.exports, "proxyRefs", () => $04439da16088dcbf$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $04439da16088dcbf$export$a20c2dd6199824cb);
$parcel$export(module.exports, "computed", () => $04439da16088dcbf$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "watch", () => $04439da16088dcbf$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "traverse", () => $04439da16088dcbf$export$df3f009e3d155b20);
/**
* @vue/reactivity v3.5.40
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $oF3Y1 = parcelRequire("oF3Y1");
function $04439da16088dcbf$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $04439da16088dcbf$var$activeEffectScope;
class $04439da16088dcbf$export$1168ed9dbc71ddbd {
    // TODO isolatedDeclarations "__v_skip"
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal track `on` calls, allow `on` call multiple times
     */ this._on = 0;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this._warnOnRun = true;
        this.__v_skip = true;
        if (!detached && $04439da16088dcbf$var$activeEffectScope) {
            if ($04439da16088dcbf$var$activeEffectScope.active) {
                this.parent = $04439da16088dcbf$var$activeEffectScope;
                this.index = ($04439da16088dcbf$var$activeEffectScope.scopes || ($04439da16088dcbf$var$activeEffectScope.scopes = [])).push(this) - 1;
            } else {
                this._active = false;
                this._warnOnRun = false;
            }
        }
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) {
                const scopes = this.scopes.slice();
                for(i = 0, l = scopes.length; i < l; i++)scopes[i].pause();
            }
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) {
                    const scopes = this.scopes.slice();
                    for(i = 0, l = scopes.length; i < l; i++)scopes[i].resume();
                }
                const effects = this.effects.slice();
                for(i = 0, l = effects.length; i < l; i++)effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $04439da16088dcbf$var$activeEffectScope;
            try {
                $04439da16088dcbf$var$activeEffectScope = this;
                return fn();
            } finally{
                $04439da16088dcbf$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        if (++this._on === 1) {
            this.prevScope = $04439da16088dcbf$var$activeEffectScope;
            $04439da16088dcbf$var$activeEffectScope = this;
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        if (this._on > 0 && --this._on === 0) {
            if ($04439da16088dcbf$var$activeEffectScope === this) $04439da16088dcbf$var$activeEffectScope = this.prevScope;
            else {
                let current = $04439da16088dcbf$var$activeEffectScope;
                while(current){
                    if (current.prevScope === this) {
                        current.prevScope = this.prevScope;
                        break;
                    }
                    current = current.prevScope;
                }
            }
            this.prevScope = void 0;
        }
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                const scopes = this.scopes.slice();
                for(i = 0, l = scopes.length; i < l; i++)scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function $04439da16088dcbf$export$7056603ea81600be(detached) {
    return new $04439da16088dcbf$export$1168ed9dbc71ddbd(detached);
}
function $04439da16088dcbf$export$c7be4b0125a10cba() {
    return $04439da16088dcbf$var$activeEffectScope;
}
function $04439da16088dcbf$export$a780418acd4762da(fn, failSilently = false) {
    if ($04439da16088dcbf$var$activeEffectScope) $04439da16088dcbf$var$activeEffectScope.cleanups.push(fn);
}
let $04439da16088dcbf$var$activeSub;
const $04439da16088dcbf$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED",
    "EVALUATED": 128,
    "128": "EVALUATED"
};
const $04439da16088dcbf$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $04439da16088dcbf$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($04439da16088dcbf$var$activeEffectScope) {
            if ($04439da16088dcbf$var$activeEffectScope.active) $04439da16088dcbf$var$activeEffectScope.effects.push(this);
            else this.flags &= -2;
        }
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($04439da16088dcbf$var$pausedQueueEffects.has(this)) {
                $04439da16088dcbf$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $04439da16088dcbf$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $04439da16088dcbf$var$cleanupEffect(this);
        $04439da16088dcbf$var$prepareDeps(this);
        const prevEffect = $04439da16088dcbf$var$activeSub;
        const prevShouldTrack = $04439da16088dcbf$var$shouldTrack;
        $04439da16088dcbf$var$activeSub = this;
        $04439da16088dcbf$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $04439da16088dcbf$var$cleanupDeps(this);
            $04439da16088dcbf$var$activeSub = prevEffect;
            $04439da16088dcbf$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$04439da16088dcbf$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $04439da16088dcbf$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $04439da16088dcbf$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($04439da16088dcbf$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $04439da16088dcbf$var$isDirty(this);
    }
}
let $04439da16088dcbf$var$batchDepth = 0;
let $04439da16088dcbf$var$batchedSub;
let $04439da16088dcbf$var$batchedComputed;
function $04439da16088dcbf$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $04439da16088dcbf$var$batchedComputed;
        $04439da16088dcbf$var$batchedComputed = sub;
        return;
    }
    sub.next = $04439da16088dcbf$var$batchedSub;
    $04439da16088dcbf$var$batchedSub = sub;
}
function $04439da16088dcbf$var$startBatch() {
    $04439da16088dcbf$var$batchDepth++;
}
function $04439da16088dcbf$var$endBatch() {
    if (--$04439da16088dcbf$var$batchDepth > 0) return;
    if ($04439da16088dcbf$var$batchedComputed) {
        let e = $04439da16088dcbf$var$batchedComputed;
        $04439da16088dcbf$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($04439da16088dcbf$var$batchedSub){
        let e = $04439da16088dcbf$var$batchedSub;
        $04439da16088dcbf$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $04439da16088dcbf$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $04439da16088dcbf$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $04439da16088dcbf$var$removeSub(link);
            $04439da16088dcbf$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $04439da16088dcbf$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($04439da16088dcbf$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $04439da16088dcbf$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $04439da16088dcbf$var$globalVersion) return;
    computed.globalVersion = $04439da16088dcbf$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$04439da16088dcbf$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $04439da16088dcbf$var$activeSub;
    const prevShouldTrack = $04439da16088dcbf$var$shouldTrack;
    $04439da16088dcbf$var$activeSub = computed;
    $04439da16088dcbf$var$shouldTrack = true;
    try {
        $04439da16088dcbf$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $oF3Y1.hasChanged)(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $04439da16088dcbf$var$activeSub = prevSub;
        $04439da16088dcbf$var$shouldTrack = prevShouldTrack;
        $04439da16088dcbf$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $04439da16088dcbf$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$04439da16088dcbf$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $04439da16088dcbf$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $04439da16088dcbf$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $04439da16088dcbf$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $04439da16088dcbf$export$28352bb4dd362521(fn);
    if (options) (0, $oF3Y1.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $04439da16088dcbf$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $04439da16088dcbf$var$shouldTrack = true;
const $04439da16088dcbf$var$trackStack = [];
function $04439da16088dcbf$export$938a971395fef855() {
    $04439da16088dcbf$var$trackStack.push($04439da16088dcbf$var$shouldTrack);
    $04439da16088dcbf$var$shouldTrack = false;
}
function $04439da16088dcbf$export$1f8ffc6fd33b1d16() {
    $04439da16088dcbf$var$trackStack.push($04439da16088dcbf$var$shouldTrack);
    $04439da16088dcbf$var$shouldTrack = true;
}
function $04439da16088dcbf$export$c39176b1babaa8b8() {
    const last = $04439da16088dcbf$var$trackStack.pop();
    $04439da16088dcbf$var$shouldTrack = last === void 0 ? true : last;
}
function $04439da16088dcbf$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($04439da16088dcbf$var$activeSub instanceof $04439da16088dcbf$export$28352bb4dd362521) $04439da16088dcbf$var$activeSub.cleanup = fn;
}
function $04439da16088dcbf$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $04439da16088dcbf$var$activeSub;
        $04439da16088dcbf$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $04439da16088dcbf$var$activeSub = prevSub;
        }
    }
}
let $04439da16088dcbf$var$globalVersion = 0;
class $04439da16088dcbf$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $04439da16088dcbf$var$Dep {
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
        /**
     * @internal
     */ this.__v_skip = true;
    }
    track(debugInfo) {
        if (!$04439da16088dcbf$var$activeSub || !$04439da16088dcbf$var$shouldTrack || $04439da16088dcbf$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $04439da16088dcbf$var$activeSub) {
            link = this.activeLink = new $04439da16088dcbf$var$Link($04439da16088dcbf$var$activeSub, this);
            if (!$04439da16088dcbf$var$activeSub.deps) $04439da16088dcbf$var$activeSub.deps = $04439da16088dcbf$var$activeSub.depsTail = link;
            else {
                link.prevDep = $04439da16088dcbf$var$activeSub.depsTail;
                $04439da16088dcbf$var$activeSub.depsTail.nextDep = link;
                $04439da16088dcbf$var$activeSub.depsTail = link;
            }
            $04439da16088dcbf$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $04439da16088dcbf$var$activeSub.depsTail;
                link.nextDep = void 0;
                $04439da16088dcbf$var$activeSub.depsTail.nextDep = link;
                $04439da16088dcbf$var$activeSub.depsTail = link;
                if ($04439da16088dcbf$var$activeSub.deps === link) $04439da16088dcbf$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $04439da16088dcbf$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $04439da16088dcbf$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $04439da16088dcbf$var$endBatch();
        }
    }
}
function $04439da16088dcbf$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$04439da16088dcbf$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $04439da16088dcbf$var$targetMap = /* @__PURE__ */ new WeakMap();
const $04439da16088dcbf$export$3c41b1a4e06acc14 = /* @__PURE__ */ Symbol("");
const $04439da16088dcbf$export$49093fa1cddcb78d = /* @__PURE__ */ Symbol("");
const $04439da16088dcbf$export$4f926f0baab682cd = /* @__PURE__ */ Symbol("");
function $04439da16088dcbf$export$6b2a7d5132615086(target, type, key) {
    if ($04439da16088dcbf$var$shouldTrack && $04439da16088dcbf$var$activeSub) {
        let depsMap = $04439da16088dcbf$var$targetMap.get(target);
        if (!depsMap) $04439da16088dcbf$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $04439da16088dcbf$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $04439da16088dcbf$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $04439da16088dcbf$var$targetMap.get(target);
    if (!depsMap) {
        $04439da16088dcbf$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $04439da16088dcbf$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $oF3Y1.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $oF3Y1.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $04439da16088dcbf$export$4f926f0baab682cd || !(0, $oF3Y1.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($04439da16088dcbf$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($04439da16088dcbf$export$3c41b1a4e06acc14));
                        if ((0, $oF3Y1.isMap)(target)) run(depsMap.get($04439da16088dcbf$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($04439da16088dcbf$export$3c41b1a4e06acc14));
                        if ((0, $oF3Y1.isMap)(target)) run(depsMap.get($04439da16088dcbf$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $oF3Y1.isMap)(target)) run(depsMap.get($04439da16088dcbf$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $04439da16088dcbf$var$endBatch();
}
function $04439da16088dcbf$var$getDepFromReactive(object, key) {
    const depMap = $04439da16088dcbf$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $04439da16088dcbf$export$1544eab4943788e4(array) {
    const raw = $04439da16088dcbf$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $04439da16088dcbf$export$6b2a7d5132615086(raw, "iterate", $04439da16088dcbf$export$4f926f0baab682cd);
    return $04439da16088dcbf$export$7f3fe6025abfa26e(array) ? raw : raw.map($04439da16088dcbf$export$45c769cf449a508c);
}
function $04439da16088dcbf$export$5eb48af14254449e(arr) {
    $04439da16088dcbf$export$6b2a7d5132615086(arr = $04439da16088dcbf$export$ab18938b9fc5f28e(arr), "iterate", $04439da16088dcbf$export$4f926f0baab682cd);
    return arr;
}
function $04439da16088dcbf$var$toWrapped(target, item) {
    if ($04439da16088dcbf$export$92d09b48637741e7(target)) return $04439da16088dcbf$export$352205f445242f02(target) ? $04439da16088dcbf$export$4a78e7a2a4fb689f($04439da16088dcbf$export$45c769cf449a508c(item)) : $04439da16088dcbf$export$4a78e7a2a4fb689f(item);
    return $04439da16088dcbf$export$45c769cf449a508c(item);
}
const $04439da16088dcbf$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $04439da16088dcbf$var$iterator(this, Symbol.iterator, (item)=>$04439da16088dcbf$var$toWrapped(this, item));
    },
    concat (...args) {
        return $04439da16088dcbf$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $oF3Y1.isArray)(x) ? $04439da16088dcbf$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $04439da16088dcbf$var$iterator(this, "entries", (value)=>{
            value[1] = $04439da16088dcbf$var$toWrapped(this, value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $04439da16088dcbf$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $04439da16088dcbf$var$apply(this, "filter", fn, thisArg, (v)=>v.map((item)=>$04439da16088dcbf$var$toWrapped(this, item)), arguments);
    },
    find (fn, thisArg) {
        return $04439da16088dcbf$var$apply(this, "find", fn, thisArg, (item)=>$04439da16088dcbf$var$toWrapped(this, item), arguments);
    },
    findIndex (fn, thisArg) {
        return $04439da16088dcbf$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $04439da16088dcbf$var$apply(this, "findLast", fn, thisArg, (item)=>$04439da16088dcbf$var$toWrapped(this, item), arguments);
    },
    findLastIndex (fn, thisArg) {
        return $04439da16088dcbf$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $04439da16088dcbf$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $04439da16088dcbf$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $04439da16088dcbf$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $04439da16088dcbf$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimization required
    lastIndexOf (...args) {
        return $04439da16088dcbf$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $04439da16088dcbf$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $04439da16088dcbf$var$noTracking(this, "pop");
    },
    push (...args) {
        return $04439da16088dcbf$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $04439da16088dcbf$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $04439da16088dcbf$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $04439da16088dcbf$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $04439da16088dcbf$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $04439da16088dcbf$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $04439da16088dcbf$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $04439da16088dcbf$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $04439da16088dcbf$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $04439da16088dcbf$var$noTracking(this, "unshift", args);
    },
    values () {
        return $04439da16088dcbf$var$iterator(this, "values", (item)=>$04439da16088dcbf$var$toWrapped(this, item));
    }
};
function $04439da16088dcbf$var$iterator(self, method, wrapValue) {
    const arr = $04439da16088dcbf$export$5eb48af14254449e(self);
    const iter = arr[method]();
    if (arr !== self && !$04439da16088dcbf$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (!result.done) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const $04439da16088dcbf$var$arrayProto = Array.prototype;
function $04439da16088dcbf$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $04439da16088dcbf$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$04439da16088dcbf$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $04439da16088dcbf$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $04439da16088dcbf$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $04439da16088dcbf$var$toWrapped(self, item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $04439da16088dcbf$var$reduce(self, method, fn, args) {
    const arr = $04439da16088dcbf$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$04439da16088dcbf$export$7f3fe6025abfa26e(self);
    let wrappedFn = fn;
    let wrapInitialAccumulator = false;
    if (arr !== self) {
        if (needsWrap) {
            wrapInitialAccumulator = args.length === 0;
            wrappedFn = function(acc, item, index) {
                if (wrapInitialAccumulator) {
                    wrapInitialAccumulator = false;
                    acc = $04439da16088dcbf$var$toWrapped(self, acc);
                }
                return fn.call(this, acc, $04439da16088dcbf$var$toWrapped(self, item), index, self);
            };
        } else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    const result = arr[method](wrappedFn, ...args);
    return wrapInitialAccumulator ? $04439da16088dcbf$var$toWrapped(self, result) : result;
}
function $04439da16088dcbf$var$searchProxy(self, method, args) {
    const arr = $04439da16088dcbf$export$ab18938b9fc5f28e(self);
    $04439da16088dcbf$export$6b2a7d5132615086(arr, "iterate", $04439da16088dcbf$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $04439da16088dcbf$export$5f3ca29d057519b3(args[0])) {
        args[0] = $04439da16088dcbf$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $04439da16088dcbf$var$noTracking(self, method, args = []) {
    $04439da16088dcbf$export$938a971395fef855();
    $04439da16088dcbf$var$startBatch();
    const res = $04439da16088dcbf$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $04439da16088dcbf$var$endBatch();
    $04439da16088dcbf$export$c39176b1babaa8b8();
    return res;
}
const $04439da16088dcbf$var$isNonTrackableKeys = /* @__PURE__ */ (0, $oF3Y1.makeMap)(`__proto__,__v_isRef,__isVue`);
const $04439da16088dcbf$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $oF3Y1.isSymbol)));
function $04439da16088dcbf$var$hasOwnProperty(key) {
    if (!(0, $oF3Y1.isSymbol)(key)) key = String(key);
    const obj = $04439da16088dcbf$export$ab18938b9fc5f28e(this);
    $04439da16088dcbf$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $04439da16088dcbf$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $04439da16088dcbf$var$shallowReadonlyMap : $04439da16088dcbf$var$readonlyMap : isShallow2 ? $04439da16088dcbf$var$shallowReactiveMap : $04439da16088dcbf$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $oF3Y1.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $04439da16088dcbf$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $04439da16088dcbf$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $04439da16088dcbf$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $oF3Y1.isSymbol)(key) ? $04439da16088dcbf$var$builtInSymbols.has(key) : $04439da16088dcbf$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $04439da16088dcbf$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($04439da16088dcbf$export$4f9f5282de18fc69(res)) {
            const value = targetIsArray && (0, $oF3Y1.isIntegerKey)(key) ? res : res.value;
            return isReadonly2 && (0, $oF3Y1.isObject)(value) ? $04439da16088dcbf$export$6ec456bd5b7b3c51(value) : value;
        }
        if ((0, $oF3Y1.isObject)(res)) return isReadonly2 ? $04439da16088dcbf$export$6ec456bd5b7b3c51(res) : $04439da16088dcbf$export$90a44edba14e47be(res);
        return res;
    }
}
class $04439da16088dcbf$var$MutableReactiveHandler extends $04439da16088dcbf$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        const isArrayWithIntegerKey = (0, $oF3Y1.isArray)(target) && (0, $oF3Y1.isIntegerKey)(key);
        if (!this._isShallow) {
            const isOldValueReadonly = $04439da16088dcbf$export$92d09b48637741e7(oldValue);
            if (!$04439da16088dcbf$export$7f3fe6025abfa26e(value) && !$04439da16088dcbf$export$92d09b48637741e7(value)) {
                oldValue = $04439da16088dcbf$export$ab18938b9fc5f28e(oldValue);
                value = $04439da16088dcbf$export$ab18938b9fc5f28e(value);
            }
            if (!isArrayWithIntegerKey && $04439da16088dcbf$export$4f9f5282de18fc69(oldValue) && !$04439da16088dcbf$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return true;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : (0, $oF3Y1.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $04439da16088dcbf$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $04439da16088dcbf$export$ab18938b9fc5f28e(receiver) && result) {
            if (!hadKey) $04439da16088dcbf$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $oF3Y1.hasChanged)(value, oldValue)) $04439da16088dcbf$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $oF3Y1.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $04439da16088dcbf$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $oF3Y1.isSymbol)(key) || !$04439da16088dcbf$var$builtInSymbols.has(key)) $04439da16088dcbf$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $04439da16088dcbf$export$6b2a7d5132615086(target, "iterate", (0, $oF3Y1.isArray)(target) ? "length" : $04439da16088dcbf$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $04439da16088dcbf$var$ReadonlyReactiveHandler extends $04439da16088dcbf$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $04439da16088dcbf$var$mutableHandlers = /* @__PURE__ */ new $04439da16088dcbf$var$MutableReactiveHandler();
const $04439da16088dcbf$var$readonlyHandlers = /* @__PURE__ */ new $04439da16088dcbf$var$ReadonlyReactiveHandler();
const $04439da16088dcbf$var$shallowReactiveHandlers = /* @__PURE__ */ new $04439da16088dcbf$var$MutableReactiveHandler(true);
const $04439da16088dcbf$var$shallowReadonlyHandlers = /* @__PURE__ */ new $04439da16088dcbf$var$ReadonlyReactiveHandler(true);
const $04439da16088dcbf$var$toShallow = (value)=>value;
const $04439da16088dcbf$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $04439da16088dcbf$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $04439da16088dcbf$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $oF3Y1.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $04439da16088dcbf$var$toShallow : isReadonly2 ? $04439da16088dcbf$export$4a78e7a2a4fb689f : $04439da16088dcbf$export$45c769cf449a508c;
        !isReadonly2 && $04439da16088dcbf$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $04439da16088dcbf$export$49093fa1cddcb78d : $04439da16088dcbf$export$3c41b1a4e06acc14);
        return (0, $oF3Y1.extend)(// inheriting all iterator properties
        Object.create(innerIterator), {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        });
    };
}
function $04439da16088dcbf$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $04439da16088dcbf$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $04439da16088dcbf$export$ab18938b9fc5f28e(target);
            const rawKey = $04439da16088dcbf$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $oF3Y1.hasChanged)(key, rawKey)) $04439da16088dcbf$export$6b2a7d5132615086(rawTarget, "get", key);
                $04439da16088dcbf$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $04439da16088dcbf$var$getProto(rawTarget);
            const wrap = shallow ? $04439da16088dcbf$var$toShallow : readonly ? $04439da16088dcbf$export$4a78e7a2a4fb689f : $04439da16088dcbf$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $04439da16088dcbf$export$6b2a7d5132615086($04439da16088dcbf$export$ab18938b9fc5f28e(target), "iterate", $04439da16088dcbf$export$3c41b1a4e06acc14);
            return target.size;
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $04439da16088dcbf$export$ab18938b9fc5f28e(target);
            const rawKey = $04439da16088dcbf$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $oF3Y1.hasChanged)(key, rawKey)) $04439da16088dcbf$export$6b2a7d5132615086(rawTarget, "has", key);
                $04439da16088dcbf$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $04439da16088dcbf$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $04439da16088dcbf$var$toShallow : readonly ? $04439da16088dcbf$export$4a78e7a2a4fb689f : $04439da16088dcbf$export$45c769cf449a508c;
            !readonly && $04439da16088dcbf$export$6b2a7d5132615086(rawTarget, "iterate", $04439da16088dcbf$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $oF3Y1.extend)(instrumentations, readonly ? {
        add: $04439da16088dcbf$var$createReadonlyMethod("add"),
        set: $04439da16088dcbf$var$createReadonlyMethod("set"),
        delete: $04439da16088dcbf$var$createReadonlyMethod("delete"),
        clear: $04439da16088dcbf$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            const target = $04439da16088dcbf$export$ab18938b9fc5f28e(this);
            const proto = $04439da16088dcbf$var$getProto(target);
            const rawValue = $04439da16088dcbf$export$ab18938b9fc5f28e(value);
            const valueToAdd = !shallow && !$04439da16088dcbf$export$7f3fe6025abfa26e(value) && !$04439da16088dcbf$export$92d09b48637741e7(value) ? rawValue : value;
            const hadKey = proto.has.call(target, valueToAdd) || (0, $oF3Y1.hasChanged)(value, valueToAdd) && proto.has.call(target, value) || (0, $oF3Y1.hasChanged)(rawValue, valueToAdd) && proto.has.call(target, rawValue);
            if (!hadKey) {
                target.add(valueToAdd);
                $04439da16088dcbf$export$e614dc9140f7ae71(target, "add", valueToAdd, valueToAdd);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$04439da16088dcbf$export$7f3fe6025abfa26e(value) && !$04439da16088dcbf$export$92d09b48637741e7(value)) value = $04439da16088dcbf$export$ab18938b9fc5f28e(value);
            const target = $04439da16088dcbf$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $04439da16088dcbf$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $04439da16088dcbf$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $04439da16088dcbf$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $oF3Y1.hasChanged)(value, oldValue)) $04439da16088dcbf$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $04439da16088dcbf$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $04439da16088dcbf$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $04439da16088dcbf$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $04439da16088dcbf$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $04439da16088dcbf$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $04439da16088dcbf$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $04439da16088dcbf$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $04439da16088dcbf$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $04439da16088dcbf$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $oF3Y1.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $04439da16088dcbf$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $04439da16088dcbf$var$createInstrumentationGetter(false, false)
};
const $04439da16088dcbf$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $04439da16088dcbf$var$createInstrumentationGetter(false, true)
};
const $04439da16088dcbf$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $04439da16088dcbf$var$createInstrumentationGetter(true, false)
};
const $04439da16088dcbf$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $04439da16088dcbf$var$createInstrumentationGetter(true, true)
};
function $04439da16088dcbf$var$checkIdentityKeys(target, has, key) {
    const rawKey = $04439da16088dcbf$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $oF3Y1.toRawType)(target);
        $04439da16088dcbf$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $04439da16088dcbf$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $04439da16088dcbf$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $04439da16088dcbf$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $04439da16088dcbf$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $04439da16088dcbf$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
// @__NO_SIDE_EFFECTS__
function $04439da16088dcbf$export$90a44edba14e47be(target) {
    if (/* @__PURE__ */ $04439da16088dcbf$export$92d09b48637741e7(target)) return target;
    return $04439da16088dcbf$var$createReactiveObject(target, false, $04439da16088dcbf$var$mutableHandlers, $04439da16088dcbf$var$mutableCollectionHandlers, $04439da16088dcbf$var$reactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $04439da16088dcbf$export$8d81cefd22d22260(target) {
    return $04439da16088dcbf$var$createReactiveObject(target, false, $04439da16088dcbf$var$shallowReactiveHandlers, $04439da16088dcbf$var$shallowCollectionHandlers, $04439da16088dcbf$var$shallowReactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $04439da16088dcbf$export$6ec456bd5b7b3c51(target) {
    return $04439da16088dcbf$var$createReactiveObject(target, true, $04439da16088dcbf$var$readonlyHandlers, $04439da16088dcbf$var$readonlyCollectionHandlers, $04439da16088dcbf$var$readonlyMap);
}
// @__NO_SIDE_EFFECTS__
function $04439da16088dcbf$export$7c4b5f2b50f09f6b(target) {
    return $04439da16088dcbf$var$createReactiveObject(target, true, $04439da16088dcbf$var$shallowReadonlyHandlers, $04439da16088dcbf$var$shallowReadonlyCollectionHandlers, $04439da16088dcbf$var$shallowReadonlyMap);
}
function $04439da16088dcbf$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $oF3Y1.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    if (target["__v_skip"] || !Object.isExtensible(target)) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $04439da16088dcbf$var$targetTypeMap((0, $oF3Y1.toRawType)(target));
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
// @__NO_SIDE_EFFECTS__
function $04439da16088dcbf$export$352205f445242f02(value) {
    if (/* @__PURE__ */ $04439da16088dcbf$export$92d09b48637741e7(value)) return /* @__PURE__ */ $04439da16088dcbf$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
// @__NO_SIDE_EFFECTS__
function $04439da16088dcbf$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
// @__NO_SIDE_EFFECTS__
function $04439da16088dcbf$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
// @__NO_SIDE_EFFECTS__
function $04439da16088dcbf$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
// @__NO_SIDE_EFFECTS__
function $04439da16088dcbf$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? /* @__PURE__ */ $04439da16088dcbf$export$ab18938b9fc5f28e(raw) : observed;
}
function $04439da16088dcbf$export$995ab8b13ad7a9d0(value) {
    if (!(0, $oF3Y1.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $oF3Y1.def)(value, "__v_skip", true);
    return value;
}
const $04439da16088dcbf$export$45c769cf449a508c = (value)=>(0, $oF3Y1.isObject)(value) ? /* @__PURE__ */ $04439da16088dcbf$export$90a44edba14e47be(value) : value;
const $04439da16088dcbf$export$4a78e7a2a4fb689f = (value)=>(0, $oF3Y1.isObject)(value) ? /* @__PURE__ */ $04439da16088dcbf$export$6ec456bd5b7b3c51(value) : value;
// @__NO_SIDE_EFFECTS__
function $04439da16088dcbf$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
// @__NO_SIDE_EFFECTS__
function $04439da16088dcbf$export$eff4d24c3ff7876e(value) {
    return $04439da16088dcbf$var$createRef(value, false);
}
// @__NO_SIDE_EFFECTS__
function $04439da16088dcbf$export$9b7bc5fe3b17c8b3(value) {
    return $04439da16088dcbf$var$createRef(value, true);
}
function $04439da16088dcbf$var$createRef(rawValue, shallow) {
    if (/* @__PURE__ */ $04439da16088dcbf$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $04439da16088dcbf$var$RefImpl(rawValue, shallow);
}
class $04439da16088dcbf$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $04439da16088dcbf$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $04439da16088dcbf$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $04439da16088dcbf$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $04439da16088dcbf$export$7f3fe6025abfa26e(newValue) || $04439da16088dcbf$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $04439da16088dcbf$export$ab18938b9fc5f28e(newValue);
        if ((0, $oF3Y1.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $04439da16088dcbf$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
}
function $04439da16088dcbf$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $04439da16088dcbf$export$a239a76781616204(ref2) {
    return /* @__PURE__ */ $04439da16088dcbf$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $04439da16088dcbf$export$30bdcc2218aa9458(source) {
    return (0, $oF3Y1.isFunction)(source) ? source() : $04439da16088dcbf$export$a239a76781616204(source);
}
const $04439da16088dcbf$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $04439da16088dcbf$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if (/* @__PURE__ */ $04439da16088dcbf$export$4f9f5282de18fc69(oldValue) && !/* @__PURE__ */ $04439da16088dcbf$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $04439da16088dcbf$export$f353fd1b97db3fa0(objectWithRefs) {
    return $04439da16088dcbf$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $04439da16088dcbf$var$shallowUnwrapHandlers);
}
class $04439da16088dcbf$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $04439da16088dcbf$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $04439da16088dcbf$export$a20c2dd6199824cb(factory) {
    return new $04439da16088dcbf$var$CustomRefImpl(factory);
}
// @__NO_SIDE_EFFECTS__
function $04439da16088dcbf$export$2e9533675e5e70e0(object) {
    const ret = (0, $oF3Y1.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $04439da16088dcbf$var$propertyToRef(object, key);
    return ret;
}
class $04439da16088dcbf$var$ObjectRefImpl {
    constructor(_object, key, _defaultValue){
        this._object = _object;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
        this._key = (0, $oF3Y1.isSymbol)(key) ? key : String(key);
        this._raw = $04439da16088dcbf$export$ab18938b9fc5f28e(_object);
        let shallow = true;
        let obj = _object;
        if (!(0, $oF3Y1.isArray)(_object) || (0, $oF3Y1.isSymbol)(this._key) || !(0, $oF3Y1.isIntegerKey)(this._key)) do shallow = !$04439da16088dcbf$export$5f3ca29d057519b3(obj) || $04439da16088dcbf$export$7f3fe6025abfa26e(obj);
        while (shallow && (obj = obj["__v_raw"]));
        this._shallow = shallow;
    }
    get value() {
        let val = this._object[this._key];
        if (this._shallow) val = $04439da16088dcbf$export$a239a76781616204(val);
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        if (this._shallow && /* @__PURE__ */ $04439da16088dcbf$export$4f9f5282de18fc69(this._raw[this._key])) {
            const nestedRef = this._object[this._key];
            if (/* @__PURE__ */ $04439da16088dcbf$export$4f9f5282de18fc69(nestedRef)) {
                nestedRef.value = newVal;
                return;
            }
        }
        this._object[this._key] = newVal;
    }
    get dep() {
        return $04439da16088dcbf$var$getDepFromReactive(this._raw, this._key);
    }
}
class $04439da16088dcbf$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
// @__NO_SIDE_EFFECTS__
function $04439da16088dcbf$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if (/* @__PURE__ */ $04439da16088dcbf$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $oF3Y1.isFunction)(source)) return new $04439da16088dcbf$var$GetterRefImpl(source);
    else if ((0, $oF3Y1.isObject)(source) && arguments.length > 1) return $04439da16088dcbf$var$propertyToRef(source, key, defaultValue);
    else return /* @__PURE__ */ $04439da16088dcbf$export$eff4d24c3ff7876e(source);
}
function $04439da16088dcbf$var$propertyToRef(source, key, defaultValue) {
    return new $04439da16088dcbf$var$ObjectRefImpl(source, key, defaultValue);
}
class $04439da16088dcbf$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $04439da16088dcbf$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $04439da16088dcbf$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $04439da16088dcbf$var$activeSub !== this) {
            $04439da16088dcbf$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $04439da16088dcbf$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
// @__NO_SIDE_EFFECTS__
function $04439da16088dcbf$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $oF3Y1.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $04439da16088dcbf$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $04439da16088dcbf$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $04439da16088dcbf$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $04439da16088dcbf$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $04439da16088dcbf$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $04439da16088dcbf$var$INITIAL_WATCHER_VALUE = {};
const $04439da16088dcbf$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $04439da16088dcbf$var$activeWatcher = void 0;
function $04439da16088dcbf$export$2532f7acfca7c82d() {
    return $04439da16088dcbf$var$activeWatcher;
}
function $04439da16088dcbf$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $04439da16088dcbf$var$activeWatcher) {
    if (owner) {
        let cleanups = $04439da16088dcbf$var$cleanupMap.get(owner);
        if (!cleanups) $04439da16088dcbf$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $04439da16088dcbf$export$3db5d71bdb2d5499(source, cb, options = (0, $oF3Y1.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $04439da16088dcbf$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($04439da16088dcbf$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $04439da16088dcbf$export$df3f009e3d155b20(source2, 1);
        return $04439da16088dcbf$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($04439da16088dcbf$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $04439da16088dcbf$export$7f3fe6025abfa26e(source);
    } else if ($04439da16088dcbf$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $oF3Y1.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$04439da16088dcbf$export$352205f445242f02(s) || $04439da16088dcbf$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($04439da16088dcbf$export$4f9f5282de18fc69(s)) return s.value;
                else if ($04439da16088dcbf$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $oF3Y1.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $oF3Y1.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $04439da16088dcbf$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $04439da16088dcbf$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $04439da16088dcbf$var$activeWatcher;
            $04439da16088dcbf$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $04439da16088dcbf$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $oF3Y1.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$04439da16088dcbf$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $04439da16088dcbf$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $oF3Y1.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            const res = _cb(...args);
            watchHandle();
            return res;
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($04439da16088dcbf$var$INITIAL_WATCHER_VALUE) : $04439da16088dcbf$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (immediateFirstRun || deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $oF3Y1.hasChanged)(v, oldValue[i])) : (0, $oF3Y1.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = $04439da16088dcbf$var$activeWatcher;
                $04439da16088dcbf$var$activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $04439da16088dcbf$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $04439da16088dcbf$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    oldValue = newValue;
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                } finally{
                    $04439da16088dcbf$var$activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $04439da16088dcbf$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$04439da16088dcbf$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $04439da16088dcbf$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $04439da16088dcbf$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $04439da16088dcbf$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $oF3Y1.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Map();
    if ((seen.get(value) || 0) >= depth) return value;
    seen.set(value, depth);
    depth--;
    if ($04439da16088dcbf$export$4f9f5282de18fc69(value)) $04439da16088dcbf$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $oF3Y1.isArray)(value)) for(let i = 0; i < value.length; i++)$04439da16088dcbf$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $oF3Y1.isSet)(value) || (0, $oF3Y1.isMap)(value)) value.forEach((v)=>{
        $04439da16088dcbf$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $oF3Y1.isPlainObject)(value)) {
        for(const key in value)$04439da16088dcbf$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $04439da16088dcbf$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("oF3Y1", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $04a21842715d974b$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $04a21842715d974b$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $04a21842715d974b$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $04a21842715d974b$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $04a21842715d974b$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $04a21842715d974b$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $04a21842715d974b$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $04a21842715d974b$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $04a21842715d974b$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $04a21842715d974b$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $04a21842715d974b$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $04a21842715d974b$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $04a21842715d974b$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $04a21842715d974b$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $04a21842715d974b$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $04a21842715d974b$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $04a21842715d974b$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $04a21842715d974b$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $04a21842715d974b$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $04a21842715d974b$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $04a21842715d974b$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $04a21842715d974b$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $04a21842715d974b$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $04a21842715d974b$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $04a21842715d974b$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $04a21842715d974b$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $04a21842715d974b$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $04a21842715d974b$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $04a21842715d974b$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $04a21842715d974b$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $04a21842715d974b$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $04a21842715d974b$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $04a21842715d974b$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $04a21842715d974b$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $04a21842715d974b$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $04a21842715d974b$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $04a21842715d974b$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $04a21842715d974b$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "isHTMLTag", () => $04a21842715d974b$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $04a21842715d974b$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $04a21842715d974b$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $04a21842715d974b$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $04a21842715d974b$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $04a21842715d974b$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $04a21842715d974b$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $04a21842715d974b$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $04a21842715d974b$export$921dd2acf0d386a3);
$parcel$export(module.exports, "getEscapedCssVarName", () => $04a21842715d974b$export$ad9a320bfb7ba440);
$parcel$export(module.exports, "looseEqual", () => $04a21842715d974b$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $04a21842715d974b$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $04a21842715d974b$export$b5b1545233b45293);
$parcel$export(module.exports, "normalizeCssVarValue", () => $04a21842715d974b$export$97fe3d6453ee2f5e);
/**
* @vue/shared v3.5.40
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ // @__NO_SIDE_EFFECTS__
function $04a21842715d974b$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $04a21842715d974b$export$cf583d23ab39677c = {};
const $04a21842715d974b$export$6bd8558f433f1cc1 = [];
const $04a21842715d974b$export$5702a91a6f42969f = ()=>{};
const $04a21842715d974b$export$c01351c0af048e39 = ()=>false;
const $04a21842715d974b$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $04a21842715d974b$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $04a21842715d974b$export$8b58be045bf06082 = Object.assign;
const $04a21842715d974b$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $04a21842715d974b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $04a21842715d974b$export$b5a638e9b3fff9f3 = (val, key)=>$04a21842715d974b$var$hasOwnProperty.call(val, key);
const $04a21842715d974b$export$43bee75e5e14138e = Array.isArray;
const $04a21842715d974b$export$5c90113a285f2241 = (val)=>$04a21842715d974b$export$1dccc787cc36538b(val) === "[object Map]";
const $04a21842715d974b$export$6750766a7c7ec627 = (val)=>$04a21842715d974b$export$1dccc787cc36538b(val) === "[object Set]";
const $04a21842715d974b$export$871608497c498473 = (val)=>$04a21842715d974b$export$1dccc787cc36538b(val) === "[object Date]";
const $04a21842715d974b$export$49841c62b9eff15 = (val)=>$04a21842715d974b$export$1dccc787cc36538b(val) === "[object RegExp]";
const $04a21842715d974b$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $04a21842715d974b$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $04a21842715d974b$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $04a21842715d974b$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $04a21842715d974b$export$4369c812aac99591 = (val)=>{
    return ($04a21842715d974b$export$a6cdc56e425d0d0a(val) || $04a21842715d974b$export$f6e2535fb5126e54(val)) && $04a21842715d974b$export$f6e2535fb5126e54(val.then) && $04a21842715d974b$export$f6e2535fb5126e54(val.catch);
};
const $04a21842715d974b$export$830c053460e5ddf6 = Object.prototype.toString;
const $04a21842715d974b$export$1dccc787cc36538b = (value)=>$04a21842715d974b$export$830c053460e5ddf6.call(value);
const $04a21842715d974b$export$5ad0a3c360b8fbb5 = (value)=>{
    return $04a21842715d974b$export$1dccc787cc36538b(value).slice(8, -1);
};
const $04a21842715d974b$export$53b83ca8eaab0383 = (val)=>$04a21842715d974b$export$1dccc787cc36538b(val) === "[object Object]";
const $04a21842715d974b$export$e2a2b93446ec9fe = (key)=>$04a21842715d974b$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $04a21842715d974b$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $04a21842715d974b$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $04a21842715d974b$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $04a21842715d974b$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $04a21842715d974b$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $04a21842715d974b$var$camelizeRE = /-\w/g;
const $04a21842715d974b$export$161d051f5dd25de7 = $04a21842715d974b$var$cacheStringFunction((str)=>{
    return str.replace($04a21842715d974b$var$camelizeRE, (c)=>c.slice(1).toUpperCase());
});
const $04a21842715d974b$var$hyphenateRE = /\B([A-Z])/g;
const $04a21842715d974b$export$6e6a0a3676c4b8bb = $04a21842715d974b$var$cacheStringFunction((str)=>str.replace($04a21842715d974b$var$hyphenateRE, "-$1").toLowerCase());
const $04a21842715d974b$export$9a00dee1beb8f576 = $04a21842715d974b$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $04a21842715d974b$export$8c022799eeaaefcd = $04a21842715d974b$var$cacheStringFunction((str)=>{
    const s = str ? `on${$04a21842715d974b$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $04a21842715d974b$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $04a21842715d974b$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $04a21842715d974b$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $04a21842715d974b$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $04a21842715d974b$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $04a21842715d974b$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $04a21842715d974b$var$_globalThis;
const $04a21842715d974b$export$ff5f2eeb11fc7e14 = ()=>{
    return $04a21842715d974b$var$_globalThis || ($04a21842715d974b$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $04a21842715d974b$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $04a21842715d974b$export$53d5e12f9a1d3cde(name) {
    return $04a21842715d974b$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $04a21842715d974b$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $04a21842715d974b$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $04a21842715d974b$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `CACHED`,
    [-2]: `BAIL`
};
const $04a21842715d974b$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $04a21842715d974b$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $04a21842715d974b$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $04a21842715d974b$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $04a21842715d974b$export$f73b8c13b7f97ebf = /* @__PURE__ */ $04a21842715d974b$export$b41394a5437791c8($04a21842715d974b$var$GLOBALS_ALLOWED);
const $04a21842715d974b$export$d6571a1911e4f27e = $04a21842715d974b$export$f73b8c13b7f97ebf;
const $04a21842715d974b$var$range = 2;
function $04a21842715d974b$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $04a21842715d974b$var$range; j <= i + $04a21842715d974b$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $04a21842715d974b$export$8756898546458274(value) {
    if ($04a21842715d974b$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $04a21842715d974b$export$844ec244b1367d54(item) ? $04a21842715d974b$export$76a205ce979d066a(item) : $04a21842715d974b$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($04a21842715d974b$export$844ec244b1367d54(value) || $04a21842715d974b$export$a6cdc56e425d0d0a(value)) return value;
}
const $04a21842715d974b$var$listDelimiterRE = /;(?![^(]*\))/g;
const $04a21842715d974b$var$propertyDelimiterRE = /:([^]+)/;
const $04a21842715d974b$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $04a21842715d974b$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($04a21842715d974b$var$styleCommentRE, "").split($04a21842715d974b$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($04a21842715d974b$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $04a21842715d974b$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($04a21842715d974b$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($04a21842715d974b$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $04a21842715d974b$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $04a21842715d974b$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($04a21842715d974b$export$844ec244b1367d54(value)) res = value;
    else if ($04a21842715d974b$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $04a21842715d974b$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($04a21842715d974b$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $04a21842715d974b$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$04a21842715d974b$export$844ec244b1367d54(klass)) props.class = $04a21842715d974b$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $04a21842715d974b$export$8756898546458274(style);
    return props;
}
const $04a21842715d974b$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $04a21842715d974b$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $04a21842715d974b$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $04a21842715d974b$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $04a21842715d974b$export$1ccf854a0984f890 = /* @__PURE__ */ $04a21842715d974b$export$b41394a5437791c8($04a21842715d974b$var$HTML_TAGS);
const $04a21842715d974b$export$6328ce7565ea1049 = /* @__PURE__ */ $04a21842715d974b$export$b41394a5437791c8($04a21842715d974b$var$SVG_TAGS);
const $04a21842715d974b$export$4a46ca4c5be17b20 = /* @__PURE__ */ $04a21842715d974b$export$b41394a5437791c8($04a21842715d974b$var$MATH_TAGS);
const $04a21842715d974b$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $04a21842715d974b$export$b41394a5437791c8($04a21842715d974b$var$VOID_TAGS);
const $04a21842715d974b$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $04a21842715d974b$export$d186f5eb2e810715 = /* @__PURE__ */ $04a21842715d974b$export$b41394a5437791c8($04a21842715d974b$var$specialBooleanAttrs);
const $04a21842715d974b$export$f763ba3b84e9cd8c = /* @__PURE__ */ $04a21842715d974b$export$b41394a5437791c8($04a21842715d974b$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $04a21842715d974b$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $04a21842715d974b$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $04a21842715d974b$var$attrValidationCache = {};
function $04a21842715d974b$export$d55ef77660f30d12(name) {
    if ($04a21842715d974b$var$attrValidationCache.hasOwnProperty(name)) return $04a21842715d974b$var$attrValidationCache[name];
    const isUnsafe = $04a21842715d974b$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $04a21842715d974b$var$attrValidationCache[name] = !isUnsafe;
}
const $04a21842715d974b$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $04a21842715d974b$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $04a21842715d974b$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $04a21842715d974b$export$80da416f43933831 = /* @__PURE__ */ $04a21842715d974b$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $04a21842715d974b$export$fc0748a8e0014066 = /* @__PURE__ */ $04a21842715d974b$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $04a21842715d974b$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $04a21842715d974b$var$escapeRE = /["'&<>]/;
function $04a21842715d974b$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $04a21842715d974b$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $04a21842715d974b$var$commentStripRE = /^(?:-?>)+|<!--|-->|--!>|<!-$/g;
function $04a21842715d974b$export$7b105034a53bde5f(src) {
    let prev;
    do {
        prev = src;
        src = src.replace($04a21842715d974b$var$commentStripRE, "");
    }while (src !== prev);
    return src;
}
const $04a21842715d974b$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $04a21842715d974b$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($04a21842715d974b$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $04a21842715d974b$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $04a21842715d974b$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $04a21842715d974b$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $04a21842715d974b$export$871608497c498473(a);
    let bValidType = $04a21842715d974b$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $04a21842715d974b$export$a244864fd9645c7f(a);
    bValidType = $04a21842715d974b$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $04a21842715d974b$export$43bee75e5e14138e(a);
    bValidType = $04a21842715d974b$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $04a21842715d974b$var$looseCompareArrays(a, b) : false;
    aValidType = $04a21842715d974b$export$a6cdc56e425d0d0a(a);
    bValidType = $04a21842715d974b$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$04a21842715d974b$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $04a21842715d974b$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$04a21842715d974b$export$ae8015769846262c(item, val));
}
const $04a21842715d974b$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $04a21842715d974b$export$b5b1545233b45293 = (val)=>{
    return $04a21842715d974b$export$844ec244b1367d54(val) ? val : val == null ? "" : $04a21842715d974b$export$43bee75e5e14138e(val) || $04a21842715d974b$export$a6cdc56e425d0d0a(val) && (val.toString === $04a21842715d974b$export$830c053460e5ddf6 || !$04a21842715d974b$export$f6e2535fb5126e54(val.toString)) ? $04a21842715d974b$var$isRef(val) ? $04a21842715d974b$export$b5b1545233b45293(val.value) : JSON.stringify(val, $04a21842715d974b$var$replacer, 2) : String(val);
};
const $04a21842715d974b$var$replacer = (_key, val)=>{
    if ($04a21842715d974b$var$isRef(val)) return $04a21842715d974b$var$replacer(_key, val.value);
    else if ($04a21842715d974b$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$04a21842715d974b$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($04a21842715d974b$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$04a21842715d974b$var$stringifySymbol(v))
    };
    else if ($04a21842715d974b$export$a244864fd9645c7f(val)) return $04a21842715d974b$var$stringifySymbol(val);
    else if ($04a21842715d974b$export$a6cdc56e425d0d0a(val) && !$04a21842715d974b$export$43bee75e5e14138e(val) && !$04a21842715d974b$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $04a21842715d974b$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $04a21842715d974b$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};
function $04a21842715d974b$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

});



parcelRegister("jfBPE", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("igcaK")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("igcaK")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("igcaK")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("oF3Y1")).camelize);
$parcel$export(module.exports, "computed", () => (parcelRequire("igcaK")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("igcaK")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("igcaK")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("igcaK")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("igcaK")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("igcaK")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("igcaK")).createRenderer);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("igcaK")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("igcaK")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("igcaK")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("igcaK")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("igcaK")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("igcaK")).getTransitionRawChildren);
$parcel$export(module.exports, "h", () => (parcelRequire("igcaK")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("igcaK")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("igcaK")).inject);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("igcaK")).isRuntimeOnly);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("igcaK")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("oF3Y1")).normalizeClass);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("igcaK")).onActivated);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("igcaK")).onBeforeUpdate);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("igcaK")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("igcaK")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("igcaK")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("igcaK")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("igcaK")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("igcaK")).provide);
$parcel$export(module.exports, "queuePostFlushCb", () => (parcelRequire("igcaK")).queuePostFlushCb);
$parcel$export(module.exports, "reactive", () => (parcelRequire("mHgsT")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("mHgsT")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("igcaK")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("igcaK")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("igcaK")).resolveComponent);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("igcaK")).resolveDynamicComponent);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("igcaK")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("igcaK")).setTransitionHooks);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("mHgsT")).shallowReactive);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("mHgsT")).shallowRef);
$parcel$export(module.exports, "Static", () => (parcelRequire("igcaK")).Static);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("mHgsT")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("igcaK")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("igcaK")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("igcaK")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("igcaK")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("igcaK")).withCtx);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("oF3Y1")).toDisplayString);

$parcel$export(module.exports, "Transition", () => $039de21fb4b9777e$export$be58926105124dd4);
$parcel$export(module.exports, "createApp", () => $039de21fb4b9777e$export$4e373c34abfa8c68);
$parcel$export(module.exports, "withModifiers", () => $039de21fb4b9777e$export$26bd3b8e29e6f273);
/**
* @vue/runtime-dom v3.5.40
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $igcaK = parcelRequire("igcaK");
var $oF3Y1 = parcelRequire("oF3Y1");
var $mHgsT = parcelRequire("mHgsT");parcelRequire("oF3Y1");
var $mHgsT = parcelRequire("mHgsT");

var $oF3Y1 = parcelRequire("oF3Y1");
let $039de21fb4b9777e$var$policy = void 0;
const $039de21fb4b9777e$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($039de21fb4b9777e$var$tt) try {
    $039de21fb4b9777e$var$policy = /* @__PURE__ */ $039de21fb4b9777e$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $039de21fb4b9777e$var$unsafeToTrustedHTML = $039de21fb4b9777e$var$policy ? (val)=>$039de21fb4b9777e$var$policy.createHTML(val) : (val)=>val;
const $039de21fb4b9777e$var$svgNS = "http://www.w3.org/2000/svg";
const $039de21fb4b9777e$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $039de21fb4b9777e$var$doc = typeof document !== "undefined" ? document : null;
const $039de21fb4b9777e$var$templateContainer = $039de21fb4b9777e$var$doc && /* @__PURE__ */ $039de21fb4b9777e$var$doc.createElement("template");
const $039de21fb4b9777e$export$de4fb7f5030605d3 = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $039de21fb4b9777e$var$doc.createElementNS($039de21fb4b9777e$var$svgNS, tag) : namespace === "mathml" ? $039de21fb4b9777e$var$doc.createElementNS($039de21fb4b9777e$var$mathmlNS, tag) : is ? $039de21fb4b9777e$var$doc.createElement(tag, {
            is: is
        }) : $039de21fb4b9777e$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$039de21fb4b9777e$var$doc.createTextNode(text),
    createComment: (text)=>$039de21fb4b9777e$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$039de21fb4b9777e$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $039de21fb4b9777e$var$templateContainer.innerHTML = $039de21fb4b9777e$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $039de21fb4b9777e$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $039de21fb4b9777e$var$TRANSITION = "transition";
const $039de21fb4b9777e$var$ANIMATION = "animation";
const $039de21fb4b9777e$var$vtcKey = /* @__PURE__ */ Symbol("_vtc");
const $039de21fb4b9777e$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $039de21fb4b9777e$var$TransitionPropsValidators = /* @__PURE__ */ (0, $oF3Y1.extend)({}, (0, $igcaK.BaseTransitionPropsValidators), $039de21fb4b9777e$var$DOMTransitionPropsValidators);
const $039de21fb4b9777e$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $039de21fb4b9777e$var$TransitionPropsValidators;
    return t;
};
const $039de21fb4b9777e$export$be58926105124dd4 = /* @__PURE__ */ $039de21fb4b9777e$var$decorate$1((props, { slots: slots })=>(0, $igcaK.h)((0, $igcaK.BaseTransition), $039de21fb4b9777e$var$resolveTransitionProps(props), slots));
const $039de21fb4b9777e$var$callHook = (hook, args = [])=>{
    if ((0, $oF3Y1.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $039de21fb4b9777e$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $oF3Y1.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $039de21fb4b9777e$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $039de21fb4b9777e$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $039de21fb4b9777e$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $039de21fb4b9777e$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $039de21fb4b9777e$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $039de21fb4b9777e$var$removeTransitionClass(el, leaveFromClass);
        $039de21fb4b9777e$var$removeTransitionClass(el, leaveToClass);
        $039de21fb4b9777e$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $039de21fb4b9777e$var$callHook(hook, [
                el,
                resolve
            ]);
            $039de21fb4b9777e$var$nextFrame(()=>{
                $039de21fb4b9777e$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $039de21fb4b9777e$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$039de21fb4b9777e$var$hasExplicitCallback(hook)) $039de21fb4b9777e$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $oF3Y1.extend)(baseProps, {
        onBeforeEnter (el) {
            $039de21fb4b9777e$var$callHook(onBeforeEnter, [
                el
            ]);
            $039de21fb4b9777e$var$addTransitionClass(el, enterFromClass);
            $039de21fb4b9777e$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $039de21fb4b9777e$var$callHook(onBeforeAppear, [
                el
            ]);
            $039de21fb4b9777e$var$addTransitionClass(el, appearFromClass);
            $039de21fb4b9777e$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $039de21fb4b9777e$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $039de21fb4b9777e$var$forceReflow(el);
                $039de21fb4b9777e$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $039de21fb4b9777e$var$addTransitionClass(el, leaveActiveClass);
                $039de21fb4b9777e$var$forceReflow(el);
            }
            $039de21fb4b9777e$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $039de21fb4b9777e$var$removeTransitionClass(el, leaveFromClass);
                $039de21fb4b9777e$var$addTransitionClass(el, leaveToClass);
                if (!$039de21fb4b9777e$var$hasExplicitCallback(onLeave)) $039de21fb4b9777e$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $039de21fb4b9777e$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $039de21fb4b9777e$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $039de21fb4b9777e$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $039de21fb4b9777e$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $039de21fb4b9777e$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $oF3Y1.isObject)(duration)) return [
        $039de21fb4b9777e$var$NumberOf(duration.enter),
        $039de21fb4b9777e$var$NumberOf(duration.leave)
    ];
    else {
        const n = $039de21fb4b9777e$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $039de21fb4b9777e$var$NumberOf(val) {
    const res = (0, $oF3Y1.toNumber)(val);
    return res;
}
function $039de21fb4b9777e$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$039de21fb4b9777e$var$vtcKey] || (el[$039de21fb4b9777e$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $039de21fb4b9777e$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$039de21fb4b9777e$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$039de21fb4b9777e$var$vtcKey] = void 0;
    }
}
function $039de21fb4b9777e$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $039de21fb4b9777e$var$endId = 0;
function $039de21fb4b9777e$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$039de21fb4b9777e$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $039de21fb4b9777e$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $039de21fb4b9777e$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$039de21fb4b9777e$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$039de21fb4b9777e$var$TRANSITION}Duration`);
    const transitionTimeout = $039de21fb4b9777e$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$039de21fb4b9777e$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$039de21fb4b9777e$var$ANIMATION}Duration`);
    const animationTimeout = $039de21fb4b9777e$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $039de21fb4b9777e$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $039de21fb4b9777e$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $039de21fb4b9777e$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $039de21fb4b9777e$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $039de21fb4b9777e$var$TRANSITION : $039de21fb4b9777e$var$ANIMATION : null;
        propCount = type ? type === $039de21fb4b9777e$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $039de21fb4b9777e$var$TRANSITION && /\b(?:transform|all)(?:,|$)/.test(getStyleProperties(`${$039de21fb4b9777e$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $039de21fb4b9777e$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$039de21fb4b9777e$var$toMs(d) + $039de21fb4b9777e$var$toMs(delays[i])));
}
function $039de21fb4b9777e$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $039de21fb4b9777e$var$forceReflow(el) {
    const targetDocument = el ? el.ownerDocument : document;
    return targetDocument.body.offsetHeight;
}
function $039de21fb4b9777e$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$039de21fb4b9777e$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $039de21fb4b9777e$var$vShowOriginalDisplay = /* @__PURE__ */ Symbol("_vod");
const $039de21fb4b9777e$var$vShowHidden = /* @__PURE__ */ Symbol("_vsh");
const $039de21fb4b9777e$export$5cb4fcdc6937d7e1 = {
    // used for prop mismatch check during hydration
    name: "show",
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$039de21fb4b9777e$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $039de21fb4b9777e$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $039de21fb4b9777e$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $039de21fb4b9777e$var$setDisplay(el, false);
            });
        } else $039de21fb4b9777e$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $039de21fb4b9777e$var$setDisplay(el, value);
    }
};
function $039de21fb4b9777e$var$setDisplay(el, value) {
    el.style.display = value ? el[$039de21fb4b9777e$var$vShowOriginalDisplay] : "none";
    el[$039de21fb4b9777e$var$vShowHidden] = !value;
}
function $039de21fb4b9777e$var$initVShowForSSR() {
    $039de21fb4b9777e$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $039de21fb4b9777e$var$CSS_VAR_TEXT = /* @__PURE__ */ Symbol("");
function $039de21fb4b9777e$export$ef28b76f07940108(getter) {
    const instance = (0, $igcaK.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$039de21fb4b9777e$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $039de21fb4b9777e$var$setVarsOnNode(instance.ce, vars);
        else $039de21fb4b9777e$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $igcaK.onBeforeUpdate)(()=>{
        (0, $igcaK.queuePostFlushCb)(setVars);
    });
    (0, $igcaK.onMounted)(()=>{
        (0, $igcaK.watch)(setVars, (0, $oF3Y1.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $igcaK.onUnmounted)(()=>ob.disconnect());
    });
}
function $039de21fb4b9777e$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $039de21fb4b9777e$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $039de21fb4b9777e$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $igcaK.Fragment)) vnode.children.forEach((c)=>$039de21fb4b9777e$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $igcaK.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $039de21fb4b9777e$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $039de21fb4b9777e$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            const value = (0, $oF3Y1.normalizeCssVarValue)(vars[key]);
            style.setProperty(`--${key}`, value);
            cssText += `--${key}: ${value};`;
        }
        style[$039de21fb4b9777e$var$CSS_VAR_TEXT] = cssText;
    }
}
const $039de21fb4b9777e$var$displayRE = /(?:^|;)\s*display\s*:/;
function $039de21fb4b9777e$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $oF3Y1.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $oF3Y1.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $039de21fb4b9777e$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $039de21fb4b9777e$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            const value = next[key];
            if (value != null) {
                if (!$039de21fb4b9777e$var$shouldPreserveTextareaResizeStyle(el, key, !(0, $oF3Y1.isString)(prev) && prev ? prev[key] : void 0, value)) $039de21fb4b9777e$var$setStyle(style, key, value);
            } else $039de21fb4b9777e$var$setStyle(style, key, "");
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$039de21fb4b9777e$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $039de21fb4b9777e$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($039de21fb4b9777e$var$vShowOriginalDisplay in el) {
        el[$039de21fb4b9777e$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$039de21fb4b9777e$var$vShowHidden]) style.display = "none";
    }
}
const $039de21fb4b9777e$var$semicolonRE = /[^\\];\s*$/;
const $039de21fb4b9777e$var$importantRE = /\s*!important$/;
function $039de21fb4b9777e$var$setStyle(style, name, val) {
    if ((0, $oF3Y1.isArray)(val)) val.forEach((v)=>$039de21fb4b9777e$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $039de21fb4b9777e$var$autoPrefix(style, name);
            if ($039de21fb4b9777e$var$importantRE.test(val)) style.setProperty((0, $oF3Y1.hyphenate)(prefixed), val.replace($039de21fb4b9777e$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $039de21fb4b9777e$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $039de21fb4b9777e$var$prefixCache = {};
function $039de21fb4b9777e$var$autoPrefix(style, rawName) {
    const cached = $039de21fb4b9777e$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $oF3Y1.camelize)(rawName);
    if (name !== "filter" && name in style) return $039de21fb4b9777e$var$prefixCache[rawName] = name;
    name = (0, $oF3Y1.capitalize)(name);
    for(let i = 0; i < $039de21fb4b9777e$var$prefixes.length; i++){
        const prefixed = $039de21fb4b9777e$var$prefixes[i] + name;
        if (prefixed in style) return $039de21fb4b9777e$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
function $039de21fb4b9777e$var$shouldPreserveTextareaResizeStyle(el, key, prev, next) {
    return el.tagName === "TEXTAREA" && (key === "width" || key === "height") && (0, $oF3Y1.isString)(next) && prev === next;
}
const $039de21fb4b9777e$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $039de21fb4b9777e$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $oF3Y1.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($039de21fb4b9777e$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($039de21fb4b9777e$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $oF3Y1.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $oF3Y1.isSymbol)(value) ? String(value) : value);
}
function $039de21fb4b9777e$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $039de21fb4b9777e$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $oF3Y1.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $039de21fb4b9777e$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $039de21fb4b9777e$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $039de21fb4b9777e$var$veiKey = /* @__PURE__ */ Symbol("_vei");
function $039de21fb4b9777e$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$039de21fb4b9777e$var$veiKey] || (el[$039de21fb4b9777e$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $039de21fb4b9777e$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $039de21fb4b9777e$var$createInvoker(nextValue, instance);
            $039de21fb4b9777e$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $039de21fb4b9777e$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $039de21fb4b9777e$var$optionsModifierRE = /(Once|Passive|Capture)$/;
const $039de21fb4b9777e$var$optionsModifierEventRE = /^on:?(?:Once|Passive|Capture)$/;
function $039de21fb4b9777e$var$parseName(name) {
    let options;
    let m;
    while((m = name.match($039de21fb4b9777e$var$optionsModifierRE)) && !$039de21fb4b9777e$var$optionsModifierEventRE.test(name)){
        if (!options) options = {};
        name = name.slice(0, name.length - m[1].length);
        options[m[1].toLowerCase()] = true;
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $oF3Y1.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $039de21fb4b9777e$var$cachedNow = 0;
const $039de21fb4b9777e$var$p = /* @__PURE__ */ Promise.resolve();
const $039de21fb4b9777e$var$getNow = ()=>$039de21fb4b9777e$var$cachedNow || ($039de21fb4b9777e$var$p.then(()=>$039de21fb4b9777e$var$cachedNow = 0), $039de21fb4b9777e$var$cachedNow = Date.now());
function $039de21fb4b9777e$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        const value = invoker.value;
        if ((0, $oF3Y1.isArray)(value)) {
            const originalStop = e.stopImmediatePropagation;
            e.stopImmediatePropagation = ()=>{
                originalStop.call(e);
                e._stopped = true;
            };
            const handlers = value.slice();
            const args = [
                e
            ];
            for(let i = 0; i < handlers.length; i++){
                if (e._stopped) break;
                const handler = handlers[i];
                if (handler) (0, $igcaK.callWithAsyncErrorHandling)(handler, instance, 5, args);
            }
        } else (0, $igcaK.callWithAsyncErrorHandling)(value, instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $039de21fb4b9777e$var$getNow();
    return invoker;
}
function $039de21fb4b9777e$var$sanitizeEventValue(value, propName) {
    if ((0, $oF3Y1.isFunction)(value) || (0, $oF3Y1.isArray)(value)) return value;
    (0, $igcaK.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $oF3Y1.NOOP;
}
const $039de21fb4b9777e$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $039de21fb4b9777e$export$cd4aa0842d13df8b = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $039de21fb4b9777e$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $039de21fb4b9777e$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $oF3Y1.isOn)(key)) {
        if (!(0, $oF3Y1.isModelListener)(key)) $039de21fb4b9777e$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $039de21fb4b9777e$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $039de21fb4b9777e$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $039de21fb4b9777e$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && // #12408 check if it's declared prop or it's async custom element
    ($039de21fb4b9777e$var$shouldSetAsPropForVueCE(el, key) || // @ts-expect-error _def is private
    el._def.__asyncLoader && (/[A-Z]/.test(key) || !(0, $oF3Y1.isString)(nextValue)))) $039de21fb4b9777e$var$patchDOMProp(el, (0, $oF3Y1.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $039de21fb4b9777e$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $039de21fb4b9777e$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $039de21fb4b9777e$var$isNativeOn(key) && (0, $oF3Y1.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
    if (key === "sandbox" && el.tagName === "IFRAME") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($039de21fb4b9777e$var$isNativeOn(key) && (0, $oF3Y1.isString)(value)) return false;
    return key in el;
}
function $039de21fb4b9777e$var$shouldSetAsPropForVueCE(el, key) {
    const props = // @ts-expect-error _def is private
    el._def.props;
    if (!props) return false;
    const camelKey = (0, $oF3Y1.camelize)(key);
    return Array.isArray(props) ? props.some((prop)=>(0, $oF3Y1.camelize)(prop) === camelKey) : Object.keys(props).some((prop)=>(0, $oF3Y1.camelize)(prop) === camelKey);
}
const $039de21fb4b9777e$var$REMOVAL = {};
// @__NO_SIDE_EFFECTS__
function $039de21fb4b9777e$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    let Comp = (0, $igcaK.defineComponent)(options, extraOptions);
    if ((0, $oF3Y1.isPlainObject)(Comp)) Comp = (0, $oF3Y1.extend)({}, Comp, extraOptions);
    class VueCustomElement extends $039de21fb4b9777e$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $039de21fb4b9777e$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $039de21fb4b9777e$export$a00e2346eabbdbef(options, extraOptions, $039de21fb4b9777e$export$35800275c0037383);
};
const $039de21fb4b9777e$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $039de21fb4b9777e$export$b337c1a55163dbe3 extends $039de21fb4b9777e$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $039de21fb4b9777e$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._patching = false;
        this._dirty = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._styleAnchors = /* @__PURE__ */ new WeakMap();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $039de21fb4b9777e$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow((0, $oF3Y1.extend)({}, _def.shadowRootOptions, {
                mode: "open"
            }));
            this._root = this.shadowRoot;
        } else this._root = this;
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot && !this._resolved) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && // #12479 should check assignedSlot first to get correct parent
        (parent.assignedSlot || parent.parentNode || parent.host))if (parent instanceof $039de21fb4b9777e$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) this._mount(this._def);
            else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._inheritParentContext(parent);
        }
    }
    _inheritParentContext(parent = this._parent) {
        if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $igcaK.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
                if (this._teleportTargets) {
                    this._teleportTargets.clear();
                    this._teleportTargets = void 0;
                }
            }
        });
    }
    _processMutations(mutations) {
        for (const m of mutations)this._setAttr(m.attributeName);
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver(this._processMutations.bind(this));
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $oF3Y1.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $oF3Y1.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $oF3Y1.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) this._pendingResolve = asyncDef().then((def)=>{
            def.configureApp = this._def.configureApp;
            resolve(this._def = def, true);
        });
        else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        this._inheritParentContext();
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $oF3Y1.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $mHgsT.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $oF3Y1.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $oF3Y1.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, !this._patching);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $039de21fb4b9777e$var$REMOVAL;
        const camelKey = (0, $oF3Y1.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $oF3Y1.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            this._dirty = true;
            if (val === $039de21fb4b9777e$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                if (ob) {
                    this._processMutations(ob.takeRecords());
                    ob.disconnect();
                }
                if (val === true) this.setAttribute((0, $oF3Y1.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $oF3Y1.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $oF3Y1.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        const vnode = this._createVNode();
        if (this._app) vnode.appContext = this._app._context;
        $039de21fb4b9777e$export$b3890eb0ae9dca99(vnode, this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $igcaK.createVNode)(this._def, (0, $oF3Y1.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $oF3Y1.isPlainObject)(args[0]) ? (0, $oF3Y1.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $oF3Y1.hyphenate)(event) !== event) dispatch((0, $oF3Y1.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner, parentComp) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        const root = this.shadowRoot;
        const insertionAnchor = parentComp ? this._getStyleAnchor(parentComp) || this._getStyleAnchor(this._def) : this._getRootStyleInsertionAnchor(root);
        let last = null;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            root.insertBefore(s, last || insertionAnchor);
            last = s;
            if (i === 0) {
                if (!parentComp) this._styleAnchors.set(this._def, s);
                if (owner) this._styleAnchors.set(owner, s);
            }
        }
    }
    _getStyleAnchor(comp) {
        if (!comp) return null;
        const anchor = this._styleAnchors.get(comp);
        if (anchor && anchor.parentNode === this.shadowRoot) return anchor;
        if (anchor) this._styleAnchors.delete(comp);
        return null;
    }
    _getRootStyleInsertionAnchor(root) {
        for(let i = 0; i < root.childNodes.length; i++){
            const node = root.childNodes[i];
            if (!(node instanceof HTMLStyleElement)) return node;
        }
        return null;
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = this._getSlots();
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _getSlots() {
        const roots = [
            this
        ];
        if (this._teleportTargets) roots.push(...this._teleportTargets);
        const slots = /* @__PURE__ */ new Set();
        for (const root of roots){
            const found = root.querySelectorAll("slot");
            for(let i = 0; i < found.length; i++)slots.add(found[i]);
        }
        return Array.from(slots);
    }
    /**
   * @internal
   */ _injectChildStyle(comp, parentComp) {
        this._applyStyles(comp.styles, comp, parentComp);
    }
    /**
   * @internal
   */ _beginPatch() {
        this._patching = true;
        this._dirty = false;
    }
    /**
   * @internal
   */ _endPatch() {
        this._patching = false;
        if (this._dirty && this._instance) this._update();
    }
    /**
   * @internal
   */ _hasShadowRoot() {
        return this._def.shadowRoot !== false;
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function $039de21fb4b9777e$export$da5acfe93a94e37d(caller) {
    const instance = (0, $igcaK.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $igcaK.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $igcaK.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $039de21fb4b9777e$export$64d45095031fa749() {
    const el = $039de21fb4b9777e$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $039de21fb4b9777e$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $igcaK.getCurrentInstance)();
        if (!instance) return 0, $oF3Y1.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $oF3Y1.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $oF3Y1.EMPTY_OBJ;
        return mod;
    }
}
const $039de21fb4b9777e$var$positionMap = /* @__PURE__ */ new WeakMap();
const $039de21fb4b9777e$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $039de21fb4b9777e$var$moveCbKey = /* @__PURE__ */ Symbol("_moveCb");
const $039de21fb4b9777e$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
const $039de21fb4b9777e$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $039de21fb4b9777e$var$TransitionGroupImpl = /* @__PURE__ */ $039de21fb4b9777e$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $oF3Y1.extend)({}, $039de21fb4b9777e$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $igcaK.getCurrentInstance)();
        const state = (0, $igcaK.useTransitionState)();
        let prevChildren;
        let children;
        (0, $igcaK.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$039de21fb4b9777e$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach($039de21fb4b9777e$var$callPendingCbs);
            prevChildren.forEach($039de21fb4b9777e$var$recordPosition);
            const movedChildren = prevChildren.filter($039de21fb4b9777e$var$applyTranslation);
            $039de21fb4b9777e$var$forceReflow(instance.vnode.el);
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $039de21fb4b9777e$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$039de21fb4b9777e$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || e.propertyName.endsWith("transform")) {
                        el.removeEventListener("transitionend", cb);
                        el[$039de21fb4b9777e$var$moveCbKey] = null;
                        $039de21fb4b9777e$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
        });
        return ()=>{
            const rawProps = (0, $mHgsT.toRaw)(props);
            const cssTransitionProps = $039de21fb4b9777e$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $igcaK.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element && // Hidden v-show nodes have no previous layout box to animate from.
                !child.el[$039de21fb4b9777e$var$vShowHidden]) {
                    prevChildren.push(child);
                    (0, $igcaK.setTransitionHooks)(child, (0, $igcaK.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $039de21fb4b9777e$var$positionMap.set(child, $039de21fb4b9777e$var$getPosition(child.el));
                }
            }
            children = slots.default ? (0, $igcaK.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $igcaK.setTransitionHooks)(child, (0, $igcaK.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $igcaK.createVNode)(tag, null, children);
        };
    }
});
const $039de21fb4b9777e$export$19ffa8f511f7bc2e = $039de21fb4b9777e$var$TransitionGroupImpl;
function $039de21fb4b9777e$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$039de21fb4b9777e$var$moveCbKey]) el[$039de21fb4b9777e$var$moveCbKey]();
    if (el[$039de21fb4b9777e$var$enterCbKey]) el[$039de21fb4b9777e$var$enterCbKey]();
}
function $039de21fb4b9777e$var$recordPosition(c) {
    $039de21fb4b9777e$var$newPositionMap.set(c, $039de21fb4b9777e$var$getPosition(c.el));
}
function $039de21fb4b9777e$var$applyTranslation(c) {
    const oldPos = $039de21fb4b9777e$var$positionMap.get(c);
    const newPos = $039de21fb4b9777e$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const el = c.el;
        const s = el.style;
        const rect = el.getBoundingClientRect();
        let scaleX = 1;
        let scaleY = 1;
        if (el.offsetWidth) scaleX = rect.width / el.offsetWidth;
        if (el.offsetHeight) scaleY = rect.height / el.offsetHeight;
        if (!Number.isFinite(scaleX) || scaleX === 0) scaleX = 1;
        if (!Number.isFinite(scaleY) || scaleY === 0) scaleY = 1;
        if (Math.abs(scaleX - 1) < 0.01) scaleX = 1;
        if (Math.abs(scaleY - 1) < 0.01) scaleY = 1;
        s.transform = s.webkitTransform = `translate(${dx / scaleX}px,${dy / scaleY}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $039de21fb4b9777e$var$getPosition(el) {
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left,
        top: rect.top
    };
}
function $039de21fb4b9777e$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$039de21fb4b9777e$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $039de21fb4b9777e$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $039de21fb4b9777e$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $oF3Y1.isArray)(fn) ? (value)=>(0, $oF3Y1.invokeArrayFns)(fn, value) : fn;
};
function $039de21fb4b9777e$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $039de21fb4b9777e$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $039de21fb4b9777e$var$assignKey = /* @__PURE__ */ Symbol("_assign");
function $039de21fb4b9777e$var$castValue(value, trim, number) {
    if (trim) value = value.trim();
    if (number) value = (0, $oF3Y1.looseToNumber)(value);
    return value;
}
const $039de21fb4b9777e$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$039de21fb4b9777e$var$assignKey] = $039de21fb4b9777e$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $039de21fb4b9777e$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            el[$039de21fb4b9777e$var$assignKey]($039de21fb4b9777e$var$castValue(el.value, trim, castToNumber));
        });
        if (trim || castToNumber) $039de21fb4b9777e$var$addEventListener(el, "change", ()=>{
            el.value = $039de21fb4b9777e$var$castValue(el.value, trim, castToNumber);
        });
        if (!lazy) {
            $039de21fb4b9777e$var$addEventListener(el, "compositionstart", $039de21fb4b9777e$var$onCompositionStart);
            $039de21fb4b9777e$var$addEventListener(el, "compositionend", $039de21fb4b9777e$var$onCompositionEnd);
            $039de21fb4b9777e$var$addEventListener(el, "change", $039de21fb4b9777e$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$039de21fb4b9777e$var$assignKey] = $039de21fb4b9777e$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $oF3Y1.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        const rootNode = el.getRootNode();
        if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $039de21fb4b9777e$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$039de21fb4b9777e$var$assignKey] = $039de21fb4b9777e$var$getModelAssigner(vnode);
        $039de21fb4b9777e$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $039de21fb4b9777e$var$getValue(el);
            const checked = el.checked;
            const assign = el[$039de21fb4b9777e$var$assignKey];
            if ((0, $oF3Y1.isArray)(modelValue)) {
                const index = (0, $oF3Y1.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $oF3Y1.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($039de21fb4b9777e$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $039de21fb4b9777e$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$039de21fb4b9777e$var$assignKey] = $039de21fb4b9777e$var$getModelAssigner(vnode);
        $039de21fb4b9777e$var$setChecked(el, binding, vnode);
    }
};
function $039de21fb4b9777e$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $oF3Y1.isArray)(value)) checked = (0, $oF3Y1.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $oF3Y1.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $oF3Y1.looseEqual)(value, $039de21fb4b9777e$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $039de21fb4b9777e$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $oF3Y1.looseEqual)(value, vnode.props.value);
        el[$039de21fb4b9777e$var$assignKey] = $039de21fb4b9777e$var$getModelAssigner(vnode);
        $039de21fb4b9777e$var$addEventListener(el, "change", ()=>{
            el[$039de21fb4b9777e$var$assignKey]($039de21fb4b9777e$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$039de21fb4b9777e$var$assignKey] = $039de21fb4b9777e$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $oF3Y1.looseEqual)(value, vnode.props.value);
    }
};
const $039de21fb4b9777e$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        el._modelValue = value;
        $039de21fb4b9777e$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $oF3Y1.looseToNumber)($039de21fb4b9777e$var$getValue(o)) : $039de21fb4b9777e$var$getValue(o));
            el[$039de21fb4b9777e$var$assignKey](el.multiple ? (0, $oF3Y1.isSet)(el._modelValue) ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $igcaK.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$039de21fb4b9777e$var$assignKey] = $039de21fb4b9777e$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $039de21fb4b9777e$var$setSelected(el, value);
    },
    beforeUpdate (el, { value: value }, vnode) {
        el._modelValue = value;
        el[$039de21fb4b9777e$var$assignKey] = $039de21fb4b9777e$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        if (!el._assigning) $039de21fb4b9777e$var$setSelected(el, value);
    }
};
function $039de21fb4b9777e$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $oF3Y1.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $oF3Y1.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $039de21fb4b9777e$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $oF3Y1.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $oF3Y1.looseEqual)($039de21fb4b9777e$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $039de21fb4b9777e$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $039de21fb4b9777e$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $039de21fb4b9777e$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $039de21fb4b9777e$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $039de21fb4b9777e$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $039de21fb4b9777e$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $039de21fb4b9777e$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $039de21fb4b9777e$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $039de21fb4b9777e$export$87d227567b51ca39;
        case "TEXTAREA":
            return $039de21fb4b9777e$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $039de21fb4b9777e$export$8847c2e532b35714;
                case "radio":
                    return $039de21fb4b9777e$export$b4356c59b38b7aa9;
                default:
                    return $039de21fb4b9777e$export$f1f88689f5728478;
            }
    }
}
function $039de21fb4b9777e$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $039de21fb4b9777e$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $039de21fb4b9777e$var$initVModelForSSR() {
    $039de21fb4b9777e$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $039de21fb4b9777e$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $oF3Y1.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $039de21fb4b9777e$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $oF3Y1.isArray)(value)) {
            if (vnode.props && (0, $oF3Y1.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $oF3Y1.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $039de21fb4b9777e$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $039de21fb4b9777e$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $039de21fb4b9777e$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $039de21fb4b9777e$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$039de21fb4b9777e$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $039de21fb4b9777e$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    if (!fn) return fn;
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $039de21fb4b9777e$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $039de21fb4b9777e$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $039de21fb4b9777e$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $oF3Y1.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $039de21fb4b9777e$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $039de21fb4b9777e$var$rendererOptions = /* @__PURE__ */ (0, $oF3Y1.extend)({
    patchProp: $039de21fb4b9777e$export$cd4aa0842d13df8b
}, $039de21fb4b9777e$export$de4fb7f5030605d3);
let $039de21fb4b9777e$var$renderer;
let $039de21fb4b9777e$var$enabledHydration = false;
function $039de21fb4b9777e$var$ensureRenderer() {
    return $039de21fb4b9777e$var$renderer || ($039de21fb4b9777e$var$renderer = (0, $igcaK.createRenderer)($039de21fb4b9777e$var$rendererOptions));
}
function $039de21fb4b9777e$var$ensureHydrationRenderer() {
    $039de21fb4b9777e$var$renderer = $039de21fb4b9777e$var$enabledHydration ? $039de21fb4b9777e$var$renderer : (0, $igcaK.createHydrationRenderer)($039de21fb4b9777e$var$rendererOptions);
    $039de21fb4b9777e$var$enabledHydration = true;
    return $039de21fb4b9777e$var$renderer;
}
const $039de21fb4b9777e$export$b3890eb0ae9dca99 = (...args)=>{
    $039de21fb4b9777e$var$ensureRenderer().render(...args);
};
const $039de21fb4b9777e$export$fa8d919ba61d84db = (...args)=>{
    $039de21fb4b9777e$var$ensureHydrationRenderer().hydrate(...args);
};
const $039de21fb4b9777e$export$4e373c34abfa8c68 = (...args)=>{
    const app = $039de21fb4b9777e$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $039de21fb4b9777e$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $oF3Y1.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $039de21fb4b9777e$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $039de21fb4b9777e$export$35800275c0037383 = (...args)=>{
    const app = $039de21fb4b9777e$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $039de21fb4b9777e$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $039de21fb4b9777e$var$resolveRootNamespace(container));
    };
    return app;
};
function $039de21fb4b9777e$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $039de21fb4b9777e$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $oF3Y1.isHTMLTag)(tag) || (0, $oF3Y1.isSVGTag)(tag) || (0, $oF3Y1.isMathMLTag)(tag),
        writable: false
    });
}
function $039de21fb4b9777e$var$injectCompilerOptionsCheck(app) {
    if ((0, $igcaK.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $igcaK.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $igcaK.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $igcaK.warn)(msg);
            }
        });
    }
}
function $039de21fb4b9777e$var$normalizeContainer(container) {
    if ((0, $oF3Y1.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $039de21fb4b9777e$var$ssrDirectiveInitialized = false;
const $039de21fb4b9777e$export$800b28255aa678d9 = ()=>{
    if (!$039de21fb4b9777e$var$ssrDirectiveInitialized) {
        $039de21fb4b9777e$var$ssrDirectiveInitialized = true;
        $039de21fb4b9777e$var$initVModelForSSR();
        $039de21fb4b9777e$var$initVShowForSSR();
    }
};

});



parcelRegister("hhMUS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c959f7f6051dca3e$export$2e2bcd8739ae039);
let $c959f7f6051dca3e$var$NOOP = ()=>{};
var $c959f7f6051dca3e$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("eCPNH", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa5ccbd08a76f16a$export$2e2bcd8739ae039);
let $aa5ccbd08a76f16a$var$script;




let $aa5ccbd08a76f16a$var$initialize = ()=>{
    $aa5ccbd08a76f16a$var$script = (parcelRequire("2w4NN"));
    if ($aa5ccbd08a76f16a$var$script.__esModule) $aa5ccbd08a76f16a$var$script = $aa5ccbd08a76f16a$var$script.default;
    $aa5ccbd08a76f16a$var$script.render = (parcelRequire("gCzAr")).render;
    $aa5ccbd08a76f16a$var$script.__cssModules = {};
    (parcelRequire("jE4s6")).default($aa5ccbd08a76f16a$var$script);
    $aa5ccbd08a76f16a$var$script.__scopeId = 'data-v-d51654';
    $aa5ccbd08a76f16a$var$script.__file = "Navigation.vue";
};
$aa5ccbd08a76f16a$var$initialize();
var $aa5ccbd08a76f16a$export$2e2bcd8739ae039 = $aa5ccbd08a76f16a$var$script;

});
parcelRegister("2w4NN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1d524b86242a6830$export$2e2bcd8739ae039);
var $1d524b86242a6830$export$2e2bcd8739ae039 = {
    name: 'Navigation'
};

});

parcelRegister("gCzAr", function(module, exports) {

$parcel$export(module.exports, "render", () => $c19bccb76722cceb$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
function $c19bccb76722cceb$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $igcaK.resolveComponent)("router-link");
    return (0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("nav", null, [
        (0, $igcaK.createElementVNode)("ul", null, [
            (0, $igcaK.createElementVNode)("li", null, [
                (0, $igcaK.createVNode)(_component_router_link, {
                    to: {
                        name: 'Home'
                    }
                }, {
                    default: (0, $igcaK.withCtx)(()=>[
                            ..._cache[0] || (_cache[0] = [
                                (0, $igcaK.createTextVNode)("Home", -1)
                            ])
                        ]),
                    _: 1
                })
            ]),
            (0, $igcaK.createElementVNode)("li", null, [
                (0, $igcaK.createVNode)(_component_router_link, {
                    to: {
                        name: 'About'
                    }
                }, {
                    default: (0, $igcaK.withCtx)(()=>[
                            ..._cache[1] || (_cache[1] = [
                                (0, $igcaK.createTextVNode)("About", -1)
                            ])
                        ]),
                    _: 1
                })
            ]),
            (0, $igcaK.createElementVNode)("li", null, [
                (0, $igcaK.createVNode)(_component_router_link, {
                    to: {
                        name: 'Fanart'
                    }
                }, {
                    default: (0, $igcaK.withCtx)(()=>[
                            ..._cache[2] || (_cache[2] = [
                                (0, $igcaK.createTextVNode)("Fan art", -1)
                            ])
                        ]),
                    _: 1
                })
            ])
        ])
    ]);
}

});

parcelRegister("jE4s6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4d534dbc6fc36b7$export$2e2bcd8739ae039);
let $e4d534dbc6fc36b7$var$NOOP = ()=>{};
var $e4d534dbc6fc36b7$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("g2ma9", function(module, exports) {

$parcel$export(module.exports, "default", () => $bace06520e3129e4$export$2e2bcd8739ae039);
let $bace06520e3129e4$var$script;



let $bace06520e3129e4$var$initialize = ()=>{
    $bace06520e3129e4$var$script = (parcelRequire("eeyLP"));
    if ($bace06520e3129e4$var$script.__esModule) $bace06520e3129e4$var$script = $bace06520e3129e4$var$script.default;
    $bace06520e3129e4$var$script.render = (parcelRequire("jlmG6")).render;
    (parcelRequire("4U7Rq")).default($bace06520e3129e4$var$script);
    $bace06520e3129e4$var$script.__scopeId = 'data-v-90f7b1';
    $bace06520e3129e4$var$script.__file = "Icon.vue";
};
$bace06520e3129e4$var$initialize();
var $bace06520e3129e4$export$2e2bcd8739ae039 = $bace06520e3129e4$var$script;

});
parcelRegister("eeyLP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a5cd582b35371f89$export$2e2bcd8739ae039);

var $jBGwt = parcelRequire("jBGwt");
var $a5cd582b35371f89$export$2e2bcd8739ae039 = {
    name: 'Icon',
    props: {
        name: String
    },
    components: {
        Iconify: (0, $jBGwt.Icon)
    }
};

});
parcelRegister("jBGwt", function(module, exports) {

$parcel$export(module.exports, "Icon", () => Icon);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
const matchIconName = /^[a-z0-9]+(-[a-z0-9]+)*$/;
const stringToIcon = (value, validate, allowSimpleName, provider = "")=>{
    const colonSeparated = value.split(":");
    if (value.slice(0, 1) === "@") {
        if (colonSeparated.length < 2 || colonSeparated.length > 3) return null;
        provider = colonSeparated.shift().slice(1);
    }
    if (colonSeparated.length > 3 || !colonSeparated.length) return null;
    if (colonSeparated.length > 1) {
        const name2 = colonSeparated.pop();
        const prefix = colonSeparated.pop();
        const result = {
            // Allow provider without '@': "provider:prefix:name"
            provider: colonSeparated.length > 0 ? colonSeparated[0] : provider,
            prefix: prefix,
            name: name2
        };
        return validate && !validateIconName(result) ? null : result;
    }
    const name = colonSeparated[0];
    const dashSeparated = name.split("-");
    if (dashSeparated.length > 1) {
        const result = {
            provider: provider,
            prefix: dashSeparated.shift(),
            name: dashSeparated.join("-")
        };
        return validate && !validateIconName(result) ? null : result;
    }
    if (allowSimpleName && provider === "") {
        const result = {
            provider: provider,
            prefix: "",
            name: name
        };
        return validate && !validateIconName(result, allowSimpleName) ? null : result;
    }
    return null;
};
const validateIconName = (icon, allowSimpleName)=>{
    if (!icon) return false;
    return !!// Check name: cannot be empty
    ((allowSimpleName && icon.prefix === "" || !!icon.prefix) && !!icon.name);
};
const defaultIconDimensions = Object.freeze({
    left: 0,
    top: 0,
    width: 16,
    height: 16
});
const defaultIconTransformations = Object.freeze({
    rotate: 0,
    vFlip: false,
    hFlip: false
});
const defaultIconProps = Object.freeze({
    ...defaultIconDimensions,
    ...defaultIconTransformations
});
const defaultExtendedIconProps = Object.freeze({
    ...defaultIconProps,
    body: "",
    hidden: false
});
function mergeIconTransformations(obj1, obj2) {
    const result = {};
    if (!obj1.hFlip !== !obj2.hFlip) result.hFlip = true;
    if (!obj1.vFlip !== !obj2.vFlip) result.vFlip = true;
    const rotate = ((obj1.rotate || 0) + (obj2.rotate || 0)) % 4;
    if (rotate) result.rotate = rotate;
    return result;
}
function mergeIconData(parent, child) {
    const result = mergeIconTransformations(parent, child);
    for(const key in defaultExtendedIconProps){
        if (key in defaultIconTransformations) {
            if (key in parent && !(key in result)) result[key] = defaultIconTransformations[key];
        } else if (key in child) result[key] = child[key];
        else if (key in parent) result[key] = parent[key];
    }
    return result;
}
function getIconsTree(data, names) {
    const icons = data.icons;
    const aliases = data.aliases || /* @__PURE__ */ Object.create(null);
    const resolved = /* @__PURE__ */ Object.create(null);
    function resolve(name) {
        if (icons[name]) return resolved[name] = [];
        if (!(name in resolved)) {
            resolved[name] = null;
            const parent = aliases[name] && aliases[name].parent;
            const value = parent && resolve(parent);
            if (value) resolved[name] = [
                parent
            ].concat(value);
        }
        return resolved[name];
    }
    Object.keys(icons).concat(Object.keys(aliases)).forEach(resolve);
    return resolved;
}
function internalGetIconData(data, name, tree) {
    const icons = data.icons;
    const aliases = data.aliases || /* @__PURE__ */ Object.create(null);
    let currentProps = {};
    function parse(name2) {
        currentProps = mergeIconData(icons[name2] || aliases[name2], currentProps);
    }
    parse(name);
    tree.forEach(parse);
    return mergeIconData(data, currentProps);
}
function parseIconSet(data, callback) {
    const names = [];
    if (typeof data !== "object" || typeof data.icons !== "object") return names;
    if (data.not_found instanceof Array) data.not_found.forEach((name)=>{
        callback(name, null);
        names.push(name);
    });
    const tree = getIconsTree(data);
    for(const name in tree){
        const item = tree[name];
        if (item) {
            callback(name, internalGetIconData(data, name, item));
            names.push(name);
        }
    }
    return names;
}
const optionalPropertyDefaults = {
    provider: "",
    aliases: {},
    not_found: {},
    ...defaultIconDimensions
};
function checkOptionalProps(item, defaults) {
    for(const prop in defaults){
        if (prop in item && typeof item[prop] !== typeof defaults[prop]) return false;
    }
    return true;
}
function quicklyValidateIconSet(obj) {
    if (typeof obj !== "object" || obj === null) return null;
    const data = obj;
    if (typeof data.prefix !== "string" || !obj.icons || typeof obj.icons !== "object") return null;
    if (!checkOptionalProps(obj, optionalPropertyDefaults)) return null;
    const icons = data.icons;
    for(const name in icons){
        const icon = icons[name];
        if (// Name cannot be empty
        !name || // Must have body
        typeof icon.body !== "string" || // Check other props
        !checkOptionalProps(icon, defaultExtendedIconProps)) return null;
    }
    const aliases = data.aliases || /* @__PURE__ */ Object.create(null);
    for(const name in aliases){
        const icon = aliases[name];
        const parent = icon.parent;
        if (// Name cannot be empty
        !name || // Parent must be set and point to existing icon
        typeof parent !== "string" || !icons[parent] && !aliases[parent] || // Check other props
        !checkOptionalProps(icon, defaultExtendedIconProps)) return null;
    }
    return data;
}
const dataStorage = /* @__PURE__ */ Object.create(null);
function newStorage(provider, prefix) {
    return {
        provider: provider,
        prefix: prefix,
        icons: /* @__PURE__ */ Object.create(null),
        missing: /* @__PURE__ */ new Set()
    };
}
function getStorage(provider, prefix) {
    const providerStorage = dataStorage[provider] || (dataStorage[provider] = /* @__PURE__ */ Object.create(null));
    return providerStorage[prefix] || (providerStorage[prefix] = newStorage(provider, prefix));
}
function addIconSet(storage, data) {
    if (!quicklyValidateIconSet(data)) return [];
    return parseIconSet(data, (name, icon)=>{
        if (icon) storage.icons[name] = icon;
        else storage.missing.add(name);
    });
}
function addIconToStorage(storage, name, icon) {
    try {
        if (typeof icon.body === "string") {
            storage.icons[name] = {
                ...icon
            };
            return true;
        }
    } catch (err) {}
    return false;
}
function listIcons(provider, prefix) {
    let allIcons = [];
    const providers = typeof provider === "string" ? [
        provider
    ] : Object.keys(dataStorage);
    providers.forEach((provider2)=>{
        const prefixes = typeof provider2 === "string" && typeof prefix === "string" ? [
            prefix
        ] : Object.keys(dataStorage[provider2] || {});
        prefixes.forEach((prefix2)=>{
            const storage = getStorage(provider2, prefix2);
            allIcons = allIcons.concat(Object.keys(storage.icons).map((name)=>(provider2 !== "" ? "@" + provider2 + ":" : "") + prefix2 + ":" + name));
        });
    });
    return allIcons;
}
let simpleNames = false;
function allowSimpleNames(allow) {
    if (typeof allow === "boolean") simpleNames = allow;
    return simpleNames;
}
function getIconData(name) {
    const icon = typeof name === "string" ? stringToIcon(name, true, simpleNames) : name;
    if (icon) {
        const storage = getStorage(icon.provider, icon.prefix);
        const iconName = icon.name;
        return storage.icons[iconName] || (storage.missing.has(iconName) ? null : void 0);
    }
}
function addIcon(name, data) {
    const icon = stringToIcon(name, true, simpleNames);
    if (!icon) return false;
    const storage = getStorage(icon.provider, icon.prefix);
    if (data) return addIconToStorage(storage, icon.name, data);
    else {
        storage.missing.add(icon.name);
        return true;
    }
}
function addCollection(data, provider) {
    if (typeof data !== "object") return false;
    if (typeof provider !== "string") provider = data.provider || "";
    if (simpleNames && !provider && !data.prefix) {
        let added = false;
        if (quicklyValidateIconSet(data)) {
            data.prefix = "";
            parseIconSet(data, (name, icon)=>{
                if (addIcon(name, icon)) added = true;
            });
        }
        return added;
    }
    const prefix = data.prefix;
    if (!validateIconName({
        provider: provider,
        prefix: prefix,
        name: "a"
    })) return false;
    const storage = getStorage(provider, prefix);
    return !!addIconSet(storage, data);
}
function iconLoaded(name) {
    return !!getIconData(name);
}
function getIcon(name) {
    const result = getIconData(name);
    return result ? {
        ...defaultIconProps,
        ...result
    } : result;
}
const defaultIconSizeCustomisations = Object.freeze({
    width: null,
    height: null
});
const defaultIconCustomisations = Object.freeze({
    // Dimensions
    ...defaultIconSizeCustomisations,
    // Transformations
    ...defaultIconTransformations
});
const unitsSplit = /(-?[0-9.]*[0-9]+[0-9.]*)/g;
const unitsTest = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function calculateSize(size, ratio, precision) {
    if (ratio === 1) return size;
    precision = precision || 100;
    if (typeof size === "number") return Math.ceil(size * ratio * precision) / precision;
    if (typeof size !== "string") return size;
    const oldParts = size.split(unitsSplit);
    if (oldParts === null || !oldParts.length) return size;
    const newParts = [];
    let code = oldParts.shift();
    let isNumber = unitsTest.test(code);
    while(true){
        if (isNumber) {
            const num = parseFloat(code);
            if (isNaN(num)) newParts.push(code);
            else newParts.push(Math.ceil(num * ratio * precision) / precision);
        } else newParts.push(code);
        code = oldParts.shift();
        if (code === void 0) return newParts.join("");
        isNumber = !isNumber;
    }
}
function splitSVGDefs(content, tag = "defs") {
    let defs = "";
    const index = content.indexOf("<" + tag);
    while(index >= 0){
        const start = content.indexOf(">", index);
        const end = content.indexOf("</" + tag);
        if (start === -1 || end === -1) break;
        const endEnd = content.indexOf(">", end);
        if (endEnd === -1) break;
        defs += content.slice(start + 1, end).trim();
        content = content.slice(0, index).trim() + content.slice(endEnd + 1);
    }
    return {
        defs: defs,
        content: content
    };
}
function mergeDefsAndContent(defs, content) {
    return defs ? "<defs>" + defs + "</defs>" + content : content;
}
function wrapSVGContent(body, start, end) {
    const split = splitSVGDefs(body);
    return mergeDefsAndContent(split.defs, start + split.content + end);
}
const isUnsetKeyword = (value)=>value === "unset" || value === "undefined" || value === "none";
function iconToSVG(icon, customisations) {
    const fullIcon = {
        ...defaultIconProps,
        ...icon
    };
    const fullCustomisations = {
        ...defaultIconCustomisations,
        ...customisations
    };
    const box = {
        left: fullIcon.left,
        top: fullIcon.top,
        width: fullIcon.width,
        height: fullIcon.height
    };
    let body = fullIcon.body;
    [
        fullIcon,
        fullCustomisations
    ].forEach((props)=>{
        const transformations = [];
        const hFlip = props.hFlip;
        const vFlip = props.vFlip;
        let rotation = props.rotate;
        if (hFlip) {
            if (vFlip) rotation += 2;
            else {
                transformations.push("translate(" + (box.width + box.left).toString() + " " + (0 - box.top).toString() + ")");
                transformations.push("scale(-1 1)");
                box.top = box.left = 0;
            }
        } else if (vFlip) {
            transformations.push("translate(" + (0 - box.left).toString() + " " + (box.height + box.top).toString() + ")");
            transformations.push("scale(1 -1)");
            box.top = box.left = 0;
        }
        let tempValue;
        if (rotation < 0) rotation -= Math.floor(rotation / 4) * 4;
        rotation = rotation % 4;
        switch(rotation){
            case 1:
                tempValue = box.height / 2 + box.top;
                transformations.unshift("rotate(90 " + tempValue.toString() + " " + tempValue.toString() + ")");
                break;
            case 2:
                transformations.unshift("rotate(180 " + (box.width / 2 + box.left).toString() + " " + (box.height / 2 + box.top).toString() + ")");
                break;
            case 3:
                tempValue = box.width / 2 + box.left;
                transformations.unshift("rotate(-90 " + tempValue.toString() + " " + tempValue.toString() + ")");
                break;
        }
        if (rotation % 2 === 1) {
            if (box.left !== box.top) {
                tempValue = box.left;
                box.left = box.top;
                box.top = tempValue;
            }
            if (box.width !== box.height) {
                tempValue = box.width;
                box.width = box.height;
                box.height = tempValue;
            }
        }
        if (transformations.length) body = wrapSVGContent(body, '<g transform="' + transformations.join(" ") + '">', "</g>");
    });
    const customisationsWidth = fullCustomisations.width;
    const customisationsHeight = fullCustomisations.height;
    const boxWidth = box.width;
    const boxHeight = box.height;
    let width;
    let height;
    if (customisationsWidth === null) {
        height = customisationsHeight === null ? "1em" : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
        width = calculateSize(height, boxWidth / boxHeight);
    } else {
        width = customisationsWidth === "auto" ? boxWidth : customisationsWidth;
        height = customisationsHeight === null ? calculateSize(width, boxHeight / boxWidth) : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
    }
    const attributes = {};
    const setAttr = (prop, value)=>{
        if (!isUnsetKeyword(value)) attributes[prop] = value.toString();
    };
    setAttr("width", width);
    setAttr("height", height);
    const viewBox = [
        box.left,
        box.top,
        boxWidth,
        boxHeight
    ];
    attributes.viewBox = viewBox.join(" ");
    return {
        attributes: attributes,
        viewBox: viewBox,
        body: body
    };
}
const regex = /\sid="(\S+)"/g;
const randomPrefix = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let counter = 0;
function replaceIDs(body, prefix = randomPrefix) {
    const ids = [];
    let match;
    while(match = regex.exec(body))ids.push(match[1]);
    if (!ids.length) return body;
    const suffix = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
    ids.forEach((id)=>{
        const newID = typeof prefix === "function" ? prefix(id) : prefix + (counter++).toString();
        const escapedID = id.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        body = body.replace(// Allowed characters before id: [#;"]
        // Allowed characters after id: [)"], .[a-z]
        new RegExp('([#;"])(' + escapedID + ')([")]|\\.[a-z])', "g"), "$1" + newID + suffix + "$3");
    });
    body = body.replace(new RegExp(suffix, "g"), "");
    return body;
}
const storage = /* @__PURE__ */ Object.create(null);
function setAPIModule(provider, item) {
    storage[provider] = item;
}
function getAPIModule(provider) {
    return storage[provider] || storage[""];
}
function createAPIConfig(source) {
    let resources;
    if (typeof source.resources === "string") resources = [
        source.resources
    ];
    else {
        resources = source.resources;
        if (!(resources instanceof Array) || !resources.length) return null;
    }
    const result = {
        resources: // API hosts
        resources,
        // Root path
        path: source.path || "/",
        // URL length limit
        maxURL: source.maxURL || 500,
        // Timeout before next host is used.
        rotate: source.rotate || 750,
        // Timeout before failing query.
        timeout: source.timeout || 5e3,
        // Randomise default API end point.
        random: source.random === true,
        // Start index
        index: source.index || 0,
        // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
        dataAfterTimeout: source.dataAfterTimeout !== false
    };
    return result;
}
const configStorage = /* @__PURE__ */ Object.create(null);
const fallBackAPISources = [
    "https://api.simplesvg.com",
    "https://api.unisvg.com"
];
const fallBackAPI = [];
while(fallBackAPISources.length > 0){
    if (fallBackAPISources.length === 1) fallBackAPI.push(fallBackAPISources.shift());
    else if (Math.random() > 0.5) fallBackAPI.push(fallBackAPISources.shift());
    else fallBackAPI.push(fallBackAPISources.pop());
}
configStorage[""] = createAPIConfig({
    resources: [
        "https://api.iconify.design"
    ].concat(fallBackAPI)
});
function addAPIProvider(provider, customConfig) {
    const config = createAPIConfig(customConfig);
    if (config === null) return false;
    configStorage[provider] = config;
    return true;
}
function getAPIConfig(provider) {
    return configStorage[provider];
}
function listAPIProviders() {
    return Object.keys(configStorage);
}
const detectFetch = ()=>{
    let callback;
    try {
        callback = fetch;
        if (typeof callback === "function") return callback;
    } catch (err) {}
};
let fetchModule = detectFetch();
function setFetch(fetch2) {
    fetchModule = fetch2;
}
function getFetch() {
    return fetchModule;
}
function calculateMaxLength(provider, prefix) {
    const config = getAPIConfig(provider);
    if (!config) return 0;
    let result;
    if (!config.maxURL) result = 0;
    else {
        let maxHostLength = 0;
        config.resources.forEach((item)=>{
            const host = item;
            maxHostLength = Math.max(maxHostLength, host.length);
        });
        const url = prefix + ".json?icons=";
        result = config.maxURL - maxHostLength - config.path.length - url.length;
    }
    return result;
}
function shouldAbort(status) {
    return status === 404;
}
const prepare = (provider, prefix, icons)=>{
    const results = [];
    const maxLength = calculateMaxLength(provider, prefix);
    const type = "icons";
    let item = {
        type: type,
        provider: provider,
        prefix: prefix,
        icons: []
    };
    let length = 0;
    icons.forEach((name, index)=>{
        length += name.length + 1;
        if (length >= maxLength && index > 0) {
            results.push(item);
            item = {
                type: type,
                provider: provider,
                prefix: prefix,
                icons: []
            };
            length = name.length;
        }
        item.icons.push(name);
    });
    results.push(item);
    return results;
};
function getPath(provider) {
    if (typeof provider === "string") {
        const config = getAPIConfig(provider);
        if (config) return config.path;
    }
    return "/";
}
const send = (host, params, callback)=>{
    if (!fetchModule) {
        callback("abort", 424);
        return;
    }
    let path = getPath(params.provider);
    switch(params.type){
        case "icons":
            {
                const prefix = params.prefix;
                const icons = params.icons;
                const iconsList = icons.join(",");
                const urlParams = new URLSearchParams({
                    icons: iconsList
                });
                path += prefix + ".json?" + urlParams.toString();
                break;
            }
        case "custom":
            {
                const uri = params.uri;
                path += uri.slice(0, 1) === "/" ? uri.slice(1) : uri;
                break;
            }
        default:
            callback("abort", 400);
            return;
    }
    let defaultError = 503;
    fetchModule(host + path).then((response)=>{
        const status = response.status;
        if (status !== 200) {
            setTimeout(()=>{
                callback(shouldAbort(status) ? "abort" : "next", status);
            });
            return;
        }
        defaultError = 501;
        return response.json();
    }).then((data)=>{
        if (typeof data !== "object" || data === null) {
            setTimeout(()=>{
                if (data === 404) callback("abort", data);
                else callback("next", defaultError);
            });
            return;
        }
        setTimeout(()=>{
            callback("success", data);
        });
    }).catch(()=>{
        callback("next", defaultError);
    });
};
const fetchAPIModule = {
    prepare: prepare,
    send: send
};
function sortIcons(icons) {
    const result = {
        loaded: [],
        missing: [],
        pending: []
    };
    const storage = /* @__PURE__ */ Object.create(null);
    icons.sort((a, b)=>{
        if (a.provider !== b.provider) return a.provider.localeCompare(b.provider);
        if (a.prefix !== b.prefix) return a.prefix.localeCompare(b.prefix);
        return a.name.localeCompare(b.name);
    });
    let lastIcon = {
        provider: "",
        prefix: "",
        name: ""
    };
    icons.forEach((icon)=>{
        if (lastIcon.name === icon.name && lastIcon.prefix === icon.prefix && lastIcon.provider === icon.provider) return;
        lastIcon = icon;
        const provider = icon.provider;
        const prefix = icon.prefix;
        const name = icon.name;
        const providerStorage = storage[provider] || (storage[provider] = /* @__PURE__ */ Object.create(null));
        const localStorage = providerStorage[prefix] || (providerStorage[prefix] = getStorage(provider, prefix));
        let list;
        if (name in localStorage.icons) list = result.loaded;
        else if (prefix === "" || localStorage.missing.has(name)) list = result.missing;
        else list = result.pending;
        const item = {
            provider: provider,
            prefix: prefix,
            name: name
        };
        list.push(item);
    });
    return result;
}
function removeCallback(storages, id) {
    storages.forEach((storage)=>{
        const items = storage.loaderCallbacks;
        if (items) storage.loaderCallbacks = items.filter((row)=>row.id !== id);
    });
}
function updateCallbacks(storage) {
    if (!storage.pendingCallbacksFlag) {
        storage.pendingCallbacksFlag = true;
        setTimeout(()=>{
            storage.pendingCallbacksFlag = false;
            const items = storage.loaderCallbacks ? storage.loaderCallbacks.slice(0) : [];
            if (!items.length) return;
            let hasPending = false;
            const provider = storage.provider;
            const prefix = storage.prefix;
            items.forEach((item)=>{
                const icons = item.icons;
                const oldLength = icons.pending.length;
                icons.pending = icons.pending.filter((icon)=>{
                    if (icon.prefix !== prefix) return true;
                    const name = icon.name;
                    if (storage.icons[name]) icons.loaded.push({
                        provider: provider,
                        prefix: prefix,
                        name: name
                    });
                    else if (storage.missing.has(name)) icons.missing.push({
                        provider: provider,
                        prefix: prefix,
                        name: name
                    });
                    else {
                        hasPending = true;
                        return true;
                    }
                    return false;
                });
                if (icons.pending.length !== oldLength) {
                    if (!hasPending) removeCallback([
                        storage
                    ], item.id);
                    item.callback(icons.loaded.slice(0), icons.missing.slice(0), icons.pending.slice(0), item.abort);
                }
            });
        });
    }
}
let idCounter = 0;
function storeCallback(callback, icons, pendingSources) {
    const id = idCounter++;
    const abort = removeCallback.bind(null, pendingSources, id);
    if (!icons.pending.length) return abort;
    const item = {
        id: id,
        icons: icons,
        callback: callback,
        abort: abort
    };
    pendingSources.forEach((storage)=>{
        (storage.loaderCallbacks || (storage.loaderCallbacks = [])).push(item);
    });
    return abort;
}
function listToIcons(list, validate = true, simpleNames = false) {
    const result = [];
    list.forEach((item)=>{
        const icon = typeof item === "string" ? stringToIcon(item, validate, simpleNames) : item;
        if (icon) result.push(icon);
    });
    return result;
}
// src/config.ts
var defaultConfig = {
    resources: [],
    index: 0,
    timeout: 2e3,
    rotate: 750,
    random: false,
    dataAfterTimeout: false
};
// src/query.ts
function sendQuery(config, payload, query, done) {
    const resourcesCount = config.resources.length;
    const startIndex = config.random ? Math.floor(Math.random() * resourcesCount) : config.index;
    let resources;
    if (config.random) {
        let list = config.resources.slice(0);
        resources = [];
        while(list.length > 1){
            const nextIndex = Math.floor(Math.random() * list.length);
            resources.push(list[nextIndex]);
            list = list.slice(0, nextIndex).concat(list.slice(nextIndex + 1));
        }
        resources = resources.concat(list);
    } else resources = config.resources.slice(startIndex).concat(config.resources.slice(0, startIndex));
    const startTime = Date.now();
    let status = "pending";
    let queriesSent = 0;
    let lastError;
    let timer = null;
    let queue = [];
    let doneCallbacks = [];
    if (typeof done === "function") doneCallbacks.push(done);
    function resetTimer() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }
    function abort() {
        if (status === "pending") status = "aborted";
        resetTimer();
        queue.forEach((item)=>{
            if (item.status === "pending") item.status = "aborted";
        });
        queue = [];
    }
    function subscribe(callback, overwrite) {
        if (overwrite) doneCallbacks = [];
        if (typeof callback === "function") doneCallbacks.push(callback);
    }
    function getQueryStatus() {
        return {
            startTime: startTime,
            payload: payload,
            status: status,
            queriesSent: queriesSent,
            queriesPending: queue.length,
            subscribe: subscribe,
            abort: abort
        };
    }
    function failQuery() {
        status = "failed";
        doneCallbacks.forEach((callback)=>{
            callback(void 0, lastError);
        });
    }
    function clearQueue() {
        queue.forEach((item)=>{
            if (item.status === "pending") item.status = "aborted";
        });
        queue = [];
    }
    function moduleResponse(item, response, data) {
        const isError = response !== "success";
        queue = queue.filter((queued)=>queued !== item);
        switch(status){
            case "pending":
                break;
            case "failed":
                if (isError || !config.dataAfterTimeout) return;
                break;
            default:
                return;
        }
        if (response === "abort") {
            lastError = data;
            failQuery();
            return;
        }
        if (isError) {
            lastError = data;
            if (!queue.length) {
                if (!resources.length) failQuery();
                else execNext();
            }
            return;
        }
        resetTimer();
        clearQueue();
        if (!config.random) {
            const index = config.resources.indexOf(item.resource);
            if (index !== -1 && index !== config.index) config.index = index;
        }
        status = "completed";
        doneCallbacks.forEach((callback)=>{
            callback(data);
        });
    }
    function execNext() {
        if (status !== "pending") return;
        resetTimer();
        const resource = resources.shift();
        if (resource === void 0) {
            if (queue.length) {
                timer = setTimeout(()=>{
                    resetTimer();
                    if (status === "pending") {
                        clearQueue();
                        failQuery();
                    }
                }, config.timeout);
                return;
            }
            failQuery();
            return;
        }
        const item = {
            status: "pending",
            resource: resource,
            callback: (status2, data)=>{
                moduleResponse(item, status2, data);
            }
        };
        queue.push(item);
        queriesSent++;
        timer = setTimeout(execNext, config.rotate);
        query(resource, payload, item.callback);
    }
    setTimeout(execNext);
    return getQueryStatus;
}
// src/index.ts
function initRedundancy(cfg) {
    const config = {
        ...defaultConfig,
        ...cfg
    };
    let queries = [];
    function cleanup() {
        queries = queries.filter((item)=>item().status === "pending");
    }
    function query(payload, queryCallback, doneCallback) {
        const query2 = sendQuery(config, payload, queryCallback, (data, error)=>{
            cleanup();
            if (doneCallback) doneCallback(data, error);
        });
        queries.push(query2);
        return query2;
    }
    function find(callback) {
        return queries.find((value)=>{
            return callback(value);
        }) || null;
    }
    const instance = {
        query: query,
        find: find,
        setIndex: (index)=>{
            config.index = index;
        },
        getIndex: ()=>config.index,
        cleanup: cleanup
    };
    return instance;
}
function emptyCallback$1() {}
const redundancyCache = /* @__PURE__ */ Object.create(null);
function getRedundancyCache(provider) {
    if (!redundancyCache[provider]) {
        const config = getAPIConfig(provider);
        if (!config) return;
        const redundancy = initRedundancy(config);
        const cachedReundancy = {
            config: config,
            redundancy: redundancy
        };
        redundancyCache[provider] = cachedReundancy;
    }
    return redundancyCache[provider];
}
function sendAPIQuery(target, query, callback) {
    let redundancy;
    let send;
    if (typeof target === "string") {
        const api = getAPIModule(target);
        if (!api) {
            callback(void 0, 424);
            return emptyCallback$1;
        }
        send = api.send;
        const cached = getRedundancyCache(target);
        if (cached) redundancy = cached.redundancy;
    } else {
        const config = createAPIConfig(target);
        if (config) {
            redundancy = initRedundancy(config);
            const moduleKey = target.resources ? target.resources[0] : "";
            const api = getAPIModule(moduleKey);
            if (api) send = api.send;
        }
    }
    if (!redundancy || !send) {
        callback(void 0, 424);
        return emptyCallback$1;
    }
    return redundancy.query(query, send, callback)().abort;
}
function emptyCallback() {}
function loadedNewIcons(storage) {
    if (!storage.iconsLoaderFlag) {
        storage.iconsLoaderFlag = true;
        setTimeout(()=>{
            storage.iconsLoaderFlag = false;
            updateCallbacks(storage);
        });
    }
}
function checkIconNamesForAPI(icons) {
    const valid = [];
    const invalid = [];
    icons.forEach((name)=>{
        (name.match(matchIconName) ? valid : invalid).push(name);
    });
    return {
        valid: valid,
        invalid: invalid
    };
}
function parseLoaderResponse(storage, icons, data) {
    function checkMissing() {
        const pending = storage.pendingIcons;
        icons.forEach((name)=>{
            if (pending) pending.delete(name);
            if (!storage.icons[name]) storage.missing.add(name);
        });
    }
    if (data && typeof data === "object") try {
        const parsed = addIconSet(storage, data);
        if (!parsed.length) {
            checkMissing();
            return;
        }
    } catch (err) {
        console.error(err);
    }
    checkMissing();
    loadedNewIcons(storage);
}
function parsePossiblyAsyncResponse(response, callback) {
    if (response instanceof Promise) response.then((data)=>{
        callback(data);
    }).catch(()=>{
        callback(null);
    });
    else callback(response);
}
function loadNewIcons(storage, icons) {
    if (!storage.iconsToLoad) storage.iconsToLoad = icons;
    else storage.iconsToLoad = storage.iconsToLoad.concat(icons).sort();
    if (!storage.iconsQueueFlag) {
        storage.iconsQueueFlag = true;
        setTimeout(()=>{
            storage.iconsQueueFlag = false;
            const { provider, prefix } = storage;
            const icons2 = storage.iconsToLoad;
            delete storage.iconsToLoad;
            if (!icons2 || !icons2.length) return;
            const customIconLoader = storage.loadIcon;
            if (storage.loadIcons && (icons2.length > 1 || !customIconLoader)) {
                parsePossiblyAsyncResponse(storage.loadIcons(icons2, prefix, provider), (data)=>{
                    parseLoaderResponse(storage, icons2, data);
                });
                return;
            }
            if (customIconLoader) {
                icons2.forEach((name)=>{
                    const response = customIconLoader(name, prefix, provider);
                    parsePossiblyAsyncResponse(response, (data)=>{
                        const iconSet = data ? {
                            prefix: prefix,
                            icons: {
                                [name]: data
                            }
                        } : null;
                        parseLoaderResponse(storage, [
                            name
                        ], iconSet);
                    });
                });
                return;
            }
            const { valid, invalid } = checkIconNamesForAPI(icons2);
            if (invalid.length) parseLoaderResponse(storage, invalid, null);
            if (!valid.length) return;
            const api = prefix.match(matchIconName) ? getAPIModule(provider) : null;
            if (!api) {
                parseLoaderResponse(storage, valid, null);
                return;
            }
            const params = api.prepare(provider, prefix, valid);
            params.forEach((item)=>{
                sendAPIQuery(provider, item, (data)=>{
                    parseLoaderResponse(storage, item.icons, data);
                });
            });
        });
    }
}
const loadIcons = (icons, callback)=>{
    const cleanedIcons = listToIcons(icons, true, allowSimpleNames());
    const sortedIcons = sortIcons(cleanedIcons);
    if (!sortedIcons.pending.length) {
        let callCallback = true;
        if (callback) setTimeout(()=>{
            if (callCallback) callback(sortedIcons.loaded, sortedIcons.missing, sortedIcons.pending, emptyCallback);
        });
        return ()=>{
            callCallback = false;
        };
    }
    const newIcons = /* @__PURE__ */ Object.create(null);
    const sources = [];
    let lastProvider, lastPrefix;
    sortedIcons.pending.forEach((icon)=>{
        const { provider, prefix } = icon;
        if (prefix === lastPrefix && provider === lastProvider) return;
        lastProvider = provider;
        lastPrefix = prefix;
        sources.push(getStorage(provider, prefix));
        const providerNewIcons = newIcons[provider] || (newIcons[provider] = /* @__PURE__ */ Object.create(null));
        if (!providerNewIcons[prefix]) providerNewIcons[prefix] = [];
    });
    sortedIcons.pending.forEach((icon)=>{
        const { provider, prefix, name } = icon;
        const storage = getStorage(provider, prefix);
        const pendingQueue = storage.pendingIcons || (storage.pendingIcons = /* @__PURE__ */ new Set());
        if (!pendingQueue.has(name)) {
            pendingQueue.add(name);
            newIcons[provider][prefix].push(name);
        }
    });
    sources.forEach((storage)=>{
        const list = newIcons[storage.provider][storage.prefix];
        if (list.length) loadNewIcons(storage, list);
    });
    return callback ? storeCallback(callback, sortedIcons, sources) : emptyCallback;
};
const loadIcon = (icon)=>{
    return new Promise((fulfill, reject)=>{
        const iconObj = typeof icon === "string" ? stringToIcon(icon, true) : icon;
        if (!iconObj) {
            reject(icon);
            return;
        }
        loadIcons([
            iconObj || icon
        ], (loaded)=>{
            if (loaded.length && iconObj) {
                const data = getIconData(iconObj);
                if (data) {
                    fulfill({
                        ...defaultIconProps,
                        ...data
                    });
                    return;
                }
            }
            reject(icon);
        });
    });
};
function setCustomIconsLoader(loader, prefix, provider) {
    getStorage(provider || "", prefix).loadIcons = loader;
}
function setCustomIconLoader(loader, prefix, provider) {
    getStorage(provider || "", prefix).loadIcon = loader;
}
function mergeCustomisations(defaults, item) {
    const result = {
        ...defaults
    };
    for(const key in item){
        const value = item[key];
        const valueType = typeof value;
        if (key in defaultIconSizeCustomisations) {
            if (value === null || value && (valueType === "string" || valueType === "number")) result[key] = value;
        } else if (valueType === typeof result[key]) result[key] = key === "rotate" ? value % 4 : value;
    }
    return result;
}
const separator = /[\s,]+/;
function flipFromString(custom, flip) {
    flip.split(separator).forEach((str)=>{
        const value = str.trim();
        switch(value){
            case "horizontal":
                custom.hFlip = true;
                break;
            case "vertical":
                custom.vFlip = true;
                break;
        }
    });
}
function rotateFromString(value, defaultValue = 0) {
    const units = value.replace(/^-?[0-9.]*/, "");
    function cleanup(value2) {
        while(value2 < 0)value2 += 4;
        return value2 % 4;
    }
    if (units === "") {
        const num = parseInt(value);
        return isNaN(num) ? 0 : cleanup(num);
    } else if (units !== value) {
        let split = 0;
        switch(units){
            case "%":
                split = 25;
                break;
            case "deg":
                split = 90;
        }
        if (split) {
            let num = parseFloat(value.slice(0, value.length - units.length));
            if (isNaN(num)) return 0;
            num = num / split;
            return num % 1 === 0 ? cleanup(num) : 0;
        }
    }
    return defaultValue;
}
function iconToHTML(body, attributes) {
    let renderAttribsHTML = body.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
    for(const attr in attributes)renderAttribsHTML += " " + attr + '="' + attributes[attr] + '"';
    return '<svg xmlns="http://www.w3.org/2000/svg"' + renderAttribsHTML + ">" + body + "</svg>";
}
function encodeSVGforURL(svg) {
    return svg.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function svgToData(svg) {
    return "data:image/svg+xml," + encodeSVGforURL(svg);
}
function svgToURL(svg) {
    return 'url("' + svgToData(svg) + '")';
}
const defaultExtendedIconCustomisations = {
    ...defaultIconCustomisations,
    inline: false
};
/**
 * Default SVG attributes
 */ const svgDefaults = {
    'xmlns': 'http://www.w3.org/2000/svg',
    'xmlns:xlink': 'http://www.w3.org/1999/xlink',
    'aria-hidden': true,
    'role': 'img'
};
/**
 * Style modes
 */ const commonProps = {
    display: 'inline-block'
};
const monotoneProps = {
    backgroundColor: 'currentColor'
};
const coloredProps = {
    backgroundColor: 'transparent'
};
// Dynamically add common props to variables above
const propsToAdd = {
    Image: 'var(--svg)',
    Repeat: 'no-repeat',
    Size: '100% 100%'
};
const propsToAddTo = {
    webkitMask: monotoneProps,
    mask: monotoneProps,
    background: coloredProps
};
for(const prefix in propsToAddTo){
    const list = propsToAddTo[prefix];
    for(const prop in propsToAdd)list[prefix + prop] = propsToAdd[prop];
}
/**
 * Aliases for customisations.
 * In Vue 'v-' properties are reserved, so v-flip must be renamed
 */ const customisationAliases = {};
[
    'horizontal',
    'vertical'
].forEach((prefix)=>{
    const attr = prefix.slice(0, 1) + 'Flip';
    // vertical-flip
    customisationAliases[prefix + '-flip'] = attr;
    // v-flip
    customisationAliases[prefix.slice(0, 1) + '-flip'] = attr;
    // verticalFlip
    customisationAliases[prefix + 'Flip'] = attr;
});
/**
 * Fix size: add 'px' to numbers
 */ function fixSize(value) {
    return value + (value.match(/^[-0-9.]+$/) ? 'px' : '');
}
/**
 * Render icon
 */ const render = (// Icon must be validated before calling this function
icon, // Partial properties
props)=>{
    // Split properties
    const customisations = mergeCustomisations(defaultExtendedIconCustomisations, props);
    const componentProps = {
        ...svgDefaults
    };
    // Check mode
    const mode = props.mode || 'svg';
    // Copy style
    const style = {};
    const propsStyle = props.style;
    const customStyle = typeof propsStyle === 'object' && !(propsStyle instanceof Array) ? propsStyle : {};
    // Get element properties
    for(let key in props){
        const value = props[key];
        if (value === void 0) continue;
        switch(key){
            // Properties to ignore
            case 'icon':
            case 'style':
            case 'onLoad':
            case 'mode':
            case 'ssr':
                break;
            // Boolean attributes
            case 'inline':
            case 'hFlip':
            case 'vFlip':
                customisations[key] = value === true || value === 'true' || value === 1;
                break;
            // Flip as string: 'horizontal,vertical'
            case 'flip':
                if (typeof value === 'string') flipFromString(customisations, value);
                break;
            // Color: override style
            case 'color':
                style.color = value;
                break;
            // Rotation as string
            case 'rotate':
                if (typeof value === 'string') customisations[key] = rotateFromString(value);
                else if (typeof value === 'number') customisations[key] = value;
                break;
            // Remove aria-hidden
            case 'ariaHidden':
            case 'aria-hidden':
                // Vue transforms 'aria-hidden' property to 'ariaHidden'
                if (value !== true && value !== 'true') delete componentProps['aria-hidden'];
                break;
            default:
                {
                    const alias = customisationAliases[key];
                    if (alias) // Aliases for boolean customisations
                    {
                        if (value === true || value === 'true' || value === 1) customisations[alias] = true;
                    } else if (defaultExtendedIconCustomisations[key] === void 0) // Copy missing property if it does not exist in customisations
                    componentProps[key] = value;
                }
        }
    }
    // Generate icon
    const item = iconToSVG(icon, customisations);
    const renderAttribs = item.attributes;
    // Inline display
    if (customisations.inline) style.verticalAlign = '-0.125em';
    if (mode === 'svg') {
        // Add style
        componentProps.style = {
            ...style,
            ...customStyle
        };
        // Add icon stuff
        Object.assign(componentProps, renderAttribs);
        // Counter for ids based on "id" property to render icons consistently on server and client
        let localCounter = 0;
        let id = props.id;
        if (typeof id === 'string') // Convert '-' to '_' to avoid errors in animations
        id = id.replace(/-/g, '_');
        // Add innerHTML and style to props
        componentProps['innerHTML'] = replaceIDs(item.body, id ? ()=>id + 'ID' + localCounter++ : 'iconifyVue');
        // Render icon
        return (0, $igcaK.h)('svg', componentProps);
    }
    // Render <span> with style
    const { body, width, height } = icon;
    const useMask = mode === 'mask' || (mode === 'bg' ? false : body.indexOf('currentColor') !== -1);
    // Generate SVG
    const html = iconToHTML(body, {
        ...renderAttribs,
        width: width + '',
        height: height + ''
    });
    // Generate style
    componentProps.style = {
        ...style,
        '--svg': svgToURL(html),
        'width': fixSize(renderAttribs.width),
        'height': fixSize(renderAttribs.height),
        ...commonProps,
        ...useMask ? monotoneProps : coloredProps,
        ...customStyle
    };
    return (0, $igcaK.h)('span', componentProps);
};
/**
 * Enable cache
 *
 * @deprecated No longer used
 */ function enableCache(storage) {
//
}
/**
 * Disable cache
 *
 * @deprecated No longer used
 */ function disableCache(storage) {
//
}
/**
 * Initialise stuff
 */ // Enable short names
allowSimpleNames(true);
// Set API module
setAPIModule('', fetchAPIModule);
/**
 * Browser stuff
 */ if (typeof document !== 'undefined' && typeof window !== 'undefined') {
    const _window = window;
    // Load icons from global "IconifyPreload"
    if (_window.IconifyPreload !== void 0) {
        const preload = _window.IconifyPreload;
        const err = 'Invalid IconifyPreload syntax.';
        if (typeof preload === 'object' && preload !== null) (preload instanceof Array ? preload : [
            preload
        ]).forEach((item)=>{
            try {
                if (// Check if item is an object and not null/array
                typeof item !== 'object' || item === null || item instanceof Array || // Check for 'icons' and 'prefix'
                typeof item.icons !== 'object' || typeof item.prefix !== 'string' || // Add icon set
                !addCollection(item)) console.error(err);
            } catch (e) {
                console.error(err);
            }
        });
    }
    // Set API from global "IconifyProviders"
    if (_window.IconifyProviders !== void 0) {
        const providers = _window.IconifyProviders;
        if (typeof providers === 'object' && providers !== null) for(let key in providers){
            const err = 'IconifyProviders[' + key + '] is invalid.';
            try {
                const value = providers[key];
                if (typeof value !== 'object' || !value || value.resources === void 0) continue;
                if (!addAPIProvider(key, value)) console.error(err);
            } catch (e) {
                console.error(err);
            }
        }
    }
}
/**
 * Empty icon data, rendered when icon is not available
 */ const emptyIcon = {
    ...defaultIconProps,
    body: ''
};
const Icon = (0, $igcaK.defineComponent)({
    // Do not inherit other attributes: it is handled by render()
    inheritAttrs: false,
    // Set initial data
    data () {
        return {
            // Current icon name
            _name: '',
            // Loading
            _loadingIcon: null,
            // Mounted status
            iconMounted: false,
            // Callback counter to trigger re-render
            counter: 0
        };
    },
    mounted () {
        // Mark as mounted
        this.iconMounted = true;
    },
    unmounted () {
        this.abortLoading();
    },
    methods: {
        abortLoading () {
            if (this._loadingIcon) {
                this._loadingIcon.abort();
                this._loadingIcon = null;
            }
        },
        // Get data for icon to render or null
        getIcon (icon, onload, customise) {
            // Icon is an object
            if (typeof icon === 'object' && icon !== null && typeof icon.body === 'string') {
                // Stop loading
                this._name = '';
                this.abortLoading();
                return {
                    data: icon
                };
            }
            // Invalid icon?
            let iconName;
            if (typeof icon !== 'string' || (iconName = stringToIcon(icon, false, true)) === null) {
                this.abortLoading();
                return null;
            }
            // Load icon
            let data = getIconData(iconName);
            if (!data) {
                // Icon data is not available
                if (!this._loadingIcon || this._loadingIcon.name !== icon) {
                    // New icon to load
                    this.abortLoading();
                    this._name = '';
                    if (data !== null) // Icon was not loaded
                    this._loadingIcon = {
                        name: icon,
                        abort: loadIcons([
                            iconName
                        ], ()=>{
                            this.counter++;
                        })
                    };
                }
                return null;
            }
            // Icon data is available
            this.abortLoading();
            if (this._name !== icon) {
                this._name = icon;
                if (onload) onload(icon);
            }
            // Customise icon
            if (customise) {
                // Clone data and customise it
                data = Object.assign({}, data);
                const customised = customise(data.body, iconName.name, iconName.prefix, iconName.provider);
                if (typeof customised === 'string') data.body = customised;
            }
            // Add classes
            const classes = [
                'iconify'
            ];
            if (iconName.prefix !== '') classes.push('iconify--' + iconName.prefix);
            if (iconName.provider !== '') classes.push('iconify--' + iconName.provider);
            return {
                data: data,
                classes: classes
            };
        }
    },
    // Render icon
    render () {
        // Re-render when counter changes
        this.counter;
        const props = this.$attrs;
        // Get icon data
        const icon = this.iconMounted || props.ssr ? this.getIcon(props.icon, props.onLoad, props.customise) : null;
        // Validate icon object
        if (!icon) return render(emptyIcon, props);
        // Add classes
        let newProps = props;
        if (icon.classes) newProps = {
            ...props,
            class: (typeof props['class'] === 'string' ? props['class'] + ' ' : '') + icon.classes.join(' ')
        };
        // Render icon
        return render({
            ...defaultIconProps,
            ...icon.data
        }, newProps);
    }
});
/**
 * Internal API
 */ const _api = {
    getAPIConfig: getAPIConfig,
    setAPIModule: setAPIModule,
    sendAPIQuery: sendAPIQuery,
    setFetch: setFetch,
    getFetch: getFetch,
    listAPIProviders: listAPIProviders
};

});


parcelRegister("jlmG6", function(module, exports) {

$parcel$export(module.exports, "render", () => $e15191e49ad82204$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
function $e15191e49ad82204$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Iconify = (0, $igcaK.resolveComponent)("Iconify");
    return (0, $igcaK.openBlock)(), (0, $igcaK.createBlock)(_component_Iconify, {
        icon: $props.name,
        width: "28",
        height: "28"
    }, null, 8, [
        "icon"
    ]);
}

});

parcelRegister("4U7Rq", function(module, exports) {

$parcel$export(module.exports, "default", () => $39227d6147a73b6f$export$2e2bcd8739ae039);
let $39227d6147a73b6f$var$NOOP = ()=>{};
var $39227d6147a73b6f$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("2OxMi", function(module, exports) {

$parcel$export(module.exports, "render", () => $20ca73de529f66d6$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
const $20ca73de529f66d6$var$_hoisted_1 = [
    "src"
];
function $20ca73de529f66d6$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $igcaK.resolveComponent)("router-link");
    const _component_Icon = (0, $igcaK.resolveComponent)("Icon");
    const _component_Navigation = (0, $igcaK.resolveComponent)("Navigation");
    const _component_Container = (0, $igcaK.resolveComponent)("Container");
    return (0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("header", null, [
        (0, $igcaK.createVNode)(_component_Container, null, {
            default: (0, $igcaK.withCtx)(()=>[
                    (0, $igcaK.createElementVNode)("h1", null, [
                        (0, $igcaK.createVNode)(_component_router_link, {
                            to: {
                                name: 'Home'
                            }
                        }, {
                            default: (0, $igcaK.withCtx)(()=>[
                                    (0, $igcaK.createElementVNode)("img", {
                                        src: $data.logo,
                                        height: "60px",
                                        width: "0",
                                        alt: "Evelyn Logo"
                                    }, null, 8, $20ca73de529f66d6$var$_hoisted_1)
                                ]),
                            _: 1
                        })
                    ]),
                    (0, $igcaK.createElementVNode)("button", {
                        onClick: _cache[0] || (_cache[0] = ()=>_ctx.$emit('toggle')),
                        "aria-label": "Toggle navigation"
                    }, [
                        (0, $igcaK.createVNode)(_component_Icon, {
                            name: $props.toggleIcon
                        }, null, 8, [
                            "name"
                        ])
                    ]),
                    (0, $igcaK.createVNode)(_component_Navigation)
                ]),
            _: 1
        })
    ]);
}

});

parcelRegister("5VMzB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4517f43ef63712c6$export$2e2bcd8739ae039);
let $4517f43ef63712c6$var$NOOP = ()=>{};
var $4517f43ef63712c6$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("hEHvj", function(module, exports) {

$parcel$export(module.exports, "default", () => $035128f408cdaebb$export$2e2bcd8739ae039);
let $035128f408cdaebb$var$script;




let $035128f408cdaebb$var$initialize = ()=>{
    $035128f408cdaebb$var$script = (parcelRequire("6phHc"));
    if ($035128f408cdaebb$var$script.__esModule) $035128f408cdaebb$var$script = $035128f408cdaebb$var$script.default;
    $035128f408cdaebb$var$script.render = (parcelRequire("a2ZgO")).render;
    $035128f408cdaebb$var$script.__cssModules = {};
    (parcelRequire("igZFZ")).default($035128f408cdaebb$var$script);
    $035128f408cdaebb$var$script.__scopeId = 'data-v-8cf84f';
    $035128f408cdaebb$var$script.__file = "HeaderOverlay.vue";
};
$035128f408cdaebb$var$initialize();
var $035128f408cdaebb$export$2e2bcd8739ae039 = $035128f408cdaebb$var$script;

});
parcelRegister("6phHc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4aa2cde6b944a66d$export$2e2bcd8739ae039);

var $3taZC = parcelRequire("3taZC");

var $b6Tqq = parcelRequire("b6Tqq");
var $4aa2cde6b944a66d$export$2e2bcd8739ae039 = {
    name: 'HeaderOverlay',
    props: {
        render: false
    },
    components: {
        Header: $3taZC.default,
        Overlay: $b6Tqq.default
    }
};

});
parcelRegister("b6Tqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $816b3f86da14a876$export$2e2bcd8739ae039);
let $816b3f86da14a876$var$script;




let $816b3f86da14a876$var$initialize = ()=>{
    $816b3f86da14a876$var$script = (parcelRequire("dqE0e"));
    if ($816b3f86da14a876$var$script.__esModule) $816b3f86da14a876$var$script = $816b3f86da14a876$var$script.default;
    $816b3f86da14a876$var$script.render = (parcelRequire("aR7U0")).render;
    $816b3f86da14a876$var$script.__cssModules = {};
    (parcelRequire("hyzTF")).default($816b3f86da14a876$var$script);
    $816b3f86da14a876$var$script.__scopeId = 'data-v-9afc62';
    $816b3f86da14a876$var$script.__file = "Overlay.vue";
};
$816b3f86da14a876$var$initialize();
var $816b3f86da14a876$export$2e2bcd8739ae039 = $816b3f86da14a876$var$script;

});
parcelRegister("dqE0e", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9c6cbbc6c259b611$export$2e2bcd8739ae039);
var $9c6cbbc6c259b611$export$2e2bcd8739ae039 = {
    name: 'Overlay'
};

});

parcelRegister("aR7U0", function(module, exports) {

$parcel$export(module.exports, "render", () => $7e74fbde5772c4b6$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
const $7e74fbde5772c4b6$var$_hoisted_1 = {
    class: "overlay"
};
function $7e74fbde5772c4b6$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("div", $7e74fbde5772c4b6$var$_hoisted_1, [
        (0, $igcaK.renderSlot)(_ctx.$slots, "default")
    ]);
}

});

parcelRegister("hyzTF", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc8175070b0a4e54$export$2e2bcd8739ae039);
let $cc8175070b0a4e54$var$NOOP = ()=>{};
var $cc8175070b0a4e54$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("a2ZgO", function(module, exports) {

$parcel$export(module.exports, "render", () => $75099e4a0b40328d$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
var $jfBPE = parcelRequire("jfBPE");
function $75099e4a0b40328d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = (0, $igcaK.resolveComponent)("Header");
    const _component_Overlay = (0, $igcaK.resolveComponent)("Overlay");
    return (0, $igcaK.openBlock)(), (0, $igcaK.createBlock)((0, $jfBPE.Transition), {
        name: "overlay"
    }, {
        default: (0, $igcaK.withCtx)(()=>[
                $props.render ? ((0, $igcaK.openBlock)(), (0, $igcaK.createBlock)(_component_Overlay, {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = (0, $jfBPE.withModifiers)(()=>_ctx.$emit('toggle'), [
                        "self"
                    ]))
                }, {
                    default: (0, $igcaK.withCtx)(()=>[
                            $props.render ? ((0, $igcaK.openBlock)(), (0, $igcaK.createBlock)(_component_Header, {
                                key: 0,
                                onToggle: _cache[0] || (_cache[0] = ()=>_ctx.$emit('toggle')),
                                toggleIcon: "eva:close-outline"
                            })) : (0, $igcaK.createCommentVNode)("", true)
                        ]),
                    _: 1
                })) : (0, $igcaK.createCommentVNode)("", true)
            ]),
        _: 1
    });
}

});

parcelRegister("igZFZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4d99042345acfba$export$2e2bcd8739ae039);
let $d4d99042345acfba$var$NOOP = ()=>{};
var $d4d99042345acfba$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("8vzlI", function(module, exports) {

$parcel$export(module.exports, "render", () => $631ca3987f30cfc4$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
function $631ca3987f30cfc4$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_HeaderDefault = (0, $igcaK.resolveComponent)("HeaderDefault");
    const _component_HeaderOverlay = (0, $igcaK.resolveComponent)("HeaderOverlay");
    return (0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)((0, $igcaK.Fragment), null, [
        (0, $igcaK.createVNode)(_component_HeaderDefault, {
            onToggle: _cache[0] || (_cache[0] = ()=>$data.overlay = true)
        }),
        (0, $igcaK.createVNode)(_component_HeaderOverlay, {
            onToggle: _cache[1] || (_cache[1] = ()=>$data.overlay = false),
            render: $data.overlay
        }, null, 8, [
            "render"
        ])
    ], 64);
}

});

parcelRegister("21zwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $17973bcf74d9506d$export$2e2bcd8739ae039);
let $17973bcf74d9506d$var$NOOP = ()=>{};
var $17973bcf74d9506d$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("bXYKW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b645547ebf1f6ae$export$2e2bcd8739ae039);
let $8b645547ebf1f6ae$var$script;




let $8b645547ebf1f6ae$var$initialize = ()=>{
    $8b645547ebf1f6ae$var$script = (parcelRequire("c5fBg"));
    if ($8b645547ebf1f6ae$var$script.__esModule) $8b645547ebf1f6ae$var$script = $8b645547ebf1f6ae$var$script.default;
    $8b645547ebf1f6ae$var$script.render = (parcelRequire("6Rx26")).render;
    $8b645547ebf1f6ae$var$script.__cssModules = {};
    (parcelRequire("eYQfj")).default($8b645547ebf1f6ae$var$script);
    $8b645547ebf1f6ae$var$script.__scopeId = 'data-v-a8e1c0';
    $8b645547ebf1f6ae$var$script.__file = "Footer.vue";
};
$8b645547ebf1f6ae$var$initialize();
var $8b645547ebf1f6ae$export$2e2bcd8739ae039 = $8b645547ebf1f6ae$var$script;

});
parcelRegister("c5fBg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $36db4774bc5f7bb6$export$2e2bcd8739ae039);

var $iGa2N = parcelRequire("iGa2N");
var $36db4774bc5f7bb6$export$2e2bcd8739ae039 = {
    name: 'Footer',
    components: {
        Container: $iGa2N.default
    }
};

});

parcelRegister("6Rx26", function(module, exports) {

$parcel$export(module.exports, "render", () => $4ff150f365a0a24b$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
function $4ff150f365a0a24b$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("footer", null, [
        ..._cache[0] || (_cache[0] = [
            (0, $igcaK.createElementVNode)("p", null, [
                (0, $igcaK.createTextVNode)("Made with \u2764\uFE0F by "),
                (0, $igcaK.createElementVNode)("b", null, "Gifaldy Azka"),
                (0, $igcaK.createTextVNode)(".")
            ], -1)
        ])
    ]);
}

});

parcelRegister("eYQfj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae7f323b2964071d$export$2e2bcd8739ae039);
let $ae7f323b2964071d$var$NOOP = ()=>{};
var $ae7f323b2964071d$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("1LCJs", function(module, exports) {

$parcel$export(module.exports, "default", () => $149839a0598a7ac2$export$2e2bcd8739ae039);
let $149839a0598a7ac2$var$script;




let $149839a0598a7ac2$var$initialize = ()=>{
    $149839a0598a7ac2$var$script = (parcelRequire("dJLi8"));
    if ($149839a0598a7ac2$var$script.__esModule) $149839a0598a7ac2$var$script = $149839a0598a7ac2$var$script.default;
    $149839a0598a7ac2$var$script.render = (parcelRequire("9lbXg")).render;
    $149839a0598a7ac2$var$script.__cssModules = {};
    (parcelRequire("8I2Oe")).default($149839a0598a7ac2$var$script);
    $149839a0598a7ac2$var$script.__scopeId = 'data-v-494ff7';
    $149839a0598a7ac2$var$script.__file = "Loading.vue";
};
$149839a0598a7ac2$var$initialize();
var $149839a0598a7ac2$export$2e2bcd8739ae039 = $149839a0598a7ac2$var$script;

});
parcelRegister("dJLi8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a0042969e08b79f7$export$2e2bcd8739ae039);

var $ehG8O = parcelRequire("ehG8O");

var $iGa2N = parcelRequire("iGa2N");
var $a0042969e08b79f7$export$2e2bcd8739ae039 = {
    name: 'Loading',
    components: {
        LoadEffect: $ehG8O.default,
        Container: $iGa2N.default
    }
};

});
parcelRegister("ehG8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6635797170d8bb7$export$2e2bcd8739ae039);
let $a6635797170d8bb7$var$script;




let $a6635797170d8bb7$var$initialize = ()=>{
    $a6635797170d8bb7$var$script = (parcelRequire("9oowU"));
    if ($a6635797170d8bb7$var$script.__esModule) $a6635797170d8bb7$var$script = $a6635797170d8bb7$var$script.default;
    $a6635797170d8bb7$var$script.render = (parcelRequire("8sEvP")).render;
    $a6635797170d8bb7$var$script.__cssModules = {};
    (parcelRequire("aQcKg")).default($a6635797170d8bb7$var$script);
    $a6635797170d8bb7$var$script.__scopeId = 'data-v-5b79a2';
    $a6635797170d8bb7$var$script.__file = "LoadEffect.vue";
};
$a6635797170d8bb7$var$initialize();
var $a6635797170d8bb7$export$2e2bcd8739ae039 = $a6635797170d8bb7$var$script;

});
parcelRegister("9oowU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6d696208d8749af6$export$2e2bcd8739ae039);
var $6d696208d8749af6$export$2e2bcd8739ae039 = {
    name: 'LoadEffect',
    props: {
        stop: {
            type: Boolean,
            default: false
        }
    }
};

});

parcelRegister("8sEvP", function(module, exports) {

$parcel$export(module.exports, "render", () => $62905d2e336456be$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
var $oF3Y1 = parcelRequire("oF3Y1");
function $62905d2e336456be$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("span", {
        class: (0, $oF3Y1.normalizeClass)([
            "load-effect",
            {
                stop: $props.stop
            }
        ])
    }, [
        (0, $igcaK.renderSlot)(_ctx.$slots, "default")
    ], 2);
}

});

parcelRegister("aQcKg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e48a5a739ee3b8e$export$2e2bcd8739ae039);
let $7e48a5a739ee3b8e$var$NOOP = ()=>{};
var $7e48a5a739ee3b8e$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("9lbXg", function(module, exports) {

$parcel$export(module.exports, "render", () => $6ccf5934546b2fde$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
const $6ccf5934546b2fde$var$_hoisted_1 = {
    class: "loading"
};
function $6ccf5934546b2fde$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoadEffect = (0, $igcaK.resolveComponent)("LoadEffect");
    const _component_Container = (0, $igcaK.resolveComponent)("Container");
    return (0, $igcaK.openBlock)(), (0, $igcaK.createBlock)(_component_Container, null, {
        default: (0, $igcaK.withCtx)(()=>[
                (0, $igcaK.createElementVNode)("div", $6ccf5934546b2fde$var$_hoisted_1, [
                    (0, $igcaK.createVNode)(_component_LoadEffect, {
                        class: "loading-text"
                    }, {
                        default: (0, $igcaK.withCtx)(()=>[
                                ..._cache[0] || (_cache[0] = [
                                    (0, $igcaK.createTextVNode)("Loading", -1)
                                ])
                            ]),
                        _: 1
                    })
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("8I2Oe", function(module, exports) {

$parcel$export(module.exports, "default", () => $65749ca4dbf63693$export$2e2bcd8739ae039);
let $65749ca4dbf63693$var$NOOP = ()=>{};
var $65749ca4dbf63693$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("3NNX1", function(module, exports) {

$parcel$export(module.exports, "render", () => $2c4cb1eb429dee56$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
var $jfBPE = parcelRequire("jfBPE");
function $2c4cb1eb429dee56$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Loading = (0, $igcaK.resolveComponent)("Loading");
    const _component_Header = (0, $igcaK.resolveComponent)("Header");
    const _component_Footer = (0, $igcaK.resolveComponent)("Footer");
    const _component_router_view = (0, $igcaK.resolveComponent)("router-view");
    return (0, $igcaK.openBlock)(), (0, $igcaK.createBlock)((0, $jfBPE.Transition), {
        name: "fade",
        mode: "out-in"
    }, {
        default: (0, $igcaK.withCtx)(()=>[
                $data.show ? ((0, $igcaK.openBlock)(), (0, $igcaK.createBlock)(_component_Loading, {
                    key: 0
                })) : ((0, $igcaK.openBlock)(), (0, $igcaK.createBlock)(_component_router_view, {
                    key: 1
                }, {
                    default: (0, $igcaK.withCtx)(({ Component: Component })=>[
                            (0, $igcaK.createVNode)(_component_Header),
                            (0, $igcaK.createVNode)((0, $jfBPE.Transition), {
                                name: "fade",
                                mode: "out-in"
                            }, {
                                default: (0, $igcaK.withCtx)(()=>[
                                        ((0, $igcaK.openBlock)(), (0, $igcaK.createBlock)((0, $igcaK.resolveDynamicComponent)(Component)))
                                    ]),
                                _: 2
                            }, 1024),
                            (0, $igcaK.createVNode)(_component_Footer)
                        ]),
                    _: 1
                }))
            ]),
        _: 1
    });
}

});

parcelRegister("1rrBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $10cdb945e864b702$export$2e2bcd8739ae039);
let $10cdb945e864b702$var$NOOP = ()=>{};
var $10cdb945e864b702$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("gxzqo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c0ab350a551b3035$export$2e2bcd8739ae039);

var $j9tZR = parcelRequire("j9tZR");
var $c0ab350a551b3035$export$2e2bcd8739ae039 = {
    name: 'Home',
    components: {
        Hero: $j9tZR.default
    }
};

});
parcelRegister("j9tZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $df1620513c16d7ce$export$2e2bcd8739ae039);
let $df1620513c16d7ce$var$script;




let $df1620513c16d7ce$var$initialize = ()=>{
    $df1620513c16d7ce$var$script = (parcelRequire("5eZ46"));
    if ($df1620513c16d7ce$var$script.__esModule) $df1620513c16d7ce$var$script = $df1620513c16d7ce$var$script.default;
    $df1620513c16d7ce$var$script.render = (parcelRequire("lsmQB")).render;
    $df1620513c16d7ce$var$script.__cssModules = {};
    (parcelRequire("9DytS")).default($df1620513c16d7ce$var$script);
    $df1620513c16d7ce$var$script.__scopeId = 'data-v-5e4130';
    $df1620513c16d7ce$var$script.__file = "Hero.vue";
};
$df1620513c16d7ce$var$initialize();
var $df1620513c16d7ce$export$2e2bcd8739ae039 = $df1620513c16d7ce$var$script;

});
parcelRegister("5eZ46", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3d0da0d896563723$export$2e2bcd8739ae039);

var $iGa2N = parcelRequire("iGa2N");

var $d8Xgm = parcelRequire("d8Xgm");

var $h9bs7 = parcelRequire("h9bs7");
var $3d0da0d896563723$export$2e2bcd8739ae039 = {
    name: 'Hero',
    components: {
        Container: $iGa2N.default,
        Button: $d8Xgm.default
    },
    data () {
        return {
            socials: $h9bs7.default
        };
    }
};

});
parcelRegister("d8Xgm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9919fe1912432c2e$export$2e2bcd8739ae039);
let $9919fe1912432c2e$var$script;




let $9919fe1912432c2e$var$initialize = ()=>{
    $9919fe1912432c2e$var$script = (parcelRequire("7SgKB"));
    if ($9919fe1912432c2e$var$script.__esModule) $9919fe1912432c2e$var$script = $9919fe1912432c2e$var$script.default;
    $9919fe1912432c2e$var$script.render = (parcelRequire("fuMSS")).render;
    $9919fe1912432c2e$var$script.__cssModules = {};
    (parcelRequire("goLSb")).default($9919fe1912432c2e$var$script);
    $9919fe1912432c2e$var$script.__scopeId = 'data-v-bf9151';
    $9919fe1912432c2e$var$script.__file = "Button.vue";
};
$9919fe1912432c2e$var$initialize();
var $9919fe1912432c2e$export$2e2bcd8739ae039 = $9919fe1912432c2e$var$script;

});
parcelRegister("7SgKB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5bba91e00164c303$export$2e2bcd8739ae039);
var $5bba91e00164c303$export$2e2bcd8739ae039 = {
    name: 'Button',
    props: {
        dest: {
            type: String
        }
    }
};

});

parcelRegister("fuMSS", function(module, exports) {

$parcel$export(module.exports, "render", () => $b47f93b5524f1074$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
const $b47f93b5524f1074$var$_hoisted_1 = {
    key: 0
};
const $b47f93b5524f1074$var$_hoisted_2 = [
    "href"
];
const $b47f93b5524f1074$var$_hoisted_3 = {
    key: 1,
    class: "button button-void",
    href: void 0
};
function $b47f93b5524f1074$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return $props.dest ? ((0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("div", $b47f93b5524f1074$var$_hoisted_1, [
        (0, $igcaK.createElementVNode)("a", {
            class: "button",
            href: $props.dest
        }, [
            (0, $igcaK.renderSlot)(_ctx.$slots, "default")
        ], 8, $b47f93b5524f1074$var$_hoisted_2)
    ])) : ((0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("a", $b47f93b5524f1074$var$_hoisted_3, [
        (0, $igcaK.renderSlot)(_ctx.$slots, "default")
    ]));
}

});

parcelRegister("goLSb", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf0405cb3ff296cb$export$2e2bcd8739ae039);
let $bf0405cb3ff296cb$var$NOOP = ()=>{};
var $bf0405cb3ff296cb$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("h9bs7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1664187f6ea23306$export$2e2bcd8739ae039);
const $1664187f6ea23306$var$socials = [
    {
        name: 'YouTube',
        username: 'Hai Halo Epel',
        url: 'https://youtube.com/c/HaiHaloEpel'
    },
    {
        name: 'Twitter',
        username: 'EpelEvelyn',
        url: 'https://twitter.com/EpelEvelyn'
    },
    {
        name: 'Facebook',
        username: 'haihalo.epel',
        url: 'https://facebook.com/haihalo.epel'
    },
    {
        name: 'Instagram',
        username: 'haihalo.epel',
        url: 'https://instagram.com/HaiHalo.Epel'
    },
    {
        name: 'Smule',
        username: 'EpelEvelyn',
        url: 'https://smule.com/EpelEvelyn'
    },
    {
        name: 'TikTok',
        username: 'HaiHaloEpel',
        url: 'https://tiktok.com/@HaiHaloEpel'
    },
    {
        name: 'Discord',
        username: "\uD83D\uDC99 Piolet Eplegorden \uD83D\uDC99",
        url: 'https://bit.ly/HaiHaloServer'
    },
    {
        name: 'Trakteer',
        username: 'HaiHaloEpel',
        url: 'https://trakteer.id/HaiHaloEpel'
    },
    {
        name: 'Saweria',
        username: 'HaiHaloEpel',
        url: 'https://saweria.co/HaiHaloEpel'
    },
    {
        name: 'Karyakarsa',
        username: 'HaiHaloEpel',
        url: 'https://karyakarsa.com/HaiHaloEpel'
    },
    {
        name: 'Streamlabs',
        username: 'evelynvtuber',
        url: 'https://streamlabs.com/evelynvtuber/tip'
    },
    {
        name: 'Steam',
        username: 'EpelEvelyn',
        url: 'https://steamcommunity.com/id/EpelEvelyn'
    },
    {
        name: 'Reality',
        username: 'Epel || Evelyn',
        url: 'https://reality.app/profile/6e0ccda3'
    }
];
var $1664187f6ea23306$export$2e2bcd8739ae039 = $1664187f6ea23306$var$socials;

});


parcelRegister("lsmQB", function(module, exports) {

$parcel$export(module.exports, "render", () => $f9edef811534789c$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");

const $f9edef811534789c$var$_hoisted_1 = {
    class: "hero"
};
const $f9edef811534789c$var$_hoisted_2 = {
    class: "info"
};
function $f9edef811534789c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Button = (0, $igcaK.resolveComponent)("Button");
    const _component_Container = (0, $igcaK.resolveComponent)("Container");
    return (0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("section", $f9edef811534789c$var$_hoisted_1, [
        (0, $igcaK.createVNode)(_component_Container, null, {
            default: (0, $igcaK.withCtx)(()=>[
                    _cache[3] || (_cache[3] = (0, $igcaK.createElementVNode)("div", {
                        class: "model"
                    }, [
                        (0, $igcaK.createElementVNode)("img", {
                            src: (0, {}),
                            height: "0",
                            width: "100%",
                            alt: "Evelyn Model"
                        })
                    ], -1)),
                    (0, $igcaK.createElementVNode)("div", $f9edef811534789c$var$_hoisted_2, [
                        _cache[1] || (_cache[1] = (0, $igcaK.createElementVNode)("p", null, [
                            (0, $igcaK.createTextVNode)(" Hai Halo!"),
                            (0, $igcaK.createElementVNode)("br"),
                            (0, $igcaK.createTextVNode)(" I'm Evelyn but you can call me Epel~ ")
                        ], -1)),
                        _cache[2] || (_cache[2] = (0, $igcaK.createElementVNode)("h1", null, [
                            (0, $igcaK.createTextVNode)(" I am aspire to become"),
                            (0, $igcaK.createElementVNode)("br"),
                            (0, $igcaK.createTextVNode)(" your best mood booster! ")
                        ], -1)),
                        (0, $igcaK.createVNode)(_component_Button, {
                            href: $data.socials[0].url
                        }, {
                            default: (0, $igcaK.withCtx)(()=>[
                                    ..._cache[0] || (_cache[0] = [
                                        (0, $igcaK.createTextVNode)("Join Epelables", -1)
                                    ])
                                ]),
                            _: 1
                        }, 8, [
                            "href"
                        ])
                    ])
                ]),
            _: 1
        })
    ]);
}

});

parcelRegister("9DytS", function(module, exports) {

$parcel$export(module.exports, "default", () => $704280bdde90e5df$export$2e2bcd8739ae039);
let $704280bdde90e5df$var$NOOP = ()=>{};
var $704280bdde90e5df$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("kRdD7", function(module, exports) {

$parcel$export(module.exports, "render", () => $f2f35480c90a826a$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
function $f2f35480c90a826a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Hero = (0, $igcaK.resolveComponent)("Hero");
    return (0, $igcaK.openBlock)(), (0, $igcaK.createBlock)(_component_Hero);
}

});

parcelRegister("daWq5", function(module, exports) {

$parcel$export(module.exports, "default", () => $997986804f6ad897$export$2e2bcd8739ae039);
let $997986804f6ad897$var$NOOP = ()=>{};
var $997986804f6ad897$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("gNU50", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c3bcb93a26292644$export$2e2bcd8739ae039);

var $iGa2N = parcelRequire("iGa2N");

var $jLLSu = parcelRequire("jLLSu");

var $i0cJB = parcelRequire("i0cJB");

var $ac8WF = parcelRequire("ac8WF");

var $dZqSr = parcelRequire("dZqSr");

var $lhmv9 = parcelRequire("lhmv9");
var $c3bcb93a26292644$export$2e2bcd8739ae039 = {
    name: 'FanArt',
    components: {
        Container: $iGa2N.default,
        PageTitle: $jLLSu.default,
        ArtCard: $i0cJB.default,
        ArtList: $ac8WF.default,
        ImageView: $dZqSr.default
    },
    data () {
        return {
            arts: $lhmv9.default,
            view: false,
            img: ''
        };
    },
    methods: {
        toggle (img) {
            this.view = !this.view;
            this.img = img;
            document.body.setAttribute('style', 'overflow: hidden;');
        },
        boolUpdate (value) {
            this.view = value;
        }
    }
};

});
parcelRegister("jLLSu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6478ba5ff2a2093$export$2e2bcd8739ae039);
let $e6478ba5ff2a2093$var$script;




let $e6478ba5ff2a2093$var$initialize = ()=>{
    $e6478ba5ff2a2093$var$script = (parcelRequire("dMPIU"));
    if ($e6478ba5ff2a2093$var$script.__esModule) $e6478ba5ff2a2093$var$script = $e6478ba5ff2a2093$var$script.default;
    $e6478ba5ff2a2093$var$script.render = (parcelRequire("2gOEy")).render;
    $e6478ba5ff2a2093$var$script.__cssModules = {};
    (parcelRequire("1sVBd")).default($e6478ba5ff2a2093$var$script);
    $e6478ba5ff2a2093$var$script.__scopeId = 'data-v-49e489';
    $e6478ba5ff2a2093$var$script.__file = "PageTitle.vue";
};
$e6478ba5ff2a2093$var$initialize();
var $e6478ba5ff2a2093$export$2e2bcd8739ae039 = $e6478ba5ff2a2093$var$script;

});
parcelRegister("dMPIU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a097e13d652b5a98$export$2e2bcd8739ae039);
var $a097e13d652b5a98$export$2e2bcd8739ae039 = {
    name: 'PageTitle'
};

});

parcelRegister("2gOEy", function(module, exports) {

$parcel$export(module.exports, "render", () => $1a745e0c86f9d157$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
const $1a745e0c86f9d157$var$_hoisted_1 = {
    class: "page-title"
};
function $1a745e0c86f9d157$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("div", $1a745e0c86f9d157$var$_hoisted_1, [
        (0, $igcaK.createElementVNode)("h1", null, [
            (0, $igcaK.renderSlot)(_ctx.$slots, "default")
        ]),
        (0, $igcaK.createElementVNode)("p", null, [
            (0, $igcaK.renderSlot)(_ctx.$slots, "sub")
        ])
    ]);
}

});

parcelRegister("1sVBd", function(module, exports) {

$parcel$export(module.exports, "default", () => $11151601b8e1e9ae$export$2e2bcd8739ae039);
let $11151601b8e1e9ae$var$NOOP = ()=>{};
var $11151601b8e1e9ae$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("i0cJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1b21ae06c876326$export$2e2bcd8739ae039);
let $d1b21ae06c876326$var$script;




let $d1b21ae06c876326$var$initialize = ()=>{
    $d1b21ae06c876326$var$script = (parcelRequire("8ALXv"));
    if ($d1b21ae06c876326$var$script.__esModule) $d1b21ae06c876326$var$script = $d1b21ae06c876326$var$script.default;
    $d1b21ae06c876326$var$script.render = (parcelRequire("1r11D")).render;
    $d1b21ae06c876326$var$script.__cssModules = {};
    (parcelRequire("5LYIS")).default($d1b21ae06c876326$var$script);
    $d1b21ae06c876326$var$script.__scopeId = 'data-v-1e45e5';
    $d1b21ae06c876326$var$script.__file = "ArtCard.vue";
};
$d1b21ae06c876326$var$initialize();
var $d1b21ae06c876326$export$2e2bcd8739ae039 = $d1b21ae06c876326$var$script;

});
parcelRegister("8ALXv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $92ee395543e5c14e$export$2e2bcd8739ae039);
var $92ee395543e5c14e$export$2e2bcd8739ae039 = {
    name: 'ArtCard',
    props: {
        img: {
            type: String,
            required: true
        },
        artist: {
            type: String,
            required: true
        },
        artistUrl: {
            type: String,
            required: true
        }
    }
};

});

parcelRegister("1r11D", function(module, exports) {

$parcel$export(module.exports, "render", () => $10b91bb0defc4379$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
var $oF3Y1 = parcelRequire("oF3Y1");
const $10b91bb0defc4379$var$_hoisted_1 = {
    class: "card"
};
const $10b91bb0defc4379$var$_hoisted_2 = [
    "src",
    "alt"
];
const $10b91bb0defc4379$var$_hoisted_3 = {
    class: "desc"
};
const $10b91bb0defc4379$var$_hoisted_4 = [
    "href"
];
function $10b91bb0defc4379$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("div", $10b91bb0defc4379$var$_hoisted_1, [
        (0, $igcaK.createElementVNode)("img", {
            src: $props.img,
            alt: `Art by ${$props.artist}`
        }, null, 8, $10b91bb0defc4379$var$_hoisted_2),
        (0, $igcaK.createElementVNode)("div", $10b91bb0defc4379$var$_hoisted_3, [
            (0, $igcaK.createElementVNode)("a", {
                href: $props.artistUrl
            }, (0, $oF3Y1.toDisplayString)($props.artist), 9, $10b91bb0defc4379$var$_hoisted_4)
        ])
    ]);
}

});

parcelRegister("5LYIS", function(module, exports) {

$parcel$export(module.exports, "default", () => $434071d6dc257fb7$export$2e2bcd8739ae039);
let $434071d6dc257fb7$var$NOOP = ()=>{};
var $434071d6dc257fb7$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("ac8WF", function(module, exports) {

$parcel$export(module.exports, "default", () => $76c1f6b9a1aa0c71$export$2e2bcd8739ae039);
let $76c1f6b9a1aa0c71$var$script;




let $76c1f6b9a1aa0c71$var$initialize = ()=>{
    $76c1f6b9a1aa0c71$var$script = (parcelRequire("jRINE"));
    if ($76c1f6b9a1aa0c71$var$script.__esModule) $76c1f6b9a1aa0c71$var$script = $76c1f6b9a1aa0c71$var$script.default;
    $76c1f6b9a1aa0c71$var$script.render = (parcelRequire("8Rwz6")).render;
    $76c1f6b9a1aa0c71$var$script.__cssModules = {};
    (parcelRequire("1NW81")).default($76c1f6b9a1aa0c71$var$script);
    $76c1f6b9a1aa0c71$var$script.__scopeId = 'data-v-69b16e';
    $76c1f6b9a1aa0c71$var$script.__file = "ArtList.vue";
};
$76c1f6b9a1aa0c71$var$initialize();
var $76c1f6b9a1aa0c71$export$2e2bcd8739ae039 = $76c1f6b9a1aa0c71$var$script;

});
parcelRegister("jRINE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e765b7de4113dbc0$export$2e2bcd8739ae039);
var $e765b7de4113dbc0$export$2e2bcd8739ae039 = {
    name: 'ArtList'
};

});

parcelRegister("8Rwz6", function(module, exports) {

$parcel$export(module.exports, "render", () => $673c88bbaca5b6a8$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
const $673c88bbaca5b6a8$var$_hoisted_1 = {
    class: "art-list"
};
function $673c88bbaca5b6a8$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("ul", $673c88bbaca5b6a8$var$_hoisted_1, [
        (0, $igcaK.renderSlot)(_ctx.$slots, "default")
    ]);
}

});

parcelRegister("1NW81", function(module, exports) {

$parcel$export(module.exports, "default", () => $1507751c3abb49ad$export$2e2bcd8739ae039);
let $1507751c3abb49ad$var$NOOP = ()=>{};
var $1507751c3abb49ad$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("dZqSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2f5d21ec6432265$export$2e2bcd8739ae039);
let $a2f5d21ec6432265$var$script;




let $a2f5d21ec6432265$var$initialize = ()=>{
    $a2f5d21ec6432265$var$script = (parcelRequire("kA3Dk"));
    if ($a2f5d21ec6432265$var$script.__esModule) $a2f5d21ec6432265$var$script = $a2f5d21ec6432265$var$script.default;
    $a2f5d21ec6432265$var$script.render = (parcelRequire("dKUR3")).render;
    $a2f5d21ec6432265$var$script.__cssModules = {};
    (parcelRequire("6pQLI")).default($a2f5d21ec6432265$var$script);
    $a2f5d21ec6432265$var$script.__scopeId = 'data-v-180329';
    $a2f5d21ec6432265$var$script.__file = "ImageView.vue";
};
$a2f5d21ec6432265$var$initialize();
var $a2f5d21ec6432265$export$2e2bcd8739ae039 = $a2f5d21ec6432265$var$script;

});
parcelRegister("kA3Dk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2ccc7172cf5fbb8c$export$2e2bcd8739ae039);

var $g2ma9 = parcelRequire("g2ma9");
var $2ccc7172cf5fbb8c$export$2e2bcd8739ae039 = {
    name: 'ImageView',
    props: [
        'arts',
        'isView',
        'img'
    ],
    components: {
        Icon: $g2ma9.default
    },
    data () {
        return {
            view: this.isView
        };
    },
    methods: {
        update () {
            this.view = !this.view;
            this.$emit('boolUpdate', this.view);
            document.body.removeAttribute('style');
        }
    }
};

});

parcelRegister("dKUR3", function(module, exports) {

$parcel$export(module.exports, "render", () => $a03bac6cce587dd5$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
var $jfBPE = parcelRequire("jfBPE");
const $a03bac6cce587dd5$var$_hoisted_1 = {
    class: "img"
};
const $a03bac6cce587dd5$var$_hoisted_2 = [
    "src"
];
function $a03bac6cce587dd5$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Icon = (0, $igcaK.resolveComponent)("Icon");
    return (0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("div", {
        class: "root",
        onClick: _cache[1] || (_cache[1] = (0, $jfBPE.withModifiers)(($event)=>$options.update(), [
            "self"
        ]))
    }, [
        (0, $igcaK.createElementVNode)("button", {
            class: "exit",
            onClick: _cache[0] || (_cache[0] = ($event)=>$options.update())
        }, [
            (0, $igcaK.createVNode)(_component_Icon, {
                name: "eva:close-outline"
            })
        ]),
        (0, $igcaK.createElementVNode)("figure", $a03bac6cce587dd5$var$_hoisted_1, [
            (0, $igcaK.createElementVNode)("img", {
                src: $props.img,
                alt: "Image"
            }, null, 8, $a03bac6cce587dd5$var$_hoisted_2)
        ])
    ]);
}

});

parcelRegister("6pQLI", function(module, exports) {

$parcel$export(module.exports, "default", () => $4abe02a054ebe5b4$export$2e2bcd8739ae039);
let $4abe02a054ebe5b4$var$NOOP = ()=>{};
var $4abe02a054ebe5b4$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("lhmv9", function(module, exports) {

$parcel$export(module.exports, "default", () => $42b481f9b4bef4fe$export$2e2bcd8739ae039);
const $42b481f9b4bef4fe$var$arts = [
    {
        img: 'https://pbs.twimg.com/media/FRmAB6yagAI0br0.jpg',
        artist: {
            username: '@ElaineCelestia',
            url: 'https://twitter.com/ElaineCelestia'
        }
    },
    {
        img: 'https://pbs.twimg.com/media/Eu9cQWIU4AYZGex.jpg',
        artist: {
            username: '@AyumiAika_',
            url: 'https://twitter.com/AyumiAika_'
        }
    },
    {
        img: 'https://pbs.twimg.com/media/E44l9wLUcAcMSdz.jpg',
        artist: {
            username: '@Ikazu401',
            url: 'https://twitter.com/Ikazu401'
        }
    },
    {
        img: 'https://pbs.twimg.com/media/FN96pDoaAAIuEQs.jpg',
        artist: {
            username: '@deidey16_',
            url: 'https://twitter.com/deidey16_'
        }
    },
    {
        img: 'https://pbs.twimg.com/media/FRljGC3VsAAMgQK.jpg',
        artist: {
            username: '@Ikazu401',
            url: 'https://twitter.com/Ikazu401'
        }
    },
    {
        img: 'https://pbs.twimg.com/media/FXfleEFacAAwCVb.jpg',
        artist: {
            username: '@MerySyafira48',
            url: 'https://twitter.com/MerySyafira48'
        }
    },
    {
        img: 'https://pbs.twimg.com/media/E_jg_FKVUAAJOf_.jpg',
        artist: {
            username: '@aditchris',
            url: 'https://twitter.com/aditchris'
        }
    },
    {
        img: 'https://pbs.twimg.com/media/Ef14v6hUEAEn7yH.jpg',
        artist: {
            username: '@Acacia_Leafs',
            url: 'https://twitter.com/Acacia_Leafs'
        }
    },
    {
        img: 'https://pbs.twimg.com/media/EmJ8YMGVgAYQG3p.jpg',
        artist: {
            username: '@SakurarinMochi',
            url: 'https://twitter.com/SakurarinMochi'
        }
    },
    {
        img: 'https://pbs.twimg.com/media/FaUgYNOaAAE-PXG.jpg',
        artist: {
            username: '@pine_pinepin',
            url: 'https://twitter.com/pine_pinepin'
        }
    },
    {
        img: 'https://pbs.twimg.com/media/FZsxffAUYAEegeF.jpg',
        artist: {
            username: '@SakurarinMochi',
            url: 'https://twitter.com/SakurarinMochi'
        }
    },
    {
        img: 'https://pbs.twimg.com/media/EfnGLyOVoAEUOaf.jpg',
        artist: {
            username: '@UpMocks',
            url: 'https://twitter.com/UpMocks'
        }
    },
    {
        img: 'https://pbs.twimg.com/media/Fc_gzamaIAA108D.jpg',
        artist: {
            username: '@pine_pinepin',
            url: 'https://twitter.com/pine_pinepin'
        }
    }
];
var $42b481f9b4bef4fe$export$2e2bcd8739ae039 = $42b481f9b4bef4fe$var$arts;

});


parcelRegister("gGP7V", function(module, exports) {

$parcel$export(module.exports, "render", () => $c2683a5086413bb6$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
var $jfBPE = parcelRequire("jfBPE");
const $c2683a5086413bb6$var$_hoisted_1 = {
    class: "fanart"
};
const $c2683a5086413bb6$var$_hoisted_2 = {
    key: 0,
    class: "viewer"
};
function $c2683a5086413bb6$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ImageView = (0, $igcaK.resolveComponent)("ImageView");
    const _component_PageTitle = (0, $igcaK.resolveComponent)("PageTitle");
    const _component_ArtCard = (0, $igcaK.resolveComponent)("ArtCard");
    const _component_ArtList = (0, $igcaK.resolveComponent)("ArtList");
    const _component_Container = (0, $igcaK.resolveComponent)("Container");
    return (0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("section", $c2683a5086413bb6$var$_hoisted_1, [
        (0, $igcaK.createVNode)((0, $jfBPE.Transition), {
            name: "fade",
            mode: "out-in"
        }, {
            default: (0, $igcaK.withCtx)(()=>[
                    $data.view ? ((0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("div", $c2683a5086413bb6$var$_hoisted_2, [
                        (0, $igcaK.createVNode)(_component_ImageView, {
                            arts: $data.arts,
                            isView: $data.view,
                            img: $data.img,
                            onBoolUpdate: _cache[0] || (_cache[0] = ($event)=>$options.boolUpdate())
                        }, null, 8, [
                            "arts",
                            "isView",
                            "img"
                        ])
                    ])) : (0, $igcaK.createCommentVNode)("", true)
                ]),
            _: 1
        }),
        (0, $igcaK.createVNode)(_component_Container, null, {
            default: (0, $igcaK.withCtx)(()=>[
                    (0, $igcaK.createVNode)(_component_PageTitle, null, {
                        default: (0, $igcaK.withCtx)(()=>[
                                ..._cache[1] || (_cache[1] = [
                                    (0, $igcaK.createTextVNode)("Fan art", -1)
                                ])
                            ]),
                        sub: (0, $igcaK.withCtx)(()=>[
                                ..._cache[2] || (_cache[2] = [
                                    (0, $igcaK.createTextVNode)("\uD83D\uDDBC\uFE0F Curated Fan-made art from ", -1),
                                    (0, $igcaK.createElementVNode)("a", {
                                        href: "https://twitter.com/hashtag/PienEpelPaint",
                                        target: "_blank"
                                    }, "#PienEpelPaint", -1),
                                    (0, $igcaK.createTextVNode)(" hashtag on \uD83D\uDC26 Twitter", -1)
                                ])
                            ]),
                        _: 1
                    }),
                    (0, $igcaK.createVNode)(_component_ArtList, null, {
                        default: (0, $igcaK.withCtx)(()=>[
                                ((0, $igcaK.openBlock)(true), (0, $igcaK.createElementBlock)((0, $igcaK.Fragment), null, (0, $igcaK.renderList)($data.arts, (art)=>{
                                    return (0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("li", null, [
                                        (0, $igcaK.createVNode)(_component_ArtCard, {
                                            onClick: ($event)=>$options.toggle(art.img),
                                            img: art.img,
                                            artist: art.artist.username,
                                            artistUrl: art.artist.url
                                        }, null, 8, [
                                            "onClick",
                                            "img",
                                            "artist",
                                            "artistUrl"
                                        ])
                                    ]);
                                }), 256))
                            ]),
                        _: 1
                    })
                ]),
            _: 1
        })
    ]);
}

});

parcelRegister("brP4W", function(module, exports) {

$parcel$export(module.exports, "default", () => $8559d67881a21b0d$export$2e2bcd8739ae039);
let $8559d67881a21b0d$var$NOOP = ()=>{};
var $8559d67881a21b0d$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("2HYh5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9374e175e7d24e89$export$2e2bcd8739ae039);

var $iGa2N = parcelRequire("iGa2N");

var $jLLSu = parcelRequire("jLLSu");

var $d8Xgm = parcelRequire("d8Xgm");

var $h9bs7 = parcelRequire("h9bs7");

var $bbBXI = parcelRequire("bbBXI");
var $9374e175e7d24e89$export$2e2bcd8739ae039 = {
    name: 'About',
    components: {
        Container: $iGa2N.default,
        PageTitle: $jLLSu.default,
        Button: $d8Xgm.default
    },
    data () {
        return {
            expanded: false,
            data: $bbBXI.default,
            socials: $h9bs7.default
        };
    },
    methods: {
        expand () {
            this.expanded = !this.expanded;
        }
    }
};

});
parcelRegister("bbBXI", function(module, exports) {

$parcel$export(module.exports, "default", () => $51d5ef7a5ed77d57$export$2e2bcd8739ae039);
const $51d5ef7a5ed77d57$var$general = {
    name: {
        origin: 'Evelyn',
        alias: 'Epel'
    },
    debut: 'January 13, 2019',
    birthday: 'December 1',
    height: {
        origin: '160 cm',
        withAhoge: '165 cm'
    },
    weight: '52 kg',
    blood: 'B+',
    zodiac: 'Sagittarius',
    affilation: {
        current: 'Independent',
        formerly: 'Re:Memories'
    },
    languages: [
        'Indonesian',
        'English',
        'Little bit of Japanese'
    ]
};
var $51d5ef7a5ed77d57$export$2e2bcd8739ae039 = $51d5ef7a5ed77d57$var$general;

});


parcelRegister("8IHNL", function(module, exports) {

$parcel$export(module.exports, "render", () => $659468e030439aea$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
var $oF3Y1 = parcelRequire("oF3Y1");

const $659468e030439aea$var$_hoisted_1 = {
    key: 0,
    class: "if-expanded"
};
const $659468e030439aea$var$_hoisted_2 = {
    id: "personal"
};
const $659468e030439aea$var$_hoisted_3 = {
    class: "content"
};
const $659468e030439aea$var$_hoisted_4 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_5 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_6 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_7 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_8 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_9 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_10 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_11 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_12 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_13 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_14 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_15 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_16 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_17 = {
    id: "socials"
};
const $659468e030439aea$var$_hoisted_18 = {
    class: "content"
};
const $659468e030439aea$var$_hoisted_19 = {
    class: "list"
};
const $659468e030439aea$var$_hoisted_20 = [
    "href"
];
const $659468e030439aea$var$_hoisted_21 = {
    key: 1,
    class: "expand-btn"
};
function $659468e030439aea$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PageTitle = (0, $igcaK.resolveComponent)("PageTitle");
    const _component_Button = (0, $igcaK.resolveComponent)("Button");
    const _component_Container = (0, $igcaK.resolveComponent)("Container");
    return (0, $igcaK.openBlock)(), (0, $igcaK.createBlock)(_component_Container, {
        class: "about-container"
    }, {
        default: (0, $igcaK.withCtx)(()=>[
                (0, $igcaK.createVNode)(_component_PageTitle, {
                    class: "about-title"
                }, {
                    default: (0, $igcaK.withCtx)(()=>[
                            ..._cache[0] || (_cache[0] = [
                                (0, $igcaK.createTextVNode)("About", -1)
                            ])
                        ]),
                    _: 1
                }),
                _cache[9] || (_cache[9] = (0, $igcaK.createElementVNode)("div", {
                    class: "model"
                }, [
                    (0, $igcaK.createElementVNode)("img", {
                        src: (0, {}),
                        alt: "Evelyn Model"
                    })
                ], -1)),
                _cache[10] || (_cache[10] = (0, $igcaK.createElementVNode)("div", {
                    class: "main-content"
                }, [
                    (0, $igcaK.createElementVNode)("div", {
                        id: "personality"
                    }, [
                        (0, $igcaK.createElementVNode)("h3", {
                            class: "subtitle"
                        }, "\uD83D\uDC99 Personality"),
                        (0, $igcaK.createElementVNode)("p", {
                            class: "content"
                        }, " Evelyn has a warm and friendly personality towards her viewers. She has a \"good girl\" persona. She's sweet, caring, full of affection, and tends to avoid sensitive issues, as well as strong or bad words and profanities. She is described as a humble, genuine and hardworking girl since she interacts with her viewers regularly by trying to reply to most all of their comments on her YouTube and social media every day. She is willing to help people and wants to grow together with her community. "),
                        (0, $igcaK.createElementVNode)("p", {
                            class: "content"
                        }, " Her channel's contents ranges from let's plays, song covers, ASMR, random talks and contents, story readings and problem consultations. Her contents were mostly VODs (Video On Demand) before she started following the live streaming trend in late August 2019. She currently focuses on live streams for nearly all of her contents. ")
                    ]),
                    (0, $igcaK.createElementVNode)("div", {
                        id: "appearance"
                    }, [
                        (0, $igcaK.createElementVNode)("h3", {
                            class: "subtitle mt"
                        }, "\uD83D\uDC85 Appearance"),
                        (0, $igcaK.createElementVNode)("p", {
                            class: "content"
                        }, " Evelyn's first appearance is a young woman with a relatively slim body, oval face, red eyes, and long sea blue hair with an ahoge. Her dominant color scheme is blue, pink and white. "),
                        (0, $igcaK.createElementVNode)("p", {
                            class: "content"
                        }, [
                            (0, $igcaK.createTextVNode)(" She got a new costume on her "),
                            (0, $igcaK.createElementVNode)("a", {
                                href: "https://youtu.be/sQk3WJPcheM"
                            }, "1st birthday"),
                            (0, $igcaK.createTextVNode)(". Her v2 outfit is a white and pink, sleeveless button-up dress resembling a maid outfit. Her hair is pink at the tips, and her ahoge is slightly shorter in length. ")
                        ]),
                        (0, $igcaK.createElementVNode)("p", {
                            class: "content"
                        }, [
                            (0, $igcaK.createTextVNode)(" She got another new costume at "),
                            (0, $igcaK.createElementVNode)("a", {
                                href: "https://youtu.be/8v0d54N4EW4&t=4075s"
                            }, "2021 valentine's day"),
                            (0, $igcaK.createTextVNode)(". This v3 outfit is more casual because it's supposed for dating (with you). She got several new expressions like sad, crying, angry, terrified, "),
                            (0, $igcaK.createElementVNode)("i", null, "gangimari"),
                            (0, $igcaK.createTextVNode)(", and yandere eyes. She also has a cat girl mode that makes her have nekomimi (cat ears) and a tail with ribbon. ")
                        ])
                    ])
                ], -1)),
                $data.expanded ? ((0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("div", $659468e030439aea$var$_hoisted_1, [
                    _cache[7] || (_cache[7] = (0, $igcaK.createElementVNode)("div", {
                        id: "history"
                    }, [
                        (0, $igcaK.createElementVNode)("h3", {
                            class: "subtitle mt"
                        }, "\uD83D\uDCDC History"),
                        (0, $igcaK.createElementVNode)("h4", {
                            class: "sub mt"
                        }, "Background"),
                        (0, $igcaK.createElementVNode)("p", {
                            class: "content"
                        }, " On 20 September 2021, she and fellow VTubers in her team (Lily Ifeta, Chloe Pawapua and Reynard Blanc) announced that their management team would become an independent agency named Re:Memories. "),
                        (0, $igcaK.createElementVNode)("h3", {
                            class: "sub mt"
                        }, "2022"),
                        (0, $igcaK.createElementVNode)("p", {
                            class: "content"
                        }, " On 30 April, Re:memories's Twitter announced that Evelyn would be separating from Re:memories agency and becoming an independent VTuber on the same day. Before that, she also held a stream to announce it. ")
                    ], -1)),
                    (0, $igcaK.createElementVNode)("div", $659468e030439aea$var$_hoisted_2, [
                        _cache[3] || (_cache[3] = (0, $igcaK.createElementVNode)("h3", {
                            class: "subtitle mt"
                        }, "\uD83D\uDC64 Personal details", -1)),
                        (0, $igcaK.createElementVNode)("ul", $659468e030439aea$var$_hoisted_3, [
                            (0, $igcaK.createElementVNode)("li", $659468e030439aea$var$_hoisted_4, [
                                (0, $igcaK.createTextVNode)(" Name: " + (0, $oF3Y1.toDisplayString)($data.data.name.origin) + " ", 1),
                                (0, $igcaK.createElementVNode)("ul", null, [
                                    (0, $igcaK.createElementVNode)("li", $659468e030439aea$var$_hoisted_5, "Alias: " + (0, $oF3Y1.toDisplayString)($data.data.name.alias), 1)
                                ])
                            ]),
                            (0, $igcaK.createElementVNode)("li", $659468e030439aea$var$_hoisted_6, "Debut date: " + (0, $oF3Y1.toDisplayString)($data.data.debut), 1),
                            (0, $igcaK.createElementVNode)("li", $659468e030439aea$var$_hoisted_7, "Birthday: " + (0, $oF3Y1.toDisplayString)($data.data.birthday), 1),
                            (0, $igcaK.createElementVNode)("li", $659468e030439aea$var$_hoisted_8, "Height: " + (0, $oF3Y1.toDisplayString)($data.data.height.origin) + " (" + (0, $oF3Y1.toDisplayString)($data.data.height.withAhoge) + " with ahoge)", 1),
                            (0, $igcaK.createElementVNode)("li", $659468e030439aea$var$_hoisted_9, "Weight: " + (0, $oF3Y1.toDisplayString)($data.data.weight), 1),
                            (0, $igcaK.createElementVNode)("li", $659468e030439aea$var$_hoisted_10, "Blood type: " + (0, $oF3Y1.toDisplayString)($data.data.blood), 1),
                            (0, $igcaK.createElementVNode)("li", $659468e030439aea$var$_hoisted_11, "Zodiac: " + (0, $oF3Y1.toDisplayString)($data.data.zodiac), 1),
                            (0, $igcaK.createElementVNode)("li", $659468e030439aea$var$_hoisted_12, [
                                _cache[1] || (_cache[1] = (0, $igcaK.createTextVNode)(" Affilation ", -1)),
                                (0, $igcaK.createElementVNode)("ul", null, [
                                    (0, $igcaK.createElementVNode)("li", $659468e030439aea$var$_hoisted_13, (0, $oF3Y1.toDisplayString)($data.data.affilation.current), 1),
                                    (0, $igcaK.createElementVNode)("li", $659468e030439aea$var$_hoisted_14, (0, $oF3Y1.toDisplayString)($data.data.affilation.formerly) + " (formerly)", 1)
                                ])
                            ]),
                            (0, $igcaK.createElementVNode)("li", $659468e030439aea$var$_hoisted_15, [
                                _cache[2] || (_cache[2] = (0, $igcaK.createTextVNode)(" Languages ", -1)),
                                (0, $igcaK.createElementVNode)("ul", null, [
                                    ((0, $igcaK.openBlock)(true), (0, $igcaK.createElementBlock)((0, $igcaK.Fragment), null, (0, $igcaK.renderList)($data.data.languages, (lang)=>{
                                        return (0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("li", $659468e030439aea$var$_hoisted_16, (0, $oF3Y1.toDisplayString)(lang), 1);
                                    }), 256))
                                ])
                            ])
                        ])
                    ]),
                    (0, $igcaK.createElementVNode)("div", $659468e030439aea$var$_hoisted_17, [
                        _cache[4] || (_cache[4] = (0, $igcaK.createElementVNode)("h3", {
                            class: "subtitle mt"
                        }, "#\uFE0F\u20E3 Socials", -1)),
                        _cache[5] || (_cache[5] = (0, $igcaK.createElementVNode)("p", {
                            class: "content"
                        }, "Evelyn is discoverable at social media. Make sure to follow her social accounts!", -1)),
                        (0, $igcaK.createElementVNode)("ul", $659468e030439aea$var$_hoisted_18, [
                            ((0, $igcaK.openBlock)(true), (0, $igcaK.createElementBlock)((0, $igcaK.Fragment), null, (0, $igcaK.renderList)($data.socials, (social)=>{
                                return (0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("li", $659468e030439aea$var$_hoisted_19, [
                                    (0, $igcaK.createTextVNode)((0, $oF3Y1.toDisplayString)(social.name) + ": ", 1),
                                    (0, $igcaK.createElementVNode)("a", {
                                        href: social.url,
                                        target: "_blank"
                                    }, "@" + (0, $oF3Y1.toDisplayString)(social.username), 9, $659468e030439aea$var$_hoisted_20)
                                ]);
                            }), 256))
                        ])
                    ]),
                    (0, $igcaK.createVNode)(_component_Button, {
                        onClick: $options.expand
                    }, {
                        default: (0, $igcaK.withCtx)(()=>[
                                ..._cache[6] || (_cache[6] = [
                                    (0, $igcaK.createTextVNode)("See less information \uD83D\uDC46", -1)
                                ])
                            ]),
                        _: 1
                    }, 8, [
                        "onClick"
                    ])
                ])) : ((0, $igcaK.openBlock)(), (0, $igcaK.createElementBlock)("div", $659468e030439aea$var$_hoisted_21, [
                    (0, $igcaK.createVNode)(_component_Button, {
                        onClick: $options.expand
                    }, {
                        default: (0, $igcaK.withCtx)(()=>[
                                ..._cache[8] || (_cache[8] = [
                                    (0, $igcaK.createTextVNode)("Expand more information \uD83D\uDC47", -1)
                                ])
                            ]),
                        _: 1
                    }, 8, [
                        "onClick"
                    ])
                ]))
            ]),
        _: 1
    });
}

});

parcelRegister("k8ast", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea7caacfd891c4b8$export$2e2bcd8739ae039);
let $ea7caacfd891c4b8$var$NOOP = ()=>{};
var $ea7caacfd891c4b8$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("a5F10", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1a23af2fe307fb1f$export$2e2bcd8739ae039);

var $iGa2N = parcelRequire("iGa2N");
var $1a23af2fe307fb1f$export$2e2bcd8739ae039 = {
    name: 'NotFound',
    components: {
        Container: $iGa2N.default
    }
};

});

parcelRegister("at2xZ", function(module, exports) {

$parcel$export(module.exports, "render", () => $79ee96a4927946f8$export$b3890eb0ae9dca99);
parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
const $79ee96a4927946f8$var$_hoisted_1 = {
    class: "error"
};
function $79ee96a4927946f8$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $igcaK.resolveComponent)("router-link");
    const _component_Container = (0, $igcaK.resolveComponent)("Container");
    return (0, $igcaK.openBlock)(), (0, $igcaK.createBlock)(_component_Container, null, {
        default: (0, $igcaK.withCtx)(()=>[
                (0, $igcaK.createElementVNode)("section", $79ee96a4927946f8$var$_hoisted_1, [
                    _cache[5] || (_cache[5] = (0, $igcaK.createElementVNode)("h1", null, ":(", -1)),
                    _cache[6] || (_cache[6] = (0, $igcaK.createElementVNode)("h2", null, "404 Error - Oops!", -1)),
                    (0, $igcaK.createElementVNode)("p", null, [
                        _cache[1] || (_cache[1] = (0, $igcaK.createTextVNode)(" Sadly, Epel can't find your request on this web page. Please check back the URL \uD83D\uDE0A. ", -1)),
                        _cache[2] || (_cache[2] = (0, $igcaK.createElementVNode)("br", null, null, -1)),
                        _cache[3] || (_cache[3] = (0, $igcaK.createTextVNode)(" Or maybe you want back to ", -1)),
                        (0, $igcaK.createVNode)(_component_router_link, {
                            to: {
                                name: 'Home'
                            }
                        }, {
                            default: (0, $igcaK.withCtx)(()=>[
                                    ..._cache[0] || (_cache[0] = [
                                        (0, $igcaK.createTextVNode)("Home page", -1)
                                    ])
                                ]),
                            _: 1
                        }),
                        _cache[4] || (_cache[4] = (0, $igcaK.createTextVNode)("? Let me take you there~ ", -1))
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("iFUMc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d98818f02d83cf91$export$2e2bcd8739ae039);
let $d98818f02d83cf91$var$NOOP = ()=>{};
var $d98818f02d83cf91$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire("4GnCG");
var $jfBPE = parcelRequire("jfBPE");
// @ts-nocheck


let $ae3de8900c09c2f9$var$script;




let $ae3de8900c09c2f9$var$initialize = ()=>{
    $ae3de8900c09c2f9$var$script = (parcelRequire("boZNq"));
    if ($ae3de8900c09c2f9$var$script.__esModule) $ae3de8900c09c2f9$var$script = $ae3de8900c09c2f9$var$script.default;
    $ae3de8900c09c2f9$var$script.render = (parcelRequire("3NNX1")).render;
    $ae3de8900c09c2f9$var$script.__cssModules = {};
    (parcelRequire("1rrBo")).default($ae3de8900c09c2f9$var$script);
    $ae3de8900c09c2f9$var$script.__scopeId = 'data-v-3170b6';
    $ae3de8900c09c2f9$var$script.__file = "App.vue";
};
$ae3de8900c09c2f9$var$initialize();
var $ae3de8900c09c2f9$export$2e2bcd8739ae039 = $ae3de8900c09c2f9$var$script;


/*!
 * vue-router v4.6.4
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */ /*!
 * vue-router v4.6.4
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */ parcelRequire("4GnCG");
var $igcaK = parcelRequire("igcaK");
var $mHgsT = parcelRequire("mHgsT");
function $a64da22f94f2a1a2$export$5a2d366b2d9f38f6() {
    return $a64da22f94f2a1a2$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $a64da22f94f2a1a2$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== 'undefined' && typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : {};
}
const $a64da22f94f2a1a2$export$bc32a04c49ed7464 = typeof Proxy === 'function';


const $44596e28c79d61f0$export$b1499c3bd2a3f4df = 'devtools-plugin:setup';
const $44596e28c79d61f0$export$a0897f44accbe922 = 'plugin:settings:set';



let $fbd65e87907bd23e$var$supported;
let $fbd65e87907bd23e$var$perf;
function $fbd65e87907bd23e$export$70d26280bc1ca547() {
    var _a;
    if ($fbd65e87907bd23e$var$supported !== undefined) return $fbd65e87907bd23e$var$supported;
    if (typeof window !== 'undefined' && window.performance) {
        $fbd65e87907bd23e$var$supported = true;
        $fbd65e87907bd23e$var$perf = window.performance;
    } else if (typeof globalThis !== 'undefined' && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $fbd65e87907bd23e$var$supported = true;
        $fbd65e87907bd23e$var$perf = globalThis.perf_hooks.performance;
    } else $fbd65e87907bd23e$var$supported = false;
    return $fbd65e87907bd23e$var$supported;
}
function $fbd65e87907bd23e$export$461939dd4422153() {
    return $fbd65e87907bd23e$export$70d26280bc1ca547() ? $fbd65e87907bd23e$var$perf.now() : Date.now();
}


class $ea36bf607cf38936$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $fbd65e87907bd23e$export$461939dd4422153)();
            }
        };
        if (hook) hook.on((0, $44596e28c79d61f0$export$a0897f44accbe922), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === 'on') return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}





function $54c6cb99091f414d$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $a64da22f94f2a1a2$export$c22522a4dfa48e9c)();
    const hook = (0, $a64da22f94f2a1a2$export$5a2d366b2d9f38f6)();
    const enableProxy = (0, $a64da22f94f2a1a2$export$bc32a04c49ed7464) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $44596e28c79d61f0$export$b1499c3bd2a3f4df), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $ea36bf607cf38936$export$5728f3776e9b2ac1)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}


//#region src/utils/env.ts
const $d713ccdd7edb23e5$export$3d8c2f653ac9d0b9 = typeof document !== "undefined";
//#endregion
//#region src/utils/index.ts
/**
* Identity function that returns the value as is.
*
* @param v - the value to return
*
* @internal
*/ const $d713ccdd7edb23e5$export$8743009a87fcb00f = (v)=>v;
/**
* Allows differentiating lazy components from functional components and vue-class-component
* @internal
*
* @param component
*/ function $d713ccdd7edb23e5$var$isRouteComponent(component) {
    return typeof component === "object" || "displayName" in component || "props" in component || "__vccOpts" in component;
}
function $d713ccdd7edb23e5$var$isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === "Module" || obj.default && $d713ccdd7edb23e5$var$isRouteComponent(obj.default);
}
const $d713ccdd7edb23e5$export$b4171a6734a65d42 = Object.assign;
function $d713ccdd7edb23e5$export$9e5f44173e64f162(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $d713ccdd7edb23e5$export$78acf4525d8a74c4(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $d713ccdd7edb23e5$export$3722cfe417b6ed86 = ()=>{};
/**
* Typesafe alternative to Array.isArray
* https://github.com/microsoft/TypeScript/pull/48228
*
* @internal
*/ const $d713ccdd7edb23e5$export$78acf4525d8a74c4 = Array.isArray;
function $d713ccdd7edb23e5$export$dc98b0b04f4c7758(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
//#endregion
//#region src/warning.ts
function $d713ccdd7edb23e5$export$3466f893ebf79586(msg) {
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        "[Vue Router warn]: " + msg
    ].concat(args));
}
//#endregion
//#region src/encoding.ts
/**
* Encoding Rules (␣ = Space)
* - Path: ␣ " < > # ? { }
* - Query: ␣ " < > # & =
* - Hash: ␣ " < > `
*
* On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
* defines some extra characters to be encoded. Most browsers do not encode them
* in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
* also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
* plus `-._~`. This extra safety should be applied to query by patching the
* string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
* should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
* into a `/` if directly typed in. The _backtick_ (`````) should also be
* encoded everywhere because some browsers like FF encode it when directly
* written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
*/ const $d713ccdd7edb23e5$var$HASH_RE = /#/g;
const $d713ccdd7edb23e5$var$AMPERSAND_RE = /&/g;
const $d713ccdd7edb23e5$var$SLASH_RE = /\//g;
const $d713ccdd7edb23e5$var$EQUAL_RE = /=/g;
const $d713ccdd7edb23e5$var$IM_RE = /\?/g;
const $d713ccdd7edb23e5$var$PLUS_RE = /\+/g;
/**
* NOTE: It's not clear to me if we should encode the + symbol in queries, it
* seems to be less flexible than not doing so and I can't find out the legacy
* systems requiring this for regular requests like text/html. In the standard,
* the encoding of the plus character is only mentioned for
* application/x-www-form-urlencoded
* (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
* leave the plus character as is in queries. To be more flexible, we allow the
* plus character on the query, but it can also be manually encoded by the user.
*
* Resources:
* - https://url.spec.whatwg.org/#urlencoded-parsing
* - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
*/ const $d713ccdd7edb23e5$var$ENC_BRACKET_OPEN_RE = /%5B/g;
const $d713ccdd7edb23e5$var$ENC_BRACKET_CLOSE_RE = /%5D/g;
const $d713ccdd7edb23e5$var$ENC_CARET_RE = /%5E/g;
const $d713ccdd7edb23e5$var$ENC_BACKTICK_RE = /%60/g;
const $d713ccdd7edb23e5$var$ENC_CURLY_OPEN_RE = /%7B/g;
const $d713ccdd7edb23e5$var$ENC_PIPE_RE = /%7C/g;
const $d713ccdd7edb23e5$var$ENC_CURLY_CLOSE_RE = /%7D/g;
const $d713ccdd7edb23e5$var$ENC_SPACE_RE = /%20/g;
/**
* Encode characters that need to be encoded on the path, search and hash
* sections of the URL.
*
* @internal
* @param text - string to encode
* @returns encoded string
*/ function $d713ccdd7edb23e5$var$commonEncode(text) {
    return text == null ? "" : encodeURI("" + text).replace($d713ccdd7edb23e5$var$ENC_PIPE_RE, "|").replace($d713ccdd7edb23e5$var$ENC_BRACKET_OPEN_RE, "[").replace($d713ccdd7edb23e5$var$ENC_BRACKET_CLOSE_RE, "]");
}
/**
* Encode characters that need to be encoded on the hash section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $d713ccdd7edb23e5$export$3a6d5c9ae78a2c08(text) {
    return $d713ccdd7edb23e5$var$commonEncode(text).replace($d713ccdd7edb23e5$var$ENC_CURLY_OPEN_RE, "{").replace($d713ccdd7edb23e5$var$ENC_CURLY_CLOSE_RE, "}").replace($d713ccdd7edb23e5$var$ENC_CARET_RE, "^");
}
/**
* Encode characters that need to be encoded query values on the query
* section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $d713ccdd7edb23e5$var$encodeQueryValue(text) {
    return $d713ccdd7edb23e5$var$commonEncode(text).replace($d713ccdd7edb23e5$var$PLUS_RE, "%2B").replace($d713ccdd7edb23e5$var$ENC_SPACE_RE, "+").replace($d713ccdd7edb23e5$var$HASH_RE, "%23").replace($d713ccdd7edb23e5$var$AMPERSAND_RE, "%26").replace($d713ccdd7edb23e5$var$ENC_BACKTICK_RE, "`").replace($d713ccdd7edb23e5$var$ENC_CURLY_OPEN_RE, "{").replace($d713ccdd7edb23e5$var$ENC_CURLY_CLOSE_RE, "}").replace($d713ccdd7edb23e5$var$ENC_CARET_RE, "^");
}
/**
* Like `encodeQueryValue` but also encodes the `=` character.
*
* @param text - string to encode
*/ function $d713ccdd7edb23e5$var$encodeQueryKey(text) {
    return $d713ccdd7edb23e5$var$encodeQueryValue(text).replace($d713ccdd7edb23e5$var$EQUAL_RE, "%3D");
}
/**
* Encode characters that need to be encoded on the path section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $d713ccdd7edb23e5$export$2329c99376c9d0a4(text) {
    return $d713ccdd7edb23e5$var$commonEncode(text).replace($d713ccdd7edb23e5$var$HASH_RE, "%23").replace($d713ccdd7edb23e5$var$IM_RE, "%3F");
}
/**
* Encode characters that need to be encoded on the path section of the URL as a
* param. This function encodes everything {@link encodePath} does plus the
* slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
* string instead.
*
* @param text - string to encode
* @returns encoded string
*/ function $d713ccdd7edb23e5$export$71cec2538cb2c617(text) {
    return $d713ccdd7edb23e5$export$2329c99376c9d0a4(text).replace($d713ccdd7edb23e5$var$SLASH_RE, "%2F");
}
function $d713ccdd7edb23e5$export$7f8ddf7c7c20b3cd(text) {
    if (text == null) return null;
    try {
        return decodeURIComponent("" + text);
    } catch (err) {}
    return "" + text;
}
//#endregion
//#region src/location.ts
const $d713ccdd7edb23e5$var$TRAILING_SLASH_RE = /\/$/;
const $d713ccdd7edb23e5$var$removeTrailingSlash = (path)=>path.replace($d713ccdd7edb23e5$var$TRAILING_SLASH_RE, "");
/**
* Transforms a URI into a normalized history location
*
* @param parseQuery
* @param location - URI to normalize
* @param currentLocation - current absolute location. Allows resolving relative
* paths. Must start with `/`. Defaults to `/`
* @returns a normalized history location
*/ function $d713ccdd7edb23e5$export$db202ddc8be9136(parseQuery$1, location, currentLocation = "/") {
    let path, query = {}, searchString = "", hash = "";
    const hashPos = location.indexOf("#");
    let searchPos = location.indexOf("?");
    searchPos = hashPos >= 0 && searchPos > hashPos ? -1 : searchPos;
    if (searchPos >= 0) {
        path = location.slice(0, searchPos);
        searchString = location.slice(searchPos, hashPos > 0 ? hashPos : location.length);
        query = parseQuery$1(searchString.slice(1));
    }
    if (hashPos >= 0) {
        path = path || location.slice(0, hashPos);
        hash = location.slice(hashPos, location.length);
    }
    path = $d713ccdd7edb23e5$export$df995fae86a55f06(path != null ? path : location, currentLocation);
    return {
        fullPath: path + searchString + hash,
        path: path,
        query: query,
        hash: $d713ccdd7edb23e5$export$7f8ddf7c7c20b3cd(hash)
    };
}
function $d713ccdd7edb23e5$export$a07804094c3ecf2d(stringifyQuery$1, path, query, hash = "") {
    const searchText = stringifyQuery$1(query);
    return path + (searchText && "?") + searchText + $d713ccdd7edb23e5$export$3a6d5c9ae78a2c08(hash);
}
/**
* Stringifies a URL object
*
* @param stringifyQuery
* @param location
*/ function $d713ccdd7edb23e5$export$ef35774e6d314e91(stringifyQuery$1, location) {
    const query = location.query ? stringifyQuery$1(location.query) : "";
    return location.path + (query && "?") + query + (location.hash || "");
}
/**
* Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
*
* @param pathname - location.pathname
* @param base - base to strip off
*/ function $d713ccdd7edb23e5$export$e7c866399fa523f5(pathname, base) {
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || "/";
}
/**
* Checks if two RouteLocation are equal. This means that both locations are
* pointing towards the same {@link RouteRecord} and that all `params`, `query`
* parameters and `hash` are the same
*
* @param stringifyQuery - A function that takes a query object of type LocationQueryRaw and returns a string representation of it.
* @param a - first {@link RouteLocation}
* @param b - second {@link RouteLocation}
*/ function $d713ccdd7edb23e5$export$d66501df72047452(stringifyQuery$1, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $d713ccdd7edb23e5$export$61196ced6d74a310(a.matched[aLastIndex], b.matched[bLastIndex]) && $d713ccdd7edb23e5$export$9bb611d729802a56(a.params, b.params) && stringifyQuery$1(a.query) === stringifyQuery$1(b.query) && a.hash === b.hash;
}
/**
* Check if two `RouteRecords` are equal. Takes into account aliases: they are
* considered equal to the `RouteRecord` they are aliasing.
*
* @param a - first {@link RouteRecord}
* @param b - second {@link RouteRecord}
*/ function $d713ccdd7edb23e5$export$61196ced6d74a310(a, b) {
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $d713ccdd7edb23e5$export$9bb611d729802a56(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(var key in a)if (!$d713ccdd7edb23e5$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    return true;
}
function $d713ccdd7edb23e5$var$isSameRouteLocationParamsValue(a, b) {
    return $d713ccdd7edb23e5$export$78acf4525d8a74c4(a) ? $d713ccdd7edb23e5$var$isEquivalentArray(a, b) : $d713ccdd7edb23e5$export$78acf4525d8a74c4(b) ? $d713ccdd7edb23e5$var$isEquivalentArray(b, a) : a?.valueOf() === b?.valueOf();
}
/**
* Check if two arrays are the same or if an array with one single entry is the
* same as another primitive value. Used to check query and parameters
*
* @param a - array of values
* @param b - array of values or a single value
*/ function $d713ccdd7edb23e5$var$isEquivalentArray(a, b) {
    return $d713ccdd7edb23e5$export$78acf4525d8a74c4(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
* Resolves a relative path that starts with `.`.
*
* @param to - path location we are resolving
* @param from - currentLocation.path, should start with `/`
*/ function $d713ccdd7edb23e5$export$df995fae86a55f06(to, from) {
    if (to.startsWith("/")) return to;
    if (!to) return from;
    const fromSegments = from.split("/");
    const toSegments = to.split("/");
    const lastToSegment = toSegments[toSegments.length - 1];
    if (lastToSegment === ".." || lastToSegment === ".") toSegments.push("");
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        if (segment === ".") continue;
        if (segment === "..") {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join("/") + "/" + toSegments.slice(toPosition).join("/");
}
/**
* Initial route location where the router is. Can be used in navigation guards
* to differentiate the initial navigation.
*
* @example
* ```js
* import { START_LOCATION } from 'vue-router'
*
* router.beforeEach((to, from) => {
*   if (from === START_LOCATION) {
*     // initial navigation
*   }
* })
* ```
*/ const $d713ccdd7edb23e5$export$56c0d5a1e737357d = {
    path: "/",
    name: void 0,
    params: {},
    query: {},
    hash: "",
    fullPath: "/",
    matched: [],
    meta: {},
    redirectedFrom: void 0
};
//#endregion
//#region src/history/common.ts
let $d713ccdd7edb23e5$export$342063e11d6c3cad = /* @__PURE__ */ function(NavigationType$1) {
    NavigationType$1["pop"] = "pop";
    NavigationType$1["push"] = "push";
    return NavigationType$1;
}({});
let $d713ccdd7edb23e5$export$c4ce752e73470fba = /* @__PURE__ */ function(NavigationDirection$1) {
    NavigationDirection$1["back"] = "back";
    NavigationDirection$1["forward"] = "forward";
    NavigationDirection$1["unknown"] = "";
    return NavigationDirection$1;
}({});
/**
* Starting location for Histories
*/ const $d713ccdd7edb23e5$export$ebd11618f299a286 = "";
/**
* Normalizes a base by removing any trailing slash and reading the base tag if
* present.
*
* @param base - base to normalize
*/ function $d713ccdd7edb23e5$export$3a1a48c8f6ef640e(base) {
    if (!base) {
        if ($d713ccdd7edb23e5$export$3d8c2f653ac9d0b9) {
            const baseEl = document.querySelector("base");
            base = baseEl && baseEl.getAttribute("href") || "/";
            base = base.replace(/^\w+:\/\/[^\/]+/, "");
        } else base = "/";
    }
    if (base[0] !== "/" && base[0] !== "#") base = "/" + base;
    return $d713ccdd7edb23e5$var$removeTrailingSlash(base);
}
const $d713ccdd7edb23e5$var$BEFORE_HASH_RE = /^[^#]+#/;
function $d713ccdd7edb23e5$export$35e795649ee09318(base, location) {
    return base.replace($d713ccdd7edb23e5$var$BEFORE_HASH_RE, "#") + location;
}
//#endregion
//#region src/scrollBehavior.ts
function $d713ccdd7edb23e5$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $d713ccdd7edb23e5$export$e7094788287c5e9b = ()=>({
        left: window.scrollX,
        top: window.scrollY
    });
function $d713ccdd7edb23e5$export$96f57966bedc81b4(position) {
    let scrollToOptions;
    if ("el" in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === "string" && positionEl.startsWith("#");
        var err;
        const el = typeof positionEl === "string" ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $d713ccdd7edb23e5$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ("scrollBehavior" in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.scrollX, scrollToOptions.top != null ? scrollToOptions.top : window.scrollY);
}
function $d713ccdd7edb23e5$export$971d5caa766a69d7(path, delta) {
    return (history.state ? history.state.position - delta : -1) + path;
}
const $d713ccdd7edb23e5$var$scrollPositions = /* @__PURE__ */ new Map();
function $d713ccdd7edb23e5$export$a9c23c6ac3fc3eca(key, scrollPosition) {
    $d713ccdd7edb23e5$var$scrollPositions.set(key, scrollPosition);
}
function $d713ccdd7edb23e5$export$efccba1c4a2ef57b(key) {
    const scroll = $d713ccdd7edb23e5$var$scrollPositions.get(key);
    $d713ccdd7edb23e5$var$scrollPositions.delete(key);
    return scroll;
}
/**
* ScrollBehavior instance used by the router to compute and restore the scroll
* position when navigating.
*/ //#endregion
//#region src/types/typeGuards.ts
function $d713ccdd7edb23e5$export$d141bba7fdc215a3(route) {
    return typeof route === "string" || route && typeof route === "object";
}
function $d713ccdd7edb23e5$export$25ce5a424b770e84(name) {
    return typeof name === "string" || typeof name === "symbol";
}
//#endregion
//#region src/errors.ts
/**
* Flags so we can combine them when checking for multiple errors. This is the internal version of
* {@link NavigationFailureType}.
*
* @internal
*/ let $d713ccdd7edb23e5$export$71511d61b312f219 = /* @__PURE__ */ function(ErrorTypes$1) {
    ErrorTypes$1[ErrorTypes$1["MATCHER_NOT_FOUND"] = 1] = "MATCHER_NOT_FOUND";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_GUARD_REDIRECT"] = 2] = "NAVIGATION_GUARD_REDIRECT";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_ABORTED"] = 4] = "NAVIGATION_ABORTED";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_CANCELLED"] = 8] = "NAVIGATION_CANCELLED";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_DUPLICATED"] = 16] = "NAVIGATION_DUPLICATED";
    return ErrorTypes$1;
}({});
const $d713ccdd7edb23e5$var$NavigationFailureSymbol = Symbol("");
/**
* Enumeration with all possible types for navigation failures. Can be passed to
* {@link isNavigationFailure} to check for specific failures.
*/ let $d713ccdd7edb23e5$export$90a7f3efeed30595 = /* @__PURE__ */ function(NavigationFailureType$1) {
    /**
	* An aborted navigation is a navigation that failed because a navigation
	* guard returned `false` or called `next(false)`
	*/ NavigationFailureType$1[NavigationFailureType$1["aborted"] = 4] = "aborted";
    /**
	* A cancelled navigation is a navigation that failed because a more recent
	* navigation finished started (not necessarily finished).
	*/ NavigationFailureType$1[NavigationFailureType$1["cancelled"] = 8] = "cancelled";
    /**
	* A duplicated navigation is a navigation that failed because it was
	* initiated while already being at the exact same location.
	*/ NavigationFailureType$1[NavigationFailureType$1["duplicated"] = 16] = "duplicated";
    return NavigationFailureType$1;
}({});
const $d713ccdd7edb23e5$var$ErrorTypeMessages = {
    [$d713ccdd7edb23e5$export$71511d61b312f219.MATCHER_NOT_FOUND] ({ location: location, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location)}${currentLocation ? "\nwhile being at\n" + JSON.stringify(currentLocation) : ""}`;
    },
    [$d713ccdd7edb23e5$export$71511d61b312f219.NAVIGATION_GUARD_REDIRECT] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$d713ccdd7edb23e5$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [$d713ccdd7edb23e5$export$71511d61b312f219.NAVIGATION_ABORTED] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [$d713ccdd7edb23e5$export$71511d61b312f219.NAVIGATION_CANCELLED] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [$d713ccdd7edb23e5$export$71511d61b312f219.NAVIGATION_DUPLICATED] ({ from: from, to: to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
/**
* Creates a typed NavigationFailure object.
* @internal
* @param type - NavigationFailureType
* @param params - { from, to }
*/ function $d713ccdd7edb23e5$export$4a5767248b18ef41(type, params) {
    return $d713ccdd7edb23e5$export$b4171a6734a65d42(/* @__PURE__ */ new Error(), {
        type: type,
        [$d713ccdd7edb23e5$var$NavigationFailureSymbol]: true
    }, params);
}
function $d713ccdd7edb23e5$export$8b22cf2602fb60ce(error, type) {
    return error instanceof Error && $d713ccdd7edb23e5$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $d713ccdd7edb23e5$var$propertiesToLog = [
    "params",
    "query",
    "hash"
];
function $d713ccdd7edb23e5$var$stringifyRoute(to) {
    if (typeof to === "string") return to;
    if (to.path != null) return to.path;
    const location = {};
    for (const key of $d713ccdd7edb23e5$var$propertiesToLog)if (key in to) location[key] = to[key];
    return JSON.stringify(location, null, 2);
}
//#endregion
//#region src/query.ts
/**
* Transforms a queryString into a {@link LocationQuery} object. Accept both, a
* version with the leading `?` and without Should work as URLSearchParams

* @internal
*
* @param search - search string to parse
* @returns a query object
*/ function $d713ccdd7edb23e5$export$dda1d9f60106f0e9(search) {
    const query = {};
    if (search === "" || search === "?") return query;
    const searchParams = (search[0] === "?" ? search.slice(1) : search).split("&");
    for(let i = 0; i < searchParams.length; ++i){
        const searchParam = searchParams[i].replace($d713ccdd7edb23e5$var$PLUS_RE, " ");
        const eqPos = searchParam.indexOf("=");
        const key = $d713ccdd7edb23e5$export$7f8ddf7c7c20b3cd(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $d713ccdd7edb23e5$export$7f8ddf7c7c20b3cd(searchParam.slice(eqPos + 1));
        if (key in query) {
            let currentValue = query[key];
            if (!$d713ccdd7edb23e5$export$78acf4525d8a74c4(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
* Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
* doesn't prepend a `?`
*
* @internal
*
* @param query - query object to stringify
* @returns string version of the query without the leading `?`
*/ function $d713ccdd7edb23e5$export$39b482c5e57630a8(query) {
    let search = "";
    for(let key in query){
        const value = query[key];
        key = $d713ccdd7edb23e5$var$encodeQueryKey(key);
        if (value == null) {
            if (value !== void 0) search += (search.length ? "&" : "") + key;
            continue;
        }
        ($d713ccdd7edb23e5$export$78acf4525d8a74c4(value) ? value.map((v)=>v && $d713ccdd7edb23e5$var$encodeQueryValue(v)) : [
            value && $d713ccdd7edb23e5$var$encodeQueryValue(value)
        ]).forEach((value$1)=>{
            if (value$1 !== void 0) {
                search += (search.length ? "&" : "") + key;
                if (value$1 != null) search += "=" + value$1;
            }
        });
    }
    return search;
}
/**
* Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
* numbers into strings, removing keys with an undefined value and replacing
* undefined with null in arrays
*
* @param query - query object to normalize
* @returns a normalized query object
*/ function $d713ccdd7edb23e5$export$953cecd6e717a553(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== void 0) normalizedQuery[key] = $d713ccdd7edb23e5$export$78acf4525d8a74c4(value) ? value.map((v)=>v == null ? null : "" + v) : value == null ? value : "" + value;
    }
    return normalizedQuery;
}
//#endregion
//#region src/injectionSymbols.ts
/**
* RouteRecord being rendered by the closest ancestor Router View. Used for
* `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
* Location Matched
*
* @internal
*/ const $d713ccdd7edb23e5$export$882b5998b3b9117c = Symbol("");
/**
* Allows overriding the router view depth to control which component in
* `matched` is rendered. rvd stands for Router View Depth
*
* @internal
*/ const $d713ccdd7edb23e5$export$ffb5f4729a158638 = Symbol("");
/**
* Allows overriding the router instance returned by `useRouter` in tests. r
* stands for router
*
* @internal
*/ const $d713ccdd7edb23e5$export$4368d992c4eafac0 = Symbol("");
/**
* Allows overriding the current route returned by `useRoute` in tests. rl
* stands for route location
*
* @internal
*/ const $d713ccdd7edb23e5$export$3b14a55fb2447963 = Symbol("");
/**
* Allows overriding the current route used by router-view. Internally this is
* used when the `route` prop is passed.
*
* @internal
*/ const $d713ccdd7edb23e5$export$2d1720544b23b823 = Symbol("");
//#endregion
//#region src/utils/callbacks.ts
/**
* Create a list of callbacks that can be reset. Used to create before and after navigation guards list
*/ function $d713ccdd7edb23e5$export$db3b6bfb95261072() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers.slice(),
        reset: reset
    };
}
//#endregion
//#region src/navigationGuards.ts
function $d713ccdd7edb23e5$var$registerGuard(record, name, guard) {
    const removeFromList = ()=>{
        record[name].delete(guard);
    };
    (0, $igcaK.onUnmounted)(removeFromList);
    (0, $igcaK.onDeactivated)(removeFromList);
    (0, $igcaK.onActivated)(()=>{
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
* Add a navigation guard that triggers whenever the component for the current
* location is about to be left. Similar to {@link beforeRouteLeave} but can be
* used in any component. The guard is removed when the component is unmounted.
*
* @param leaveGuard - {@link NavigationGuard}
*/ function $d713ccdd7edb23e5$export$ae1af26003f05816(leaveGuard) {
    const activeRecord = (0, $igcaK.inject)($d713ccdd7edb23e5$export$882b5998b3b9117c, {}).value;
    if (!activeRecord) return;
    $d713ccdd7edb23e5$var$registerGuard(activeRecord, "leaveGuards", leaveGuard);
}
/**
* Add a navigation guard that triggers whenever the current location is about
* to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
* component. The guard is removed when the component is unmounted.
*
* @param updateGuard - {@link NavigationGuard}
*/ function $d713ccdd7edb23e5$export$2408f22a0fab9ae5(updateGuard) {
    const activeRecord = (0, $igcaK.inject)($d713ccdd7edb23e5$export$882b5998b3b9117c, {}).value;
    if (!activeRecord) return;
    $d713ccdd7edb23e5$var$registerGuard(activeRecord, "updateGuards", updateGuard);
}
function $d713ccdd7edb23e5$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext = (fn)=>fn()) {
    const enterCallbackArray = record && (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject($d713ccdd7edb23e5$export$4a5767248b18ef41($d713ccdd7edb23e5$export$71511d61b312f219.NAVIGATION_ABORTED, {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($d713ccdd7edb23e5$export$d141bba7fdc215a3(valid)) reject($d713ccdd7edb23e5$export$4a5767248b18ef41($d713ccdd7edb23e5$export$71511d61b312f219.NAVIGATION_GUARD_REDIRECT, {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && record.enterCallbacks[name] === enterCallbackArray && typeof valid === "function") enterCallbackArray.push(valid);
                    resolve();
                }
            };
            const guardReturn = runWithContext(()=>guard.call(record && record.instances[name], to, from, next));
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch((err)=>reject(err));
        });
}
function $d713ccdd7edb23e5$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) $d713ccdd7edb23e5$export$3466f893ebf79586(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $d713ccdd7edb23e5$export$43caf9889c228507(matched, guardType, to, from, runWithContext = (fn)=>fn()) {
    const guards = [];
    for (const record of matched)for(const name in record.components){
        let rawComponent = record.components[name];
        if (guardType !== "beforeRouteEnter" && !record.instances[name]) continue;
        if ($d713ccdd7edb23e5$var$isRouteComponent(rawComponent)) {
            const guard = (rawComponent.__vccOpts || rawComponent)[guardType];
            guard && guards.push($d713ccdd7edb23e5$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext));
        } else {
            let componentPromise = rawComponent();
            guards.push(()=>componentPromise.then((resolved)=>{
                    if (!resolved) throw new Error(`Couldn't resolve component "${name}" at "${record.path}"`);
                    const resolvedComponent = $d713ccdd7edb23e5$var$isESModule(resolved) ? resolved.default : resolved;
                    record.mods[name] = resolved;
                    record.components[name] = resolvedComponent;
                    const guard = (resolvedComponent.__vccOpts || resolvedComponent)[guardType];
                    return guard && $d713ccdd7edb23e5$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext)();
                }));
        }
    }
    return guards;
}
/**
* Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
*
* @param route - resolved route to load
*/ function $d713ccdd7edb23e5$export$407448d2b89b1813(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(/* @__PURE__ */ new Error("Cannot load a route that redirects.")) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === "function" && !("displayName" in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(/* @__PURE__ */ new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = $d713ccdd7edb23e5$var$isESModule(resolved) ? resolved.default : resolved;
                record.mods[name] = resolved;
                record.components[name] = resolvedComponent;
            }));
            return promises;
        }, [])))).then(()=>route);
}
/**
* Split the leaving, updating, and entering records.
* @internal
*
* @param  to - Location we are navigating to
* @param from - Location we are navigating from
*/ function $d713ccdd7edb23e5$export$7ccc53e8f1e7dfc5(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$d713ccdd7edb23e5$export$61196ced6d74a310(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) {
            if (!from.matched.find((record)=>$d713ccdd7edb23e5$export$61196ced6d74a310(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
//#endregion
//#region src/devtools.ts
/**
* Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
*
* @param routeLocation - routeLocation to format
* @param tooltip - optional tooltip
* @returns a copy of the routeLocation
*/ function $d713ccdd7edb23e5$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = $d713ccdd7edb23e5$export$b4171a6734a65d42({}, routeLocation, {
        matched: routeLocation.matched.map((matched)=>$d713ccdd7edb23e5$var$omit(matched, [
                "instances",
                "children",
                "aliasOf"
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $d713ccdd7edb23e5$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
let $d713ccdd7edb23e5$var$routerId = 0;
function $d713ccdd7edb23e5$export$625550452a3fa3ec(app, router, matcher) {
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    const id = $d713ccdd7edb23e5$var$routerId++;
    (0, $54c6cb99091f414d$export$63b9a9bba9f20f3e)({
        id: "org.vuejs.router" + (id ? "." + id : ""),
        label: "Vue Router",
        packageName: "vue-router",
        homepage: "https://router.vuejs.org",
        logo: "https://router.vuejs.org/logo.png",
        componentStateTypes: [
            "Routing"
        ],
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") $d713ccdd7edb23e5$export$3466f893ebf79586("[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        api.on.inspectComponent((payload, ctx)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: "Routing",
                key: "$route",
                editable: false,
                value: $d713ccdd7edb23e5$var$formatRouteLocation(router.currentRoute.value, "Current Route")
            });
        });
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : "") + info.path,
                    textColor: 0,
                    tooltip: "This component is rendered by &lt;router-view&gt;",
                    backgroundColor: $d713ccdd7edb23e5$var$PINK_500
                });
            }
            if ($d713ccdd7edb23e5$export$78acf4525d8a74c4(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let label = devtoolsData.route.path;
                    let backgroundColor = $d713ccdd7edb23e5$var$ORANGE_400;
                    let tooltip = "";
                    let textColor = 0;
                    if (devtoolsData.error) {
                        label = devtoolsData.error;
                        backgroundColor = $d713ccdd7edb23e5$var$RED_100;
                        textColor = $d713ccdd7edb23e5$var$RED_700;
                    } else if (devtoolsData.isExactActive) {
                        backgroundColor = $d713ccdd7edb23e5$var$LIME_500;
                        tooltip = "This is exactly active";
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $d713ccdd7edb23e5$var$BLUE_600;
                        tooltip = "This link is active";
                    }
                    node.tags.push({
                        label: label,
                        textColor: textColor,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $mHgsT.watch)(router.currentRoute, ()=>{
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = "router:navigations:" + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? " " + id : ""} Navigations`,
            color: 4237508
        });
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "Error during Navigation",
                    subtitle: to.fullPath,
                    logType: "error",
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $d713ccdd7edb23e5$var$formatDisplay("beforeEach"),
                from: $d713ccdd7edb23e5$var$formatRouteLocation(from, "Current Location during this navigation"),
                to: $d713ccdd7edb23e5$var$formatRouteLocation(to, "Target location")
            };
            Object.defineProperty(to.meta, "__navigationId", {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: "Start of navigation",
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $d713ccdd7edb23e5$var$formatDisplay("afterEach")
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : "",
                        tooltip: "Navigation Failure",
                        value: failure
                    }
                };
                data.status = $d713ccdd7edb23e5$var$formatDisplay("\u274C");
            } else data.status = $d713ccdd7edb23e5$var$formatDisplay("\u2705");
            data.from = $d713ccdd7edb23e5$var$formatRouteLocation(from, "Current Location during this navigation");
            data.to = $d713ccdd7edb23e5$var$formatRouteLocation(to, "Target location");
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "End of navigation",
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? "warning" : "default",
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
		* Inspector of Existing routes
		*/ const routerInspectorId = "router-inspector:" + id;
        api.addInspector({
            id: routerInspectorId,
            label: "Routes" + (id ? " " + id : ""),
            icon: "book",
            treeFilterPlaceholder: "Search routes"
        });
        function refreshRoutesView() {
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            let routes = matcher.getRoutes().filter((route)=>!route.parent || !route.parent.record.components);
            routes.forEach($d713ccdd7edb23e5$var$resetMatchStateOnRouteRecord);
            if (payload.filter) routes = routes.filter((route)=>$d713ccdd7edb23e5$var$isRouteMatching(route, payload.filter.toLowerCase()));
            routes.forEach((route)=>$d713ccdd7edb23e5$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($d713ccdd7edb23e5$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
		* Display information about the currently selected route record
		*/ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const route = matcher.getRoutes().find((route$1)=>route$1.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $d713ccdd7edb23e5$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $d713ccdd7edb23e5$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? "*" : "?";
    else return key.repeatable ? "+" : "";
}
function $d713ccdd7edb23e5$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: "path",
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: "name",
        value: record.name
    });
    fields.push({
        editable: false,
        key: "regexp",
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: "keys",
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$d713ccdd7edb23e5$var$modifierForKey(key)}`).join(" "),
                tooltip: "Param keys",
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: "redirect",
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: "aliases",
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: "meta",
        value: route.record.meta
    });
    fields.push({
        key: "score",
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(", ")).join(" | "),
                tooltip: "Score used to sort routes",
                value: route.score
            }
        }
    });
    return fields;
}
/**
* Extracted from tailwind palette
*/ const $d713ccdd7edb23e5$var$PINK_500 = 15485081;
const $d713ccdd7edb23e5$var$BLUE_600 = 2450411;
const $d713ccdd7edb23e5$var$LIME_500 = 8702998;
const $d713ccdd7edb23e5$var$CYAN_400 = 2282478;
const $d713ccdd7edb23e5$var$ORANGE_400 = 16486972;
const $d713ccdd7edb23e5$var$DARK = 6710886;
const $d713ccdd7edb23e5$var$RED_100 = 16704226;
const $d713ccdd7edb23e5$var$RED_700 = 12131356;
function $d713ccdd7edb23e5$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $d713ccdd7edb23e5$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: "alias",
        textColor: 0,
        backgroundColor: $d713ccdd7edb23e5$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: "matches",
        textColor: 0,
        backgroundColor: $d713ccdd7edb23e5$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: "exact",
        textColor: 0,
        backgroundColor: $d713ccdd7edb23e5$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: "active",
        textColor: 0,
        backgroundColor: $d713ccdd7edb23e5$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === "string" ? `redirect: ${record.redirect}` : "redirects",
        textColor: 16777215,
        backgroundColor: $d713ccdd7edb23e5$var$DARK
    });
    let id = record.__vd_id;
    if (id == null) {
        id = String($d713ccdd7edb23e5$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($d713ccdd7edb23e5$var$formatRouteRecordForInspector)
    };
}
let $d713ccdd7edb23e5$var$routeRecordId = 0;
const $d713ccdd7edb23e5$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $d713ccdd7edb23e5$var$markRouteRecordActive(route, currentRoute) {
    const isExactActive = currentRoute.matched.length && $d713ccdd7edb23e5$export$61196ced6d74a310(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$d713ccdd7edb23e5$export$61196ced6d74a310(match, route.record));
    route.children.forEach((childRoute)=>$d713ccdd7edb23e5$var$markRouteRecordActive(childRoute, currentRoute));
}
function $d713ccdd7edb23e5$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($d713ccdd7edb23e5$var$resetMatchStateOnRouteRecord);
}
function $d713ccdd7edb23e5$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($d713ccdd7edb23e5$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    if (new RegExp(found[1].replace(/\$$/, ""), found[2]).test(filter)) {
        route.children.forEach((child)=>$d713ccdd7edb23e5$var$isRouteMatching(child, filter));
        if (route.record.path !== "/" || filter === "/") {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $d713ccdd7edb23e5$export$7f8ddf7c7c20b3cd(path);
    if (!filter.startsWith("/") && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$d713ccdd7edb23e5$var$isRouteMatching(child, filter));
}
function $d713ccdd7edb23e5$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) ret[key] = obj[key];
    return ret;
}


parcelRequire("4GnCG");
var $mHgsT = parcelRequire("mHgsT");
var $igcaK = parcelRequire("igcaK");
//#region src/history/html5.ts
let $0edbee8a5a0fee0a$var$createBaseLocation = ()=>location.protocol + "//" + location.host;
/**
* Creates a normalized history location from a window.location object
* @param base - The base path
* @param location - The window.location object
*/ function $0edbee8a5a0fee0a$var$createCurrentLocation(base, location$1) {
    const { pathname: pathname, search: search, hash: hash } = location$1;
    const hashPos = base.indexOf("#");
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        let pathFromHash = hash.slice(slicePos);
        if (pathFromHash[0] !== "/") pathFromHash = "/" + pathFromHash;
        return (0, $d713ccdd7edb23e5$export$e7c866399fa523f5)(pathFromHash, "");
    }
    return (0, $d713ccdd7edb23e5$export$e7c866399fa523f5)(pathname, base) + search + hash;
}
function $0edbee8a5a0fee0a$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    let pauseState = null;
    const popStateHandler = ({ state: state })=>{
        const to = $0edbee8a5a0fee0a$var$createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        listeners.forEach((listener)=>{
            listener(currentLocation.value, from, {
                delta: delta,
                type: (0, $d713ccdd7edb23e5$export$342063e11d6c3cad).pop,
                direction: delta ? delta > 0 ? (0, $d713ccdd7edb23e5$export$c4ce752e73470fba).forward : (0, $d713ccdd7edb23e5$export$c4ce752e73470fba).back : (0, $d713ccdd7edb23e5$export$c4ce752e73470fba).unknown
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        listeners.push(callback);
        const teardown = ()=>{
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        if (document.visibilityState === "hidden") {
            const { history: history$1 } = window;
            if (!history$1.state) return;
            history$1.replaceState((0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({}, history$1.state, {
                scroll: (0, $d713ccdd7edb23e5$export$e7094788287c5e9b)()
            }), "");
        }
    }
    function destroy() {
        for (const teardown of teardowns)teardown();
        teardowns = [];
        window.removeEventListener("popstate", popStateHandler);
        window.removeEventListener("pagehide", beforeUnloadListener);
        document.removeEventListener("visibilitychange", beforeUnloadListener);
    }
    window.addEventListener("popstate", popStateHandler);
    window.addEventListener("pagehide", beforeUnloadListener);
    document.addEventListener("visibilitychange", beforeUnloadListener);
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
* Creates a state object
*/ function $0edbee8a5a0fee0a$var$buildState(back, current, forward, replaced = false, computeScroll = false) {
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: computeScroll ? (0, $d713ccdd7edb23e5$export$e7094788287c5e9b)() : null
    };
}
function $0edbee8a5a0fee0a$var$useHistoryStateNavigation(base) {
    const { history: history$1, location: location$1 } = window;
    const currentLocation = {
        value: $0edbee8a5a0fee0a$var$createCurrentLocation(base, location$1)
    };
    const historyState = {
        value: history$1.state
    };
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        position: history$1.length - 1,
        replaced: true,
        scroll: null
    }, true);
    function changeLocation(to, state, replace$1) {
        /**
		* if a base tag is provided, and we are on a normal domain, we have to
		* respect the provided `base` attribute because pushState() will use it and
		* potentially erase anything before the `#` like at
		* https://github.com/vuejs/router/issues/685 where a base of
		* `/folder/#` but a base of `/` would erase the `/folder/` section. If
		* there is no host, the `<base>` tag makes no sense and if there isn't a
		* base tag we can just use everything after the `#`.
		*/ const hashIndex = base.indexOf("#");
        const url = hashIndex > -1 ? (location$1.host && document.querySelector("base") ? base : base.slice(hashIndex)) + to : $0edbee8a5a0fee0a$var$createBaseLocation() + base + to;
        try {
            history$1[replace$1 ? "replaceState" : "pushState"](state, "", url);
            historyState.value = state;
        } catch (err) {
            console.error(err);
            location$1[replace$1 ? "replace" : "assign"](url);
        }
    }
    function replace(to, data) {
        changeLocation(to, (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({}, history$1.state, $0edbee8a5a0fee0a$var$buildState(historyState.value.back, to, historyState.value.forward, true), data, {
            position: historyState.value.position
        }), true);
        currentLocation.value = to;
    }
    function push(to, data) {
        const currentState = (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({}, historyState.value, history$1.state, {
            forward: to,
            scroll: (0, $d713ccdd7edb23e5$export$e7094788287c5e9b)()
        });
        changeLocation(currentState.current, currentState, true);
        changeLocation(to, (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({}, $0edbee8a5a0fee0a$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data), false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
* Creates an HTML5 history. Most common history for single page applications.
*
* @param base -
*/ function $0edbee8a5a0fee0a$export$7b4942f78e7b8a49(base) {
    base = (0, $d713ccdd7edb23e5$export$3a1a48c8f6ef640e)(base);
    const historyNavigation = $0edbee8a5a0fee0a$var$useHistoryStateNavigation(base);
    const historyListeners = $0edbee8a5a0fee0a$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({
        location: "",
        base: base,
        go: go,
        createHref: (0, $d713ccdd7edb23e5$export$35e795649ee09318).bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>historyNavigation.location.value
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>historyNavigation.state.value
    });
    return routerHistory;
}
//#endregion
//#region src/history/memory.ts
/**
* Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
* It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
*
* @param base - Base applied to all urls, defaults to '/'
* @returns a history object that can be passed to the router constructor
*/ function $0edbee8a5a0fee0a$export$2b76ad033c6e6d08(base = "") {
    let listeners = [];
    let queue = [
        [
            (0, $d713ccdd7edb23e5$export$ebd11618f299a286),
            {}
        ]
    ];
    let position = 0;
    base = (0, $d713ccdd7edb23e5$export$3a1a48c8f6ef640e)(base);
    function setLocation(location$1, state = {}) {
        position++;
        if (position !== queue.length) queue.splice(position);
        queue.push([
            location$1,
            state
        ]);
    }
    function triggerListeners(to, from, { direction: direction, delta: delta }) {
        const info = {
            direction: direction,
            delta: delta,
            type: (0, $d713ccdd7edb23e5$export$342063e11d6c3cad).pop
        };
        for (const callback of listeners)callback(to, from, info);
    }
    const routerHistory = {
        location: (0, $d713ccdd7edb23e5$export$ebd11618f299a286),
        state: {},
        base: base,
        createHref: (0, $d713ccdd7edb23e5$export$35e795649ee09318).bind(null, base),
        replace (to, state) {
            queue.splice(position--, 1);
            setLocation(to, state);
        },
        push (to, state) {
            setLocation(to, state);
        },
        listen (callback) {
            listeners.push(callback);
            return ()=>{
                const index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy () {
            listeners = [];
            queue = [
                [
                    (0, $d713ccdd7edb23e5$export$ebd11618f299a286),
                    {}
                ]
            ];
            position = 0;
        },
        go (delta, shouldTrigger = true) {
            const from = this.location;
            const direction = delta < 0 ? (0, $d713ccdd7edb23e5$export$c4ce752e73470fba).back : (0, $d713ccdd7edb23e5$export$c4ce752e73470fba).forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>queue[position][0]
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>queue[position][1]
    });
    return routerHistory;
}
//#endregion
//#region src/history/hash.ts
/**
* Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
* handle any URL is not possible.
*
* @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
* in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
* calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
* after the `#`).
*
* @example
* ```js
* // at https://example.com/folder
* createWebHashHistory() // gives a url of `https://example.com/folder#`
* createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
* // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
* createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
* // you should avoid doing this because it changes the original url and breaks copying urls
* createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
*
* // at file:///usr/etc/folder/index.html
* // for locations with no `host`, the base is ignored
* createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
* ```
*/ function $0edbee8a5a0fee0a$export$542bc3a76486c94d(base) {
    base = location.host ? base || location.pathname + location.search : "";
    if (!base.includes("#")) base += "#";
    return $0edbee8a5a0fee0a$export$7b4942f78e7b8a49(base);
}
//#endregion
//#region src/matcher/pathTokenizer.ts
let $0edbee8a5a0fee0a$var$TokenType = /* @__PURE__ */ function(TokenType$1) {
    TokenType$1[TokenType$1["Static"] = 0] = "Static";
    TokenType$1[TokenType$1["Param"] = 1] = "Param";
    TokenType$1[TokenType$1["Group"] = 2] = "Group";
    return TokenType$1;
}({});
var $0edbee8a5a0fee0a$var$TokenizerState = /* @__PURE__ */ function(TokenizerState$1) {
    TokenizerState$1[TokenizerState$1["Static"] = 0] = "Static";
    TokenizerState$1[TokenizerState$1["Param"] = 1] = "Param";
    TokenizerState$1[TokenizerState$1["ParamRegExp"] = 2] = "ParamRegExp";
    TokenizerState$1[TokenizerState$1["ParamRegExpEnd"] = 3] = "ParamRegExpEnd";
    TokenizerState$1[TokenizerState$1["EscapeNext"] = 4] = "EscapeNext";
    return TokenizerState$1;
}($0edbee8a5a0fee0a$var$TokenizerState || {});
const $0edbee8a5a0fee0a$var$ROOT_TOKEN = {
    type: $0edbee8a5a0fee0a$var$TokenType.Static,
    value: ""
};
const $0edbee8a5a0fee0a$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
function $0edbee8a5a0fee0a$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === "/") return [
        [
            $0edbee8a5a0fee0a$var$ROOT_TOKEN
        ]
    ];
    if (!path.startsWith("/")) throw new Error(`Invalid path "${path}"`);
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = $0edbee8a5a0fee0a$var$TokenizerState.Static;
    let previousState = state;
    const tokens = [];
    let segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    let i = 0;
    let char;
    let buffer = "";
    let customRe = "";
    function consumeBuffer() {
        if (!buffer) return;
        if (state === $0edbee8a5a0fee0a$var$TokenizerState.Static) segment.push({
            type: $0edbee8a5a0fee0a$var$TokenType.Static,
            value: buffer
        });
        else if (state === $0edbee8a5a0fee0a$var$TokenizerState.Param || state === $0edbee8a5a0fee0a$var$TokenizerState.ParamRegExp || state === $0edbee8a5a0fee0a$var$TokenizerState.ParamRegExpEnd) {
            if (segment.length > 1 && (char === "*" || char === "+")) crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: $0edbee8a5a0fee0a$var$TokenType.Param,
                value: buffer,
                regexp: customRe,
                repeatable: char === "*" || char === "+",
                optional: char === "*" || char === "?"
            });
        } else crash("Invalid state to consume buffer");
        buffer = "";
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        if (char === "\\" && state !== $0edbee8a5a0fee0a$var$TokenizerState.ParamRegExp) {
            previousState = state;
            state = $0edbee8a5a0fee0a$var$TokenizerState.EscapeNext;
            continue;
        }
        switch(state){
            case $0edbee8a5a0fee0a$var$TokenizerState.Static:
                if (char === "/") {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ":") {
                    consumeBuffer();
                    state = $0edbee8a5a0fee0a$var$TokenizerState.Param;
                } else addCharToBuffer();
                break;
            case $0edbee8a5a0fee0a$var$TokenizerState.EscapeNext:
                addCharToBuffer();
                state = previousState;
                break;
            case $0edbee8a5a0fee0a$var$TokenizerState.Param:
                if (char === "(") state = $0edbee8a5a0fee0a$var$TokenizerState.ParamRegExp;
                else if ($0edbee8a5a0fee0a$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = $0edbee8a5a0fee0a$var$TokenizerState.Static;
                    if (char !== "*" && char !== "?" && char !== "+") i--;
                }
                break;
            case $0edbee8a5a0fee0a$var$TokenizerState.ParamRegExp:
                if (char === ")") {
                    if (customRe[customRe.length - 1] == "\\") customRe = customRe.slice(0, -1) + char;
                    else state = $0edbee8a5a0fee0a$var$TokenizerState.ParamRegExpEnd;
                } else customRe += char;
                break;
            case $0edbee8a5a0fee0a$var$TokenizerState.ParamRegExpEnd:
                consumeBuffer();
                state = $0edbee8a5a0fee0a$var$TokenizerState.Static;
                if (char !== "*" && char !== "?" && char !== "+") i--;
                customRe = "";
                break;
            default:
                crash("Unknown state");
                break;
        }
    }
    if (state === $0edbee8a5a0fee0a$var$TokenizerState.ParamRegExp) crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    return tokens;
}
//#endregion
//#region src/matcher/pathParserRanker.ts
const $0edbee8a5a0fee0a$var$BASE_PARAM_PATTERN = "[^/]+?";
const $0edbee8a5a0fee0a$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
var $0edbee8a5a0fee0a$var$PathScore = /* @__PURE__ */ function(PathScore$1) {
    PathScore$1[PathScore$1["_multiplier"] = 10] = "_multiplier";
    PathScore$1[PathScore$1["Root"] = 90] = "Root";
    PathScore$1[PathScore$1["Segment"] = 40] = "Segment";
    PathScore$1[PathScore$1["SubSegment"] = 30] = "SubSegment";
    PathScore$1[PathScore$1["Static"] = 40] = "Static";
    PathScore$1[PathScore$1["Dynamic"] = 20] = "Dynamic";
    PathScore$1[PathScore$1["BonusCustomRegExp"] = 10] = "BonusCustomRegExp";
    PathScore$1[PathScore$1["BonusWildcard"] = -50] = "BonusWildcard";
    PathScore$1[PathScore$1["BonusRepeatable"] = -20] = "BonusRepeatable";
    PathScore$1[PathScore$1["BonusOptional"] = -8] = "BonusOptional";
    PathScore$1[PathScore$1["BonusStrict"] = .7000000000000001] = "BonusStrict";
    PathScore$1[PathScore$1["BonusCaseSensitive"] = .25] = "BonusCaseSensitive";
    return PathScore$1;
}($0edbee8a5a0fee0a$var$PathScore || {});
const $0edbee8a5a0fee0a$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
* Creates a path parser from an array of Segments (a segment is an array of Tokens)
*
* @param segments - array of segments returned by tokenizePath
* @param extraOptions - optional options for the regexp
* @returns a PathParser
*/ function $0edbee8a5a0fee0a$var$tokensToParser(segments, extraOptions) {
    const options = (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({}, $0edbee8a5a0fee0a$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    const score = [];
    let pattern = options.start ? "^" : "";
    const keys = [];
    for (const segment of segments){
        const segmentScores = segment.length ? [] : [
            $0edbee8a5a0fee0a$var$PathScore.Root
        ];
        if (options.strict && !segment.length) pattern += "/";
        for(let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
            const token = segment[tokenIndex];
            let subSegmentScore = $0edbee8a5a0fee0a$var$PathScore.Segment + (options.sensitive ? $0edbee8a5a0fee0a$var$PathScore.BonusCaseSensitive : 0);
            if (token.type === $0edbee8a5a0fee0a$var$TokenType.Static) {
                if (!tokenIndex) pattern += "/";
                pattern += token.value.replace($0edbee8a5a0fee0a$var$REGEX_CHARS_RE, "\\$&");
                subSegmentScore += $0edbee8a5a0fee0a$var$PathScore.Static;
            } else if (token.type === $0edbee8a5a0fee0a$var$TokenType.Param) {
                const { value: value, repeatable: repeatable, optional: optional, regexp: regexp } = token;
                keys.push({
                    name: value,
                    repeatable: repeatable,
                    optional: optional
                });
                const re$1 = regexp ? regexp : $0edbee8a5a0fee0a$var$BASE_PARAM_PATTERN;
                if (re$1 !== $0edbee8a5a0fee0a$var$BASE_PARAM_PATTERN) subSegmentScore += $0edbee8a5a0fee0a$var$PathScore.BonusCustomRegExp;
                let subPattern = repeatable ? `((?:${re$1})(?:/(?:${re$1}))*)` : `(${re$1})`;
                if (!tokenIndex) subPattern = optional && segment.length < 2 ? `(?:/${subPattern})` : "/" + subPattern;
                if (optional) subPattern += "?";
                pattern += subPattern;
                subSegmentScore += $0edbee8a5a0fee0a$var$PathScore.Dynamic;
                if (optional) subSegmentScore += $0edbee8a5a0fee0a$var$PathScore.BonusOptional;
                if (repeatable) subSegmentScore += $0edbee8a5a0fee0a$var$PathScore.BonusRepeatable;
                if (re$1 === ".*") subSegmentScore += $0edbee8a5a0fee0a$var$PathScore.BonusWildcard;
            }
            segmentScores.push(subSegmentScore);
        }
        score.push(segmentScores);
    }
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += $0edbee8a5a0fee0a$var$PathScore.BonusStrict;
    }
    if (!options.strict) pattern += "/?";
    if (options.end) pattern += "$";
    else if (options.strict && !pattern.endsWith("/")) pattern += "(?:/|$)";
    const re = new RegExp(pattern, options.sensitive ? "" : "i");
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match) return null;
        for(let i = 1; i < match.length; i++){
            const value = match[i] || "";
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split("/") : value;
        }
        return params;
    }
    function stringify(params) {
        let path = "";
        let avoidDuplicatedSlash = false;
        for (const segment of segments){
            if (!avoidDuplicatedSlash || !path.endsWith("/")) path += "/";
            avoidDuplicatedSlash = false;
            for (const token of segment)if (token.type === $0edbee8a5a0fee0a$var$TokenType.Static) path += token.value;
            else if (token.type === $0edbee8a5a0fee0a$var$TokenType.Param) {
                const { value: value, repeatable: repeatable, optional: optional } = token;
                const param = value in params ? params[value] : "";
                if ((0, $d713ccdd7edb23e5$export$78acf4525d8a74c4)(param) && !repeatable) throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                const text = (0, $d713ccdd7edb23e5$export$78acf4525d8a74c4)(param) ? param.join("/") : param;
                if (!text) {
                    if (optional) {
                        if (segment.length < 2) {
                            if (path.endsWith("/")) path = path.slice(0, -1);
                            else avoidDuplicatedSlash = true;
                        }
                    } else throw new Error(`Missing required param "${value}"`);
                }
                path += text;
            }
        }
        return path || "/";
    }
    return {
        re: re,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
* Compares an array of numbers as used in PathParser.score and returns a
* number. This function can be used to `sort` an array
*
* @param a - first array of numbers
* @param b - second array of numbers
* @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
* should be sorted first
*/ function $0edbee8a5a0fee0a$var$compareScoreArray(a, b) {
    let i = 0;
    while(i < a.length && i < b.length){
        const diff = b[i] - a[i];
        if (diff) return diff;
        i++;
    }
    if (a.length < b.length) return a.length === 1 && a[0] === $0edbee8a5a0fee0a$var$PathScore.Static + $0edbee8a5a0fee0a$var$PathScore.Segment ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === $0edbee8a5a0fee0a$var$PathScore.Static + $0edbee8a5a0fee0a$var$PathScore.Segment ? 1 : -1;
    return 0;
}
/**
* Compare function that can be used with `sort` to sort an array of PathParser
*
* @param a - first PathParser
* @param b - second PathParser
* @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
*/ function $0edbee8a5a0fee0a$var$comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        const comp = $0edbee8a5a0fee0a$var$compareScoreArray(aScore[i], bScore[i]);
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($0edbee8a5a0fee0a$var$isLastScoreNegative(aScore)) return 1;
        if ($0edbee8a5a0fee0a$var$isLastScoreNegative(bScore)) return -1;
    }
    return bScore.length - aScore.length;
}
/**
* This allows detecting splats at the end of a path: /home/:id(.*)*
*
* @param score - score to check
* @returns true if the last entry is negative
*/ function $0edbee8a5a0fee0a$var$isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
const $0edbee8a5a0fee0a$var$PATH_PARSER_OPTIONS_DEFAULTS = {
    strict: false,
    end: true,
    sensitive: false
};
//#endregion
//#region src/matcher/pathMatcher.ts
function $0edbee8a5a0fee0a$var$createRouteRecordMatcher(record, parent, options) {
    const parser = $0edbee8a5a0fee0a$var$tokensToParser($0edbee8a5a0fee0a$var$tokenizePath(record.path), options);
    const matcher = (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)(parser, {
        record: record,
        parent: parent,
        children: [],
        alias: []
    });
    if (parent) {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
//#endregion
//#region src/matcher/index.ts
/**
* Creates a Router Matcher.
*
* @internal
* @param routes - array of initial routes
* @param globalOptions - global route options
*/ function $0edbee8a5a0fee0a$export$36302c85fdcc95a8(routes, globalOptions) {
    const matchers = [];
    const matcherMap = /* @__PURE__ */ new Map();
    globalOptions = (0, $d713ccdd7edb23e5$export$dc98b0b04f4c7758)($0edbee8a5a0fee0a$var$PATH_PARSER_OPTIONS_DEFAULTS, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = $0edbee8a5a0fee0a$var$normalizeRouteRecord(record);
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = (0, $d713ccdd7edb23e5$export$dc98b0b04f4c7758)(globalOptions, record);
        const normalizedRecords = [
            mainNormalizedRecord
        ];
        if ("alias" in record) {
            const aliases = typeof record.alias === "string" ? [
                record.alias
            ] : record.alias;
            for (const alias of aliases)normalizedRecords.push($0edbee8a5a0fee0a$var$normalizeRouteRecord((0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({}, mainNormalizedRecord, {
                components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                path: alias,
                aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
            })));
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords){
            const { path: path } = normalizedRecord;
            if (parent && path[0] !== "/") {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === "/" ? "" : "/";
                normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
            }
            matcher = $0edbee8a5a0fee0a$var$createRouteRecordMatcher(normalizedRecord, parent, options);
            if (originalRecord) originalRecord.alias.push(matcher);
            else {
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                if (isRootAdd && record.name && !$0edbee8a5a0fee0a$var$isAliasRecord(matcher)) removeRoute(record.name);
            }
            if ($0edbee8a5a0fee0a$var$isMatchable(matcher)) insertMatcher(matcher);
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for(let i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
            }
            originalRecord = originalRecord || matcher;
        }
        return originalMatcher ? ()=>{
            removeRoute(originalMatcher);
        } : (0, $d713ccdd7edb23e5$export$3722cfe417b6ed86);
    }
    function removeRoute(matcherRef) {
        if ((0, $d713ccdd7edb23e5$export$25ce5a424b770e84)(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        const index = $0edbee8a5a0fee0a$var$findInsertionIndex(matcher, matchers);
        matchers.splice(index, 0, matcher);
        if (matcher.record.name && !$0edbee8a5a0fee0a$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location$1, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ("name" in location$1 && location$1.name) {
            matcher = matcherMap.get(location$1.name);
            if (!matcher) throw (0, $d713ccdd7edb23e5$export$4a5767248b18ef41)((0, $d713ccdd7edb23e5$export$71511d61b312f219).MATCHER_NOT_FOUND, {
                location: location$1
            });
            name = matcher.record.name;
            params = (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)($0edbee8a5a0fee0a$var$pickParams(currentLocation.params, matcher.keys.filter((k)=>!k.optional).concat(matcher.parent ? matcher.parent.keys.filter((k)=>k.optional) : []).map((k)=>k.name)), location$1.params && $0edbee8a5a0fee0a$var$pickParams(location$1.params, matcher.keys.map((k)=>k.name)));
            path = matcher.stringify(params);
        } else if (location$1.path != null) {
            path = location$1.path;
            matcher = matchers.find((m)=>m.re.test(path));
            if (matcher) {
                params = matcher.parse(path);
                name = matcher.record.name;
            }
        } else {
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find((m)=>m.re.test(currentLocation.path));
            if (!matcher) throw (0, $d713ccdd7edb23e5$export$4a5767248b18ef41)((0, $d713ccdd7edb23e5$export$71511d61b312f219).MATCHER_NOT_FOUND, {
                location: location$1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            params = (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({}, currentLocation.params, location$1.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while(parentMatcher){
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $0edbee8a5a0fee0a$var$mergeMetaFields(matched)
        };
    }
    routes.forEach((route)=>addRoute(route));
    function clearRoutes() {
        matchers.length = 0;
        matcherMap.clear();
    }
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        clearRoutes: clearRoutes,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
/**
* Picks an object param to contain only specified keys.
*
* @param params - params object to pick from
* @param keys - keys to pick
*/ function $0edbee8a5a0fee0a$var$pickParams(params, keys) {
    const newParams = {};
    for (const key of keys)if (key in params) newParams[key] = params[key];
    return newParams;
}
/**
* Normalizes a RouteRecordRaw. Creates a copy
*
* @param record
* @returns the normalized version
*/ function $0edbee8a5a0fee0a$var$normalizeRouteRecord(record) {
    const normalized = {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: record.aliasOf,
        beforeEnter: record.beforeEnter,
        props: $0edbee8a5a0fee0a$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: /* @__PURE__ */ new Set(),
        updateGuards: /* @__PURE__ */ new Set(),
        enterCallbacks: {},
        components: "components" in record ? record.components || null : record.component && {
            default: record.component
        }
    };
    Object.defineProperty(normalized, "mods", {
        value: {}
    });
    return normalized;
}
/**
* Normalize the optional `props` in a record to always be an object similar to
* components. Also accept a boolean for components.
* @param record
*/ function $0edbee8a5a0fee0a$var$normalizeRecordProps(record) {
    const propsObject = {};
    const props = record.props || false;
    if ("component" in record) propsObject.default = props;
    else for(const name in record.components)propsObject[name] = typeof props === "object" ? props[name] : props;
    return propsObject;
}
/**
* Checks if a record or any of its parent is an alias
* @param record
*/ function $0edbee8a5a0fee0a$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
* Merge meta fields of an array of records
*
* @param matched - array of matched records
*/ function $0edbee8a5a0fee0a$var$mergeMetaFields(matched) {
    return matched.reduce((meta, record)=>(0, $d713ccdd7edb23e5$export$b4171a6734a65d42)(meta, record.meta), {});
}
function $0edbee8a5a0fee0a$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
* Check if a path and its alias have the same required params
*
* @param a - original record
* @param b - alias record
*/ function $0edbee8a5a0fee0a$var$checkSameParams(a, b) {
    for (const key of a.keys)if (!key.optional && !b.keys.find($0edbee8a5a0fee0a$var$isSameParam.bind(null, key))) return (0, $d713ccdd7edb23e5$export$3466f893ebf79586)(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    for (const key of b.keys)if (!key.optional && !a.keys.find($0edbee8a5a0fee0a$var$isSameParam.bind(null, key))) return (0, $d713ccdd7edb23e5$export$3466f893ebf79586)(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
}
/**
* A route with a name and a child with an empty path without a name should warn when adding the route
*
* @param mainNormalizedRecord - RouteRecordNormalized
* @param parent - RouteRecordMatcher
*/ function $0edbee8a5a0fee0a$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path) (0, $d713ccdd7edb23e5$export$3466f893ebf79586)(`The route named "${String(parent.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
}
function $0edbee8a5a0fee0a$var$checkSameNameAsAncestor(record, parent) {
    for(let ancestor = parent; ancestor; ancestor = ancestor.parent)if (ancestor.record.name === record.name) throw new Error(`A route named "${String(record.name)}" has been added as a ${parent === ancestor ? "child" : "descendant"} of a route with the same name. Route names must be unique and a nested route cannot use the same name as an ancestor.`);
}
function $0edbee8a5a0fee0a$var$checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys)if (!record.keys.find($0edbee8a5a0fee0a$var$isSameParam.bind(null, key))) return (0, $d713ccdd7edb23e5$export$3466f893ebf79586)(`Absolute path "${record.record.path}" must have the exact same param named "${key.name}" as its parent "${parent.record.path}".`);
}
/**
* Performs a binary search to find the correct insertion index for a new matcher.
*
* Matchers are primarily sorted by their score. If scores are tied then we also consider parent/child relationships,
* with descendants coming before ancestors. If there's still a tie, new routes are inserted after existing routes.
*
* @param matcher - new matcher to be inserted
* @param matchers - existing matchers
*/ function $0edbee8a5a0fee0a$var$findInsertionIndex(matcher, matchers) {
    let lower = 0;
    let upper = matchers.length;
    while(lower !== upper){
        const mid = lower + upper >> 1;
        if ($0edbee8a5a0fee0a$var$comparePathParserScore(matcher, matchers[mid]) < 0) upper = mid;
        else lower = mid + 1;
    }
    const insertionAncestor = $0edbee8a5a0fee0a$var$getInsertionAncestor(matcher);
    if (insertionAncestor) upper = matchers.lastIndexOf(insertionAncestor, upper - 1);
    return upper;
}
function $0edbee8a5a0fee0a$var$getInsertionAncestor(matcher) {
    let ancestor = matcher;
    while(ancestor = ancestor.parent)if ($0edbee8a5a0fee0a$var$isMatchable(ancestor) && $0edbee8a5a0fee0a$var$comparePathParserScore(matcher, ancestor) === 0) return ancestor;
}
/**
* Checks if a matcher can be reachable. This means if it's possible to reach it as a route. For example, routes without
* a component, or name, or redirect, are just used to group other routes.
* @param matcher
* @param matcher.record record of the matcher
* @returns
*/ function $0edbee8a5a0fee0a$var$isMatchable({ record: record }) {
    return !!(record.name || record.components && Object.keys(record.components).length || record.redirect);
}
//#endregion
//#region src/RouterLink.ts
/**
* Returns the internal behavior of a {@link RouterLink} without the rendering part.
*
* @param props - a `to` location and an optional `replace` flag
*/ function $0edbee8a5a0fee0a$export$dcf14c9974fe2767(props) {
    const router = (0, $igcaK.inject)((0, $d713ccdd7edb23e5$export$4368d992c4eafac0));
    const currentRoute = (0, $igcaK.inject)((0, $d713ccdd7edb23e5$export$3b14a55fb2447963));
    let hasPrevious = false;
    let previousTo = null;
    const route = (0, $mHgsT.computed)(()=>{
        const to = (0, $mHgsT.unref)(props.to);
        return router.resolve(to);
    });
    const activeRecordIndex = (0, $mHgsT.computed)(()=>{
        const { matched: matched } = route.value;
        const { length: length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        const index = currentMatched.findIndex((0, $d713ccdd7edb23e5$export$61196ced6d74a310).bind(null, routeMatched));
        if (index > -1) return index;
        const parentRecordPath = $0edbee8a5a0fee0a$var$getOriginalPath(matched[length - 2]);
        return length > 1 && $0edbee8a5a0fee0a$var$getOriginalPath(routeMatched) === parentRecordPath && currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex((0, $d713ccdd7edb23e5$export$61196ced6d74a310).bind(null, matched[length - 2])) : index;
    });
    const isActive = (0, $mHgsT.computed)(()=>activeRecordIndex.value > -1 && $0edbee8a5a0fee0a$var$includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0, $mHgsT.computed)(()=>activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && (0, $d713ccdd7edb23e5$export$9bb611d729802a56)(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if ($0edbee8a5a0fee0a$var$guardEvent(e)) {
            const p = router[(0, $mHgsT.unref)(props.replace) ? "replace" : "push"]((0, $mHgsT.unref)(props.to)).catch((0, $d713ccdd7edb23e5$export$3722cfe417b6ed86));
            if (props.viewTransition && typeof document !== "undefined" && "startViewTransition" in document) document.startViewTransition(()=>p);
            return p;
        }
        return Promise.resolve();
    }
    if (__VUE_PROD_DEVTOOLS__ && (0, $d713ccdd7edb23e5$export$3d8c2f653ac9d0b9)) {
        const instance = (0, $igcaK.getCurrentInstance)();
        if (instance) {
            const linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value,
                error: null
            };
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $igcaK.watchEffect)(()=>{
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
                linkContextDevtools.error = (0, $d713ccdd7edb23e5$export$d141bba7fdc215a3)((0, $mHgsT.unref)(props.to)) ? null : "Invalid \"to\" value";
            }, {
                flush: "post"
            });
        }
    }
    /**
	* NOTE: update {@link _RouterLinkI}'s `$slots` type when updating this
	*/ return {
        route: route,
        href: (0, $mHgsT.computed)(()=>route.value.href),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
function $0edbee8a5a0fee0a$var$preferSingleVNode(vnodes) {
    return vnodes.length === 1 ? vnodes[0] : vnodes;
}
const $0edbee8a5a0fee0a$var$RouterLinkImpl = /* @__PURE__ */ (0, $igcaK.defineComponent)({
    name: "RouterLink",
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: "page"
        },
        viewTransition: Boolean
    },
    useLink: $0edbee8a5a0fee0a$export$dcf14c9974fe2767,
    setup (props, { slots: slots }) {
        const link = (0, $mHgsT.reactive)($0edbee8a5a0fee0a$export$dcf14c9974fe2767(props));
        const { options: options } = (0, $igcaK.inject)((0, $d713ccdd7edb23e5$export$4368d992c4eafac0));
        const elClass = (0, $mHgsT.computed)(()=>({
                [$0edbee8a5a0fee0a$var$getLinkClass(props.activeClass, options.linkActiveClass, "router-link-active")]: link.isActive,
                [$0edbee8a5a0fee0a$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, "router-link-exact-active")]: link.isExactActive
            }));
        return ()=>{
            const children = slots.default && $0edbee8a5a0fee0a$var$preferSingleVNode(slots.default(link));
            return props.custom ? children : (0, $igcaK.h)("a", {
                "aria-current": link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
/**
* Component to render a link that triggers a navigation on click.
*/ const $0edbee8a5a0fee0a$export$fce709ebdac448ed = $0edbee8a5a0fee0a$var$RouterLinkImpl;
function $0edbee8a5a0fee0a$var$guardEvent(e) {
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    if (e.defaultPrevented) return;
    if (e.button !== void 0 && e.button !== 0) return;
    if (e.currentTarget && e.currentTarget.getAttribute) {
        const target = e.currentTarget.getAttribute("target");
        if (/\b_blank\b/i.test(target)) return;
    }
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $0edbee8a5a0fee0a$var$includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key];
        const outerValue = outer[key];
        if (typeof innerValue === "string") {
            if (innerValue !== outerValue) return false;
        } else if (!(0, $d713ccdd7edb23e5$export$78acf4525d8a74c4)(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i)=>value.valueOf() !== outerValue[i].valueOf())) return false;
    }
    return true;
}
/**
* Get the original path value of a record by following its aliasOf
* @param record
*/ function $0edbee8a5a0fee0a$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
/**
* Utility class to get the active class based on defaults.
* @param propClass
* @param globalClass
* @param defaultClass
*/ const $0edbee8a5a0fee0a$var$getLinkClass = (propClass, globalClass, defaultClass)=>propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
//#endregion
//#region src/RouterView.ts
const $0edbee8a5a0fee0a$var$RouterViewImpl = /* @__PURE__ */ (0, $igcaK.defineComponent)({
    name: "RouterView",
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: "default"
        },
        route: Object
    },
    compatConfig: {
        MODE: 3
    },
    setup (props, { attrs: attrs, slots: slots }) {
        const injectedRoute = (0, $igcaK.inject)((0, $d713ccdd7edb23e5$export$2d1720544b23b823));
        const routeToDisplay = (0, $mHgsT.computed)(()=>props.route || injectedRoute.value);
        const injectedDepth = (0, $igcaK.inject)((0, $d713ccdd7edb23e5$export$ffb5f4729a158638), 0);
        const depth = (0, $mHgsT.computed)(()=>{
            let initialDepth = (0, $mHgsT.unref)(injectedDepth);
            const { matched: matched } = routeToDisplay.value;
            let matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        const matchedRouteRef = (0, $mHgsT.computed)(()=>routeToDisplay.value.matched[depth.value]);
        (0, $igcaK.provide)((0, $d713ccdd7edb23e5$export$ffb5f4729a158638), (0, $mHgsT.computed)(()=>depth.value + 1));
        (0, $igcaK.provide)((0, $d713ccdd7edb23e5$export$882b5998b3b9117c), matchedRouteRef);
        (0, $igcaK.provide)((0, $d713ccdd7edb23e5$export$2d1720544b23b823), routeToDisplay);
        const viewRef = (0, $mHgsT.ref)();
        (0, $mHgsT.watch)(()=>[
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ], ([instance, to, name], [oldInstance, from, oldName])=>{
            if (to) {
                to.instances[name] = instance;
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            if (instance && to && (!from || !(0, $d713ccdd7edb23e5$export$61196ced6d74a310)(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach((callback)=>callback(instance));
        }, {
            flush: "post"
        });
        return ()=>{
            const route = routeToDisplay.value;
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $0edbee8a5a0fee0a$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === "function" ? routePropsOption(route) : routePropsOption : null;
            const onVnodeUnmounted = (vnode)=>{
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            const component = (0, $igcaK.h)(ViewComponent, (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if (__VUE_PROD_DEVTOOLS__ && (0, $d713ccdd7edb23e5$export$3d8c2f653ac9d0b9) && component.ref) {
                const info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                ((0, $d713ccdd7edb23e5$export$78acf4525d8a74c4)(component.ref) ? component.ref.map((r)=>r.i) : [
                    component.ref.i
                ]).forEach((instance)=>{
                    instance.__vrv_devtools = info;
                });
            }
            return $0edbee8a5a0fee0a$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component;
        };
    }
});
function $0edbee8a5a0fee0a$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
/**
* Component to display the current route the user is at.
*/ const $0edbee8a5a0fee0a$export$d941f00e9b9a537 = $0edbee8a5a0fee0a$var$RouterViewImpl;
function $0edbee8a5a0fee0a$var$warnDeprecatedUsage() {
    const instance = (0, $igcaK.getCurrentInstance)();
    const parentName = instance.parent && instance.parent.type.name;
    const parentSubTreeType = instance.parent && instance.parent.subTree && instance.parent.subTree.type;
    if (parentName && (parentName === "KeepAlive" || parentName.includes("Transition")) && typeof parentSubTreeType === "object" && parentSubTreeType.name === "RouterView") {
        const comp = parentName === "KeepAlive" ? "keep-alive" : "transition";
        (0, $d713ccdd7edb23e5$export$3466f893ebf79586)(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.
Use slot props instead:

<router-view v-slot="{ Component }">
  <${comp}>\n    <component :is="Component" />\n  </${comp}>\n</router-view>`);
    }
}
//#endregion
//#region src/router.ts
/**
* Creates a Router instance that can be used by a Vue app.
*
* @param options - {@link RouterOptions}
*/ function $0edbee8a5a0fee0a$export$baddd0131ee8c05b(options) {
    const matcher = $0edbee8a5a0fee0a$export$36302c85fdcc95a8(options.routes, options);
    const parseQuery$1 = options.parseQuery || (0, $d713ccdd7edb23e5$export$dda1d9f60106f0e9);
    const stringifyQuery$1 = options.stringifyQuery || (0, $d713ccdd7edb23e5$export$39b482c5e57630a8);
    const routerHistory = options.history;
    const beforeGuards = (0, $d713ccdd7edb23e5$export$db3b6bfb95261072)();
    const beforeResolveGuards = (0, $d713ccdd7edb23e5$export$db3b6bfb95261072)();
    const afterGuards = (0, $d713ccdd7edb23e5$export$db3b6bfb95261072)();
    const currentRoute = (0, $mHgsT.shallowRef)((0, $d713ccdd7edb23e5$export$56c0d5a1e737357d));
    let pendingLocation = (0, $d713ccdd7edb23e5$export$56c0d5a1e737357d);
    if ((0, $d713ccdd7edb23e5$export$3d8c2f653ac9d0b9) && options.scrollBehavior && "scrollRestoration" in history) history.scrollRestoration = "manual";
    const normalizeParams = (0, $d713ccdd7edb23e5$export$9e5f44173e64f162).bind(null, (paramValue)=>"" + paramValue);
    const encodeParams = (0, $d713ccdd7edb23e5$export$9e5f44173e64f162).bind(null, (0, $d713ccdd7edb23e5$export$71cec2538cb2c617));
    const decodeParams = (0, $d713ccdd7edb23e5$export$9e5f44173e64f162).bind(null, (0, $d713ccdd7edb23e5$export$7f8ddf7c7c20b3cd));
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if ((0, $d713ccdd7edb23e5$export$25ce5a424b770e84)(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        } else record = parentOrRoute;
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) matcher.removeRoute(recordMatcher);
    }
    function getRoutes() {
        return matcher.getRoutes().map((routeMatcher)=>routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        currentLocation = (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === "string") {
            const locationNormalized = (0, $d713ccdd7edb23e5$export$db202ddc8be9136)(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute$1 = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            const href$1 = routerHistory.createHref(locationNormalized.fullPath);
            return (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)(locationNormalized, matchedRoute$1, {
                params: decodeParams(matchedRoute$1.params),
                hash: (0, $d713ccdd7edb23e5$export$7f8ddf7c7c20b3cd)(locationNormalized.hash),
                redirectedFrom: void 0,
                href: href$1
            });
        }
        let matcherLocation;
        if (rawLocation.path != null) matcherLocation = (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({}, rawLocation, {
            path: (0, $d713ccdd7edb23e5$export$db202ddc8be9136)(parseQuery$1, rawLocation.path, currentLocation.path).path
        });
        else {
            const targetParams = (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({}, rawLocation.params);
            for(const key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            matcherLocation = (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({}, rawLocation, {
                params: encodeParams(targetParams)
            });
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || "";
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = (0, $d713ccdd7edb23e5$export$ef35774e6d314e91)(stringifyQuery$1, (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({}, rawLocation, {
            hash: (0, $d713ccdd7edb23e5$export$3a6d5c9ae78a2c08)(hash),
            path: matchedRoute.path
        }));
        const href = routerHistory.createHref(fullPath);
        return (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({
            fullPath: fullPath,
            hash: hash,
            query: stringifyQuery$1 === (0, $d713ccdd7edb23e5$export$39b482c5e57630a8) ? (0, $d713ccdd7edb23e5$export$953cecd6e717a553)(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute, {
            redirectedFrom: void 0,
            href: href
        });
    }
    function locationAsObject(to) {
        return typeof to === "string" ? (0, $d713ccdd7edb23e5$export$db202ddc8be9136)(parseQuery$1, to, currentRoute.value.path) : (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return (0, $d713ccdd7edb23e5$export$4a5767248b18ef41)((0, $d713ccdd7edb23e5$export$71511d61b312f219).NAVIGATION_CANCELLED, {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push((0, $d713ccdd7edb23e5$export$b4171a6734a65d42)(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to, from) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect: redirect } = lastMatched;
            let newTargetLocation = typeof redirect === "function" ? redirect(to, from) : redirect;
            if (typeof newTargetLocation === "string") {
                newTargetLocation = newTargetLocation.includes("?") || newTargetLocation.includes("#") ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                newTargetLocation.params = {};
            }
            return (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({
                query: to.query,
                hash: to.hash,
                params: newTargetLocation.path != null ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = pendingLocation = resolve(to);
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        const replace$1 = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation, from);
        if (shouldRedirect) return pushWithRedirect((0, $d713ccdd7edb23e5$export$b4171a6734a65d42)(locationAsObject(shouldRedirect), {
            state: typeof shouldRedirect === "object" ? (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({}, data, shouldRedirect.state) : data,
            force: force,
            replace: replace$1
        }), redirectedFrom || targetLocation);
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && (0, $d713ccdd7edb23e5$export$d66501df72047452)(stringifyQuery$1, from, targetLocation)) {
            failure = (0, $d713ccdd7edb23e5$export$4a5767248b18ef41)((0, $d713ccdd7edb23e5$export$71511d61b312f219).NAVIGATION_DUPLICATED, {
                to: toLocation,
                from: from
            });
            handleScroll(from, from, true, false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch((error)=>(0, $d713ccdd7edb23e5$export$8b22cf2602fb60ce)(error) ? (0, $d713ccdd7edb23e5$export$8b22cf2602fb60ce)(error, (0, $d713ccdd7edb23e5$export$71511d61b312f219).NAVIGATION_GUARD_REDIRECT) ? error : markAsReady(error) : triggerError(error, toLocation, from)).then((failure$1)=>{
            if (failure$1) {
                if ((0, $d713ccdd7edb23e5$export$8b22cf2602fb60ce)(failure$1, (0, $d713ccdd7edb23e5$export$71511d61b312f219).NAVIGATION_GUARD_REDIRECT)) return pushWithRedirect((0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({
                    replace: replace$1
                }, locationAsObject(failure$1.to), {
                    state: typeof failure$1.to === "object" ? (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({}, data, failure$1.to.state) : data,
                    force: force
                }), redirectedFrom || toLocation);
            } else failure$1 = finalizeNavigation(toLocation, from, true, replace$1, data);
            triggerAfterEach(toLocation, from, failure$1);
            return failure$1;
        });
    }
    /**
	* Helper to reject and skip all navigation guards if a new navigation happened
	* @param to
	* @param from
	*/ function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    function runWithContext(fn) {
        const app = installedApps.values().next().value;
        return app && typeof app.runWithContext === "function" ? app.runWithContext(fn) : fn();
    }
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = (0, $d713ccdd7edb23e5$export$7ccc53e8f1e7dfc5)(to, from);
        guards = (0, $d713ccdd7edb23e5$export$43caf9889c228507)(leavingRecords.reverse(), "beforeRouteLeave", to, from);
        for (const record of leavingRecords)record.leaveGuards.forEach((guard)=>{
            guards.push((0, $d713ccdd7edb23e5$export$23f2a1d2818174ef)(guard, to, from));
        });
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        return runGuardQueue(guards).then(()=>{
            guards = [];
            for (const guard of beforeGuards.list())guards.push((0, $d713ccdd7edb23e5$export$23f2a1d2818174ef)(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = (0, $d713ccdd7edb23e5$export$43caf9889c228507)(updatingRecords, "beforeRouteUpdate", to, from);
            for (const record of updatingRecords)record.updateGuards.forEach((guard)=>{
                guards.push((0, $d713ccdd7edb23e5$export$23f2a1d2818174ef)(guard, to, from));
            });
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = [];
            for (const record of enteringRecords)if (record.beforeEnter) {
                if ((0, $d713ccdd7edb23e5$export$78acf4525d8a74c4)(record.beforeEnter)) for (const beforeEnter of record.beforeEnter)guards.push((0, $d713ccdd7edb23e5$export$23f2a1d2818174ef)(beforeEnter, to, from));
                else guards.push((0, $d713ccdd7edb23e5$export$23f2a1d2818174ef)(record.beforeEnter, to, from));
            }
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            to.matched.forEach((record)=>record.enterCallbacks = {});
            guards = (0, $d713ccdd7edb23e5$export$43caf9889c228507)(enteringRecords, "beforeRouteEnter", to, from, runWithContext);
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = [];
            for (const guard of beforeResolveGuards.list())guards.push((0, $d713ccdd7edb23e5$export$23f2a1d2818174ef)(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).catch((err)=>(0, $d713ccdd7edb23e5$export$8b22cf2602fb60ce)(err, (0, $d713ccdd7edb23e5$export$71511d61b312f219).NAVIGATION_CANCELLED) ? err : Promise.reject(err));
    }
    function triggerAfterEach(to, from, failure) {
        afterGuards.list().forEach((guard)=>runWithContext(()=>guard(to, from, failure)));
    }
    /**
	* - Cleans up any navigation guards
	* - Changes the url if necessary
	* - Calls the scrollBehavior
	*/ function finalizeNavigation(toLocation, from, isPush, replace$1, data) {
        const error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        const isFirstNavigation = from === (0, $d713ccdd7edb23e5$export$56c0d5a1e737357d);
        const state = !(0, $d713ccdd7edb23e5$export$3d8c2f653ac9d0b9) ? {} : history.state;
        if (isPush) {
            if (replace$1 || isFirstNavigation) routerHistory.replace(toLocation.fullPath, (0, $d713ccdd7edb23e5$export$b4171a6734a65d42)({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    function setupListeners() {
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen((to, _from, info)=>{
            if (!router.listening) return;
            const toLocation = resolve(to);
            const shouldRedirect = handleRedirectRecord(toLocation, router.currentRoute.value);
            if (shouldRedirect) {
                pushWithRedirect((0, $d713ccdd7edb23e5$export$b4171a6734a65d42)(shouldRedirect, {
                    replace: true,
                    force: true
                }), toLocation).catch((0, $d713ccdd7edb23e5$export$3722cfe417b6ed86));
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            if (0, $d713ccdd7edb23e5$export$3d8c2f653ac9d0b9) (0, $d713ccdd7edb23e5$export$a9c23c6ac3fc3eca)((0, $d713ccdd7edb23e5$export$971d5caa766a69d7)(from.fullPath, info.delta), (0, $d713ccdd7edb23e5$export$e7094788287c5e9b)());
            navigate(toLocation, from).catch((error)=>{
                if ((0, $d713ccdd7edb23e5$export$8b22cf2602fb60ce)(error, (0, $d713ccdd7edb23e5$export$71511d61b312f219).NAVIGATION_ABORTED | (0, $d713ccdd7edb23e5$export$71511d61b312f219).NAVIGATION_CANCELLED)) return error;
                if ((0, $d713ccdd7edb23e5$export$8b22cf2602fb60ce)(error, (0, $d713ccdd7edb23e5$export$71511d61b312f219).NAVIGATION_GUARD_REDIRECT)) {
                    pushWithRedirect((0, $d713ccdd7edb23e5$export$b4171a6734a65d42)(locationAsObject(error.to), {
                        force: true
                    }), toLocation).then((failure)=>{
                        if ((0, $d713ccdd7edb23e5$export$8b22cf2602fb60ce)(failure, (0, $d713ccdd7edb23e5$export$71511d61b312f219).NAVIGATION_ABORTED | (0, $d713ccdd7edb23e5$export$71511d61b312f219).NAVIGATION_DUPLICATED) && !info.delta && info.type === (0, $d713ccdd7edb23e5$export$342063e11d6c3cad).pop) routerHistory.go(-1, false);
                    }).catch((0, $d713ccdd7edb23e5$export$3722cfe417b6ed86));
                    return Promise.reject();
                }
                if (info.delta) routerHistory.go(-info.delta, false);
                return triggerError(error, toLocation, from);
            }).then((failure)=>{
                failure = failure || finalizeNavigation(toLocation, from, false);
                if (failure) {
                    if (info.delta && !(0, $d713ccdd7edb23e5$export$8b22cf2602fb60ce)(failure, (0, $d713ccdd7edb23e5$export$71511d61b312f219).NAVIGATION_CANCELLED)) routerHistory.go(-info.delta, false);
                    else if (info.type === (0, $d713ccdd7edb23e5$export$342063e11d6c3cad).pop && (0, $d713ccdd7edb23e5$export$8b22cf2602fb60ce)(failure, (0, $d713ccdd7edb23e5$export$71511d61b312f219).NAVIGATION_ABORTED | (0, $d713ccdd7edb23e5$export$71511d61b312f219).NAVIGATION_DUPLICATED)) routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            }).catch((0, $d713ccdd7edb23e5$export$3722cfe417b6ed86));
        });
    }
    let readyHandlers = (0, $d713ccdd7edb23e5$export$db3b6bfb95261072)();
    let errorListeners = (0, $d713ccdd7edb23e5$export$db3b6bfb95261072)();
    let ready;
    /**
	* Trigger errorListeners added via onError and throws the error as well
	*
	* @param error - error to throw
	* @param to - location we were navigating to when the error happened
	* @param from - location we were navigating from when the error happened
	* @returns the error as a rejected promise
	*/ function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorListeners.list();
        if (list.length) list.forEach((handler)=>handler(error, to, from));
        else console.error(error);
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== (0, $d713ccdd7edb23e5$export$56c0d5a1e737357d)) return Promise.resolve();
        return new Promise((resolve$1, reject)=>{
            readyHandlers.add([
                resolve$1,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(([resolve$1, reject])=>err ? reject(err) : resolve$1());
            readyHandlers.reset();
        }
        return err;
    }
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior: scrollBehavior } = options;
        if (!(0, $d713ccdd7edb23e5$export$3d8c2f653ac9d0b9) || !scrollBehavior) return Promise.resolve();
        const scrollPosition = !isPush && (0, $d713ccdd7edb23e5$export$efccba1c4a2ef57b)((0, $d713ccdd7edb23e5$export$971d5caa766a69d7)(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $igcaK.nextTick)().then(()=>scrollBehavior(to, from, scrollPosition)).then((position)=>position && (0, $d713ccdd7edb23e5$export$96f57966bedc81b4)(position)).catch((err)=>triggerError(err, to, from));
    }
    const go = (delta)=>routerHistory.go(delta);
    let started;
    const installedApps = /* @__PURE__ */ new Set();
    const router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        clearRoutes: matcher.clearRoutes,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: ()=>go(-1),
        forward: ()=>go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorListeners.add,
        isReady: isReady,
        install (app) {
            app.component("RouterLink", $0edbee8a5a0fee0a$export$fce709ebdac448ed);
            app.component("RouterView", $0edbee8a5a0fee0a$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, "$route", {
                enumerable: true,
                get: ()=>(0, $mHgsT.unref)(currentRoute)
            });
            if ((0, $d713ccdd7edb23e5$export$3d8c2f653ac9d0b9) && !started && currentRoute.value === (0, $d713ccdd7edb23e5$export$56c0d5a1e737357d)) {
                started = true;
                push(routerHistory.location).catch((err)=>{});
            }
            const reactiveRoute = {};
            for(const key in 0, $d713ccdd7edb23e5$export$56c0d5a1e737357d)Object.defineProperty(reactiveRoute, key, {
                get: ()=>currentRoute.value[key],
                enumerable: true
            });
            app.provide((0, $d713ccdd7edb23e5$export$4368d992c4eafac0), router);
            app.provide((0, $d713ccdd7edb23e5$export$3b14a55fb2447963), (0, $mHgsT.shallowReactive)(reactiveRoute));
            app.provide((0, $d713ccdd7edb23e5$export$2d1720544b23b823), currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                if (installedApps.size < 1) {
                    pendingLocation = (0, $d713ccdd7edb23e5$export$56c0d5a1e737357d);
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = (0, $d713ccdd7edb23e5$export$56c0d5a1e737357d);
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            if (__VUE_PROD_DEVTOOLS__ && (0, $d713ccdd7edb23e5$export$3d8c2f653ac9d0b9)) (0, $d713ccdd7edb23e5$export$625550452a3fa3ec)(app, router, matcher);
        }
    };
    function runGuardQueue(guards) {
        return guards.reduce((promise, guard)=>promise.then(()=>runWithContext(guard)), Promise.resolve());
    }
    return router;
}
//#endregion
//#region src/useApi.ts
/**
* Returns the router instance. Equivalent to using `$router` inside
* templates.
*/ function $0edbee8a5a0fee0a$export$9a302a45f65d0572() {
    return (0, $igcaK.inject)((0, $d713ccdd7edb23e5$export$4368d992c4eafac0));
}
/**
* Returns the current route location. Equivalent to using `$route` inside
* templates.
*/ function $0edbee8a5a0fee0a$export$3f79f0b98112cf57(_name) {
    return (0, $igcaK.inject)((0, $d713ccdd7edb23e5$export$3b14a55fb2447963));
}


var $25966294968d5582$exports = {};
/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */ (function(root, factory) {
    if (typeof define === 'function' && define.amd) define(factory);
    else $25966294968d5582$exports = factory();
})($25966294968d5582$exports, function() {
    var NProgress = {};
    NProgress.version = '0.2.0';
    var Settings = NProgress.settings = {
        minimum: 0.08,
        easing: 'ease',
        positionUsing: '',
        speed: 200,
        trickle: true,
        trickleRate: 0.02,
        trickleSpeed: 800,
        showSpinner: true,
        barSelector: '[role="bar"]',
        spinnerSelector: '[role="spinner"]',
        parent: 'body',
        template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
    };
    /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */ NProgress.configure = function(options) {
        var key, value;
        for(key in options){
            value = options[key];
            if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
        }
        return this;
    };
    /**
   * Last number.
   */ NProgress.status = null;
    /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */ NProgress.set = function(n) {
        var started = NProgress.isStarted();
        n = clamp(n, Settings.minimum, 1);
        NProgress.status = n === 1 ? null : n;
        var progress = NProgress.render(!started), bar = progress.querySelector(Settings.barSelector), speed = Settings.speed, ease = Settings.easing;
        progress.offsetWidth; /* Repaint */ 
        queue(function(next) {
            // Set positionUsing if it hasn't already been set
            if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();
            // Add transition
            css(bar, barPositionCSS(n, speed, ease));
            if (n === 1) {
                // Fade out
                css(progress, {
                    transition: 'none',
                    opacity: 1
                });
                progress.offsetWidth; /* Repaint */ 
                setTimeout(function() {
                    css(progress, {
                        transition: 'all ' + speed + 'ms linear',
                        opacity: 0
                    });
                    setTimeout(function() {
                        NProgress.remove();
                        next();
                    }, speed);
                }, speed);
            } else setTimeout(next, speed);
        });
        return this;
    };
    NProgress.isStarted = function() {
        return typeof NProgress.status === 'number';
    };
    /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */ NProgress.start = function() {
        if (!NProgress.status) NProgress.set(0);
        var work = function() {
            setTimeout(function() {
                if (!NProgress.status) return;
                NProgress.trickle();
                work();
            }, Settings.trickleSpeed);
        };
        if (Settings.trickle) work();
        return this;
    };
    /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */ NProgress.done = function(force) {
        if (!force && !NProgress.status) return this;
        return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
    };
    /**
   * Increments by a random amount.
   */ NProgress.inc = function(amount) {
        var n = NProgress.status;
        if (!n) return NProgress.start();
        else {
            if (typeof amount !== 'number') amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
            n = clamp(n + amount, 0, 0.994);
            return NProgress.set(n);
        }
    };
    NProgress.trickle = function() {
        return NProgress.inc(Math.random() * Settings.trickleRate);
    };
    /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */ (function() {
        var initial = 0, current = 0;
        NProgress.promise = function($promise) {
            if (!$promise || $promise.state() === "resolved") return this;
            if (current === 0) NProgress.start();
            initial++;
            current++;
            $promise.always(function() {
                current--;
                if (current === 0) {
                    initial = 0;
                    NProgress.done();
                } else NProgress.set((initial - current) / initial);
            });
            return this;
        };
    })();
    /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */ NProgress.render = function(fromStart) {
        if (NProgress.isRendered()) return document.getElementById('nprogress');
        addClass(document.documentElement, 'nprogress-busy');
        var progress = document.createElement('div');
        progress.id = 'nprogress';
        progress.innerHTML = Settings.template;
        var bar = progress.querySelector(Settings.barSelector), perc = fromStart ? '-100' : toBarPerc(NProgress.status || 0), parent = document.querySelector(Settings.parent), spinner;
        css(bar, {
            transition: 'all 0 linear',
            transform: 'translate3d(' + perc + '%,0,0)'
        });
        if (!Settings.showSpinner) {
            spinner = progress.querySelector(Settings.spinnerSelector);
            spinner && removeElement(spinner);
        }
        if (parent != document.body) addClass(parent, 'nprogress-custom-parent');
        parent.appendChild(progress);
        return progress;
    };
    /**
   * Removes the element. Opposite of render().
   */ NProgress.remove = function() {
        removeClass(document.documentElement, 'nprogress-busy');
        removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
        var progress = document.getElementById('nprogress');
        progress && removeElement(progress);
    };
    /**
   * Checks if the progress bar is rendered.
   */ NProgress.isRendered = function() {
        return !!document.getElementById('nprogress');
    };
    /**
   * Determine which positioning CSS rule to use.
   */ NProgress.getPositioningCSS = function() {
        // Sniff on document.body.style
        var bodyStyle = document.body.style;
        // Sniff prefixes
        var vendorPrefix = 'WebkitTransform' in bodyStyle ? 'Webkit' : 'MozTransform' in bodyStyle ? 'Moz' : 'msTransform' in bodyStyle ? 'ms' : 'OTransform' in bodyStyle ? 'O' : '';
        if (vendorPrefix + 'Perspective' in bodyStyle) // Modern browsers with 3D support, e.g. Webkit, IE10
        return 'translate3d';
        else if (vendorPrefix + 'Transform' in bodyStyle) // Browsers without 3D support, e.g. IE9
        return 'translate';
        else // Browsers without translate() support, e.g. IE7-8
        return 'margin';
    };
    /**
   * Helpers
   */ function clamp(n, min, max) {
        if (n < min) return min;
        if (n > max) return max;
        return n;
    }
    /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */ function toBarPerc(n) {
        return (-1 + n) * 100;
    }
    /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */ function barPositionCSS(n, speed, ease) {
        var barCSS;
        if (Settings.positionUsing === 'translate3d') barCSS = {
            transform: 'translate3d(' + toBarPerc(n) + '%,0,0)'
        };
        else if (Settings.positionUsing === 'translate') barCSS = {
            transform: 'translate(' + toBarPerc(n) + '%,0)'
        };
        else barCSS = {
            'margin-left': toBarPerc(n) + '%'
        };
        barCSS.transition = 'all ' + speed + 'ms ' + ease;
        return barCSS;
    }
    /**
   * (Internal) Queues a function to be executed.
   */ var queue = function() {
        var pending = [];
        function next() {
            var fn = pending.shift();
            if (fn) fn(next);
        }
        return function(fn) {
            pending.push(fn);
            if (pending.length == 1) next();
        };
    }();
    /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */ var css = function() {
        var cssPrefixes = [
            'Webkit',
            'O',
            'Moz',
            'ms'
        ], cssProps = {};
        function camelCase(string) {
            return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
                return letter.toUpperCase();
            });
        }
        function getVendorProp(name) {
            var style = document.body.style;
            if (name in style) return name;
            var i = cssPrefixes.length, capName = name.charAt(0).toUpperCase() + name.slice(1), vendorName;
            while(i--){
                vendorName = cssPrefixes[i] + capName;
                if (vendorName in style) return vendorName;
            }
            return name;
        }
        function getStyleProp(name) {
            name = camelCase(name);
            return cssProps[name] || (cssProps[name] = getVendorProp(name));
        }
        function applyCss(element, prop, value) {
            prop = getStyleProp(prop);
            element.style[prop] = value;
        }
        return function(element, properties) {
            var args = arguments, prop, value;
            if (args.length == 2) for(prop in properties){
                value = properties[prop];
                if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
            }
            else applyCss(element, args[1], args[2]);
        };
    }();
    /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */ function hasClass(element, name) {
        var list = typeof element == 'string' ? element : classList(element);
        return list.indexOf(' ' + name + ' ') >= 0;
    }
    /**
   * (Internal) Adds a class to an element.
   */ function addClass(element, name) {
        var oldList = classList(element), newList = oldList + name;
        if (hasClass(oldList, name)) return;
        // Trim the opening space.
        element.className = newList.substring(1);
    }
    /**
   * (Internal) Removes a class from an element.
   */ function removeClass(element, name) {
        var oldList = classList(element), newList;
        if (!hasClass(element, name)) return;
        // Replace the class name.
        newList = oldList.replace(' ' + name + ' ', ' ');
        // Trim the opening and closing spaces.
        element.className = newList.substring(1, newList.length - 1);
    }
    /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */ function classList(element) {
        return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
    }
    /**
   * (Internal) Removes an element from the DOM.
   */ function removeElement(element) {
        element && element.parentNode && element.parentNode.removeChild(element);
    }
    return NProgress;
});


let $71b22bf27c24e4d8$var$script;



let $71b22bf27c24e4d8$var$initialize = ()=>{
    $71b22bf27c24e4d8$var$script = (parcelRequire("gxzqo"));
    if ($71b22bf27c24e4d8$var$script.__esModule) $71b22bf27c24e4d8$var$script = $71b22bf27c24e4d8$var$script.default;
    $71b22bf27c24e4d8$var$script.render = (parcelRequire("kRdD7")).render;
    (parcelRequire("daWq5")).default($71b22bf27c24e4d8$var$script);
    $71b22bf27c24e4d8$var$script.__scopeId = 'data-v-733c9b';
    $71b22bf27c24e4d8$var$script.__file = "Home.vue";
};
$71b22bf27c24e4d8$var$initialize();
var $71b22bf27c24e4d8$export$2e2bcd8739ae039 = $71b22bf27c24e4d8$var$script;


let $cf3e3d128d5383b8$var$script;




let $cf3e3d128d5383b8$var$initialize = ()=>{
    $cf3e3d128d5383b8$var$script = (parcelRequire("gNU50"));
    if ($cf3e3d128d5383b8$var$script.__esModule) $cf3e3d128d5383b8$var$script = $cf3e3d128d5383b8$var$script.default;
    $cf3e3d128d5383b8$var$script.render = (parcelRequire("gGP7V")).render;
    $cf3e3d128d5383b8$var$script.__cssModules = {};
    (parcelRequire("brP4W")).default($cf3e3d128d5383b8$var$script);
    $cf3e3d128d5383b8$var$script.__scopeId = 'data-v-6833bc';
    $cf3e3d128d5383b8$var$script.__file = "FanArt.vue";
};
$cf3e3d128d5383b8$var$initialize();
var $cf3e3d128d5383b8$export$2e2bcd8739ae039 = $cf3e3d128d5383b8$var$script;


let $f6c12f7b39190ca7$var$script;




let $f6c12f7b39190ca7$var$initialize = ()=>{
    $f6c12f7b39190ca7$var$script = (parcelRequire("2HYh5"));
    if ($f6c12f7b39190ca7$var$script.__esModule) $f6c12f7b39190ca7$var$script = $f6c12f7b39190ca7$var$script.default;
    $f6c12f7b39190ca7$var$script.render = (parcelRequire("8IHNL")).render;
    $f6c12f7b39190ca7$var$script.__cssModules = {};
    (parcelRequire("k8ast")).default($f6c12f7b39190ca7$var$script);
    $f6c12f7b39190ca7$var$script.__scopeId = 'data-v-a6b0d2';
    $f6c12f7b39190ca7$var$script.__file = "About.vue";
};
$f6c12f7b39190ca7$var$initialize();
var $f6c12f7b39190ca7$export$2e2bcd8739ae039 = $f6c12f7b39190ca7$var$script;


let $ff75756085a18a57$var$script;




let $ff75756085a18a57$var$initialize = ()=>{
    $ff75756085a18a57$var$script = (parcelRequire("a5F10"));
    if ($ff75756085a18a57$var$script.__esModule) $ff75756085a18a57$var$script = $ff75756085a18a57$var$script.default;
    $ff75756085a18a57$var$script.render = (parcelRequire("at2xZ")).render;
    $ff75756085a18a57$var$script.__cssModules = {};
    (parcelRequire("iFUMc")).default($ff75756085a18a57$var$script);
    $ff75756085a18a57$var$script.__scopeId = 'data-v-af336e';
    $ff75756085a18a57$var$script.__file = "NotFound.vue";
};
$ff75756085a18a57$var$initialize();
var $ff75756085a18a57$export$2e2bcd8739ae039 = $ff75756085a18a57$var$script;


const $c0bf5d899dec86d6$var$routes = [
    {
        path: '/',
        name: 'Home',
        component: (0, $71b22bf27c24e4d8$export$2e2bcd8739ae039),
        meta: {
            title: 'Home | Hai Halo Epel'
        }
    },
    {
        path: '/about',
        name: 'About',
        component: (0, $f6c12f7b39190ca7$export$2e2bcd8739ae039),
        meta: {
            title: 'About | Hai Halo Epel'
        }
    },
    {
        path: '/fanart',
        name: 'Fanart',
        component: (0, $cf3e3d128d5383b8$export$2e2bcd8739ae039),
        meta: {
            title: 'Fan art | Hai Halo Epel'
        }
    },
    {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: (0, $ff75756085a18a57$export$2e2bcd8739ae039),
        meta: {
            title: 'Page not Found | Hai Halo Epel'
        }
    }
];
const $c0bf5d899dec86d6$var$router = (0, $0edbee8a5a0fee0a$export$baddd0131ee8c05b)({
    history: (0, $0edbee8a5a0fee0a$export$7b4942f78e7b8a49)(),
    routes: $c0bf5d899dec86d6$var$routes
});
$c0bf5d899dec86d6$var$router.beforeResolve((to, from, next)=>{
    if (to.name) (0, (/*@__PURE__*/$parcel$interopDefault($25966294968d5582$exports))).start();
    const nearestWithTitle = to.matched.slice().reverse().find((r)=>r.meta && r.meta.title);
    const nearestWithMeta = to.matched.slice().reverse().find((r)=>r.meta && r.meta.metaTags);
    const previousNearestWithMeta = from.matched.slice().reverse().find((r)=>r.meta && r.meta.metaTags);
    if (nearestWithTitle) document.title = nearestWithTitle.meta.title;
    else if (previousNearestWithMeta) document.title = previousNearestWithMeta.meta.title;
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map((el)=>el.parentNode.removeChild(el));
    if (!nearestWithMeta) return next();
    nearestWithMeta.meta.metaTags.map((tagDef)=>{
        const tag = document.createElement('meta');
        Object.keys(tagDef).forEach((key)=>{
            tag.setAttribute(key, tagDef[key]);
        });
        tag.setAttribute('data-vue-router-controlled', '');
        return tag;
    }).forEach((tag)=>document.head.appendChild(tag));
    next();
});
$c0bf5d899dec86d6$var$router.afterEach((to, from)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($25966294968d5582$exports))).done();
});
var $c0bf5d899dec86d6$export$2e2bcd8739ae039 = $c0bf5d899dec86d6$var$router;


(0, $jfBPE.createApp)((0, $ae3de8900c09c2f9$export$2e2bcd8739ae039)).use((0, $c0bf5d899dec86d6$export$2e2bcd8739ae039)).mount('#app');


//# sourceMappingURL=repo.ec416e6b.js.map
